import * as React from "react";
import React__default, { createContext as createContext$1, useMemo, createElement as createElement$1, useContext, useCallback, forwardRef, Children, isValidElement, cloneElement, Fragment as Fragment$1, useRef, useEffect, useState, useLayoutEffect as useLayoutEffect$1, useReducer, Component, useImperativeHandle } from "react";
import * as $7SXl2$reactdom from "react-dom";
import $7SXl2$reactdom__default, { flushSync, createPortal } from "react-dom";
import TextareaAutosize from "react-textarea-autosize";
var e$1 = "colors",
  t$2 = "sizes",
  r$2 = "space",
  n$3 = {
    gap: r$2,
    gridGap: r$2,
    columnGap: r$2,
    gridColumnGap: r$2,
    rowGap: r$2,
    gridRowGap: r$2,
    inset: r$2,
    insetBlock: r$2,
    insetBlockEnd: r$2,
    insetBlockStart: r$2,
    insetInline: r$2,
    insetInlineEnd: r$2,
    insetInlineStart: r$2,
    margin: r$2,
    marginTop: r$2,
    marginRight: r$2,
    marginBottom: r$2,
    marginLeft: r$2,
    marginBlock: r$2,
    marginBlockEnd: r$2,
    marginBlockStart: r$2,
    marginInline: r$2,
    marginInlineEnd: r$2,
    marginInlineStart: r$2,
    padding: r$2,
    paddingTop: r$2,
    paddingRight: r$2,
    paddingBottom: r$2,
    paddingLeft: r$2,
    paddingBlock: r$2,
    paddingBlockEnd: r$2,
    paddingBlockStart: r$2,
    paddingInline: r$2,
    paddingInlineEnd: r$2,
    paddingInlineStart: r$2,
    top: r$2,
    right: r$2,
    bottom: r$2,
    left: r$2,
    scrollMargin: r$2,
    scrollMarginTop: r$2,
    scrollMarginRight: r$2,
    scrollMarginBottom: r$2,
    scrollMarginLeft: r$2,
    scrollMarginX: r$2,
    scrollMarginY: r$2,
    scrollMarginBlock: r$2,
    scrollMarginBlockEnd: r$2,
    scrollMarginBlockStart: r$2,
    scrollMarginInline: r$2,
    scrollMarginInlineEnd: r$2,
    scrollMarginInlineStart: r$2,
    scrollPadding: r$2,
    scrollPaddingTop: r$2,
    scrollPaddingRight: r$2,
    scrollPaddingBottom: r$2,
    scrollPaddingLeft: r$2,
    scrollPaddingX: r$2,
    scrollPaddingY: r$2,
    scrollPaddingBlock: r$2,
    scrollPaddingBlockEnd: r$2,
    scrollPaddingBlockStart: r$2,
    scrollPaddingInline: r$2,
    scrollPaddingInlineEnd: r$2,
    scrollPaddingInlineStart: r$2,
    fontSize: "fontSizes",
    background: e$1,
    backgroundColor: e$1,
    backgroundImage: e$1,
    borderImage: e$1,
    border: e$1,
    borderBlock: e$1,
    borderBlockEnd: e$1,
    borderBlockStart: e$1,
    borderBottom: e$1,
    borderBottomColor: e$1,
    borderColor: e$1,
    borderInline: e$1,
    borderInlineEnd: e$1,
    borderInlineStart: e$1,
    borderLeft: e$1,
    borderLeftColor: e$1,
    borderRight: e$1,
    borderRightColor: e$1,
    borderTop: e$1,
    borderTopColor: e$1,
    caretColor: e$1,
    color: e$1,
    columnRuleColor: e$1,
    fill: e$1,
    outline: e$1,
    outlineColor: e$1,
    stroke: e$1,
    textDecorationColor: e$1,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: t$2,
    minBlockSize: t$2,
    maxBlockSize: t$2,
    inlineSize: t$2,
    minInlineSize: t$2,
    maxInlineSize: t$2,
    width: t$2,
    minWidth: t$2,
    maxWidth: t$2,
    height: t$2,
    minHeight: t$2,
    maxHeight: t$2,
    flexBasis: t$2,
    gridTemplateColumns: t$2,
    gridTemplateRows: t$2,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
  },
  i$2 = (e2, t2) => typeof t2 == "function" ? {
    "()": Function.prototype.toString.call(t2)
  } : t2,
  o$1 = () => {
    const e2 = /* @__PURE__ */Object.create(null);
    return function (t2, r2) {
      const o2 = (e3 => JSON.stringify(e3, i$2))(t2);
      for (var _len3 = arguments.length, n2 = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        n2[_key3 - 2] = arguments[_key3];
      }
      return o2 in e2 ? e2[o2] : e2[o2] = r2(t2, ...n2);
    };
  },
  l$2 = Symbol.for("sxs.internal"),
  s = (e2, t2) => Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t2)),
  a$1 = e2 => {
    for (const t2 in e2) return true;
    return false;
  },
  {
    hasOwnProperty: c$1
  } = Object.prototype,
  d$2 = e2 => e2.includes("-") ? e2 : e2.replace(/[A-Z]/g, e3 => "-" + e3.toLowerCase()),
  g$2 = /\s+(?![^()]*\))/,
  p$4 = e2 => t2 => e2(...(typeof t2 == "string" ? String(t2).split(g$2) : [t2])),
  u$1 = {
    appearance: e2 => ({
      WebkitAppearance: e2,
      appearance: e2
    }),
    backfaceVisibility: e2 => ({
      WebkitBackfaceVisibility: e2,
      backfaceVisibility: e2
    }),
    backdropFilter: e2 => ({
      WebkitBackdropFilter: e2,
      backdropFilter: e2
    }),
    backgroundClip: e2 => ({
      WebkitBackgroundClip: e2,
      backgroundClip: e2
    }),
    boxDecorationBreak: e2 => ({
      WebkitBoxDecorationBreak: e2,
      boxDecorationBreak: e2
    }),
    clipPath: e2 => ({
      WebkitClipPath: e2,
      clipPath: e2
    }),
    content: e2 => ({
      content: e2.includes('"') || e2.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e2) ? e2 : `"${e2}"`
    }),
    hyphens: e2 => ({
      WebkitHyphens: e2,
      hyphens: e2
    }),
    maskImage: e2 => ({
      WebkitMaskImage: e2,
      maskImage: e2
    }),
    maskSize: e2 => ({
      WebkitMaskSize: e2,
      maskSize: e2
    }),
    tabSize: e2 => ({
      MozTabSize: e2,
      tabSize: e2
    }),
    textSizeAdjust: e2 => ({
      WebkitTextSizeAdjust: e2,
      textSizeAdjust: e2
    }),
    userSelect: e2 => ({
      WebkitUserSelect: e2,
      userSelect: e2
    }),
    marginBlock: p$4((e2, t2) => ({
      marginBlockStart: e2,
      marginBlockEnd: t2 || e2
    })),
    marginInline: p$4((e2, t2) => ({
      marginInlineStart: e2,
      marginInlineEnd: t2 || e2
    })),
    maxSize: p$4((e2, t2) => ({
      maxBlockSize: e2,
      maxInlineSize: t2 || e2
    })),
    minSize: p$4((e2, t2) => ({
      minBlockSize: e2,
      minInlineSize: t2 || e2
    })),
    paddingBlock: p$4((e2, t2) => ({
      paddingBlockStart: e2,
      paddingBlockEnd: t2 || e2
    })),
    paddingInline: p$4((e2, t2) => ({
      paddingInlineStart: e2,
      paddingInlineEnd: t2 || e2
    }))
  },
  h$3 = /([\d.]+)([^]*)/,
  f$3 = (e2, t2) => e2.length ? e2.reduce((e3, r2) => (e3.push(...t2.map(e4 => e4.includes("&") ? e4.replace(/&/g, /[ +>|~]/.test(r2) && /&.*&/.test(e4) ? `:is(${r2})` : r2) : r2 + " " + e4)), e3), []) : t2,
  m$3 = (e2, t2) => e2 in b$2 && typeof t2 == "string" ? t2.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t3, r2, n2, i) => r2 + (n2 === "stretch" ? `-moz-available${i};${d$2(e2)}:${r2}-webkit-fill-available` : `-moz-fit-content${i};${d$2(e2)}:${r2}fit-content`) + i) : String(t2),
  b$2 = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
  },
  S = e2 => e2 ? e2 + "-" : "",
  k$1 = (e2, t2, r2) => e2.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e3, n2, i, o2, l2) => o2 == "$" == !!i ? e3 : (n2 || o2 == "--" ? "calc(" : "") + "var(--" + (o2 === "$" ? S(t2) + (l2.includes("$") ? "" : S(r2)) + l2.replace(/\$/g, "-") : l2) + ")" + (n2 || o2 == "--" ? "*" + (n2 || "") + (i || "1") + ")" : "")),
  y$1 = /\s*,\s*(?![^()]*\))/,
  B = Object.prototype.toString,
  $ = (e2, t2, r2, n2, i) => {
    let o2, l2, s2;
    const a2 = (e3, t3, r3) => {
      let c2, g2;
      const p2 = e4 => {
        for (c2 in e4) {
          const R2 = c2.charCodeAt(0) === 64,
            z2 = R2 && Array.isArray(e4[c2]) ? e4[c2] : [e4[c2]];
          for (g2 of z2) {
            const e5 = /[A-Z]/.test($2 = c2) ? $2 : $2.replace(/-[^]/g, e6 => e6[1].toUpperCase()),
              z3 = typeof g2 == "object" && g2 && g2.toString === B && (!n2.utils[e5] || !t3.length);
            if (e5 in n2.utils && !z3) {
              const t4 = n2.utils[e5];
              if (t4 !== l2) {
                l2 = t4, p2(t4(g2)), l2 = null;
                continue;
              }
            } else if (e5 in u$1) {
              const t4 = u$1[e5];
              if (t4 !== s2) {
                s2 = t4, p2(t4(g2)), s2 = null;
                continue;
              }
            }
            if (R2 && (b2 = c2.slice(1) in n2.media ? "@media " + n2.media[c2.slice(1)] : c2, c2 = b2.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e6, t4, r4, n3, i2, o3) => {
              const l3 = h$3.test(t4),
                s3 = 0.0625 * (l3 ? -1 : 1),
                [a3, c3] = l3 ? [n3, t4] : [t4, n3];
              return "(" + (r4[0] === "=" ? "" : r4[0] === ">" === l3 ? "max-" : "min-") + a3 + ":" + (r4[0] !== "=" && r4.length === 1 ? c3.replace(h$3, (e7, t5, n4) => Number(t5) + s3 * (r4 === ">" ? 1 : -1) + n4) : c3) + (i2 ? ") and (" + (i2[0] === ">" ? "min-" : "max-") + a3 + ":" + (i2.length === 1 ? o3.replace(h$3, (e7, t5, r5) => Number(t5) + s3 * (i2 === ">" ? -1 : 1) + r5) : o3) : "") + ")";
            })), z3) {
              const e6 = R2 ? r3.concat(c2) : [...r3],
                n3 = R2 ? [...t3] : f$3(t3, c2.split(y$1));
              o2 !== void 0 && i(x$2(...o2)), o2 = void 0, a2(g2, n3, e6);
            } else o2 === void 0 && (o2 = [[], t3, r3]), c2 = R2 || c2.charCodeAt(0) !== 36 ? c2 : `--${S(n2.prefix)}${c2.slice(1).replace(/\$/g, "-")}`, g2 = z3 ? g2 : typeof g2 == "number" ? g2 && e5 in I ? String(g2) + "px" : String(g2) : k$1(m$3(e5, g2 == null ? "" : g2), n2.prefix, n2.themeMap[e5]), o2[0].push(`${R2 ? `${c2} ` : `${d$2(c2)}:`}${g2}`);
          }
        }
        var b2, $2;
      };
      p2(e3), o2 !== void 0 && i(x$2(...o2)), o2 = void 0;
    };
    a2(e2, t2, r2);
  },
  x$2 = (e2, t2, r2) => `${r2.map(e3 => `${e3}{`).join("")}${t2.length ? `${t2.join(",")}{` : ""}${e2.join(";")}${t2.length ? "}" : ""}${Array(r2.length ? r2.length + 1 : 0).join("}")}`,
  I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
  },
  R = e2 => String.fromCharCode(e2 + (e2 > 25 ? 39 : 97)),
  z$1 = e2 => (e3 => {
    let t2,
      r2 = "";
    for (t2 = Math.abs(e3); t2 > 52; t2 = t2 / 52 | 0) r2 = R(t2 % 52) + r2;
    return R(t2 % 52) + r2;
  })(((e3, t2) => {
    let r2 = t2.length;
    for (; r2;) e3 = 33 * e3 ^ t2.charCodeAt(--r2);
    return e3;
  })(5381, JSON.stringify(e2)) >>> 0),
  W = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"],
  j$1 = e2 => {
    if (e2.href && !e2.href.startsWith(location.origin)) return false;
    try {
      return !!e2.cssRules;
    } catch (e3) {
      return false;
    }
  },
  E = e2 => {
    let t2;
    const r2 = () => {
        const {
          cssRules: e3
        } = t2.sheet;
        return [].map.call(e3, (r3, n3) => {
          const {
            cssText: i
          } = r3;
          let o2 = "";
          if (i.startsWith("--sxs")) return "";
          if (e3[n3 - 1] && (o2 = e3[n3 - 1].cssText).startsWith("--sxs")) {
            if (!r3.cssRules.length) return "";
            for (const e4 in t2.rules) if (t2.rules[e4].group === r3) return `--sxs{--sxs:${[...t2.rules[e4].cache].join(" ")}}${i}`;
            return r3.cssRules.length ? `${o2}${i}` : "";
          }
          return i;
        }).join("");
      },
      n2 = () => {
        if (t2) {
          const {
            rules: e3,
            sheet: r3
          } = t2;
          if (!r3.deleteRule) {
            for (; Object(Object(r3.cssRules)[0]).type === 3;) r3.cssRules.splice(0, 1);
            r3.cssRules = [];
          }
          for (const t3 in e3) delete e3[t3];
        }
        const i = Object(e2).styleSheets || [];
        for (const e3 of i) if (j$1(e3)) {
          for (let i2 = 0, o3 = e3.cssRules; o3[i2]; ++i2) {
            const l3 = Object(o3[i2]);
            if (l3.type !== 1) continue;
            const s2 = Object(o3[i2 + 1]);
            if (s2.type !== 4) continue;
            ++i2;
            const {
              cssText: a2
            } = l3;
            if (!a2.startsWith("--sxs")) continue;
            const c2 = a2.slice(14, -3).trim().split(/\s+/),
              d2 = W[c2[0]];
            d2 && (t2 || (t2 = {
              sheet: e3,
              reset: n2,
              rules: {},
              toString: r2
            }), t2.rules[d2] = {
              group: s2,
              index: i2,
              cache: new Set(c2)
            });
          }
          if (t2) break;
        }
        if (!t2) {
          const i2 = (e3, t3) => ({
            type: t3,
            cssRules: [],
            insertRule(e4, t4) {
              this.cssRules.splice(t4, 0, i2(e4, {
                import: 3,
                undefined: 1
              }[(e4.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
            },
            get cssText() {
              return e3 === "@media{}" ? `@media{${[].map.call(this.cssRules, e4 => e4.cssText).join("")}}` : e3;
            }
          });
          t2 = {
            sheet: e2 ? (e2.head || e2).appendChild(document.createElement("style")).sheet : i2("", "text/css"),
            rules: {},
            reset: n2,
            toString: r2
          };
        }
        const {
          sheet: o2,
          rules: l2
        } = t2;
        for (let e3 = W.length - 1; e3 >= 0; --e3) {
          const t3 = W[e3];
          if (!l2[t3]) {
            const r3 = W[e3 + 1],
              n3 = l2[r3] ? l2[r3].index : o2.cssRules.length;
            o2.insertRule("@media{}", n3), o2.insertRule(`--sxs{--sxs:${e3}}`, n3), l2[t3] = {
              group: o2.cssRules[n3 + 1],
              index: n3,
              cache: /* @__PURE__ */new Set([e3])
            };
          }
          v$1(l2[t3]);
        }
      };
    return n2(), t2;
  },
  v$1 = e2 => {
    const t2 = e2.group;
    let r2 = t2.cssRules.length;
    e2.apply = e3 => {
      try {
        t2.insertRule(e3, r2), ++r2;
      } catch (e4) {}
    };
  },
  T = Symbol(),
  w$3 = o$1(),
  M = (e2, t2) => w$3(e2, () => function () {
    let n2 = {
      type: null,
      composers: /* @__PURE__ */new Set()
    };
    for (var _len4 = arguments.length, r2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      r2[_key4] = arguments[_key4];
    }
    for (const t3 of r2) if (t3 != null) if (t3[l$2]) {
      n2.type == null && (n2.type = t3[l$2].type);
      for (const e3 of t3[l$2].composers) n2.composers.add(e3);
    } else t3.constructor !== Object || t3.$$typeof ? n2.type == null && (n2.type = t3) : n2.composers.add(C(t3, e2));
    return n2.type == null && (n2.type = "span"), n2.composers.size || n2.composers.add(["PJLV", {}, [], [], {}, []]), P(e2, n2, t2);
  }),
  C = (_ref9, i) => {
    let {
      variants: e2,
      compoundVariants: t2,
      defaultVariants: r2,
      ...n2
    } = _ref9;
    const o2 = `${S(i.prefix)}c-${z$1(n2)}`,
      l2 = [],
      s2 = [],
      d2 = /* @__PURE__ */Object.create(null),
      g2 = [];
    for (const e3 in r2) d2[e3] = String(r2[e3]);
    if (typeof e2 == "object" && e2) for (const t3 in e2) {
      p2 = d2, u2 = t3, c$1.call(p2, u2) || (d2[t3] = "undefined");
      const r3 = e2[t3];
      for (const e3 in r3) {
        const n3 = {
          [t3]: String(e3)
        };
        String(e3) === "undefined" && g2.push(t3);
        const i2 = r3[e3],
          o3 = [n3, i2, !a$1(i2)];
        l2.push(o3);
      }
    }
    var p2, u2;
    if (typeof t2 == "object" && t2) for (const e3 of t2) {
      let {
        css: t3,
        ...r3
      } = e3;
      t3 = typeof t3 == "object" && t3 || {};
      for (const e4 in r3) r3[e4] = String(r3[e4]);
      const n3 = [r3, t3, !a$1(t3)];
      s2.push(n3);
    }
    return [o2, n2, l2, s2, d2, g2];
  },
  P = (e2, t2, r2) => {
    const [n2, i, o2, a2] = L(t2.composers),
      c2 = typeof t2.type == "function" || t2.type.$$typeof ? (e3 => {
        function t3() {
          for (let r3 = 0; r3 < t3[T].length; r3++) {
            const [n3, i2] = t3[T][r3];
            e3.rules[n3].apply(i2);
          }
          return t3[T] = [], null;
        }
        return t3[T] = [], t3.rules = {}, W.forEach(e4 => t3.rules[e4] = {
          apply: r3 => t3[T].push([e4, r3])
        }), t3;
      })(r2) : null,
      d2 = (c2 || r2).rules,
      g2 = `.${n2}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`,
      p2 = l2 => {
        l2 = typeof l2 == "object" && l2 || A$1;
        const {
            css: s2,
            ...p3
          } = l2,
          u2 = {};
        for (const e3 in o2) if (delete p3[e3], e3 in l2) {
          let t3 = l2[e3];
          typeof t3 == "object" && t3 ? u2[e3] = {
            "@initial": o2[e3],
            ...t3
          } : (t3 = String(t3), u2[e3] = t3 !== "undefined" || a2.has(e3) ? t3 : o2[e3]);
        } else u2[e3] = o2[e3];
        const h2 = /* @__PURE__ */new Set([...i]);
        for (const [n3, i2, o3, l3] of t2.composers) {
          r2.rules.styled.cache.has(n3) || (r2.rules.styled.cache.add(n3), $(i2, [`.${n3}`], [], e2, e3 => {
            d2.styled.apply(e3);
          }));
          const t3 = O(o3, u2, e2.media),
            s3 = O(l3, u2, e2.media, true);
          for (const i3 of t3) if (i3 !== void 0) for (const [t4, o4, l4] of i3) {
            const i4 = `${n3}-${z$1(o4)}-${t4}`;
            h2.add(i4);
            const s4 = (l4 ? r2.rules.resonevar : r2.rules.onevar).cache,
              a3 = l4 ? d2.resonevar : d2.onevar;
            s4.has(i4) || (s4.add(i4), $(o4, [`.${i4}`], [], e2, e3 => {
              a3.apply(e3);
            }));
          }
          for (const t4 of s3) if (t4 !== void 0) for (const [i3, o4] of t4) {
            const t5 = `${n3}-${z$1(o4)}-${i3}`;
            h2.add(t5), r2.rules.allvar.cache.has(t5) || (r2.rules.allvar.cache.add(t5), $(o4, [`.${t5}`], [], e2, e3 => {
              d2.allvar.apply(e3);
            }));
          }
        }
        if (typeof s2 == "object" && s2) {
          const t3 = `${n2}-i${z$1(s2)}-css`;
          h2.add(t3), r2.rules.inline.cache.has(t3) || (r2.rules.inline.cache.add(t3), $(s2, [`.${t3}`], [], e2, e3 => {
            d2.inline.apply(e3);
          }));
        }
        for (const e3 of String(l2.className || "").trim().split(/\s+/)) e3 && h2.add(e3);
        const f2 = p3.className = [...h2].join(" ");
        return {
          type: t2.type,
          className: f2,
          selector: g2,
          props: p3,
          toString: () => f2,
          deferredInjector: c2
        };
      };
    return s(p2, {
      className: n2,
      selector: g2,
      [l$2]: t2,
      toString: () => (r2.rules.styled.cache.has(n2) || p2(), n2)
    });
  },
  L = e2 => {
    let t2 = "";
    const r2 = [],
      n2 = {},
      i = [];
    for (const [o2,,,, l2, s2] of e2) {
      t2 === "" && (t2 = o2), r2.push(o2), i.push(...s2);
      for (const e3 in l2) {
        const t3 = l2[e3];
        (n2[e3] === void 0 || t3 !== "undefined" || s2.includes(t3)) && (n2[e3] = t3);
      }
    }
    return [t2, r2, n2, new Set(i)];
  },
  O = (e2, t2, r2, n2) => {
    const i = [];
    e: for (let [o2, l2, s2] of e2) {
      if (s2) continue;
      let e3,
        a2 = 0,
        c2 = false;
      for (e3 in o2) {
        const n3 = o2[e3];
        let i2 = t2[e3];
        if (i2 !== n3) {
          if (typeof i2 != "object" || !i2) continue e;
          {
            let e4,
              t3,
              o3 = 0;
            for (const l3 in i2) {
              if (n3 === String(i2[l3])) {
                if (l3 !== "@initial") {
                  const e5 = l3.slice(1);
                  (t3 = t3 || []).push(e5 in r2 ? r2[e5] : l3.replace(/^@media ?/, "")), c2 = true;
                }
                a2 += o3, e4 = true;
              }
              ++o3;
            }
            if (t3 && t3.length && (l2 = {
              ["@media " + t3.join(", ")]: l2
            }), !e4) continue e;
          }
        }
      }
      (i[a2] = i[a2] || []).push([n2 ? "cv" : `${e3}-${o2[e3]}`, l2, c2]);
    }
    return i;
  },
  A$1 = {},
  N = o$1(),
  D = (e2, t2) => N(e2, () => function () {
    for (var _len5 = arguments.length, r2 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      r2[_key5] = arguments[_key5];
    }
    const n2 = () => {
      for (let n3 of r2) {
        n3 = typeof n3 == "object" && n3 || {};
        let r3 = z$1(n3);
        if (!t2.rules.global.cache.has(r3)) {
          if (t2.rules.global.cache.add(r3), "@import" in n3) {
            let e3 = [].indexOf.call(t2.sheet.cssRules, t2.rules.themed.group) - 1;
            for (let r4 of [].concat(n3["@import"])) r4 = r4.includes('"') || r4.includes("'") ? r4 : `"${r4}"`, t2.sheet.insertRule(`@import ${r4};`, e3++);
            delete n3["@import"];
          }
          $(n3, [], [], e2, e3 => {
            t2.rules.global.apply(e3);
          });
        }
      }
      return "";
    };
    return s(n2, {
      toString: n2
    });
  }),
  H = o$1(),
  V = (e2, t2) => H(e2, () => r2 => {
    const n2 = `${S(e2.prefix)}k-${z$1(r2)}`,
      i = () => {
        if (!t2.rules.global.cache.has(n2)) {
          t2.rules.global.cache.add(n2);
          const i2 = [];
          $(r2, [], [], e2, e3 => i2.push(e3));
          const o2 = `@keyframes ${n2}{${i2.join("")}}`;
          t2.rules.global.apply(o2);
        }
        return n2;
      };
    return s(i, {
      get name() {
        return i();
      },
      toString: i
    });
  }),
  G = class {
    constructor(e2, t2, r2, n2) {
      this.token = e2 == null ? "" : String(e2), this.value = t2 == null ? "" : String(t2), this.scale = r2 == null ? "" : String(r2), this.prefix = n2 == null ? "" : String(n2);
    }
    get computedValue() {
      return "var(" + this.variable + ")";
    }
    get variable() {
      return "--" + S(this.prefix) + S(this.scale) + this.token;
    }
    toString() {
      return this.computedValue;
    }
  },
  F = o$1(),
  J = (e2, t2) => F(e2, () => (r2, n2) => {
    n2 = typeof r2 == "object" && r2 || Object(n2);
    const i = `.${r2 = (r2 = typeof r2 == "string" ? r2 : "") || `${S(e2.prefix)}t-${z$1(n2)}`}`,
      o2 = {},
      l2 = [];
    for (const t3 in n2) {
      o2[t3] = {};
      for (const r3 in n2[t3]) {
        const i2 = `--${S(e2.prefix)}${t3}-${r3}`,
          s3 = k$1(String(n2[t3][r3]), e2.prefix, t3);
        o2[t3][r3] = new G(r3, s3, t3, e2.prefix), l2.push(`${i2}:${s3}`);
      }
    }
    const s2 = () => {
      if (l2.length && !t2.rules.themed.cache.has(r2)) {
        t2.rules.themed.cache.add(r2);
        const i2 = `${n2 === e2.theme ? ":root," : ""}.${r2}{${l2.join(";")}}`;
        t2.rules.themed.apply(i2);
      }
      return r2;
    };
    return {
      ...o2,
      get className() {
        return s2();
      },
      selector: i,
      toString: s2
    };
  }),
  U = o$1();
var Y = o$1(),
  q$2 = e2 => {
    const t2 = (e3 => {
      let t3 = false;
      const r2 = U(e3, e4 => {
        t3 = true;
        const r3 = "prefix" in (e4 = typeof e4 == "object" && e4 || {}) ? String(e4.prefix) : "",
          i = typeof e4.media == "object" && e4.media || {},
          o2 = typeof e4.root == "object" ? e4.root || null : globalThis.document || null,
          l2 = typeof e4.theme == "object" && e4.theme || {},
          s2 = {
            prefix: r3,
            media: i,
            theme: l2,
            themeMap: typeof e4.themeMap == "object" && e4.themeMap || {
              ...n$3
            },
            utils: typeof e4.utils == "object" && e4.utils || {}
          },
          a2 = E(o2),
          c2 = {
            css: M(s2, a2),
            globalCss: D(s2, a2),
            keyframes: V(s2, a2),
            createTheme: J(s2, a2),
            reset() {
              a2.reset(), c2.theme.toString();
            },
            theme: {},
            sheet: a2,
            config: s2,
            prefix: r3,
            getCssText: a2.toString,
            toString: a2.toString
          };
        return String(c2.theme = c2.createTheme(l2)), c2;
      });
      return t3 || r2.reset(), r2;
    })(e2);
    return t2.styled = (_ref10 => {
      let {
        config: e3,
        sheet: t3
      } = _ref10;
      return Y(e3, () => {
        const r2 = M(e3, t3);
        return function () {
          const t4 = r2(...arguments),
            n2 = t4[l$2].type,
            i = React__default.forwardRef((e5, r3) => {
              const i2 = e5 && e5.as || n2,
                {
                  props: o2,
                  deferredInjector: l2
                } = t4(e5);
              return delete o2.as, o2.ref = r3, l2 ? React__default.createElement(React__default.Fragment, null, React__default.createElement(i2, o2), React__default.createElement(l2, null)) : React__default.createElement(i2, o2);
            });
          return i.className = t4.className, i.displayName = `Styled.${n2.displayName || n2.name || n2}`, i.selector = t4.selector, i.toString = () => t4.selector, i[l$2] = t4[l$2], i;
        };
      });
    })(t2), t2;
  };
const globalStyles = {
  html: {
    fontFamily: "$primary",
    fontSize: "$base",
    letterSpacing: "normal",
    lineHeight: "$base",
    overflowX: "hidden",
    textRendering: "optimizeLegibility",
    textSizeAdjust: "100%",
    boxSizing: "border-box"
  },
  "*": {
    boxSizing: "inherit"
  },
  "*::before": {
    boxSizing: "inherit"
  },
  "*::after": {
    boxSizing: "inherit"
  },
  ol: {
    listStyle: "none"
  },
  ul: {
    listStyle: "none"
  },
  menu: {
    listStyle: "none"
  },
  body: {
    margin: 0,
    padding: 0,
    fontFamily: "$primary",
    textStyles: "body",
    color: "$body"
  },
  "@font-face": [{
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "400",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "400",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-regular-italic.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "700",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "700",
    src: "url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-bold-italic.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "normal",
    fontWeight: "600",
    src: "local('proxima'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-semibold.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-semibold.woff2') format('woff2')"
  }, {
    fontFamily: "proxima",
    fontStyle: "italic",
    fontWeight: "600",
    src: "url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-condensed-semibold-italic.woff') format('woff'), url('https://s3.amazonaws.com/tide-assets/fonts/proxima-nova/proxima-nova-condensed-semibold-italic.woff2') format('woff2')"
  }]
};
const gray = {
  gray1: "#FEFEFE",
  gray2: "#F3F6F8",
  gray3: "#DFE4E8",
  gray4: "#BDC6CB",
  gray5: "#A3AEB5",
  gray6: "#939FA6",
  gray7: "#788790",
  gray8: "#606E78",
  gray9: "#505D67",
  gray10: "#424D54",
  gray11: "#353E43",
  gray12: "#1D2226"
};
const blue = {
  blue1: "#F3F8FE",
  blue2: "#DCECFE",
  blue3: "#BBDBFE",
  blue4: "#92C6FE",
  blue5: "#72AEF4",
  blue6: "#5196ED",
  blue7: "#2A7EEA",
  blue8: "#086BD5",
  blue9: "#105CAE",
  blue10: "#0E4D92",
  blue11: "#083F79",
  blue12: "#092A4F"
};
const red = {
  red1: "#FEEAEA",
  red2: "#FEDCD8",
  red3: "#FEBFB9",
  red4: "#FD9F97",
  red5: "#FB7C71",
  red6: "#F05B4D",
  red7: "#E5352A",
  red8: "#C7291B",
  red9: "#A32D22",
  red10: "#862A22",
  red11: "#6D231C",
  red12: "#431A16"
};
const green = {
  green1: "#F5FBF4",
  green2: "#E5F8E2",
  green3: "#B6F1AC",
  green4: "#78EB69",
  green5: "#4CC949",
  green6: "#24B232",
  green7: "#0F9C28",
  green8: "#0C8228",
  green9: "#0C7331",
  green10: "#0B6135",
  green11: "#184F32",
  green12: "#193726"
};
const yellow = {
  yellow1: "#FEFAED",
  yellow2: "#FEF3D2",
  yellow3: "#FEDF83",
  yellow4: "#FECC3A",
  yellow5: "#EAAD07",
  yellow6: "#D89708",
  yellow7: "#B2801D",
  yellow8: "#8E6923",
  yellow9: "#765923",
  yellow10: "#644D22",
  yellow11: "#52401F",
  yellow12: "#3C2F1A"
};
const teal = {
  teal1: "#F0FDFE",
  teal2: "#D4F2F6",
  teal3: "#AAE4EA",
  teal4: "#7AD1D9",
  teal5: "#5BB9C2",
  teal6: "#4BA1A9",
  teal7: "#448A90",
  teal8: "#3B767B",
  teal9: "#326368",
  teal10: "#2B5256",
  teal11: "#244345",
  teal12: "#1A2B2D"
};
const indigo = {
  indigo1: "#F9F9FC",
  indigo2: "#E9EBF8",
  indigo3: "#D6D9F6",
  indigo4: "#BEC1F9",
  indigo5: "#A5A8F6",
  indigo6: "#8C92E7",
  indigo7: "#757CD9",
  indigo8: "#6066CE",
  indigo9: "#4F54C6",
  indigo10: "#4441B7",
  indigo11: "#3C2FA6",
  indigo12: "#1F1C85"
};
const purple = {
  purple1: "#FBF9FC",
  purple2: "#F3E9F9",
  purple3: "#ECD3F9",
  purple4: "#E5B5FC",
  purple5: "#CF9EEA",
  purple6: "#B987D9",
  purple7: "#A471C9",
  purple8: "#8F59B8",
  purple9: "#8248AE",
  purple10: "#6F3C96",
  purple11: "#5A3577",
  purple12: "#3C284D"
};
const pink = {
  pink1: "#FBF6F9",
  pink2: "#F8E5F2",
  pink3: "#F7D1EA",
  pink4: "#EFB4D9",
  pink5: "#E199C4",
  pink6: "#D47EAF",
  pink7: "#C7649C",
  pink8: "#B94687",
  pink9: "#AE2F79",
  pink10: "#A00C69",
  pink11: "#801C56",
  pink12: "#541D3A"
};
const orange = {
  orange1: "#FAF7EC",
  orange2: "#F8ECCE",
  orange3: "#F7DFA9",
  orange4: "#F0BD6B",
  orange5: "#E6A152",
  orange6: "#D8863D",
  orange7: "#C66F2F",
  orange8: "#B25722",
  orange9: "#9D4C20",
  orange10: "#834320",
  orange11: "#6B391F",
  orange12: "#482A19"
};
const lime = {
  lime1: "#F5FDE8",
  lime2: "#E8FBB8",
  lime3: "#C6FD03",
  lime4: "#B4E324",
  lime5: "#99BE32",
  lime6: "#829F36",
  lime7: "#6D8435",
  lime8: "#617332",
  lime9: "#4F5E2E",
  lime10: "#47532B",
  lime11: "#394224",
  lime12: "#282E1C"
};
const cyan = {
  cyan1: "#D5FDFA",
  cyan2: "#80FEF9",
  cyan3: "#03F0F0",
  cyan4: "#04D8DD",
  cyan5: "#01BFCB",
  cyan6: "#12A6BF",
  cyan7: "#2A90A5",
  cyan8: "#317A8A",
  cyan9: "#326976",
  cyan10: "#2F5963",
  cyan11: "#2B4951",
  cyan12: "#223338"
};
var systemColors = {
  blue,
  gray,
  red,
  yellow,
  green,
  teal,
  pink,
  indigo,
  purple,
  orange,
  lime,
  cyan
};
var defaultTheme$1 = {
  prefix: "drift-dds",
  theme: {
    colors: {
      ...systemColors.gray,
      ...systemColors.blue,
      ...systemColors.red,
      ...systemColors.yellow,
      ...systemColors.green,
      ...systemColors.teal,
      ...systemColors.indigo,
      ...systemColors.orange,
      ...systemColors.purple,
      ...systemColors.pink,
      ...systemColors.lime,
      ...systemColors.cyan,
      black: "#000000",
      white: "#FFFFFF",
      success: "$green8",
      successHover: "$green9",
      successActive: "$green10",
      danger: "$red8",
      dangerHover: "$red9",
      dangerActive: "$red10",
      education: "$purple8",
      educationHover: "$purple9",
      educationActive: "$purple10",
      warning: "$yellow8",
      warningHover: "$yellow9",
      warningActive: "$yellow10",
      subtleLink: "$gray8",
      subtleLinkHover: "$gray9",
      subtleLinkActive: "$gray10",
      inlineLink: "$blue8",
      inlineLinkHover: "$blue9",
      inlineLinkActive: "$blue10",
      primaryButtonText: "$white",
      secondaryButtonText: "$gray12",
      tertiaryButtonText: "$gray12",
      navItem: "$gray12",
      navItemActive: "$blue8",
      inherit: "inherit",
      h1: "$gray12",
      h2: "$gray12",
      h3: "$gray12",
      h4: "$gray10",
      thead: "$gray10",
      metric: "$gray12",
      subtitle1: "$gray10",
      subtitle2: "$gray10",
      metadata: "$gray10",
      body: "$gray12",
      bodyBold: "$gray12"
    },
    fonts: {
      primary: "'proxima', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif"
    },
    sizes: {
      base: "8px",
      0: 0,
      half: "calc($base / 2)",
      1: "$base",
      2: "calc($base * 2)",
      3: "calc($base * 3)",
      4: "calc($base * 4)",
      5: "calc($base * 5)",
      6: "calc($base * 6)",
      7: "calc($base * 7)",
      8: "calc($base * 8)"
    },
    space: {
      base: "8px",
      0: 0,
      half: "calc($base / 2)",
      1: "$base",
      2: "calc($base * 2)",
      3: "calc($base * 3)",
      4: "calc($base * 4)",
      5: "calc($base * 5)",
      6: "calc($base * 6)",
      7: "calc($base * 7)",
      8: "calc($base * 8)"
    },
    fontSizes: {
      base: "14px",
      1: "0.857rem",
      2: "1rem",
      3: "1.143rem",
      4: "1.429rem",
      5: "1.714rem",
      6: "2.286rem",
      inherit: "inherit",
      h1: "1.714rem",
      h2: "1.429rem",
      h3: "1.143rem",
      h4: "0.857rem",
      thead: "0.857rem",
      subtitle1: "1.143rem",
      subtitle2: "1rem",
      bodyBold: "1rem",
      body: "1rem",
      button1: "1rem",
      button2: "0.857rem",
      metadata: "0.857rem",
      metric: "2.857rem"
    },
    fontWeights: {
      lightest: 400,
      light: 400,
      normal: 400,
      semibold: 600,
      bold: 700,
      boldest: 700,
      inherit: "inherit",
      h1: "$semibold",
      h2: "$normal",
      h3: "$semibold",
      h4: "$semibold",
      thead: "$semibold",
      subtitle1: "$normal",
      subtitle2: "$normal",
      bodyBold: "$semibold",
      body: "$normal",
      button1: "$semibold",
      button2: "$semibold",
      metadata: "$normal",
      metric: "$semibold"
    },
    lineHeights: {
      base: "14px",
      inherit: "inherit",
      h1: "2.571rem",
      h2: "2rem",
      h3: "1.714rem",
      h4: "1.143rem",
      thead: "1.143rem",
      subtitle1: "1.714rem",
      subtitle2: "1.429rem",
      bodyBold: "1.429rem",
      body: "1.429rem",
      button1: "1rem",
      button2: "1rem",
      metadata: "1.143rem",
      metric: "3.714rem"
    },
    letterSpacings: {
      base: "14px",
      inherit: "inherit",
      h1: "-0.011rem",
      h2: "-0.011rem",
      h3: "-0.011rem",
      h4: "0.023rem",
      thead: "0.023rem",
      subtitle1: "-0.011rem",
      subtitle2: "-0.011rem",
      bodyBold: "-0.011rem",
      body: "-0.011rem",
      button1: "-0.011rem",
      button2: "-0.011rem",
      metadata: "-0.011rem",
      metric: "-0.011rem"
    },
    radii: {
      1: "3px",
      2: "6px",
      3: "8px",
      4: "12px",
      round: "50%"
    },
    shadows: {
      none: "none",
      1: "0px 2px 4px rgba(96, 110, 120, 0.12), 0px 0px 8px rgba(96, 110, 120, 0.12)",
      2: "0px 0px 16px rgba(96, 110, 120, 0.12)",
      3: "0px 2px 4px rgba(96, 110, 120, 0.24), 0px 0px 24px rgba(96, 110, 120, 0.24)",
      raised08: "$1",
      container16: "$2",
      inflate24: "$3"
    },
    transitions: {
      transitionEaseInOut: "150ms cubic-bezier(0.4, 0, 0.2, 1) forwards",
      transitionEaseOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      transitionEaseIn: "cubic-bezier(0.4, 0, 1, 1)",
      transitionSharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    zIndices: {
      default: 800,
      nav: 1e3,
      appBar: 1050,
      drawer: 1100,
      modal: 1200,
      snackbar: 1300,
      menu: 1400,
      tooltip: 1500,
      toast: 1600,
      max: 5e3
    }
  },
  media: {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)",
    motion: "(prefers-reduced-motion)",
    hover: "(any-hover: hover)",
    dark: "(prefers-color-scheme: dark)",
    light: "(prefers-color-scheme: light)"
  },
  utils: {
    marginX: value => ({
      marginLeft: value,
      marginRight: value
    }),
    marginY: value => ({
      marginTop: value,
      marginBottom: value
    }),
    paddingY: value => ({
      paddingTop: value,
      paddingBottom: value
    }),
    paddingX: value => ({
      paddingLeft: value,
      paddingRight: value
    }),
    size: value => ({
      width: value,
      height: value
    }),
    textStyles: variant => ({
      fontFamily: "$primary",
      margin: 0,
      fontSize: `$${variant}`,
      fontWeight: `$${variant}`,
      lineHeight: `$${variant}`,
      letterSpacing: `$${variant}`
    }),
    textColor: variant => ({
      color: `$${variant}`
    }),
    clampLines: lineCount => ({
      "-webkit-line-clamp": `${lineCount}`,
      "-webkit-box-orient": "vertical",
      display: "-webkit-box",
      overflow: "hidden"
    })
  }
};
const {
  css: css$4,
  theme,
  config: config$1,
  styled,
  globalCss,
  getCssText,
  keyframes: keyframes$1
} = q$2(defaultTheme$1);
const applyGlobalStyles = globalCss(globalStyles);
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function (target, source) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s2 = 1; s2 < arguments.length; s2++) {
    from2 = Object(arguments[s2]);
    for (var key in from2) {
      if (hasOwnProperty$1.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from2, symbols[i])) {
          to[symbols[i]] = from2[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$2 = React__default,
  g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h$2 = Symbol.for;
  g$1 = h$2("react.element");
  reactJsxRuntime_production_min.Fragment = h$2("react.fragment");
}
var m$2 = f$2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  n$2 = Object.prototype.hasOwnProperty,
  p$3 = {
    key: true,
    ref: true,
    __self: true,
    __source: true
  };
function q$1(c2, a2, k2) {
  var b2,
    d2 = {},
    e2 = null,
    l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a2.key !== void 0 && (e2 = "" + a2.key);
  a2.ref !== void 0 && (l2 = a2.ref);
  for (b2 in a2) n$2.call(a2, b2) && !p$3.hasOwnProperty(b2) && (d2[b2] = a2[b2]);
  if (c2 && c2.defaultProps) for (b2 in a2 = c2.defaultProps, a2) d2[b2] === void 0 && (d2[b2] = a2[b2]);
  return {
    $$typeof: g$1,
    type: c2,
    key: e2,
    ref: l2,
    props: d2,
    _owner: m$2.current
  };
}
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const ThemeProvider = _ref11 => {
  let {
    children
  } = _ref11;
  applyGlobalStyles();
  return /* @__PURE__ */jsx$1(Fragment, {
    children
  });
};
const ServerThemeProvider = () => /* @__PURE__ */jsx$1("style", {
  id: "drift-dds",
  dangerouslySetInnerHTML: {
    __html: getCssText()
  }
});
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
  const Context = /* @__PURE__ */createContext$1(defaultContext);
  function Provider(props) {
    const {
      children,
      ...context
    } = props;
    const value = useMemo(() => context, Object.values(context));
    return /* @__PURE__ */createElement$1(Context.Provider, {
      value
    }, children);
  }
  function useContext$1(consumerName) {
    const context = useContext(Context);
    if (context) return context;
    if (defaultContext !== void 0) return defaultContext;
    throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
  }
  Provider.displayName = rootComponentName + "Provider";
  return [Provider, useContext$1];
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName) {
  let createContextScopeDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae11092(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */createContext$1(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider(props) {
      const {
        scope,
        children,
        ...context
      } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = useMemo(() => context, Object.values(context));
      return /* @__PURE__ */createElement$1(Context.Provider, {
        value
      }, children);
    }
    function useContext$1(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [Provider, useContext$1];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map(defaultContext => {
      return /* @__PURE__ */createContext$1(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return useMemo(() => ({
        [`__scope${scopeName}`]: {
          ...scope,
          [scopeName]: contexts
        }
      }), [scope, contexts]);
    };
  };
  createScope.scopeName = scopeName;
  return [$c512c27ab02ef895$export$fd42f52fd3ae11092, $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)];
}
function $c512c27ab02ef895$var$composeContextScopes() {
  for (var _len6 = arguments.length, scopes = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    scopes[_key6] = arguments[_key6];
  }
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(createScope => ({
      useScope: createScope(),
      scopeName: createScope.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, _ref12) => {
        let {
          useScope,
          scopeName
        } = _ref12;
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return useMemo(() => ({
        [`__scope${baseScope.scopeName}`]: nextScopes1
      }), [nextScopes1]);
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}
function $6ed0406888f73fc4$var$setRef$1(ref, value) {
  if (typeof ref === "function") ref(value);else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af$1() {
  for (var _len7 = arguments.length, refs = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    refs[_key7] = arguments[_key7];
  }
  return node2 => refs.forEach(ref => $6ed0406888f73fc4$var$setRef$1(ref, node2));
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05() {
  for (var _len8 = arguments.length, refs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    refs[_key8] = arguments[_key8];
  }
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af$1(...refs), refs);
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$6 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$6);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$6, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$6, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$6.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$6 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$6(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$6.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$6 = _ref13 => {
  let {
    children
  } = _ref13;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$6(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$6;
}
function $5e63c961fc1ce211$var$mergeProps$6(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = function () {
        childPropValue(...arguments);
        slotPropValue(...arguments);
      };else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */new Map()
  });
  const CollectionProvider = props => {
    const {
      scope,
      children
    } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef( /* @__PURE__ */new Map()).current;
    return /* @__PURE__ */React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children
    } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$6, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children,
      ...itemData
    } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$6, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort((a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current));
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
  let {
    checkForDefaultPrevented = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(() => function () {
    var _callbackRef$current;
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
  }, []);
}
function $71cd76cc60e0454e$export$6f32135080cb4c3(_ref14) {
  let {
    prop: prop3,
    defaultProp,
    onChange: onChange3 = () => {}
  } = _ref14;
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange: onChange3
  });
  const isControlled = prop3 !== void 0;
  const value1 = isControlled ? prop3 : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange3);
  const setValue = useCallback(nextValue => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop3) : nextValue;
      if (value !== prop3) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [isControlled, prop3, setUncontrolledProp, handleChange]);
  return [value1, setValue];
}
function $71cd76cc60e0454e$var$useUncontrolledState(_ref15) {
  let {
    defaultProp,
    onChange: onChange3
  } = _ref15;
  const uncontrolledState = useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange3);
  useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
const $8927f6f2acc4f386$var$NODES$5 = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$5 = $8927f6f2acc4f386$var$NODES$5.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$6 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
const $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? useLayoutEffect$1 : () => {};
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
  return useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}
const $921a889cee6df7e8$export$99c2b779aa4e8b8b = props => {
  const {
    present,
    children
  } = props;
  const presence = $921a889cee6df7e8$var$usePresence(present);
  const child = typeof children === "function" ? children({
    present: presence.isPresent
  }) : Children.only(children);
  const ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? /* @__PURE__ */cloneElement(child, {
    ref
  }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(present) {
  const [node1, setNode] = useState();
  const stylesRef = useRef({});
  const prevPresentRef = useRef(present);
  const prevAnimationNameRef = useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  useEffect(() => {
    const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const styles2 = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles2);
      if (present) send("MOUNT");else if (currentAnimationName === "none" || (styles2 === null || styles2 === void 0 ? void 0 : styles2.display) === "none") send("UNMOUNT");else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) send("ANIMATION_OUT");else send("UNMOUNT");
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (node1) {
      const handleAnimationEnd = event => {
        const currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node1 && isCurrentAnimation) flushSync(() => send("ANIMATION_END"));
      };
      const handleAnimationStart = event => {
        if (event.target === node1) prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
      };
      node1.addEventListener("animationstart", handleAnimationStart);
      node1.addEventListener("animationcancel", handleAnimationEnd);
      node1.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node1.removeEventListener("animationstart", handleAnimationStart);
        node1.removeEventListener("animationcancel", handleAnimationEnd);
        node1.removeEventListener("animationend", handleAnimationEnd);
      };
    } else send("ANIMATION_END");
  }, [node1, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: useCallback(node2 => {
      if (node2) stylesRef.current = getComputedStyle(node2);
      setNode(node2);
    }, [])
  };
}
function $921a889cee6df7e8$var$getAnimationName(styles2) {
  return (styles2 === null || styles2 === void 0 ? void 0 : styles2.animationName) || "none";
}
const $1746a345f3d73bb7$var$useReactId = React["useId".toString()] || (() => void 0);
let $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  const [id, setId] = React.useState($1746a345f3d73bb7$var$useReactId());
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (!deterministicId) setId(reactId => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}
const $409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
const [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($409067139f391064$var$COLLAPSIBLE_NAME);
const [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
const $409067139f391064$export$6eb0f7ddcda6131f = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeCollapsible,
    open: openProp,
    defaultOpen,
    disabled: disabled2,
    onOpenChange,
    ...collapsibleProps
  } = props;
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($409067139f391064$var$CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled: disabled2,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open: open2,
    onOpenToggle: useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen])
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$5.div, _extends$1({
    "data-state": $409067139f391064$var$getState(open2),
    "data-disabled": disabled2 ? "" : void 0
  }, collapsibleProps, {
    ref: forwardedRef
  })));
});
const $409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
const $409067139f391064$export$c135dce7b15bbbdc = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeCollapsible,
    ...triggerProps
  } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$5.button, _extends$1({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
});
const $409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
const $409067139f391064$export$aadde00976f34151 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    forceMount,
    ...contentProps
  } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, _ref16 => {
    let {
      present
    } = _ref16;
    return /* @__PURE__ */createElement$1($409067139f391064$var$CollapsibleContentImpl, _extends$1({}, contentProps, {
      ref: forwardedRef,
      present
    }));
  });
});
const $409067139f391064$var$CollapsibleContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeCollapsible,
    present,
    children,
    ...contentProps
  } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
  const [isPresent, setIsPresent] = useState(present);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const heightRef = useRef(0);
  const height = heightRef.current;
  const widthRef = useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = useRef(isOpen);
  const originalStylesRef = useRef();
  useEffect(() => {
    const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
    return () => cancelAnimationFrame(rAF);
  }, []);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const node2 = ref.current;
    if (node2) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node2.style.transitionDuration,
        animationName: node2.style.animationName
      };
      node2.style.transitionDuration = "0s";
      node2.style.animationName = "none";
      const rect = node2.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node2.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node2.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [context.open, present]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$5.div, _extends$1({
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps, {
    ref: composedRefs,
    style: {
      [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
      [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
      ...props.style
    }
  }), isOpen && children);
});
function $409067139f391064$var$getState(open2) {
  return open2 ? "open" : "closed";
}
const $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
const $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
const $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;
const $1bf158f521e1b1b4$var$ACCORDION_NAME = "Accordion";
const $1bf158f521e1b1b4$var$ACCORDION_KEYS = ["Home", "End", "ArrowDown", "ArrowUp"];
const [$1bf158f521e1b1b4$var$Collection, $1bf158f521e1b1b4$var$useCollection, $1bf158f521e1b1b4$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$2($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$createAccordionContext, $1bf158f521e1b1b4$export$9748edc328a73be1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($1bf158f521e1b1b4$var$ACCORDION_NAME, [$1bf158f521e1b1b4$var$createCollectionScope, $409067139f391064$export$952b32dcbe73087a]);
const $1bf158f521e1b1b4$var$useCollapsibleScope = $409067139f391064$export$952b32dcbe73087a();
const $1bf158f521e1b1b4$export$a766cd26d0d69044 = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    type: type3,
    ...accordionProps
  } = props;
  const singleProps = accordionProps;
  const multipleProps = accordionProps;
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$Collection.Provider, {
    scope: props.__scopeAccordion
  }, type3 === "multiple" ? /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionImplMultiple, _extends$1({}, multipleProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionImplSingle, _extends$1({}, singleProps, {
    ref: forwardedRef
  })));
});
$1bf158f521e1b1b4$export$a766cd26d0d69044.propTypes = {
  type(props) {
    const value = props.value || props.defaultValue;
    if (props.type && !["single", "multiple"].includes(props.type)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.");
    if (props.type === "multiple" && typeof value === "string") return new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.");
    if (props.type === "single" && Array.isArray(value)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.");
    return null;
  }
};
const [$1bf158f521e1b1b4$var$AccordionValueProvider, $1bf158f521e1b1b4$var$useAccordionValueContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const [$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, {
  collapsible: false
});
const $1bf158f521e1b1b4$var$AccordionImplSingle = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {},
    collapsible = false,
    ...accordionSingleProps
  } = props;
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value ? [value] : [],
    onItemOpen: setValue,
    onItemClose: React__default.useCallback(() => collapsible && setValue(""), [collapsible, setValue])
  }, /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible
  }, /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$1({}, accordionSingleProps, {
    ref: forwardedRef
  }))));
});
const $1bf158f521e1b1b4$var$AccordionImplMultiple = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {},
    ...accordionMultipleProps
  } = props;
  const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const handleItemOpen = React__default.useCallback(itemValue => setValue(function () {
    let prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return [...prevValue, itemValue];
  }), [setValue]);
  const handleItemClose = React__default.useCallback(itemValue => setValue(function () {
    let prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return prevValue.filter(value => value !== itemValue);
  }), [setValue]);
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value1,
    onItemOpen: handleItemOpen,
    onItemClose: handleItemClose
  }, /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible: true
  }, /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends$1({}, accordionMultipleProps, {
    ref: forwardedRef
  }))));
});
const [$1bf158f521e1b1b4$var$AccordionImplProvider, $1bf158f521e1b1b4$var$useAccordionContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
const $1bf158f521e1b1b4$var$AccordionImpl = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    __scopeAccordion,
    disabled: disabled2,
    ...accordionProps
  } = props;
  const accordionRef = React__default.useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(accordionRef, forwardedRef);
  const getItems = $1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
  const handleKeyDown = $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
    var _triggerCollection$cl;
    if (!$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
    const target = event.target;
    const triggerCollection = getItems().filter(item => {
      var _item$ref$current;
      return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
    });
    const triggerIndex = triggerCollection.findIndex(item => item.ref.current === target);
    const triggerCount = triggerCollection.length;
    if (triggerIndex === -1) return;
    event.preventDefault();
    let nextIndex = triggerIndex;
    switch (event.key) {
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = triggerCount - 1;
        break;
      case "ArrowDown":
        nextIndex = triggerIndex + 1;
        break;
      case "ArrowUp":
        nextIndex = triggerIndex - 1;
        if (nextIndex < 0) nextIndex = triggerCount - 1;
        break;
    }
    const clampedIndex = nextIndex % triggerCount;
    (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
  });
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionImplProvider, {
    scope: __scopeAccordion,
    disabled: disabled2
  }, /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$Collection.Slot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$5.div, _extends$1({}, accordionProps, {
    ref: composedRefs,
    onKeyDown: disabled2 ? void 0 : handleKeyDown
  }))));
});
const $1bf158f521e1b1b4$var$ITEM_NAME = "AccordionItem";
const [$1bf158f521e1b1b4$var$AccordionItemProvider, $1bf158f521e1b1b4$var$useAccordionItemContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME);
const $1bf158f521e1b1b4$export$d99097c13d4dac9f = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    __scopeAccordion,
    value,
    ...accordionItemProps
  } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const valueContext = $1bf158f521e1b1b4$var$useAccordionValueContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  const triggerId = $1746a345f3d73bb7$export$f680877a34711e37();
  const open1 = value && valueContext.value.includes(value) || false;
  const disabled2 = accordionContext.disabled || props.disabled;
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$AccordionItemProvider, {
    scope: __scopeAccordion,
    open: open1,
    disabled: disabled2,
    triggerId
  }, /* @__PURE__ */React__default.createElement($409067139f391064$export$be92b6f5f03c0fe9, _extends$1({
    "data-state": open1 ? "open" : "closed"
  }, collapsibleScope, accordionItemProps, {
    ref: forwardedRef,
    disabled: disabled2,
    open: open1,
    onOpenChange: open2 => {
      if (open2) valueContext.onItemOpen(value);else valueContext.onItemClose(value);
    }
  })));
});
const $1bf158f521e1b1b4$var$HEADER_NAME = "AccordionHeader";
const $1bf158f521e1b1b4$export$5e3e5deaaf81ee41 = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    __scopeAccordion,
    ...headerProps
  } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
  return /* @__PURE__ */React__default.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034$5.h3, _extends$1({
    "data-state": $1bf158f521e1b1b4$var$getState(itemContext.open),
    "data-disabled": itemContext.disabled ? "" : void 0
  }, headerProps, {
    ref: forwardedRef
  }));
});
const $1bf158f521e1b1b4$var$TRIGGER_NAME = "AccordionTrigger";
const $1bf158f521e1b1b4$export$94e939b1f85bdd73 = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    __scopeAccordion,
    ...triggerProps
  } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleContext = $1bf158f521e1b1b4$var$useAccordionCollapsibleContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */React__default.createElement($1bf158f521e1b1b4$var$Collection.ItemSlot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */React__default.createElement($409067139f391064$export$41fb9f06171c75f4, _extends$1({
    "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
    id: itemContext.triggerId
  }, collapsibleScope, triggerProps, {
    ref: forwardedRef
  })));
});
const $1bf158f521e1b1b4$var$CONTENT_NAME = "AccordionContent";
const $1bf158f521e1b1b4$export$985b9a77379b54a0 = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
  const {
    __scopeAccordion,
    ...contentProps
  } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */React__default.createElement($409067139f391064$export$7c6e2c02157bb7d2, _extends$1({
    role: "region",
    "aria-labelledby": itemContext.triggerId
  }, collapsibleScope, contentProps, {
    ref: forwardedRef,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...props.style
    }
  }));
});
function $1bf158f521e1b1b4$var$getState(open2) {
  return open2 ? "open" : "closed";
}
const $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 = $1bf158f521e1b1b4$export$a766cd26d0d69044;
const $1bf158f521e1b1b4$export$6d08773d2e66f8f2 = $1bf158f521e1b1b4$export$d99097c13d4dac9f;
const $1bf158f521e1b1b4$export$8b251419efc915eb = $1bf158f521e1b1b4$export$5e3e5deaaf81ee41;
const $1bf158f521e1b1b4$export$41fb9f06171c75f4 = $1bf158f521e1b1b4$export$94e939b1f85bdd73;
const $1bf158f521e1b1b4$export$7c6e2c02157bb7d2 = $1bf158f521e1b1b4$export$985b9a77379b54a0;
const TextTruncateVariant$1 = {
  true: {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    maxWidth: "100%"
  }
};
const TextGutterBottomVariant$1 = {
  half: {
    marginBottom: "$half"
  },
  0: {
    marginBottom: "$0"
  },
  1: {
    marginBottom: "$1"
  },
  2: {
    marginBottom: "$2"
  },
  3: {
    marginBottom: "$3"
  },
  4: {
    marginBottom: "$4"
  },
  5: {
    marginBottom: "$5"
  },
  6: {
    marginBottom: "$6"
  },
  7: {
    marginBottom: "$7"
  },
  8: {
    marginBottom: "$8"
  }
};
const TextTransformVariants = {
  truncate: TextTruncateVariant$1,
  gutterBottom: TextGutterBottomVariant$1
};
var HeaderVariantEnum = /* @__PURE__ */(HeaderVariantEnum2 => {
  HeaderVariantEnum2["H1"] = "h1";
  HeaderVariantEnum2["H2"] = "h2";
  HeaderVariantEnum2["H3"] = "h3";
  HeaderVariantEnum2["H4"] = "h4";
  HeaderVariantEnum2["METRIC"] = "metric";
  return HeaderVariantEnum2;
})(HeaderVariantEnum || {});
const HeaderVariant = {
  h1: {
    textStyles: "h1",
    textColor: "h1"
  },
  h2: {
    textStyles: "h2",
    textColor: "h2"
  },
  h3: {
    textStyles: "h3",
    textColor: "h3"
  },
  h4: {
    textStyles: "h4",
    textColor: "h4",
    textTransform: "uppercase"
  },
  metric: {
    textStyles: "metric",
    textColor: "metric"
  }
};
const StyledBase$5 = styled("h1", {
  margin: 0,
  variants: {
    variant: HeaderVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    variant: "h1"
  }
});
const HeaderTypeToElementMap = {
  metric: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4"
};
const Header = forwardRef((_ref17, forwardedRef) => {
  let {
    variant = "h1",
    isPrivate,
    as,
    children,
    rootProps,
    ...props
  } = _ref17;
  return /* @__PURE__ */jsx$1(StyledBase$5, {
    ref: forwardedRef,
    variant,
    as: as || HeaderTypeToElementMap[variant],
    "data-private": isPrivate,
    ...rootProps,
    ...props,
    children
  });
});
Header.displayName = "Header";
var TextVariantEnum = /* @__PURE__ */(TextVariantEnum2 => {
  TextVariantEnum2["SUBTITLE1"] = "subtitle1";
  TextVariantEnum2["SUBTITLE2"] = "subtitle2";
  TextVariantEnum2["BODY_BOLD"] = "bodyBold";
  TextVariantEnum2["BODY"] = "body";
  TextVariantEnum2["METADATA"] = "metadata";
  return TextVariantEnum2;
})(TextVariantEnum || {});
const TextVariant = {
  subtitle1: {
    textStyles: "subtitle1",
    textColor: "subtitle1"
  },
  subtitle2: {
    textStyles: "subtitle2",
    textColor: "subtitle2"
  },
  bodyBold: {
    textStyles: "bodyBold",
    textColor: "bodyBold"
  },
  body: {
    textStyles: "body",
    textColor: "body"
  },
  metadata: {
    textStyles: "metadata",
    textColor: "metadata"
  }
};
const TextTruncateVariant = {
  true: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflowWrap: "break-word",
    wordBreak: "break-all",
    maxWidth: "100%"
  }
};
const TextGutterBottomVariant = {
  half: {
    marginBottom: "$half"
  },
  0: {
    marginBottom: "$0"
  },
  1: {
    marginBottom: "$1"
  },
  2: {
    marginBottom: "$2"
  },
  3: {
    marginBottom: "$3"
  },
  4: {
    marginBottom: "$4"
  },
  5: {
    marginBottom: "$5"
  },
  6: {
    marginBottom: "$6"
  },
  7: {
    marginBottom: "$7"
  },
  8: {
    marginBottom: "$8"
  }
};
const StyledBase$4 = styled("p", {
  margin: 0,
  variants: {
    variant: TextVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    variant: "body",
    truncate: false
  }
});
const TextTypeToElementMap = {
  bodyBold: "p",
  body: "p",
  subtitle1: "p",
  subtitle2: "p",
  metadata: "span"
};
const Text = forwardRef((_ref18, forwardedRef) => {
  let {
    variant = "body",
    as,
    children,
    inline,
    isPrivate,
    rootProps,
    ...props
  } = _ref18;
  const elementType = as || inline ? "span" : TextTypeToElementMap[variant];
  return /* @__PURE__ */jsx$1(StyledBase$4, {
    ref: forwardedRef,
    variant,
    as: elementType,
    "data-private": isPrivate,
    ...rootProps,
    ...props,
    children
  });
});
Text.displayName = "Text";
function _isPlaceholder(a2) {
  return a2 != null && typeof a2 === "object" && a2["@@functional/placeholder"] === true;
}
function _curry1(fn) {
  return function f1(a2) {
    if (arguments.length === 0 || _isPlaceholder(a2)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}
function _curry2(fn) {
  return function f2(a2, b2) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a2) ? f2 : _curry1(function (_b) {
          return fn(a2, _b);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f2 : _isPlaceholder(a2) ? _curry1(function (_a) {
          return fn(_a, b2);
        }) : _isPlaceholder(b2) ? _curry1(function (_b) {
          return fn(a2, _b);
        }) : fn(a2, b2);
    }
  };
}
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];
  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
}
function _arity(n2, fn) {
  switch (n2) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function _curryN(length2, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length2;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length2, combined, fn));
  };
}
var curryN = /* @__PURE__ */_curry2(function curryN2(length2, fn) {
  if (length2 === 1) {
    return _curry1(fn);
  }
  return _arity(length2, _curryN(length2, [], fn));
});
var curryN$1 = curryN;
function _curry3(fn) {
  return function f3(a2, b2, c2) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a2) ? f3 : _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        });
      case 2:
        return _isPlaceholder(a2) && _isPlaceholder(b2) ? f3 : _isPlaceholder(a2) ? _curry2(function (_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) ? _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a2, b2, _c);
        });
      default:
        return _isPlaceholder(a2) && _isPlaceholder(b2) && _isPlaceholder(c2) ? f3 : _isPlaceholder(a2) && _isPlaceholder(b2) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c2);
        }) : _isPlaceholder(a2) && _isPlaceholder(c2) ? _curry2(function (_a, _c) {
          return fn(_a, b2, _c);
        }) : _isPlaceholder(b2) && _isPlaceholder(c2) ? _curry2(function (_b, _c) {
          return fn(a2, _b, _c);
        }) : _isPlaceholder(a2) ? _curry1(function (_a) {
          return fn(_a, b2, c2);
        }) : _isPlaceholder(b2) ? _curry1(function (_b) {
          return fn(a2, _b, c2);
        }) : _isPlaceholder(c2) ? _curry1(function (_c) {
          return fn(a2, b2, _c);
        }) : fn(a2, b2, c2);
    }
  };
}
var _isArray = Array.isArray || function _isArray2(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, xf, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}
var _xfBase = {
  init: function () {
    return this.xf["@@transducer/init"]();
  },
  result: function (result) {
    return this.xf["@@transducer/result"](result);
  }
};
function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}
function _isString(x2) {
  return Object.prototype.toString.call(x2) === "[object String]";
}
var _isArrayLike = /* @__PURE__ */_curry1(function isArrayLike(x2) {
  if (_isArray(x2)) {
    return true;
  }
  if (!x2) {
    return false;
  }
  if (typeof x2 !== "object") {
    return false;
  }
  if (_isString(x2)) {
    return false;
  }
  if (x2.nodeType === 1) {
    return !!x2.length;
  }
  if (x2.length === 0) {
    return true;
  }
  if (x2.length > 0) {
    return x2.hasOwnProperty(0) && x2.hasOwnProperty(x2.length - 1);
  }
  return false;
});
var _isArrayLike$1 = _isArrayLike;
var XWrap = /* @__PURE__ */function () {
  function XWrap2(fn) {
    this.f = fn;
  }
  XWrap2.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function (acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function (acc, x2) {
    return this.f(acc, x2);
  };
  return XWrap2;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}
var bind = /* @__PURE__ */_curry2(function bind2(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});
var bind$1 = bind;
function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind$1(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn, acc, list) {
  if (typeof fn === "function") {
    fn = _xwrap(fn);
  }
  if (_isArrayLike$1(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list["fantasy-land/reduce"] === "function") {
    return _methodReduce(fn, acc, list, "fantasy-land/reduce");
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === "function") {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === "function") {
    return _methodReduce(fn, acc, list, "reduce");
  }
  throw new TypeError("reduce: list must be array or iterable");
}
var XMap = /* @__PURE__ */function () {
  function XMap2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function (result, input) {
    return this.xf["@@transducer/step"](result, this.f(input));
  };
  return XMap2;
}();
var _xmap = /* @__PURE__ */_curry2(function _xmap2(f2, xf) {
  return new XMap(f2, xf);
});
var _xmap$1 = _xmap;
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
var toString$3 = Object.prototype.toString;
var _isArguments = /* @__PURE__ */function () {
  return toString$3.call(arguments) === "[object Arguments]" ? function _isArguments2(x2) {
    return toString$3.call(x2) === "[object Arguments]";
  } : function _isArguments2(x2) {
    return _has("callee", x2);
  };
}();
var _isArguments$1 = _isArguments;
var hasEnumBug = ! /* @__PURE__ */{
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = /* @__PURE__ */function () {
  return arguments.propertyIsEnumerable("length");
}();
var contains$1 = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /* @__PURE__ */_curry1(function keys2(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /* @__PURE__ */_curry1(function keys3(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments$1(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains$1(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var keys$1 = keys;
var map = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["fantasy-land/map", "map"], _xmap$1, function map2(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case "[object Function]":
      return curryN$1(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case "[object Object]":
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys$1(functor));
    default:
      return _map(fn, functor);
  }
}));
var map$1 = map;
var _isInteger = Number.isInteger || function _isInteger2(n2) {
  return n2 << 0 === n2;
};
var nth = /* @__PURE__ */_curry2(function nth2(offset2, list) {
  var idx = offset2 < 0 ? list.length + offset2 : offset2;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth$1 = nth;
var paths = /* @__PURE__ */_curry2(function paths2(pathsArray, obj) {
  return pathsArray.map(function (paths3) {
    var val = obj;
    var idx = 0;
    var p2;
    while (idx < paths3.length) {
      if (val == null) {
        return;
      }
      p2 = paths3[idx];
      val = _isInteger(p2) ? nth$1(p2, val) : val[p2];
      idx += 1;
    }
    return val;
  });
});
var paths$1 = paths;
var path = /* @__PURE__ */_curry2(function path2(pathAr, obj) {
  return paths$1([pathAr], obj)[0];
});
var path$1 = path;
var prop = /* @__PURE__ */_curry2(function prop2(p2, obj) {
  return path$1([p2], obj);
});
var prop$1 = prop;
var append$1 = /* @__PURE__ */_curry2(function append(el, list) {
  return _concat(list, [el]);
});
var append$2 = append$1;
var isNil = /* @__PURE__ */_curry1(function isNil2(x2) {
  return x2 == null;
});
var isNil$1 = isNil;
var curry = /* @__PURE__ */_curry1(function curry2(fn) {
  return curryN$1(fn.length, fn);
});
var curry$1 = curry;
function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;
    while (idx < ilen) {
      if (_isArrayLike$1(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
}
function _forceReduced(x2) {
  return {
    "@@transducer/value": x2,
    "@@transducer/reduced": true
  };
}
var preservingReduced = function (xf) {
  return {
    "@@transducer/init": _xfBase.init,
    "@@transducer/result": function (result) {
      return xf["@@transducer/result"](result);
    },
    "@@transducer/step": function (result, input) {
      var ret = xf["@@transducer/step"](result, input);
      return ret["@@transducer/reduced"] ? _forceReduced(ret) : ret;
    }
  };
};
var _flatCat = function _xcat(xf) {
  var rxf = preservingReduced(xf);
  return {
    "@@transducer/init": _xfBase.init,
    "@@transducer/result": function (result) {
      return rxf["@@transducer/result"](result);
    },
    "@@transducer/step": function (result, input) {
      return !_isArrayLike$1(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
    }
  };
};
var _flatCat$1 = _flatCat;
var _xchain = /* @__PURE__ */_curry2(function _xchain2(f2, xf) {
  return map$1(f2, _flatCat$1(xf));
});
var _xchain$1 = _xchain;
var chain = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["fantasy-land/chain", "chain"], _xchain$1, function chain2(fn, monad) {
  if (typeof monad === "function") {
    return function (x2) {
      return fn(monad(x2))(x2);
    };
  }
  return _makeFlat(false)(map$1(fn, monad));
}));
var chain$1 = chain;
var type = /* @__PURE__ */_curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var type$1 = type;
function _checkForMethod(methodname, fn) {
  return function () {
    var length2 = arguments.length;
    if (length2 === 0) {
      return fn();
    }
    var obj = arguments[length2 - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length2 - 1));
  };
}
var slice$1 = /* @__PURE__ */_curry3( /* @__PURE__ */_checkForMethod("slice", function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var slice$2 = slice$1;
function _identity(x2) {
  return x2;
}
var identity = /* @__PURE__ */_curry1(_identity);
var identity$1 = identity;
function _arrayFromIterator(iter) {
  var list = [];
  var next2;
  while (!(next2 = iter.next()).done) {
    list.push(next2.value);
  }
  return list;
}
function _includesWith(pred, x2, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x2, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f2) {
  var match2 = String(f2).match(/^function (\w*)/);
  return match2 == null ? "" : match2[1];
}
function _objectIs(a2, b2) {
  if (a2 === b2) {
    return a2 !== 0 || 1 / a2 === 1 / b2;
  } else {
    return a2 !== a2 && b2 !== b2;
  }
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a2 = _arrayFromIterator(aIterator);
  var b2 = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function (b3, aItem) {
    return !_includesWith(eq, aItem, b3);
  }, b2, a2);
}
function _equals(a2, b2, stackA, stackB) {
  if (_objectIs$1(a2, b2)) {
    return true;
  }
  var typeA = type$1(a2);
  if (typeA !== type$1(b2)) {
    return false;
  }
  if (a2 == null || b2 == null) {
    return false;
  }
  if (typeof a2["fantasy-land/equals"] === "function" || typeof b2["fantasy-land/equals"] === "function") {
    return typeof a2["fantasy-land/equals"] === "function" && a2["fantasy-land/equals"](b2) && typeof b2["fantasy-land/equals"] === "function" && b2["fantasy-land/equals"](a2);
  }
  if (typeof a2.equals === "function" || typeof b2.equals === "function") {
    return typeof a2.equals === "function" && a2.equals(b2) && typeof b2.equals === "function" && b2.equals(a2);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a2.constructor === "function" && _functionName(a2.constructor) === "Promise") {
        return a2 === b2;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a2 === typeof b2 && _objectIs$1(a2.valueOf(), b2.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a2.valueOf(), b2.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a2.name === b2.name && a2.message === b2.message;
    case "RegExp":
      if (!(a2.source === b2.source && a2.global === b2.global && a2.ignoreCase === b2.ignoreCase && a2.multiline === b2.multiline && a2.sticky === b2.sticky && a2.unicode === b2.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a2) {
      return stackB[idx] === b2;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.entries(), b2.entries(), stackA.concat([a2]), stackB.concat([b2]));
    case "Set":
      if (a2.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a2.values(), b2.values(), stackA.concat([a2]), stackB.concat([b2]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys$1(a2);
  if (keysA.length !== keys$1(b2).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a2]);
  var extendedStackB = stackB.concat([b2]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b2) && _equals(b2[key], a2[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals$1 = /* @__PURE__ */_curry2(function equals(a2, b2) {
  return _equals(a2, b2, [], []);
});
var equals$2 = equals$1;
function _indexOf(list, a2, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a2) {
      case "number":
        if (a2 === 0) {
          inf = 1 / a2;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a2 !== a2) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a2, idx);
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a2, idx);
      case "object":
        if (a2 === null) {
          return list.indexOf(a2, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals$2(list[idx], a2)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}
function _includes(a2, list) {
  return _indexOf(list, a2, 0) >= 0;
}
function _quote(s2) {
  var escaped = s2.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
var pad = function pad2(n2) {
  return (n2 < 10 ? "0" : "") + n2;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString2(d2) {
  return d2.toISOString();
} : function _toISOString3(d2) {
  return d2.getUTCFullYear() + "-" + pad(d2.getUTCMonth() + 1) + "-" + pad(d2.getUTCDate()) + "T" + pad(d2.getUTCHours()) + ":" + pad(d2.getUTCMinutes()) + ":" + pad(d2.getUTCSeconds()) + "." + (d2.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
var _toISOString$1 = _toISOString;
function _complement(f2) {
  return function () {
    return !f2.apply(this, arguments);
  };
}
function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}
function _isObject(x2) {
  return Object.prototype.toString.call(x2) === "[object Object]";
}
var XFilter = /* @__PURE__ */function () {
  function XFilter2(f2, xf) {
    this.xf = xf;
    this.f = f2;
  }
  XFilter2.prototype["@@transducer/init"] = _xfBase.init;
  XFilter2.prototype["@@transducer/result"] = _xfBase.result;
  XFilter2.prototype["@@transducer/step"] = function (result, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
  };
  return XFilter2;
}();
var _xfilter = /* @__PURE__ */_curry2(function _xfilter2(f2, xf) {
  return new XFilter(f2, xf);
});
var _xfilter$1 = _xfilter;
var filter = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["filter"], _xfilter$1, function (pred, filterable) {
  return _isObject(filterable) ? _reduce(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }
    return acc;
  }, {}, keys$1(filterable)) : _filter(pred, filterable);
}));
var filter$1 = filter;
var reject = /* @__PURE__ */_curry2(function reject2(pred, filterable) {
  return filter$1(_complement(pred), filterable);
});
var reject$1 = reject;
function _toString(x2, seen) {
  var recur = function recur2(y2) {
    var xs = seen.concat([x2]);
    return _includes(y2, xs) ? "<Circular>" : _toString(y2, xs);
  };
  var mapPairs = function (obj, keys4) {
    return _map(function (k2) {
      return _quote(k2) + ": " + recur(obj[k2]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x2)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + _map(recur, x2).join(", ") + "))";
    case "[object Array]":
      return "[" + _map(recur, x2).concat(mapPairs(x2, reject$1(function (k2) {
        return /^\d+$/.test(k2);
      }, keys$1(x2)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof x2 === "object" ? "new Boolean(" + recur(x2.valueOf()) + ")" : x2.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(x2.valueOf()) ? recur(NaN) : _quote(_toISOString$1(x2))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x2 === "object" ? "new Number(" + recur(x2.valueOf()) + ")" : 1 / x2 === -Infinity ? "-0" : x2.toString(10);
    case "[object String]":
      return typeof x2 === "object" ? "new String(" + recur(x2.valueOf()) + ")" : _quote(x2);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x2.toString === "function") {
        var repr = x2.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x2, keys$1(x2)).join(", ") + "}";
  }
}
var toString$1 = /* @__PURE__ */_curry1(function toString(val) {
  return _toString(val, []);
});
var toString$2 = toString$1;
var _Set = /* @__PURE__ */function () {
  function _Set2() {
    this._nativeSet = typeof Set === "function" ? /* @__PURE__ */new Set() : null;
    this._items = {};
  }
  _Set2.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
  };
  _Set2.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
  };
  return _Set2;
}();
function hasOrAdd(item, shouldAdd, set) {
  var type3 = typeof item;
  var prevSize, newSize;
  switch (type3) {
    case "string":
    case "number":
      if (item === 0 && 1 / item === -Infinity) {
        if (set._items["-0"]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items["-0"] = true;
          }
          return false;
        }
      }
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set._items)) {
          if (shouldAdd) {
            set._items[type3] = {};
            set._items[type3][item] = true;
          }
          return false;
        } else if (item in set._items[type3]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type3][item] = true;
          }
          return false;
        }
      }
    case "boolean":
      if (type3 in set._items) {
        var bIdx = item ? 1 : 0;
        if (set._items[type3][bIdx]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type3][bIdx] = true;
          }
          return false;
        }
      } else {
        if (shouldAdd) {
          set._items[type3] = item ? [false, true] : [true, false];
        }
        return false;
      }
    case "function":
      if (set._nativeSet !== null) {
        if (shouldAdd) {
          prevSize = set._nativeSet.size;
          set._nativeSet.add(item);
          newSize = set._nativeSet.size;
          return newSize === prevSize;
        } else {
          return set._nativeSet.has(item);
        }
      } else {
        if (!(type3 in set._items)) {
          if (shouldAdd) {
            set._items[type3] = [item];
          }
          return false;
        }
        if (!_includes(item, set._items[type3])) {
          if (shouldAdd) {
            set._items[type3].push(item);
          }
          return false;
        }
        return true;
      }
    case "undefined":
      if (set._items[type3]) {
        return true;
      } else {
        if (shouldAdd) {
          set._items[type3] = true;
        }
        return false;
      }
    case "object":
      if (item === null) {
        if (!set._items["null"]) {
          if (shouldAdd) {
            set._items["null"] = true;
          }
          return false;
        }
        return true;
      }
    default:
      type3 = Object.prototype.toString.call(item);
      if (!(type3 in set._items)) {
        if (shouldAdd) {
          set._items[type3] = [item];
        }
        return false;
      }
      if (!_includes(item, set._items[type3])) {
        if (shouldAdd) {
          set._items[type3].push(item);
        }
        return false;
      }
      return true;
  }
}
var _Set$1 = _Set;
var XDrop = /* @__PURE__ */function () {
  function XDrop2(n2, xf) {
    this.xf = xf;
    this.n = n2;
  }
  XDrop2.prototype["@@transducer/init"] = _xfBase.init;
  XDrop2.prototype["@@transducer/result"] = _xfBase.result;
  XDrop2.prototype["@@transducer/step"] = function (result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf["@@transducer/step"](result, input);
  };
  return XDrop2;
}();
var _xdrop = /* @__PURE__ */_curry2(function _xdrop2(n2, xf) {
  return new XDrop(n2, xf);
});
var _xdrop$1 = _xdrop;
var drop = /* @__PURE__ */_curry2( /* @__PURE__ */_dispatchable(["drop"], _xdrop$1, function drop2(n2, xs) {
  return slice$2(Math.max(0, n2), Infinity, xs);
}));
var drop$1 = drop;
var empty = /* @__PURE__ */_curry1(function empty2(x2) {
  return x2 != null && typeof x2["fantasy-land/empty"] === "function" ? x2["fantasy-land/empty"]() : x2 != null && x2.constructor != null && typeof x2.constructor["fantasy-land/empty"] === "function" ? x2.constructor["fantasy-land/empty"]() : x2 != null && typeof x2.empty === "function" ? x2.empty() : x2 != null && x2.constructor != null && typeof x2.constructor.empty === "function" ? x2.constructor.empty() : _isArray(x2) ? [] : _isString(x2) ? "" : _isObject(x2) ? {} : _isArguments$1(x2) ? function () {
    return arguments;
  }() : void 0;
});
var empty$1 = empty;
var takeLast = /* @__PURE__ */_curry2(function takeLast2(n2, xs) {
  return drop$1(n2 >= 0 ? xs.length - n2 : 0, xs);
});
var takeLast$1 = takeLast;
var flip$1 = /* @__PURE__ */_curry1(function flip(fn) {
  return curryN$1(fn.length, function (a2, b2) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b2;
    args[1] = a2;
    return fn.apply(this, args);
  });
});
var flip$2 = flip$1;
var uniqBy = /* @__PURE__ */_curry2(function uniqBy2(fn, list) {
  var set = new _Set$1();
  var result = [];
  var idx = 0;
  var appliedItem, item;
  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});
var uniqBy$1 = uniqBy;
var uniq = /* @__PURE__ */uniqBy$1(identity$1);
var uniq$1 = uniq;
function _objectAssign(target) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }
  var output = Object(target);
  var idx = 1;
  var length2 = arguments.length;
  while (idx < length2) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
}
var _objectAssign$1 = typeof Object.assign === "function" ? Object.assign : _objectAssign;
var is = /* @__PURE__ */_curry2(function is2(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});
var is$1 = is;
var isEmpty = /* @__PURE__ */_curry1(function isEmpty2(x2) {
  return x2 != null && equals$2(x2, empty$1(x2));
});
var isEmpty$1 = isEmpty;
var memoizeWith = /* @__PURE__ */_curry2(function memoizeWith2(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function () {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});
var memoizeWith$1 = memoizeWith;
var mergeWithKey = /* @__PURE__ */_curry3(function mergeWithKey2(fn, l2, r2) {
  var result = {};
  var k2;
  for (k2 in l2) {
    if (_has(k2, l2)) {
      result[k2] = _has(k2, r2) ? fn(k2, l2[k2], r2[k2]) : l2[k2];
    }
  }
  for (k2 in r2) {
    if (_has(k2, r2) && !_has(k2, result)) {
      result[k2] = r2[k2];
    }
  }
  return result;
});
var mergeWithKey$1 = mergeWithKey;
var mergeDeepWithKey = /* @__PURE__ */_curry3(function mergeDeepWithKey2(fn, lObj, rObj) {
  return mergeWithKey$1(function (k2, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey2(fn, lVal, rVal);
    } else {
      return fn(k2, lVal, rVal);
    }
  }, lObj, rObj);
});
var mergeDeepWithKey$1 = mergeDeepWithKey;
var mergeDeepRight = /* @__PURE__ */_curry2(function mergeDeepRight2(lObj, rObj) {
  return mergeDeepWithKey$1(function (k2, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});
var mergeDeepRight$1 = mergeDeepRight;
var mergeRight = /* @__PURE__ */_curry2(function mergeRight2(l2, r2) {
  return _objectAssign$1({}, l2, r2);
});
var mergeRight$1 = mergeRight;
var without = /* @__PURE__ */_curry2(function (xs, list) {
  return reject$1(flip$2(_includes)(xs), list);
});
var without$1 = without;
var zipObj = /* @__PURE__ */_curry2(function zipObj2(keys4, values) {
  var idx = 0;
  var len = Math.min(keys4.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys4[idx]] = values[idx];
    idx += 1;
  }
  return out;
});
var zipObj$1 = zipObj;
const pause = async ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
const delay = async (fn, ms) => {
  await pause(ms);
  await fn();
};
curry$1(list => chain$1(zipObj$1, map$1(prop$1("id")))(list));
const error = e2 => {
  const error2 = e2 instanceof Error ? e2 : new Error(e2);
  const errorHandler = err => {
    {
      throw err;
    }
  };
  errorHandler(error2);
};
memoizeWith$1(toString$2, (selected, all) => uniq$1([...selected, ...all]));
const isNilOrEmpty = value => isNil$1(value) || isEmpty$1(value);
const createComponentContext = (rootComponentName, defaultContext) => {
  const Context = createContext$1(defaultContext);
  function Provider(props) {
    const {
      children,
      ...context
    } = props;
    const value = useMemo(() => context, Object.values(context));
    return /* @__PURE__ */jsx$1(Context.Provider, {
      value,
      children
    });
  }
  const useContext$1 = consumerName => {
    const context = useContext(Context);
    if (context) {
      return context;
    }
    if (defaultContext !== void 0) {
      return defaultContext;
    }
    error(`\`${consumerName != null ? consumerName : "this component"}\` must be used within \`${rootComponentName}\``);
    return {};
  };
  Provider.displayName = `${rootComponentName}Provider`;
  return [Provider, useContext$1];
};
var faChevronRight$3 = {};
Object.defineProperty(faChevronRight$3, "__esModule", {
  value: true
});
var faChevronRight_2$1 = faChevronRight$3.faChevronRight = void 0;
const faChevronRight$2 = {
  prefix: "fal",
  iconName: "faChevronRight",
  icon: [320, 512, [], "", "M85.14 475.8c-3.438-3.141-5.156-7.438-5.156-11.75c0-3.891 1.406-7.781 4.25-10.86l181.1-197.1L84.23 58.86c-6-6.5-5.625-16.64 .9062-22.61c6.5-6 16.59-5.594 22.59 .8906l192 208c5.688 6.156 5.688 15.56 0 21.72l-192 208C101.7 481.3 91.64 481.8 85.14 475.8z"]
};
faChevronRight_2$1 = faChevronRight$3.faChevronRight = faChevronRight$2;
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$2(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
    return typeof obj2;
  } : function (obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1();
}
function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2();
}
function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o2, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop$1 = function noop() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop$1,
  measure: noop$1
};
try {
  if (typeof window !== "undefined") _WINDOW = window;
  if (typeof document !== "undefined") _DOCUMENT = document;
  if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== "undefined") _PERFORMANCE = performance;
} catch (e2) {}
var _ref$1 = _WINDOW.navigator || {},
  _ref$userAgent = _ref$1.userAgent,
  userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"];
var PRODUCTION$1 = function () {
  try {
    return true;
  } catch (e2) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  "fas": "solid",
  "fa-solid": "solid",
  "far": "regular",
  "fa-regular": "regular",
  "fal": "light",
  "fa-light": "light",
  "fat": "thin",
  "fa-thin": "thin",
  "fad": "duotone",
  "fa-duotone": "duotone",
  "fab": "brands",
  "fa-brands": "brands",
  "fak": "kit",
  "fa-kit": "kit",
  "fa": "solid"
};
var STYLE_TO_PREFIX = {
  "solid": "fas",
  "regular": "far",
  "light": "fal",
  "thin": "fat",
  "duotone": "fad",
  "brands": "fab",
  "kit": "fak"
};
var PREFIX_TO_LONG_STYLE = {
  "fab": "fa-brands",
  "fad": "fa-duotone",
  "fak": "fa-kit",
  "fal": "fa-light",
  "far": "fa-regular",
  "fas": "fa-solid",
  "fat": "fa-thin"
};
var LONG_STYLE_TO_PREFIX = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/;
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = {
  "900": "fas",
  "400": "far",
  "normal": "far",
  "300": "fal",
  "100": "fat"
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"];
var DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
var RESERVED_CLASSES = [].concat(_toConsumableArray$2(Object.keys(STYLE_TO_PREFIX)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n2) {
  return "".concat(n2, "x");
})).concat(oneToTwenty.map(function (n2) {
  return "w-".concat(n2);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector("script[" + attr + "]");
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  if (val === "") return true;
  if (val === "false") return false;
  if (val === "true") return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function (_ref3) {
    var _ref22 = _slicedToArray$1(_ref3, 2),
      attr = _ref22[0],
      key = _ref22[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== void 0 && val !== null) {
      initial[key] = val;
    }
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: "solid",
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
var _config = _objectSpread2$2(_objectSpread2$2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function (key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set(val) {
      _config[key] = val;
      _onChangeCb.forEach(function (cb) {
        return cb(config);
      });
    },
    get: function get() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);
  return function () {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}
var d$1 = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css4) {
  if (!css4 || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css4;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || "").toUpperCase();
    if (["STYLE", "LINK"].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css4;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  var size = 12;
  var id = "";
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function toArray(obj) {
  var array = [];
  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }
  return array;
}
function classArray(node2) {
  if (node2.classList) {
    return toArray(node2.classList);
  } else {
    return (node2.getAttribute("class") || "").split(" ").filter(function (i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
  }, "").trim();
}
function joinStyles(styles2) {
  return Object.keys(styles2 || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles2[styleName].trim(), ";");
  }, "");
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref3) {
  var transform = _ref3.transform,
    containerWidth = _ref3.containerWidth,
    iconWidth = _ref3.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path3 = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path: path3
  };
}
function transformForCss(_ref22) {
  var transform = _ref22.transform,
    _ref2$width = _ref22.width,
    width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width,
    _ref2$height = _ref22.height,
    height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height,
    _ref2$startCentered = _ref22.startCentered,
    startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = "";
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d$1 - width / 2, "em, ").concat(transform.y / d$1 - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d$1, "em), calc(-50% + ").concat(transform.y / d$1, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d$1, "em, ").concat(transform.y / d$1, "em) ");
  }
  val += "scale(".concat(transform.size / d$1 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d$1 * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css$3() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s2 = baseStyles;
  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
    var rPatt = new RegExp("\\.".concat(drc), "g");
    s2 = s2.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s2;
}
var _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css$3());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css: css$3,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};
var w$2 = WINDOW || {};
if (!w$2[NAMESPACE_IDENTIFIER]) w$2[NAMESPACE_IDENTIFIER] = {};
if (!w$2[NAMESPACE_IDENTIFIER].styles) w$2[NAMESPACE_IDENTIFIER].styles = {};
if (!w$2[NAMESPACE_IDENTIFIER].hooks) w$2[NAMESPACE_IDENTIFIER].hooks = {};
if (!w$2[NAMESPACE_IDENTIFIER].shims) w$2[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w$2[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
    _abstractNodes$attrib = abstractNodes.attributes,
    attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
    _abstractNodes$childr = abstractNodes.children,
    children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === "string") {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
  }
}
function iconFromMapping(mapping, prefix2, iconName) {
  if (mapping && mapping[prefix2] && mapping[prefix2][iconName]) {
    return {
      prefix: prefix2,
      iconName,
      icon: mapping[prefix2][iconName]
    };
  }
}
var bindInternal4 = function bindInternal42(func, thisContext) {
  return function (a2, b2, c2, d2) {
    return func.call(thisContext, a2, b2, c2, d2);
  };
};
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys4 = Object.keys(subject),
    length2 = keys4.length,
    iterator = thisContext !== void 0 ? bindInternal4(fn, thisContext) : fn,
    i,
    key,
    result;
  if (initialValue === void 0) {
    i = 1;
    result = subject[keys4[0]];
  } else {
    i = 0;
    result = initialValue;
  }
  for (; i < length2; i++) {
    key = keys4[i];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};
function ucs2decode(string) {
  var output = [];
  var counter = 0;
  var length2 = string.length;
  while (counter < length2) {
    var value = string.charCodeAt(counter++);
    if (value >= 55296 && value <= 56319 && counter < length2) {
      var extra = string.charCodeAt(counter++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index2) {
  var size = string.length;
  var first = string.charCodeAt(index2);
  var second;
  if (first >= 55296 && first <= 56319 && size > index2 + 1) {
    second = string.charCodeAt(index2 + 1);
    if (second >= 56320 && second <= 57343) {
      return (first - 55296) * 1024 + second - 56320 + 65536;
    }
  }
  return first;
}
function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function (acc, iconName) {
    var icon3 = icons[iconName];
    var expanded = !!icon3.icon;
    if (expanded) {
      acc[icon3.iconName] = icon3.icon;
    } else {
      acc[iconName] = icon3;
    }
    return acc;
  }, {});
}
function defineIcons(prefix2, icons) {
  var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
    skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
    namespace.hooks.addPack(prefix2, normalizeIcons(icons));
  } else {
    namespace.styles[prefix2] = _objectSpread2$2(_objectSpread2$2({}, namespace.styles[prefix2] || {}), normalized);
  }
  if (prefix2 === "fas") {
    defineIcons("fa", icons);
  }
}
var styles = namespace.styles,
  shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(familyPrefix, cls) {
  var parts = cls.split("-");
  var prefix2 = parts[0];
  var iconName = parts.slice(1).join("-");
  if (prefix2 === familyPrefix && iconName !== "" && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build2() {
  var lookup = function lookup2(reducer) {
    return reduce(styles, function (o2, style, prefix2) {
      o2[prefix2] = reduce(style, reducer, {});
      return o2;
    }, {});
  };
  _byUnicode = lookup(function (acc, icon3, iconName) {
    if (icon3[3]) {
      acc[icon3[3]] = iconName;
    }
    if (icon3[2]) {
      var aliases = icon3[2].filter(function (a2) {
        return typeof a2 === "number";
      });
      aliases.forEach(function (alias) {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup(function (acc, icon3, iconName) {
    acc[iconName] = iconName;
    if (icon3[2]) {
      var aliases = icon3[2].filter(function (a2) {
        return typeof a2 === "string";
      });
      aliases.forEach(function (alias) {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup(function (acc, icon3, iconName) {
    var aliases = icon3[2];
    acc[iconName] = iconName;
    aliases.forEach(function (alias) {
      acc[alias] = iconName;
    });
    return acc;
  });
  var hasRegular = "far" in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function (acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix2 = shim[1];
    var iconName = shim[2];
    if (prefix2 === "far" && !hasRegular) {
      prefix2 = "fas";
    }
    if (typeof maybeNameMaybeUnicode === "string") {
      acc.names[maybeNameMaybeUnicode] = {
        prefix: prefix2,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === "number") {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix: prefix2,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function (c2) {
  _defaultUsablePrefix = getCanonicalPrefix(c2.styleDefault);
});
build();
function byUnicode(prefix2, unicode) {
  return (_byUnicode[prefix2] || {})[unicode];
}
function byLigature(prefix2, ligature) {
  return (_byLigature[prefix2] || {})[ligature];
}
function byAlias(prefix2, alias) {
  return (_byAlias[prefix2] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode("fas", unicode);
  return oldUnicode || (newUnicode ? {
    prefix: "fas",
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon2() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix2 = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix2 || defined || null;
}
function getCanonicalIcon(values) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups,
    skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);
    if (styles[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }
    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);
      if (shim.prefix) {
        givenPrefix = null;
      }
      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;
      if (acc.prefix === "far" && !styles["far"] && styles["fas"] && !config.autoFetchSvg) {
        acc.prefix = "fas";
      }
    }
    return acc;
  }, emptyCanonicalIcon());
  if (canonical.prefix === "fa" || givenPrefix === "fa") {
    canonical.prefix = getDefaultUsablePrefix() || "fas";
  }
  return canonical;
}
var Library = /* @__PURE__ */function () {
  function Library2() {
    _classCallCheck$1(this, Library2);
    this.definitions = {};
  }
  _createClass$1(Library2, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread2$2(_objectSpread2$2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
          prefix2 = _normalized$key.prefix,
          iconName = _normalized$key.iconName,
          icon3 = _normalized$key.icon;
        var aliases = icon3[2];
        if (!additions[prefix2]) additions[prefix2] = {};
        if (aliases.length > 0) {
          aliases.forEach(function (alias) {
            if (typeof alias === "string") {
              additions[prefix2][alias] = icon3;
            }
          });
        }
        additions[prefix2][iconName] = icon3;
      });
      return additions;
    }
  }]);
  return Library2;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref3) {
  var obj = _ref3.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function (k2) {
    if (defaultProviderKeys.indexOf(k2) === -1) {
      delete providers[k2];
    }
  });
  _plugins.forEach(function (plugin) {
    var mixout8 = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout8).forEach(function (tk) {
      if (typeof mixout8[tk] === "function") {
        obj[tk] = mixout8[tk];
      }
      if (_typeof$2(mixout8[tk]) === "object") {
        Object.keys(mixout8[tk]).forEach(function (sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout8[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      var hooks8 = plugin.hooks();
      Object.keys(hooks8).forEach(function (hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }
        _hooks[hook].push(hooks8[hook]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args));
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function (hookFn) {
    hookFn.apply(null, args);
  });
  return void 0;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : void 0;
}
function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === "fa") {
    iconLookup.prefix = "fas";
  }
  var iconName = iconLookup.iconName;
  var prefix2 = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix2, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix2, iconName) || iconFromMapping(namespace.styles, prefix2, iconName);
}
var library = new Library();
var noAuto = function noAuto2() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks("noAuto");
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (IS_DOM) {
      callHooks("beforeI2svg", params);
      callProvided("pseudoElements2svg", params);
      return callProvided("i2svg", params);
    } else {
      return Promise.reject("Operation requires a DOM of some kind.");
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(function () {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks("watch", params);
    });
  }
};
var parse$2 = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }
    if (_typeof$2(_icon) === "object" && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }
    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix2 = getCanonicalPrefix(_icon[0]);
      return {
        prefix: prefix2,
        iconName: byAlias(prefix2, iconName) || iconName
      };
    }
    if (typeof _icon === "string" && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof _icon === "string") {
      var _prefix = getDefaultUsablePrefix();
      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto,
  config,
  dom,
  parse: parse$2,
  library,
  findIconDefinition,
  toHtml
};
var autoReplace = function autoReplace2() {
  var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
    autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};
function domVariants(val, abstractCreator) {
  Object.defineProperty(val, "abstract", {
    get: abstractCreator
  });
  Object.defineProperty(val, "html", {
    get: function get() {
      return val.abstract.map(function (a2) {
        return toHtml(a2);
      });
    }
  });
  Object.defineProperty(val, "node", {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement("div");
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}
function asIcon(_ref3) {
  var children = _ref3.children,
    main = _ref3.main,
    mask = _ref3.mask,
    attributes = _ref3.attributes,
    styles2 = _ref3.styles,
    transform = _ref3.transform;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
      height = main.height;
    var offset2 = {
      x: width / height / 2,
      y: 0.5
    };
    attributes["style"] = joinStyles(_objectSpread2$2(_objectSpread2$2({}, styles2), {}, {
      "transform-origin": "".concat(offset2.x + transform.x / 16, "em ").concat(offset2.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes,
    children
  }];
}
function asSymbol(_ref3) {
  var prefix2 = _ref3.prefix,
    iconName = _ref3.iconName,
    children = _ref3.children,
    attributes = _ref3.attributes,
    symbol = _ref3.symbol;
  var id = symbol === true ? "".concat(prefix2, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$2(_objectSpread2$2({}, attributes), {}, {
        id
      }),
      children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
    main = _params$icons.main,
    mask = _params$icons.mask,
    prefix2 = params.prefix,
    iconName = params.iconName,
    transform = params.transform,
    symbol = params.symbol,
    title = params.title,
    maskId = params.maskId,
    titleId = params.titleId,
    extra = params.extra,
    _params$watchable = params.watchable,
    watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref3 = mask.found ? mask : main,
    width = _ref3.width,
    height = _ref3.height;
  var isUploadedIcon = prefix2 === "fak";
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ""].filter(function (c2) {
    return extra.classes.indexOf(c2) === -1;
  }).filter(function (c2) {
    return c2 !== "" || !!c2;
  }).concat(extra.classes).join(" ");
  var content = {
    children: [],
    attributes: _objectSpread2$2(_objectSpread2$2({}, extra.attributes), {}, {
      "data-prefix": prefix2,
      "data-icon": iconName,
      "class": attrClass,
      "role": extra.attributes.role || "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = "";
  }
  if (title) {
    content.children.push({
      tag: "title",
      attributes: {
        id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }
  var args = _objectSpread2$2(_objectSpread2$2({}, content), {}, {
    prefix: prefix2,
    iconName,
    main,
    mask,
    maskId,
    transform,
    symbol,
    styles: _objectSpread2$2(_objectSpread2$2({}, uploadedIconWidthStyle), extra.styles)
  });
  var _ref22 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
      children: [],
      attributes: {}
    } : callProvided("generateAbstractIcon", args) || {
      children: [],
      attributes: {}
    },
    children = _ref22.children,
    attributes = _ref22.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content,
    width = params.width,
    height = params.height,
    transform = params.transform,
    title = params.title,
    extra = params.extra,
    _params$watchable2 = params.watchable,
    watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
  var attributes = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = "";
  }
  var styles2 = _objectSpread2$2({}, extra.styles);
  if (transformIsMeaningful(transform)) {
    styles2["transform"] = transformForCss({
      transform,
      startCentered: true,
      width,
      height
    });
    styles2["-webkit-transform"] = styles2["transform"];
  }
  var styleString = joinStyles(styles2);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content,
    title = params.title,
    extra = params.extra;
  var attributes = _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  var styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon3) {
  var width = icon3[0];
  var height = icon3[1];
  var _icon$slice = icon3.slice(4),
    _icon$slice2 = _slicedToArray$1(_icon$slice, 1),
    vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: "g",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: "currentColor",
          d: vectorData[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: "currentColor",
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix2) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix2, '" is missing.'));
  }
}
function findIcon(iconName, prefix2) {
  var givenPrefix = prefix2;
  if (prefix2 === "fa" && config.styleDefault !== null) {
    prefix2 = getDefaultUsablePrefix();
  }
  return new Promise(function (resolve, reject3) {
    ({
      found: false,
      width: 512,
      height: 512,
      icon: callProvided("missingIconAbstract") || {}
    });
    if (givenPrefix === "fa") {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix2 = shim.prefix || prefix2;
    }
    if (iconName && prefix2 && styles$1[prefix2] && styles$1[prefix2][iconName]) {
      var icon3 = styles$1[prefix2][iconName];
      return resolve(asFoundIcon(icon3));
    }
    maybeNotifyMissing(iconName, prefix2);
    resolve(_objectSpread2$2(_objectSpread2$2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1$1 = function noop2() {};
var p$2 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1$1,
  measure: noop$1$1
};
var preamble = 'FA "6.1.1"';
var begin = function begin2(name) {
  p$2.mark("".concat(preamble, " ").concat(name, " begins"));
  return function () {
    return end(name);
  };
};
var end = function end2(name) {
  p$2.mark("".concat(preamble, " ").concat(name, " ends"));
  p$2.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};
var noop$2 = function noop3() {};
function isWatched(node2) {
  var i2svg2 = node2.getAttribute ? node2.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg2 === "string";
}
function hasPrefixAndIcon(node2) {
  var prefix2 = node2.getAttribute ? node2.getAttribute(DATA_PREFIX) : null;
  var icon3 = node2.getAttribute ? node2.getAttribute(DATA_ICON) : null;
  return prefix2 && icon3;
}
function hasBeenReplaced(node2) {
  return node2 && node2.classList && node2.classList.contains && node2.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$ceFn = params.ceFn,
    ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement : _params$ceFn;
  if (typeof abstractObj === "string") {
    return DOCUMENT.createTextNode(abstractObj);
  }
  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node2) {
  var comment2 = " ".concat(node2.outerHTML, " ");
  comment2 = "".concat(comment2, "Font Awesome fontawesome.com ");
  return comment2;
}
var mutators = {
  replace: function replace(mutation) {
    var node2 = mutation[0];
    if (node2.parentNode) {
      mutation[1].forEach(function (abstract) {
        node2.parentNode.insertBefore(convertSVG(abstract), node2);
      });
      if (node2.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment2 = DOCUMENT.createComment(nodeAsComment(node2));
        node2.parentNode.replaceChild(comment2, node2);
      } else {
        node2.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node2 = mutation[0];
    var abstract = mutation[1];
    if (~classArray(node2).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;
    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(" ").reduce(function (acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(" ");
      if (splitClasses.toNode.length === 0) {
        node2.removeAttribute("class");
      } else {
        node2.setAttribute("class", splitClasses.toNode.join(" "));
      }
    }
    var newInnerHTML = abstract.map(function (a2) {
      return toHtml(a2);
    }).join("\n");
    node2.setAttribute(DATA_FA_I2SVG, "");
    node2.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback) {
  var callbackFunction = typeof callback === "function" ? callback : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin("mutate");
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  var _options$treeCallback = options.treeCallback,
    treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback,
    _options$nodeCallback = options.nodeCallback,
    nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback,
    _options$pseudoElemen = options.pseudoElementsCallback,
    pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen,
    _options$observeMutat = options.observeMutationsRoot,
    observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
            prefix2 = _getCanonicalIcon.prefix,
            iconName = _getCanonicalIcon.iconName;
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix2 || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}
function styleParser(node2) {
  var style = node2.getAttribute("style");
  var val = [];
  if (style) {
    val = style.split(";").reduce(function (acc, style2) {
      var styles2 = style2.split(":");
      var prop3 = styles2[0];
      var value = styles2.slice(1);
      if (prop3 && value.length > 0) {
        acc[prop3] = value.join(":").trim();
      }
      return acc;
    }, {});
  }
  return val;
}
function classParser(node2) {
  var existingPrefix = node2.getAttribute("data-prefix");
  var existingIconName = node2.getAttribute("data-icon");
  var innerText = node2.innerText !== void 0 ? node2.innerText.trim() : "";
  var val = getCanonicalIcon(classArray(node2));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node2.innerText) || byUnicode(val.prefix, toHex(node2.innerText));
  }
  return val;
}
function attributesParser(node2) {
  var extraAttributes = toArray(node2.attributes).reduce(function (acc, attr) {
    if (acc.name !== "class" && acc.name !== "style") {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  var title = node2.getAttribute("title");
  var titleId = node2.getAttribute("data-fa-title-id");
  if (config.autoA11y) {
    if (title) {
      extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes["aria-hidden"] = "true";
      extraAttributes["focusable"] = "false";
    }
  }
  return extraAttributes;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node2) {
  var parser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: true
  };
  var _classParser = classParser(node2),
    iconName = _classParser.iconName,
    prefix2 = _classParser.prefix,
    extraClasses = _classParser.rest;
  var extraAttributes = attributesParser(node2);
  var pluginMeta = chainHooks("parseNodeAttributes", {}, node2);
  var extraStyles = parser.styleParser ? styleParser(node2) : [];
  return _objectSpread2$2({
    iconName,
    title: node2.getAttribute("title"),
    titleId: node2.getAttribute("data-fa-title-id"),
    prefix: prefix2,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node2) {
  var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node2, {
    styleParser: false
  }) : parseMeta(node2);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided("generateLayersText", node2, nodeMeta);
  } else {
    return callProvided("generateSvgReplacementMutation", node2, nodeMeta);
  }
}
function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd2(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var hclRemove = function hclRemove2(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function (p2) {
    return ".".concat(p2, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  var candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e2) {}
  if (candidates.length > 0) {
    hclAdd("pending");
    hclRemove("complete");
  } else {
    return Promise.resolve();
  }
  var mark = perf.begin("onTree");
  var mutations = candidates.reduce(function (acc, node2) {
    try {
      var mutation = generateMutation(node2);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e2) {
      if (!PRODUCTION$1) {
        if (e2.name === "MissingIcon") {
          console.error(e2);
        }
      }
    }
    return acc;
  }, []);
  return new Promise(function (resolve, reject3) {
    Promise.all(mutations).then(function (resolvedMutations) {
      perform(resolvedMutations, function () {
        hclAdd("active");
        hclAdd("complete");
        hclRemove("pending");
        if (typeof callback === "function") callback();
        mark();
        resolve();
      });
    }).catch(function (e2) {
      mark();
      reject3(e2);
    });
  });
}
function onNode(node2) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(node2).then(function (mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}
function resolveIcons(next2) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next2(iconDefinition, _objectSpread2$2(_objectSpread2$2({}, params), {}, {
      mask
    }));
  };
}
var render = function render2(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$transform = params.transform,
    transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
    _params$symbol = params.symbol,
    symbol = _params$symbol === void 0 ? false : _params$symbol,
    _params$mask = params.mask,
    mask = _params$mask === void 0 ? null : _params$mask,
    _params$maskId = params.maskId,
    maskId = _params$maskId === void 0 ? null : _params$maskId,
    _params$title = params.title,
    title = _params$title === void 0 ? null : _params$title,
    _params$titleId = params.titleId,
    titleId = _params$titleId === void 0 ? null : _params$titleId,
    _params$classes = params.classes,
    classes = _params$classes === void 0 ? [] : _params$classes,
    _params$attributes = params.attributes,
    attributes = _params$attributes === void 0 ? {} : _params$attributes,
    _params$styles = params.styles,
    styles2 = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix2 = iconDefinition.prefix,
    iconName = iconDefinition.iconName,
    icon3 = iconDefinition.icon;
  return domVariants(_objectSpread2$2({
    type: "icon"
  }, iconDefinition), function () {
    callHooks("beforeDOMElementCreation", {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title) {
        attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes["aria-hidden"] = "true";
        attributes["focusable"] = "false";
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon3),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix2,
      iconName,
      transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), transform),
      symbol,
      title,
      maskId,
      titleId,
      extra: {
        attributes,
        styles: styles2,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout2() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks2() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      var _params$node = params.node,
        node2 = _params$node === void 0 ? DOCUMENT : _params$node,
        _params$callback = params.callback,
        callback = _params$callback === void 0 ? function () {} : _params$callback;
      return onTree(node2, callback);
    };
    providers$$1.generateSvgReplacementMutation = function (node2, nodeMeta) {
      var iconName = nodeMeta.iconName,
        title = nodeMeta.title,
        titleId = nodeMeta.titleId,
        prefix2 = nodeMeta.prefix,
        transform = nodeMeta.transform,
        symbol = nodeMeta.symbol,
        mask = nodeMeta.mask,
        maskId = nodeMeta.maskId,
        extra = nodeMeta.extra;
      return new Promise(function (resolve, reject3) {
        Promise.all([findIcon(iconName, prefix2), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function (_ref3) {
          var _ref22 = _slicedToArray$1(_ref3, 2),
            main = _ref22[0],
            mask2 = _ref22[1];
          resolve([node2, makeInlineSvgAbstract({
            icons: {
              main,
              mask: mask2
            },
            prefix: prefix2,
            iconName,
            transform,
            symbol,
            maskId,
            title,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject3);
      });
    };
    providers$$1.generateAbstractIcon = function (_ref3) {
      var children = _ref3.children,
        attributes = _ref3.attributes,
        main = _ref3.main,
        transform = _ref3.transform,
        styles2 = _ref3.styles;
      var styleString = joinStyles(styles2);
      if (styleString.length > 0) {
        attributes["style"] = styleString;
      }
      var nextChild;
      if (transformIsMeaningful(transform)) {
        nextChild = callProvided("generateAbstractTransformGrouping", {
          main,
          transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};
var Layers = {
  mixout: function mixout3() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: "layer"
        }, function () {
          callHooks("beforeDOMElementCreation", {
            assembler,
            params
          });
          var children = [];
          assembler(function (args) {
            Array.isArray(args) ? args.map(function (a2) {
              children = children.concat(a2.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: "span",
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$2(classes)).join(" ")
            },
            children
          }];
        });
      }
    };
  }
};
var LayersCounter = {
  mixout: function mixout4() {
    return {
      counter: function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$title = params.title,
          title = _params$title === void 0 ? null : _params$title,
          _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes,
          _params$attributes = params.attributes,
          attributes = _params$attributes === void 0 ? {} : _params$attributes,
          _params$styles = params.styles,
          styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "counter",
          content
        }, function () {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$2(classes))
            }
          });
        });
      }
    };
  }
};
var LayersText = {
  mixout: function mixout5() {
    return {
      text: function text2(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$transform = params.transform,
          transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
          _params$title = params.title,
          title = _params$title === void 0 ? null : _params$title,
          _params$classes = params.classes,
          classes = _params$classes === void 0 ? [] : _params$classes,
          _params$attributes = params.attributes,
          attributes = _params$attributes === void 0 ? {} : _params$attributes,
          _params$styles = params.styles,
          styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "text",
          content
        }, function () {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersTextAbstract({
            content,
            transform: _objectSpread2$2(_objectSpread2$2({}, meaninglessTransform), transform),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$2(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides2(providers$$1) {
    providers$$1.generateLayersText = function (node2, nodeMeta) {
      var title = nodeMeta.title,
        transform = nodeMeta.transform,
        extra = nodeMeta.extra;
      var width = null;
      var height = null;
      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node2).fontSize, 10);
        var boundingClientRect = node2.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title) {
        extra.attributes["aria-hidden"] = "true";
      }
      return Promise.resolve([node2, makeLayersTextAbstract({
        content: node2.innerHTML,
        width,
        height,
        transform,
        title,
        extra,
        watchable: true
      })]);
    };
  }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, "");
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function replaceForPosition(node2, position2) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position2.replace(":", "-"));
  return new Promise(function (resolve, reject3) {
    if (node2.getAttribute(pendingAttribute) !== null) {
      return resolve();
    }
    var children = toArray(node2.children);
    var alreadyProcessedPseudoElement = children.filter(function (c2) {
      return c2.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position2;
    })[0];
    var styles2 = WINDOW.getComputedStyle(node2, position2);
    var fontFamily = styles2.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
    var fontWeight = styles2.getPropertyValue("font-weight");
    var content = styles2.getPropertyValue("content");
    if (alreadyProcessedPseudoElement && !fontFamily) {
      node2.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== "none" && content !== "") {
      var _content = styles2.getPropertyValue("content");
      var prefix2 = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
      var _hexValueFromContent = hexValueFromContent(_content),
        hexValue = _hexValueFromContent.value,
        isSecondary = _hexValueFromContent.isSecondary;
      var isV4 = fontFamily[0].startsWith("FontAwesome");
      var iconName = byUnicode(prefix2, hexValue);
      var iconIdentifier = iconName;
      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix2 = iconName4.prefix;
        }
      }
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix2 || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node2.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          node2.removeChild(alreadyProcessedPseudoElement);
        }
        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position2;
        findIcon(iconName, prefix2).then(function (main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2$2(_objectSpread2$2({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix: prefix2,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement("svg");
          if (position2 === "::before") {
            node2.insertBefore(element, node2.firstChild);
          } else {
            node2.appendChild(element);
          }
          element.outerHTML = abstract.map(function (a2) {
            return toHtml(a2);
          }).join("\n");
          node2.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject3);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace$1(node2) {
  return Promise.all([replaceForPosition(node2, "::before"), replaceForPosition(node2, "::after")]);
}
function processable(node2) {
  return node2.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node2.tagName.toUpperCase()) && !node2.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node2.parentNode || node2.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function (resolve, reject3) {
    var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace$1);
    var end3 = perf.begin("searchPseudoElements");
    disableObservation();
    Promise.all(operations).then(function () {
      end3();
      enableObservation();
      resolve();
    }).catch(function () {
      end3();
      enableObservation();
      reject3();
    });
  });
}
var PseudoElements = {
  hooks: function hooks3() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides3(providers$$1) {
    providers$$1.pseudoElements2svg = function (params) {
      var _params$node = params.node,
        node2 = _params$node === void 0 ? DOCUMENT : _params$node;
      if (config.searchPseudoElements) {
        searchPseudoElements(node2);
      }
    };
  }
};
var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout6() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks4() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function noAuto3() {
        disconnect();
      },
      watch: function watch2(params) {
        var observeMutationsRoot = params.observeMutationsRoot;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks("mutationObserverCallbacks", {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};
var parseTransformString = function parseTransformString2(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(" ").reduce(function (acc, n2) {
    var parts = n2.toLowerCase().split("-");
    var first = parts[0];
    var rest = parts.slice(1).join("-");
    if (first && rest === "h") {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === "v") {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case "grow":
        acc.size = acc.size + rest;
        break;
      case "shrink":
        acc.size = acc.size - rest;
        break;
      case "left":
        acc.x = acc.x - rest;
        break;
      case "right":
        acc.x = acc.x + rest;
        break;
      case "up":
        acc.y = acc.y - rest;
        break;
      case "down":
        acc.y = acc.y + rest;
        break;
      case "rotate":
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout7() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks5() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node2) {
        var transformString = node2.getAttribute("data-fa-transform");
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides: function provides4(providers2) {
    providers2.generateAbstractTransformGrouping = function (_ref3) {
      var main = _ref3.main,
        transform = _ref3.transform,
        containerWidth = _ref3.containerWidth,
        iconWidth = _ref3.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path3 = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer,
        inner,
        path: path3
      };
      return {
        tag: "g",
        attributes: _objectSpread2$2({}, operations.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$2(_objectSpread2$2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = "black";
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === "g") {
    return abstract.children;
  } else {
    return [abstract];
  }
}
var Masks = {
  hooks: function hooks6() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node2) {
        var maskData = node2.getAttribute("data-fa-mask");
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function (i) {
          return i.trim();
        }));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node2.getAttribute("data-fa-mask-id");
        return accumulator;
      }
    };
  },
  provides: function provides5(providers2) {
    providers2.generateAbstractMask = function (_ref3) {
      var children = _ref3.children,
        attributes = _ref3.attributes,
        main = _ref3.main,
        mask = _ref3.mask,
        explicitMaskId = _ref3.maskId,
        transform = _ref3.transform;
      var mainWidth = main.width,
        mainPath = main.icon;
      var maskWidth = mask.width,
        maskPath = mask.icon;
      var trans = transformForSvg({
        transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: "rect",
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          fill: "white"
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: "g",
        attributes: _objectSpread2$2({}, trans.inner),
        children: [fillBlack(_objectSpread2$2({
          tag: mainPath.tag,
          attributes: _objectSpread2$2(_objectSpread2$2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: "g",
        attributes: _objectSpread2$2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: "mask",
        attributes: _objectSpread2$2(_objectSpread2$2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: "rect",
        attributes: _objectSpread2$2({
          fill: "currentColor",
          "clip-path": "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};
var MissingIconIndicator = {
  provides: function provides6(providers2) {
    var reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    providers2.missingIconAbstract = function () {
      var gChildren = [];
      var FILL = {
        fill: "currentColor"
      };
      var ANIMATION_BASE = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var OPACITY_ANIMATE = _objectSpread2$2(_objectSpread2$2({}, ANIMATION_BASE), {}, {
        attributeName: "opacity"
      });
      var dot = {
        tag: "circle",
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: "animate",
          attributes: _objectSpread2$2(_objectSpread2$2({}, ANIMATION_BASE), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
            values: "1;0;1;1;0;1;"
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: reduceMotion ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      });
      if (!reduceMotion) {
        gChildren.push({
          tag: "path",
          attributes: _objectSpread2$2(_objectSpread2$2({}, FILL), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: _objectSpread2$2(_objectSpread2$2({}, OPACITY_ANIMATE), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        });
      }
      return {
        tag: "g",
        attributes: {
          "class": "missing"
        },
        children: gChildren
      };
    };
  }
};
var SvgSymbols = {
  hooks: function hooks7() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node2) {
        var symbolData = node2.getAttribute("data-fa-symbol");
        var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
        accumulator["symbol"] = symbol;
        return accumulator;
      }
    };
  }
};
var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon2 = api.icon;
api.layer;
api.text;
api.counter;
var propTypes = {
  exports: {}
};
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location2, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function ownKeys$1(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
    return typeof obj2;
  } : function (obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
  var _classes;
  var beat = props.beat,
    fade = props.fade,
    beatFade = props.beatFade,
    bounce = props.bounce,
    shake = props.shake,
    flash = props.flash,
    spin = props.spin,
    spinPulse = props.spinPulse,
    spinReverse = props.spinReverse,
    pulse = props.pulse,
    fixedWidth = props.fixedWidth,
    inverse = props.inverse,
    border = props.border,
    listItem = props.listItem,
    flip3 = props.flip,
    size = props.size,
    rotation = props.rotation,
    pull = props.pull;
  var classes = (_classes = {
    "fa-beat": beat,
    "fa-fade": fade,
    "fa-beat-fade": beatFade,
    "fa-bounce": bounce,
    "fa-shake": shake,
    "fa-flash": flash,
    "fa-spin": spin,
    "fa-spin-reverse": spinReverse,
    "fa-spin-pulse": spinPulse,
    "fa-pulse": pulse,
    "fa-fw": fixedWidth,
    "fa-inverse": inverse,
    "fa-border": border,
    "fa-li": listItem,
    "fa-flip": flip3 === true,
    "fa-flip-horizontal": flip3 === "horizontal" || flip3 === "both",
    "fa-flip-vertical": flip3 === "vertical" || flip3 === "both"
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty$1(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}
function _isNumerical(obj) {
  obj = obj - 0;
  return obj === obj;
}
function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  }
  string = string.replace(/[\-_\s]+(.)?/g, function (match2, chr) {
    return chr ? chr.toUpperCase() : "";
  });
  return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded$1$2 = ["style"];
function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(";").map(function (s2) {
    return s2.trim();
  }).filter(function (s2) {
    return s2;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(":");
    var prop3 = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop3.startsWith("webkit") ? acc[capitalize(prop3)] = value : acc[prop3] = value;
    return acc;
  }, {});
}
function convert(createElement2, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof element === "string") {
    return element;
  }
  var children = (element.children || []).map(function (child) {
    return convert(createElement2, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc.attrs["className"] = val;
        delete element.attributes["class"];
        break;
      case "style":
        acc.attrs["style"] = styleToObject(val);
        break;
      default:
        if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style,
    existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
    remaining = _objectWithoutProperties$1(extraProps, _excluded$1$2);
  mixins.attrs["style"] = _objectSpread2$1(_objectSpread2$1({}, mixins.attrs["style"]), existingStyle);
  return createElement2.apply(void 0, [element.tag, _objectSpread2$1(_objectSpread2$1({}, mixins.attrs), remaining)].concat(_toConsumableArray$1(children)));
}
var PRODUCTION = false;
try {
  PRODUCTION = true;
} catch (e2) {}
function log() {
  if (!PRODUCTION && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon3) {
  if (icon3 && _typeof$1(icon3) === "object" && icon3.prefix && icon3.iconName && icon3.icon) {
    return icon3;
  }
  if (parse$1$1.icon) {
    return parse$1$1.icon(icon3);
  }
  if (icon3 === null) {
    return null;
  }
  if (icon3 && _typeof$1(icon3) === "object" && icon3.prefix && icon3.iconName) {
    return icon3;
  }
  if (Array.isArray(icon3) && icon3.length === 2) {
    return {
      prefix: icon3[0],
      iconName: icon3[1]
    };
  }
  if (typeof icon3 === "string") {
    return {
      prefix: "fas",
      iconName: icon3
    };
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}
var _excluded$6 = ["forwardedRef"];
function FontAwesomeIcon(_ref3) {
  var forwardedRef = _ref3.forwardedRef,
    props = _objectWithoutProperties$1(_ref3, _excluded$6);
  var iconArgs = props.icon,
    maskArgs = props.mask,
    symbol = props.symbol,
    className = props.className,
    title = props.title,
    titleId = props.titleId,
    maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey("classes", [].concat(_toConsumableArray$1(classList(props)), _toConsumableArray$1(className.split(" "))));
  var transform = objectWithKey("transform", typeof props.transform === "string" ? parse$1$1.transform(props.transform) : props.transform);
  var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
  var renderedIcon = icon2(iconLookup, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, classes), transform), mask), {}, {
    symbol,
    title,
    titleId,
    maskId
  }));
  if (!renderedIcon) {
    log("Could not find icon", iconLookup);
    return null;
  }
  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  beatFade: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf([true, false, "horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React__default.createElement);
const resolveColorFromTheme = color => {
  if (isNil$1(color)) {
    return void 0;
  }
  if (path$1(["value"], color)) {
    return path$1(["value"], color);
  }
  if (color.startsWith("$")) {
    color = color.substring(1);
  }
  if (Object.keys(theme.colors).includes(color)) {
    return theme.colors[color].value;
  }
  return color;
};
var IconSizeVariantEnum = /* @__PURE__ */(IconSizeVariantEnum2 => {
  IconSizeVariantEnum2["INHERIT"] = "inherit";
  IconSizeVariantEnum2["EXTRA_SMALL"] = "extra-small";
  IconSizeVariantEnum2["SMALL"] = "small";
  IconSizeVariantEnum2["MEDIUM"] = "medium";
  IconSizeVariantEnum2["LARGE"] = "large";
  IconSizeVariantEnum2["EXTRA_LARGE"] = "extra-large";
  return IconSizeVariantEnum2;
})(IconSizeVariantEnum || {});
var IconColorVariantEnum = /* @__PURE__ */(IconColorVariantEnum2 => {
  IconColorVariantEnum2["LIGHT"] = "light";
  IconColorVariantEnum2["GRAY"] = "gray";
  IconColorVariantEnum2["DARK"] = "dark";
  IconColorVariantEnum2["DISABLED"] = "disabled";
  return IconColorVariantEnum2;
})(IconColorVariantEnum || {});
const IconSizeVariant = {
  inherit: {
    size: "1em"
  },
  "extra-small": {
    size: "0.714rem"
  },
  small: {
    size: "$fontSizes$1"
  },
  medium: {
    size: "$fontSizes$2"
  },
  large: {
    size: "$fontSizes$3"
  },
  "extra-large": {
    size: "$fontSizes$5"
  }
};
const IconColorVariant = {
  light: {
    color: "$white"
  },
  gray: {
    color: "$gray8"
  },
  dark: {
    color: "$gray12"
  },
  disabled: {
    color: "$gray5"
  }
};
const StyledIconBase = styled(FontAwesomeIcon, {
  variants: {
    size: IconSizeVariant,
    variant: IconColorVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const Icon = forwardRef((_ref19, forwardedRef) => {
  let {
    variant,
    size,
    color,
    icon: icon3,
    rootProps,
    ...props
  } = _ref19;
  return /* @__PURE__ */jsx$1(StyledIconBase, {
    size,
    variant,
    color: resolveColorFromTheme(color),
    forwardedRef,
    icon: icon3,
    ...props,
    ...rootProps
  });
});
Icon.displayName = "Icon";
const AccordionHeaderVariantMap = {
  container: "h3",
  card: "h4",
  stacked: "h3"
};
const AccordionRootThemeVariant = {
  container: {
    gap: "$3"
  },
  card: {
    gap: "$3"
  },
  stacked: {
    gap: "$0",
    paddingBottom: 0
  }
};
const AccordionTriggerContainerThemeVariant = {
  container: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  card: {
    flexDirection: "row",
    justifyContent: "space-between"
  },
  stacked: {
    flexDirection: "row-reverse",
    justifyContent: "flex-end"
  }
};
const AccordionItemThemeVariant = {
  container: {
    border: "1px solid $gray3",
    borderRadius: "$1",
    '&[data-state="open"]': {
      borderColor: "$gray4"
    }
  },
  card: {
    boxShadow: "$container16",
    borderRadius: "$1"
  },
  stacked: {
    borderBottom: "1px solid $gray3"
  }
};
const AccordionContentContainerThemeVariant = {
  container: {
    padding: "$2",
    paddingTop: "$1"
  },
  card: {
    padding: "$2",
    paddingTop: "$1"
  },
  stacked: {
    padding: "$1"
  }
};
const open = keyframes$1({
  from: {
    opacity: 0,
    height: 0
  },
  to: {
    opacity: 1,
    height: "var(--radix-accordion-content-height)"
  }
});
const close = keyframes$1({
  from: {
    opacity: 1,
    height: "var(--radix-accordion-content-height)"
  },
  to: {
    opacity: 0,
    height: 0
  }
});
const StyledAccordionRoot = styled($1bf158f521e1b1b4$export$be92b6f5f03c0fe9, {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  variants: {
    variant: AccordionRootThemeVariant,
    headerVariant: HeaderVariant
  }
});
const StyledAccordionIcon = styled(Icon, {
  transition: "transform 300ms",
  "[data-state=open] &": {
    transform: "rotate(90deg)"
  }
});
const StyledAccordionTrigger = styled($1bf158f521e1b1b4$export$41fb9f06171c75f4, {
  border: "none",
  background: "transparent",
  width: "100%",
  cursor: "pointer",
  backgroundColor: "$white",
  "&:hover": {
    backgroundColor: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  variants: {
    variant: {
      container: {
        padding: "$2"
      },
      card: {
        padding: "$2"
      },
      stacked: {
        padding: "$1"
      }
    }
  }
});
const StyledAccordionHeaderContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "$half",
  textAlign: "left",
  "&:hover": {
    backgroundColor: "$gray2"
  }
});
const StyledAccordionTriggerContainer = styled("div", {
  display: "flex",
  gap: "$2",
  alignItems: "center",
  variants: {
    variant: AccordionTriggerContainerThemeVariant
  }
});
const StyledAccordionItem = styled($1bf158f521e1b1b4$export$6d08773d2e66f8f2, {
  backgroundColor: "$white",
  variants: {
    variant: AccordionItemThemeVariant
  }
});
const StyledAccordionContent = styled($1bf158f521e1b1b4$export$7c6e2c02157bb7d2, {
  overflow: "hidden",
  backgroundColor: "$white",
  '&[data-state="open"]': {
    animation: `${open} 150ms cubic-bezier(0.87, 0, 0.13, 1)`
  },
  '&[data-state="closed"]': {
    animation: `${close} 150ms cubic-bezier(0.87, 0, 0.13, 1)`
  },
  variants: {
    variant: AccordionContentContainerThemeVariant
  }
});
const COMPONENT_NAME$1 = "Accordion";
const [AccordionProvider, useAccordionContext] = createComponentContext(COMPONENT_NAME$1, {
  variant: "container",
  headerVariant: "h3"
});
const AccordionGroup = forwardRef((_ref20, forwardedRef) => {
  let {
    variant = "container",
    headerVariant = AccordionHeaderVariantMap[variant],
    canOpenMultiple,
    children,
    defaultValue,
    rootProps,
    ...props
  } = _ref20;
  const accordionType = canOpenMultiple ? "multiple" : "single";
  return /* @__PURE__ */jsx$1(StyledAccordionRoot, {
    variant,
    headerVariant,
    type: accordionType,
    ref: forwardedRef,
    ...(accordionType === "single" ? {
      collapsible: true,
      defaultValue
    } : {
      defaultValue
    }),
    ...rootProps,
    ...props,
    children: /* @__PURE__ */jsx$1(AccordionProvider, {
      variant,
      headerVariant,
      children
    })
  });
});
AccordionGroup.displayName = "AccordionGroup";
const AccordionItem = forwardRef((_ref21, forwardedRef) => {
  let {
    id,
    header,
    subheader,
    children
  } = _ref21;
  var _a, _b;
  const variant = ((_a = useAccordionContext(COMPONENT_NAME$1)) == null ? void 0 : _a.variant) || "container";
  const headerVariant = ((_b = useAccordionContext(COMPONENT_NAME$1)) == null ? void 0 : _b.headerVariant) || AccordionHeaderVariantMap[variant];
  return /* @__PURE__ */jsxs(StyledAccordionItem, {
    variant,
    ref: forwardedRef,
    value: id,
    children: [/* @__PURE__ */jsx$1($1bf158f521e1b1b4$export$8b251419efc915eb, {
      asChild: true,
      children: /* @__PURE__ */jsx$1(StyledAccordionTrigger, {
        variant,
        children: /* @__PURE__ */jsxs(StyledAccordionTriggerContainer, {
          variant,
          children: [/* @__PURE__ */jsxs(StyledAccordionHeaderContainer, {
            children: [/* @__PURE__ */jsx$1(Header, {
              variant: headerVariant,
              children: header
            }), subheader && /* @__PURE__ */jsx$1(Text, {
              as: "span",
              variant: "subtitle2",
              children: subheader
            })]
          }), /* @__PURE__ */jsx$1(StyledAccordionIcon, {
            title: "accordion trigger",
            variant: "dark",
            icon: faChevronRight_2$1,
            "aria-hidden": true
          })]
        })
      })
    }), /* @__PURE__ */jsx$1(StyledAccordionContent, {
      variant,
      children
    })]
  });
});
AccordionItem.displayName = "AccordionItem";
const Accordion = {
  Group: AccordionGroup,
  Item: AccordionItem
};
var AccordionThemeVariantEnum = /* @__PURE__ */(AccordionThemeVariantEnum2 => {
  AccordionThemeVariantEnum2["CONTAINER"] = "container";
  AccordionThemeVariantEnum2["CARD"] = "card";
  AccordionThemeVariantEnum2["STACKED"] = "stacked";
  return AccordionThemeVariantEnum2;
})(AccordionThemeVariantEnum || {});
const FullWidthVariant = {
  true: {
    width: "100%"
  }
};
const FullHeightVariant = {
  true: {
    height: "100%"
  }
};
const StyledBase$3 = styled("div", {
  variants: {
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  }
});
const Box = forwardRef((_ref23, forwardedRef) => {
  let {
    as = "div",
    height,
    width,
    css: css4 = {},
    rootProps,
    ...props
  } = _ref23;
  return /* @__PURE__ */jsx$1(StyledBase$3, {
    as,
    ref: forwardedRef,
    css: {
      height,
      width,
      ...css4
    },
    ...rootProps,
    ...props
  });
});
Box.displayName = "Box";
const FlexDirectionVariant = {
  row: {
    flexDirection: "row"
  },
  "row-reverse": {
    flexDirection: "row-reverse"
  },
  column: {
    flexDirection: "column"
  },
  "column-reverse": {
    flexDirection: "column-reverse"
  }
};
const FlexJustifyContentVariant = {
  "flex-start": {
    justifyContent: "flex-start"
  },
  "flex-end": {
    justifyContent: "flex-end"
  },
  center: {
    justifyContent: "center"
  },
  "space-between": {
    justifyContent: "space-between"
  },
  "space-around": {
    justifyContent: "space-around"
  },
  "space-evenly": {
    justifyContent: "space-evenly"
  }
};
const FlexAlignItemsVariant = {
  "flex-start": {
    alignItems: "flex-start"
  },
  "flex-end": {
    alignItems: "flex-end"
  },
  center: {
    alignItems: "center"
  },
  baseline: {
    alignItems: "baseline"
  },
  stretch: {
    alignItems: "stretch"
  }
};
const FlexWrapVariant = {
  wrap: {
    flexWrap: "wrap"
  },
  nowrap: {
    flexWrap: "nowrap"
  },
  "wrap-reverse": {
    flexWrap: "wrap-reverse"
  }
};
const FlexGapVariant = {
  half: {
    gap: "$half"
  },
  0: {
    gap: "$0"
  },
  1: {
    gap: "$1"
  },
  2: {
    gap: "$2"
  },
  3: {
    gap: "$3"
  },
  4: {
    gap: "$4"
  },
  5: {
    gap: "$5"
  },
  6: {
    gap: "$6"
  },
  7: {
    gap: "$7"
  },
  8: {
    gap: "$8"
  }
};
const FlexItemAlignSelfVariant = {
  center: {
    alignSelf: "center"
  },
  start: {
    alignSelf: "start"
  },
  end: {
    alignSelf: "end"
  },
  baseline: {
    alignSelf: "baseline"
  },
  stretch: {
    alignSelf: "stretch"
  }
};
const StyledFlexBase = styled(Box, {
  display: "flex",
  variants: {
    direction: FlexDirectionVariant,
    justifyContent: FlexJustifyContentVariant,
    alignItems: FlexAlignItemsVariant,
    gap: FlexGapVariant,
    wrap: FlexWrapVariant,
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  },
  defaultVariants: {
    direction: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    wrap: "nowrap",
    gap: 1
  }
});
const StyledFlexItemBase = styled(Box, {
  variants: {
    alignSelf: FlexItemAlignSelfVariant
  }
});
const Flex = forwardRef((_ref24, forwardedRef) => {
  let {
    direction,
    alignItems,
    justifyContent,
    gap,
    wrap,
    grow = "inherit",
    height,
    width,
    children,
    css: css4,
    rootProps,
    ...props
  } = _ref24;
  return /* @__PURE__ */jsx$1(StyledFlexBase, {
    ref: forwardedRef,
    direction,
    alignItems,
    justifyContent,
    gap,
    wrap,
    css: {
      flexGrow: grow,
      height,
      width,
      ...css4
    },
    ...rootProps,
    ...props,
    children
  });
});
Flex.displayName = "Flex";
const FlexItem = forwardRef((_ref25, forwardedRef) => {
  let {
    alignSelf,
    height,
    width,
    children,
    rootProps,
    ...props
  } = _ref25;
  return /* @__PURE__ */jsx$1(StyledFlexItemBase, {
    ref: forwardedRef,
    alignSelf,
    css: {
      height,
      width
    },
    ...rootProps,
    ...props,
    children
  });
});
FlexItem.displayName = "FlexItem";
Flex.Item = FlexItem;
var FlexDirectionVariantEnum = /* @__PURE__ */(FlexDirectionVariantEnum2 => {
  FlexDirectionVariantEnum2["ROW"] = "row";
  FlexDirectionVariantEnum2["COLUMN"] = "column";
  FlexDirectionVariantEnum2["ROW_REVERSE"] = "row-reverse";
  FlexDirectionVariantEnum2["COLUMN_REVERSE"] = "column-reverse";
  return FlexDirectionVariantEnum2;
})(FlexDirectionVariantEnum || {});
var FlexJustifyContentVariantEnum = /* @__PURE__ */(FlexJustifyContentVariantEnum2 => {
  FlexJustifyContentVariantEnum2["FLEX_START"] = "flex-start";
  FlexJustifyContentVariantEnum2["FLEX_END"] = "flex-end";
  FlexJustifyContentVariantEnum2["CENTER"] = "center";
  FlexJustifyContentVariantEnum2["SPACE_BETWEEN"] = "space-between";
  FlexJustifyContentVariantEnum2["SPACE_AROUND"] = "space-around";
  FlexJustifyContentVariantEnum2["SPACE_EVENLY"] = "space-evenly";
  return FlexJustifyContentVariantEnum2;
})(FlexJustifyContentVariantEnum || {});
var FlexAlignItemsVariantEnum = /* @__PURE__ */(FlexAlignItemsVariantEnum2 => {
  FlexAlignItemsVariantEnum2["FLEX_START"] = "flex-start";
  FlexAlignItemsVariantEnum2["FLEX_END"] = "flex-end";
  FlexAlignItemsVariantEnum2["CENTER"] = "center";
  FlexAlignItemsVariantEnum2["BASELINE"] = "baseline";
  FlexAlignItemsVariantEnum2["STRETCH"] = "stretch";
  return FlexAlignItemsVariantEnum2;
})(FlexAlignItemsVariantEnum || {});
var FlexWrapVariantEnum = /* @__PURE__ */(FlexWrapVariantEnum2 => {
  FlexWrapVariantEnum2["NOWRAP"] = "nowrap";
  FlexWrapVariantEnum2["WRAP"] = "wrap";
  FlexWrapVariantEnum2["WRAP_REVERSE"] = "wrap-reverse";
  return FlexWrapVariantEnum2;
})(FlexWrapVariantEnum || {});
var FlexItemAlignSelfVariantEnum = /* @__PURE__ */(FlexItemAlignSelfVariantEnum2 => {
  FlexItemAlignSelfVariantEnum2["CENTER"] = "center";
  FlexItemAlignSelfVariantEnum2["START"] = "start";
  FlexItemAlignSelfVariantEnum2["END"] = "end";
  FlexItemAlignSelfVariantEnum2["BASELINE"] = "baseline";
  FlexItemAlignSelfVariantEnum2["STRETCH"] = "stretch";
  return FlexItemAlignSelfVariantEnum2;
})(FlexItemAlignSelfVariantEnum || {});
var LoaderStyleVariantEnum = /* @__PURE__ */(LoaderStyleVariantEnum2 => {
  LoaderStyleVariantEnum2["DARK"] = "dark";
  LoaderStyleVariantEnum2["LIGHT"] = "light";
  LoaderStyleVariantEnum2["INHERIT"] = "inherit";
  return LoaderStyleVariantEnum2;
})(LoaderStyleVariantEnum || {});
const LoaderStyleVariant = {
  dark: {
    stroke: "$gray12"
  },
  light: {
    stroke: "$white"
  },
  inherit: {
    stroke: "currentColor"
  }
};
const rotate = keyframes$1({
  "100%": {
    transform: "rotate(360deg)"
  }
});
const animateCircleLoader = keyframes$1({
  "0%": {
    strokeDasharray: "1, 200",
    strokeDashoffset: 0
  },
  "50%": {
    strokeDasharray: "89, 200",
    strokeDashoffset: "-35px"
  },
  "100%": {
    strokeDasharray: "89, 200",
    strokeDashoffset: "-124px"
  }
});
const BaseBox = styled("div", {
  position: "relative",
  variants: {
    size: IconSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const BaseStyles = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  animation: `${rotate} 2s linear infinite`,
  transformOrigin: "center center",
  position: "absolute",
  margin: "auto"
};
const StyledCircle = styled("circle", {
  strokeWidth: "10%",
  strokeDasharray: "1, 200",
  strokeDashoffset: 0,
  animation: `${animateCircleLoader} 1.5s ease-in-out infinite`,
  strokeLinecap: "round"
});
const StyledCircleLoaderBase = styled("svg", {
  ...BaseStyles,
  variants: {
    size: IconSizeVariant,
    variant: LoaderStyleVariant
  },
  defaultVariants: {
    size: "medium",
    variant: "dark"
  }
});
const CircleLoader = forwardRef((_ref26, forwardedRef) => {
  let {
    variant,
    size,
    css: css4,
    rootProps,
    ...props
  } = _ref26;
  return /* @__PURE__ */jsx$1(BaseBox, {
    ref: forwardedRef,
    css: css4,
    ...rootProps,
    children: /* @__PURE__ */jsx$1(StyledCircleLoaderBase, {
      viewBox: "25 25 50 50",
      variant,
      size,
      ...props,
      children: /* @__PURE__ */jsx$1(StyledCircle, {
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none"
      })
    })
  });
});
CircleLoader.displayName = "CircleLoader";
const ButtonIcon = _ref27 => {
  let {
    icon: icon3
  } = _ref27;
  return /* @__PURE__ */jsx$1(Icon, {
    icon: icon3,
    size: "inherit"
  });
};
const ButtonBaseStyles = {
  display: "flex",
  width: "max-content",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  borderStyle: "solid",
  borderWidth: 1,
  margin: 0,
  borderRadius: "$1",
  cursor: "pointer",
  outline: 0,
  textDecoration: "none",
  transitionProperty: "background-color, box-shadow, color, border-color",
  transition: "$transitionEaseInOut",
  paddingRight: "$2",
  paddingLeft: "$2",
  position: "relative",
  textStyles: "button1",
  fontFamily: "$primary",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  }
};
var ButtonBaseColorVariantEnum = /* @__PURE__ */(ButtonBaseColorVariantEnum2 => {
  ButtonBaseColorVariantEnum2["PRIMARY"] = "primary";
  ButtonBaseColorVariantEnum2["SECONDARY"] = "secondary";
  ButtonBaseColorVariantEnum2["TERTIARY"] = "tertiary";
  ButtonBaseColorVariantEnum2["ERROR"] = "error";
  ButtonBaseColorVariantEnum2["EDUCATION"] = "education";
  ButtonBaseColorVariantEnum2["SECONDARY_ERROR"] = "secondaryError";
  ButtonBaseColorVariantEnum2["TERTIARY_ERROR"] = "tertiaryError";
  return ButtonBaseColorVariantEnum2;
})(ButtonBaseColorVariantEnum || {});
const ButtonBaseColorVariant = {
  primary: {
    backgroundColor: "$blue8",
    borderColor: "$blue8",
    color: "$white",
    "&:hover": {
      backgroundColor: "$blue9",
      borderColor: "$blue9"
    },
    "&:active": {
      backgroundColor: "$blue10",
      borderColor: "$blue10"
    },
    "&:disabled": {
      backgroundColor: "$gray3",
      borderColor: "$gray3",
      cursor: "not-allowed"
    }
  },
  secondary: {
    backgroundColor: "$white",
    borderColor: "$gray3",
    color: "$gray12",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray4"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray5"
    },
    "&:disabled": {
      color: "$gray5",
      borderColor: "$gray3",
      backgroundColor: "$white",
      cursor: "not-allowed"
    }
  },
  tertiary: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    boxShadow: "none",
    color: "$gray12",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray2"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray3"
    },
    "&:disabled": {
      color: "$gray5",
      backgroundColor: "transparent",
      borderColor: "transparent",
      cursor: "not-allowed"
    }
  },
  error: {
    backgroundColor: "$red8",
    borderColor: "$red8",
    color: "$white",
    "&:hover": {
      backgroundColor: "$red9",
      borderColor: "$red9"
    },
    "&:active": {
      backgroundColor: "$red10",
      borderColor: "$red10"
    },
    "&:disabled": {
      backgroundColor: "$gray3",
      borderColor: "$gray3",
      cursor: "not-allowed"
    }
  },
  education: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    boxShadow: "none",
    color: "$purple8",
    "&:hover": {
      backgroundColor: "$purple1"
    },
    "&:active": {
      backgroundColor: "$purple2"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: "$gray5",
      cursor: "not-allowed"
    }
  },
  secondaryError: {
    backgroundColor: "$white",
    borderColor: "$gray3",
    color: "$red8",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray4"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray5"
    },
    "&:disabled": {
      backgroundColor: "$white",
      borderColor: "$gray3",
      color: "$gray5",
      cursor: "not-allowed"
    }
  },
  tertiaryError: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    boxShadow: "none",
    color: "$red8",
    "&:hover": {
      backgroundColor: "$gray2",
      borderColor: "$gray2"
    },
    "&:active": {
      backgroundColor: "$gray3",
      borderColor: "$gray3"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      borderColor: "transparent",
      color: "$gray5",
      cursor: "not-allowed"
    }
  }
};
const StyledButtonBase$3 = styled("button", {
  ...ButtonBaseStyles,
  variants: {
    variant: ButtonBaseColorVariant
  },
  defaultVariants: {
    variant: "primary"
  }
});
const ButtonBase = forwardRef((_ref28, forwardedRef) => {
  let {
    css: css4,
    variant = "primary",
    children,
    onClick,
    type: type3 = "button",
    rootProps,
    ...props
  } = _ref28;
  return /* @__PURE__ */jsx$1(StyledButtonBase$3, {
    ref: forwardedRef,
    css: css4,
    variant,
    onClick,
    type: type3,
    ...props,
    ...rootProps,
    children
  });
});
ButtonBase.displayName = "ButtonBase";
var ButtonSizeVariantEnum = /* @__PURE__ */(ButtonSizeVariantEnum2 => {
  ButtonSizeVariantEnum2["SMALL"] = "small";
  ButtonSizeVariantEnum2["MEDIUM"] = "medium";
  return ButtonSizeVariantEnum2;
})(ButtonSizeVariantEnum || {});
const ButtonSizeVariant = {
  small: {
    paddingTop: "$half",
    paddingBottom: "$half",
    textStyles: "button2"
  },
  medium: {
    paddingTop: "$1",
    paddingBottom: "$1",
    textStyles: "button1"
  }
};
const StyledButtonBase$2 = styled(ButtonBase, {
  variants: {
    size: ButtonSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const StyledButtonContentBase$1 = styled("span", {
  display: "flex",
  gap: "$1",
  variants: {
    hidden: {
      true: {
        visibility: "hidden"
      }
    }
  }
});
const LoaderStyleMap = {
  primary: "light",
  secondary: "dark",
  tertiary: "dark",
  education: "inherit",
  error: "light"
};
const LoaderStyle = {
  position: "absolute"
};
const ButtonComponent = forwardRef((_ref29, forwardedRef) => {
  let {
    size = "medium",
    variant = "primary",
    children,
    loading,
    ...props
  } = _ref29;
  const loaderVariant = LoaderStyleMap[variant] || "dark";
  return /* @__PURE__ */jsxs(StyledButtonBase$2, {
    ref: forwardedRef,
    size,
    variant,
    "aria-busy": loading,
    ...props,
    children: [loading && /* @__PURE__ */jsx$1(CircleLoader, {
      "aria-label": "loading",
      variant: loaderVariant,
      css: LoaderStyle
    }), /* @__PURE__ */jsx$1(StyledButtonContentBase$1, {
      "aria-hidden": loading,
      hidden: loading,
      children
    })]
  });
});
ButtonComponent.displayName = "Button";
const Button = {
  ...ButtonComponent,
  Icon: ButtonIcon
};
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$5);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$5, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$5, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$5.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$5(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$5.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$5 = _ref30 => {
  let {
    children
  } = _ref30;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$5(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$5;
}
function $5e63c961fc1ce211$var$mergeProps$5(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES$4 = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$4 = $8927f6f2acc4f386$var$NODES$4.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$5 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f$2(target, event) {
  if (target) flushSync(() => target.dispatchEvent(event));
}
function $addc16e1bbe58fd0$export$3a72a57244d6e765$2(onEscapeKeyDownProp) {
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onEscapeKeyDown]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE$2 = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$2 = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE$2 = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents$2;
const $5cb92bef7577960e$var$DismissableLayerContext$2 = /* @__PURE__ */createContext$1({
  layers: /* @__PURE__ */new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
  branches: /* @__PURE__ */new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    disableOutsidePointerEvents = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext$2);
  const [node1, setNode] = useState(null);
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setNode(node2));
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside$2(event => {
    const target = event.target;
    const isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  });
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside$2(event => {
    const target = event.target;
    const isFocusInBranch = [...context.branches].some(branch => branch.contains(target));
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  });
  $addc16e1bbe58fd0$export$3a72a57244d6e765$2(event => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  });
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents$2 = document.body.style.pointerEvents;
        document.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate$2();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents$2;
    };
  }, [node1, disableOutsidePointerEvents, context]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate$2();
    };
  }, [node1, context]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$2, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$2, handleUpdate);
  }, []);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
const $5cb92bef7577960e$export$4d5eb2109db14228 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext$2);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    const node2 = ref.current;
    if (node2) {
      context.branches.add(node2);
      return () => {
        context.branches.delete(node2);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, props, {
    ref: composedRefs
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside$2(onPointerDownOutside) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {});
  useEffect(() => {
    const handlePointerDown = event => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function () {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent$2($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$2, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          document.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          document.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      document.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("click", handleClickRef.current);
    };
  }, [handlePointerDownOutside]);
  return {
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside$2(onFocusOutside) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent$2($5cb92bef7577960e$var$FOCUS_OUTSIDE$2, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    document.addEventListener("focusin", handleFocus);
    return () => document.removeEventListener("focusin", handleFocus);
  }, [handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate$2() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE$2);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent$2(name, handler, detail, _ref31) {
  let {
    discrete
  } = _ref31;
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f$2(target, event);else target.dispatchEvent(event);
}
const $5cb92bef7577960e$export$be92b6f5f03c0fe9 = $5cb92bef7577960e$export$177fb62ff3ec1f22$2;
const $5cb92bef7577960e$export$aecb2ddcb55c95be = $5cb92bef7577960e$export$4d5eb2109db14228;
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "x" : "y";
}
function getLengthFromAxis(axis) {
  return axis === "y" ? "height" : "width";
}
function computeCoordsFromPlacement(_ref3, placement, rtl) {
  let {
    reference,
    floating
  } = _ref3;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const mainAxis = getMainAxisFromPlacement(placement);
  const length2 = getLengthFromAxis(mainAxis);
  const commonAlign = reference[length2] / 2 - floating[length2] / 2;
  const side = getSide(placement);
  const isVertical = mainAxis === "x";
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[mainAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[mainAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware: middleware2 = [],
    platform: platform2
  } = config2;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < middleware2.length; i++) {
    const {
      name,
      fn
    } = middleware2[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getSideObjectFromPadding(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}
async function detectOverflow(middlewareArguments, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = middlewareArguments;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: elementContext === "floating" ? {
      ...rects.floating,
      x: x2,
      y: y2
    } : rects.reference,
    offsetParent: await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating)),
    strategy
  }) : rects[elementContext]);
  return {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
}
const min$2 = Math.min;
const max$2 = Math.max;
function within(min$12, value, max$12) {
  return max$2(min$12, min$2(value, max$12));
}
const arrow$1 = options => ({
  name: "arrow",
  options,
  async fn(middlewareArguments) {
    const {
      element,
      padding = 0
    } = options != null ? options : {};
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2
    } = middlewareArguments;
    if (element == null) {
      return {};
    }
    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getMainAxisFromPlacement(placement);
    const alignment = getAlignment(placement);
    const length2 = getLengthFromAxis(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const minProp = axis === "y" ? "top" : "left";
    const maxProp = axis === "y" ? "bottom" : "right";
    const endDiff = rects.reference[length2] + rects.reference[axis] - coords[axis] - rects.floating[length2];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    if (clientSize === 0) {
      clientSize = rects.floating[length2];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const min2 = paddingObject[minProp];
    const max2 = clientSize - arrowDimensions[length2] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length2] / 2 + centerToReference;
    const offset2 = within(min2, center, max2);
    const alignmentPadding = alignment === "start" ? paddingObject[minProp] : paddingObject[maxProp];
    const shouldAddOffset = alignmentPadding > 0 && center !== offset2 && rects.reference[length2] <= rects.floating[length2];
    const alignmentOffset = shouldAddOffset ? center < min2 ? min2 - center : max2 - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2
      }
    };
  }
});
const hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, matched => hash$1[matched]);
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const mainAxis = getMainAxisFromPlacement(placement);
  const length2 = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length2] > rects.floating[length2]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}
const hash$2 = {
  start: "end",
  end: "start"
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, matched => hash$2[matched]);
}
const sides = ["top", "right", "bottom", "left"];
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
const flip2 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(middlewareArguments) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const side = getSide(placement);
      const isBasePlacement = side === initialPlacement;
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides(placement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
        overflows.push(overflow[main], overflow[cross]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every(side2 => side2 <= 0)) {
        var _middlewareData$flip$, _middlewareData$flip2;
        const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) != null ? _middlewareData$flip$ : 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = "bottom";
        switch (fallbackStrategy) {
          case "bestFit":
            {
              var _overflowsData$map$so;
              const placement2 = (_overflowsData$map$so = overflowsData.map(d2 => [d2, d2.overflows.filter(overflow2 => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$map$so[0].placement;
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
          case "initialPlacement":
            resetPlacement = initialPlacement;
            break;
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
const hide$1 = function (_temp) {
  let {
    strategy = "referenceHidden",
    ...detectOverflowOptions
  } = _temp === void 0 ? {} : _temp;
  return {
    name: "hide",
    async fn(middlewareArguments) {
      const {
        rects
      } = middlewareArguments;
      switch (strategy) {
        case "referenceHidden":
          {
            const overflow = await detectOverflow(middlewareArguments, {
              ...detectOverflowOptions,
              elementContext: "reference"
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case "escaped":
          {
            const overflow = await detectOverflow(middlewareArguments, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};
async function convertValueToCoords(middlewareArguments, value) {
  const {
    placement,
    platform: platform2,
    elements
  } = middlewareArguments;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getMainAxisFromPlacement(placement) === "x";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = typeof value === "function" ? value(middlewareArguments) : value;
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function (value) {
  if (value === void 0) {
    value = 0;
  }
  return {
    name: "offset",
    options: value,
    async fn(middlewareArguments) {
      const {
        x: x2,
        y: y2
      } = middlewareArguments;
      const diffCoords = await convertValueToCoords(middlewareArguments, value);
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: diffCoords
      };
    }
  };
};
function getCrossAxis(axis) {
  return axis === "x" ? "y" : "x";
}
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(middlewareArguments) {
      const {
        x: x2,
        y: y2,
        placement
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref3 => {
            let {
              x: x3,
              y: y3
            } = _ref3;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getSide(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...middlewareArguments,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2
        }
      };
    }
  };
};
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(middlewareArguments) {
      const {
        x: x2,
        y: y2,
        placement,
        rects,
        middlewareData
      } = middlewareArguments;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = options;
      const coords = {
        x: x2,
        y: y2
      };
      const mainAxis = getMainAxisFromPlacement(placement);
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = typeof offset2 === "function" ? offset2({
        ...rects,
        placement
      }) : offset2;
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2, _middlewareData$offse3, _middlewareData$offse4;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = ["top", "left"].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? (_middlewareData$offse = (_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) != null ? _middlewareData$offse : 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : (_middlewareData$offse3 = (_middlewareData$offse4 = middlewareData.offset) == null ? void 0 : _middlewareData$offse4[crossAxis]) != null ? _middlewareData$offse3 : 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
function isWindow$1(value) {
  return value && value.document && value.location && value.alert && value.setInterval;
}
function getWindow$1(node2) {
  if (node2 == null) {
    return window;
  }
  if (!isWindow$1(node2)) {
    const ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function getComputedStyle$1$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function getNodeName$1(node2) {
  return isWindow$1(node2) ? "" : node2 ? (node2.nodeName || "").toLowerCase() : "";
}
function getUAString$1() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(item => item.brand + "/" + item.version).join(" ");
  }
  return navigator.userAgent;
}
function isHTMLElement$1(value) {
  return value instanceof getWindow$1(value).HTMLElement;
}
function isElement$1(value) {
  return value instanceof getWindow$1(value).Element;
}
function isNode$1(value) {
  return value instanceof getWindow$1(value).Node;
}
function isShadowRoot$1(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow$1(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function isOverflowElement$1(element) {
  const {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle$1$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName$1(element));
}
function isContainingBlock(element) {
  const isFirefox = /firefox/i.test(getUAString$1());
  const css4 = getComputedStyle$1$1(element);
  return css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].includes(css4.willChange) || isFirefox && css4.willChange === "filter" || isFirefox && (css4.filter ? css4.filter !== "none" : false);
}
function isLayoutViewport$1() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString$1());
}
const min$1 = Math.min;
const max$1 = Math.max;
const round$1 = Math.round;
function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  let scaleX = 1;
  let scaleY = 1;
  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  const win = isElement$1(element) ? getWindow$1(element) : window;
  const addVisualOffsets = !isLayoutViewport$1() && isFixedStrategy;
  const x2 = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
  const y2 = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
  const width = clientRect.width / scaleX;
  const height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getDocumentElement$1(node2) {
  return ((isNode$1(node2) ? node2.ownerDocument : node2.document) || window.document).documentElement;
}
function getNodeScroll(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getNodeScroll(element).scrollLeft;
}
function isScaled(element) {
  const rect = getBoundingClientRect$1(element);
  return round$1(rect.width) !== element.offsetWidth || round$1(rect.height) !== element.offsetHeight;
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  const rect = getBoundingClientRect$1(element, isOffsetParentAnElement && isScaled(offsetParent), strategy === "fixed");
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName$1(offsetParent) !== "body" || isOverflowElement$1(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getParentNode$1(node2) {
  if (getNodeName$1(node2) === "html") {
    return node2;
  }
  return node2.assignedSlot || node2.parentNode || (isShadowRoot$1(node2) ? node2.host : null) || getDocumentElement$1(node2);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  let currentNode = getParentNode$1(element);
  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$1(currentNode) && !["html", "body"].includes(getNodeName$1(currentNode))) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  const window2 = getWindow$1(element);
  let offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName$1(offsetParent) === "html" || getNodeName$1(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getDimensions(element) {
  if (isHTMLElement$1(element)) {
    return {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }
  const rect = getBoundingClientRect$1(element);
  return {
    width: rect.width,
    height: rect.height
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref3) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref3;
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement$1(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName$1(offsetParent) !== "body" || isOverflowElement$1(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect$1(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    ...rect,
    x: rect.x - scroll.scrollLeft + offsets.x,
    y: rect.y - scroll.scrollTop + offsets.y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow$1(element);
  const html = getDocumentElement$1(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const layoutViewport = isLayoutViewport$1();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  const html = getDocumentElement$1(element);
  const scroll = getNodeScroll(element);
  const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  const height = max$1(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1$1(body || html).direction === "rtl") {
    x2 += max$1(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getNearestOverflowAncestor$1(node2) {
  const parentNode = getParentNode$1(node2);
  if (["html", "body", "#document"].includes(getNodeName$1(parentNode))) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement$1(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor$1(parentNode);
}
function getOverflowAncestors$1(node2, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor$1(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow$1(scrollableAncestor);
  const target = isBody ? [win].concat(win.visualViewport || [], isOverflowElement$1(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
  const updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(getOverflowAncestors$1(target));
}
function contains2(parent, child) {
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot$1(rootNode)) {
    let next2 = child;
    do {
      if (next2 && parent === next2) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect$1(element, false, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  return {
    top,
    left,
    x: left,
    y: top,
    right: left + element.clientWidth,
    bottom: top + element.clientHeight,
    width: element.clientWidth,
    height: element.clientHeight
  };
}
function getClientRectFromClippingAncestor(element, clippingParent, strategy) {
  if (clippingParent === "viewport") {
    return rectToClientRect(getViewportRect(element, strategy));
  }
  if (isElement$1(clippingParent)) {
    return getInnerBoundingClientRect(clippingParent, strategy);
  }
  return rectToClientRect(getDocumentRect(getDocumentElement$1(element)));
}
function getClippingAncestors(element) {
  const clippingAncestors = getOverflowAncestors$1(element);
  const canEscapeClipping = ["absolute", "fixed"].includes(getComputedStyle$1$1(element).position);
  const clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingAncestors.filter(clippingAncestors2 => isElement$1(clippingAncestors2) && contains2(clippingAncestors2, clipperElement) && getNodeName$1(clippingAncestors2) !== "body");
}
function getClippingRect(_ref3) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref3;
  const mainClippingAncestors = boundary === "clippingAncestors" ? getClippingAncestors(element) : [].concat(boundary);
  const clippingAncestors = [...mainClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
const platform = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement: isElement$1,
  getDimensions,
  getOffsetParent,
  getDocumentElement: getDocumentElement$1,
  getElementRects: _ref3 => {
    let {
      reference,
      floating,
      strategy
    } = _ref3;
    return {
      reference: getRectRelativeToOffsetParent(reference, getOffsetParent(floating), strategy),
      floating: {
        ...getDimensions(floating),
        x: 0,
        y: 0
      }
    };
  },
  getClientRects: element => Array.from(element.getClientRects()),
  isRTL: element => getComputedStyle$1$1(element).direction === "rtl"
};
function autoUpdate$1(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll: _ancestorScroll = true,
    ancestorResize: _ancestorResize = true,
    elementResize = true,
    animationFrame = false
  } = options;
  const ancestorScroll = _ancestorScroll && !animationFrame;
  const ancestorResize = _ancestorResize && !animationFrame;
  const ancestors = ancestorScroll || ancestorResize ? [...(isElement$1(reference) ? getOverflowAncestors$1(reference) : []), ...getOverflowAncestors$1(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  let observer = null;
  if (elementResize) {
    let initialUpdate = true;
    observer = new ResizeObserver(() => {
      if (!initialUpdate) {
        update();
      }
      initialUpdate = false;
    });
    isElement$1(reference) && !animationFrame && observer.observe(reference);
    observer.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect$1(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect$1(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _observer;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    (_observer = observer) == null ? void 0 : _observer.disconnect();
    observer = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const computePosition = (reference, floating, options) => computePosition$1(reference, floating, {
  platform,
  ...options
});
var index$1 = typeof document !== "undefined" ? useLayoutEffect$1 : useEffect;
function deepEqual(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (typeof a2 === "function" && a2.toString() === b2.toString()) {
    return true;
  }
  let length2, i, keys4;
  if (a2 && b2 && typeof a2 == "object") {
    if (Array.isArray(a2)) {
      length2 = a2.length;
      if (length2 != b2.length) return false;
      for (i = length2; i-- !== 0;) {
        if (!deepEqual(a2[i], b2[i])) {
          return false;
        }
      }
      return true;
    }
    keys4 = Object.keys(a2);
    length2 = keys4.length;
    if (length2 !== Object.keys(b2).length) {
      return false;
    }
    for (i = length2; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b2, keys4[i])) {
        return false;
      }
    }
    for (i = length2; i-- !== 0;) {
      const key = keys4[i];
      if (key === "_owner" && a2.$$typeof) {
        continue;
      }
      if (!deepEqual(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return a2 !== a2 && b2 !== b2;
}
function useLatestRef(value) {
  const ref = React.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(_temp) {
  let {
    middleware: middleware2,
    placement = "bottom",
    strategy = "absolute",
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React.useRef(null);
  const floating = React.useRef(null);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const cleanupRef = React.useRef(null);
  const [data, setData] = React.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware2);
  if (!deepEqual(latestMiddleware == null ? void 0 : latestMiddleware.map(_ref3 => {
    let {
      options
    } = _ref3;
    return options;
  }), middleware2 == null ? void 0 : middleware2.map(_ref22 => {
    let {
      options
    } = _ref22;
    return options;
  }))) {
    setLatestMiddleware(middleware2);
  }
  const update = React.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }
    computePosition(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then(data2 => {
      if (isMountedRef.current) {
        $7SXl2$reactdom.flushSync(() => {
          setData(data2);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index$1(() => {
    if (isMountedRef.current) {
      update();
    }
  }, [update]);
  const isMountedRef = React.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React.useCallback(() => {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
        cleanupRef.current = cleanupFn;
      } else {
        update();
      }
    }
  }, [update, whileElementsMountedRef]);
  const setReference = React.useCallback(node2 => {
    reference.current = node2;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React.useCallback(node2 => {
    floating.current = node2;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React.useMemo(() => ({
    reference,
    floating
  }), []);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, setReference, setFloating]);
}
const arrow = options => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};
const $7e8f5cd07187803e$export$21b07c8f274aebd5$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    width = 10,
    height = 5,
    ...arrowProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.svg, _extends$1({}, arrowProps, {
    ref: forwardedRef,
    width,
    height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */createElement$1("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
const $7e8f5cd07187803e$export$be92b6f5f03c0fe9$1 = $7e8f5cd07187803e$export$21b07c8f274aebd5$1;
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size, setSize] = useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver(entries => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else setSize(void 0);
  }, [element]);
  return size;
}
const $cf1ac5d9fe0e8206$var$POPPER_NAME$1 = "Popper";
const [$cf1ac5d9fe0e8206$var$createPopperContext$1, $cf1ac5d9fe0e8206$export$722aac194ae923$1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME$1);
const [$cf1ac5d9fe0e8206$var$PopperProvider$1, $cf1ac5d9fe0e8206$var$usePopperContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$POPPER_NAME$1);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9$1 = props => {
  const {
    __scopePopper,
    children
  } = props;
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperProvider$1, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
const $cf1ac5d9fe0e8206$var$ANCHOR_NAME$1 = "PopperAnchor";
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopper,
    virtualRef,
    ...anchorProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext$1($cf1ac5d9fe0e8206$var$ANCHOR_NAME$1, __scopePopper);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, anchorProps, {
    ref: composedRefs
  }));
});
const $cf1ac5d9fe0e8206$var$CONTENT_NAME$1 = "PopperContent";
const [$cf1ac5d9fe0e8206$var$PopperContentProvider$1, $cf1ac5d9fe0e8206$var$useContentContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider$1, $cf1ac5d9fe0e8206$var$usePositionContext$1] = $cf1ac5d9fe0e8206$var$createPopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const {
    __scopePopper,
    side = "bottom",
    sideOffset = 0,
    align = "center",
    alignOffset = 0,
    arrowPadding = 0,
    collisionBoundary = [],
    collisionPadding: collisionPaddingProp = 0,
    sticky = "partial",
    hideWhenDetached = false,
    avoidCollisions = true,
    ...contentProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, __scopePopper);
  const [content, setContent] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContent(node2));
  const [arrow$12, setArrow] = useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow$12);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull$1),
    altBoundary: hasExplicitBoundaries
  };
  const {
    reference,
    floating,
    strategy,
    x: x2,
    y: y2,
    placement,
    middlewareData,
    update
  } = useFloating({
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: autoUpdate$1,
    middleware: [offset({
      mainAxis: sideOffset + arrowHeight,
      alignmentAxis: alignOffset
    }), avoidCollisions ? shift({
      mainAxis: true,
      crossAxis: false,
      limiter: sticky === "partial" ? limitShift() : void 0,
      ...detectOverflowOptions
    }) : void 0, arrow$12 ? arrow({
      element: arrow$12,
      padding: arrowPadding
    }) : void 0, avoidCollisions ? flip2({
      ...detectOverflowOptions
    }) : void 0, $cf1ac5d9fe0e8206$var$transformOrigin$1({
      arrowWidth,
      arrowHeight
    }), hideWhenDetached ? hide$1({
      strategy: "referenceHidden"
    }) : void 0].filter($cf1ac5d9fe0e8206$var$isDefined$1)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    reference(context.anchor);
  }, [reference, context.anchor]);
  const isPlaced = x2 !== null && y2 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  const {
    hasParent,
    positionUpdateFns
  } = $cf1ac5d9fe0e8206$var$usePositionContext$1($cf1ac5d9fe0e8206$var$CONTENT_NAME$1, __scopePopper);
  const isRoot = !hasParent;
  useLayoutEffect$1(() => {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return () => {
        positionUpdateFns.delete(update);
      };
    }
  }, [isRoot, positionUpdateFns, update]);
  useLayoutEffect$1(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(fn => requestAnimationFrame(fn));
  }, [isRoot, isPlaced, positionUpdateFns]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      animation: !isPlaced ? "none" : void 0,
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */createElement$1("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x2)}px, ${Math.round(y2)}px, 0)` : "translate3d(0, -200%, 0)",
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(" ")
    }
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperContentProvider$1, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PositionContextProvider$1, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, commonProps)) : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, commonProps)));
});
const $cf1ac5d9fe0e8206$var$ARROW_NAME$1 = "PopperArrow";
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE$1 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0$1 = /* @__PURE__ */forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
  const {
    __scopePopper,
    ...arrowProps
  } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext$1($cf1ac5d9fe0e8206$var$ARROW_NAME$1, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE$1[contentContext.placedSide];
  return /* @__PURE__ */createElement$1("span", {
    ref: contentContext.onArrowChange,
    style: {
      position: "absolute",
      left: contentContext.arrowX,
      top: contentContext.arrowY,
      [baseSide]: 0,
      transformOrigin: {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[contentContext.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: `rotate(180deg)`,
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[contentContext.placedSide],
      visibility: contentContext.shouldHideArrow ? "hidden" : void 0
    }
  }, /* @__PURE__ */createElement$1($7e8f5cd07187803e$export$be92b6f5f03c0fe9$1, _extends$1({}, arrowProps, {
    ref: forwardedRef,
    style: {
      ...arrowProps.style,
      display: "block"
    }
  })));
});
function $cf1ac5d9fe0e8206$var$isDefined$1(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull$1(value) {
  return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin$1 = options => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const {
      placement,
      rects,
      middlewareData
    } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x2 = "";
    let y2 = "";
    if (placedSide === "bottom") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x2 = `${-arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x2 = `${rects.floating.width + arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x2,
        y: y2
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement$1(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9$1;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7$1 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d$1;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2$1 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc$1;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5$1 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0$1;
const $f1701beae083dbae$export$602eac185826482c$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const {
    container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body,
    ...portalProps
  } = props;
  return container ? /* @__PURE__ */$7SXl2$reactdom__default.createPortal( /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
const $f1701beae083dbae$export$be92b6f5f03c0fe9 = $f1701beae083dbae$export$602eac185826482c$2;
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$4);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$4, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$4, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$4.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$4(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$4.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$4 = _ref33 => {
  let {
    children
  } = _ref33;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$4(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$4;
}
function $5e63c961fc1ce211$var$mergeProps$4(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $ea1ef594cf570d83$export$439d29a4e110a164$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({}, props, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9$1 = $ea1ef594cf570d83$export$439d29a4e110a164$2;
const [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Tooltip", [$cf1ac5d9fe0e8206$export$722aac194ae923$1]);
const $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923$1();
const $a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
const $a093c7e1ec25a057$export$f78649fb9ca566b8 = props => {
  const {
    __scopeTooltip,
    delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION,
    skipDelayDuration = 300,
    disableHoverableContent = false,
    children
  } = props;
  const [isOpenDelayed, setIsOpenDelayed] = useState(true);
  const isPointerInTransitRef = useRef(false);
  const skipDelayTimerRef = useRef(0);
  useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed,
    delayDuration,
    onOpen: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(() => setIsOpenDelayed(true), skipDelayDuration);
    }, [skipDelayDuration]),
    isPointerInTransitRef,
    onPointerInTransitChange: useCallback(inTransit => {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent
  }, children);
};
const $a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
const $a093c7e1ec25a057$export$28c660c63b792dea = props => {
  const {
    __scopeTooltip,
    children,
    open: openProp,
    defaultOpen = false,
    onOpenChange,
    disableHoverableContent: disableHoverableContentProp,
    delayDuration: delayDurationProp
  } = props;
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = useState(null);
  const contentId = $1746a345f3d73bb7$export$f680877a34711e37();
  const openTimerRef = useRef(0);
  const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = useRef(false);
  const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: open2 => {
      if (open2) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
      } else providerContext.onClose();
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(open2);
    }
  });
  const stateAttribute = useMemo(() => {
    return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open1]);
  const handleOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  const handleClose = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [setOpen]);
  const handleDelayedOpen = useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [delayDuration, setOpen]);
  useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1, popperScope, /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContextProvider, {
    scope: __scopeTooltip,
    contentId,
    open: open1,
    stateAttribute,
    trigger,
    onTriggerChange: setTrigger,
    onTriggerEnter: useCallback(() => {
      if (providerContext.isOpenDelayed) handleDelayedOpen();else handleOpen();
    }, [providerContext.isOpenDelayed, handleDelayedOpen, handleOpen]),
    onTriggerLeave: useCallback(() => {
      if (disableHoverableContent) handleClose();else window.clearTimeout(openTimerRef.current);
    }, [handleClose, disableHoverableContent]),
    onOpen: handleOpen,
    onClose: handleClose,
    disableHoverableContent
  }, children));
};
const $a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $a093c7e1ec25a057$export$8c610744efcf8a1d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    ...triggerProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onTriggerChange);
  const isPointerDownRef = useRef(false);
  const hasPointerMoveOpenedRef = useRef(false);
  const handlePointerUp = useCallback(() => isPointerDownRef.current = false, []);
  useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [handlePointerUp]);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$b688253958b8dfe7$1, _extends$1({
    asChild: true
  }, popperScope), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    "aria-describedby": context.open ? context.contentId : void 0,
    "data-state": context.stateAttribute
  }, triggerProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, event => {
      if (event.pointerType === "touch") return;
      if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
        context.onTriggerEnter();
        hasPointerMoveOpenedRef.current = true;
      }
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, () => {
      context.onTriggerLeave();
      hasPointerMoveOpenedRef.current = false;
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, () => {
      isPointerDownRef.current = true;
      document.addEventListener("pointerup", handlePointerUp, {
        once: true
      });
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => {
      if (!isPointerDownRef.current) context.onOpen();
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, context.onClose),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      const isKeyboardClick = event.detail === 0;
      if (isKeyboardClick) context.onClose();
    })
  })));
});
const $a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
  forceMount: void 0
});
const $a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $a093c7e1ec25a057$export$e9003e2be37ec060 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const {
    forceMount = portalContext.forceMount,
    side = "top",
    ...contentProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.disableHoverableContent ? /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentImpl, _extends$1({
    side
  }, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentHoverable, _extends$1({
    side
  }, contentProps, {
    ref: forwardedRef
  })));
});
const $a093c7e1ec25a057$var$TooltipContentHoverable = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = useState(null);
  const {
    trigger,
    onClose
  } = context;
  const content = ref.current;
  const {
    onPointerInTransitChange
  } = providerContext;
  const handleRemoveGraceArea = useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  const handleCreateGraceArea = useCallback((event, hoverTarget) => {
    const currentTarget = event.currentTarget;
    const exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    const bleed = exitSide === "right" || exitSide === "bottom" ? -5 : 5;
    const isXAxis = exitSide === "right" || exitSide === "left";
    const startPoint = isXAxis ? {
      x: event.clientX + bleed,
      y: event.clientY
    } : {
      x: event.clientX,
      y: event.clientY + bleed
    };
    const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
    const graceArea = $a093c7e1ec25a057$var$getHull([startPoint, ...hoverTargetPoints]);
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [onPointerInTransitChange]);
  useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [handleRemoveGraceArea]);
  useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = event => handleCreateGraceArea(event, content);
      const handleContentLeave = event => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = event => {
        const target = event.target;
        const pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) handleRemoveGraceArea();else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$TooltipContentImpl, _extends$1({}, props, {
    ref: composedRefs
  }));
});
const [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
  isInside: false
});
const $a093c7e1ec25a057$var$TooltipContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    children,
    "aria-label": ariaLabel,
    onEscapeKeyDown,
    onPointerDownOutside,
    ...contentProps
  } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const {
    onClose
  } = context;
  useEffect(() => {
    document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    return () => document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
  }, [onClose]);
  useEffect(() => {
    if (context.trigger) {
      const handleScroll2 = event => {
        const target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll2, {
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll2, {
        capture: true
      });
    }
  }, [context.trigger, onClose]);
  return /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22$2, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: event => event.preventDefault(),
    onDismiss: onClose
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2$1, _extends$1({
    "data-state": context.stateAttribute
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      ["--radix-tooltip-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }), /* @__PURE__ */createElement$1($5e63c961fc1ce211$export$d9f1ccf0bdb05d45$4, null, children), /* @__PURE__ */createElement$1($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
    scope: __scopeTooltip,
    isInside: true
  }, /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$be92b6f5f03c0fe9$1, {
    id: context.contentId,
    role: "tooltip"
  }, ariaLabel || children))));
});
const $a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $a093c7e1ec25a057$export$c27ee0ad710f7559 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTooltip,
    ...arrowProps
  } = props;
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$21b07c8f274aebd5$1, _extends$1({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      return null;
  }
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
  const {
    top,
    right,
    bottom,
    left
  } = rect;
  return [{
    x: left,
    y: top
  }, {
    x: right,
    y: top
  }, {
    x: right,
    y: bottom
  }, {
    x: left,
    y: bottom
  }];
}
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
  const {
    x: x2,
    y: y2
  } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $a093c7e1ec25a057$var$getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a2, b2) => {
    if (a2.x < b2.x) return -1;else if (a2.x > b2.x) return 1;else if (a2.y < b2.y) return -1;else if (a2.y > b2.y) return 1;else return 0;
  });
  return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
}
function $a093c7e1ec25a057$var$getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p2 = points[i];
    while (upperHull.length >= 2) {
      const q2 = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) upperHull.pop();else break;
    }
    upperHull.push(p2);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i1 = points.length - 1; i1 >= 0; i1--) {
    const p2 = points[i1];
    while (lowerHull.length >= 2) {
      const q2 = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q2.x - r2.x) * (p2.y - r2.y) >= (q2.y - r2.y) * (p2.x - r2.x)) lowerHull.pop();else break;
    }
    lowerHull.push(p2);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;else return upperHull.concat(lowerHull);
}
const $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
const $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
const $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
const $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
const $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;
const TooltipBorderRadiusVariant = {
  default: {},
  round: {
    "&:focus-visible": {
      borderRadius: "50%",
      outline: "solid 2px $blue6"
    }
  }
};
const StyledTooltipContent = styled($a093c7e1ec25a057$export$7c6e2c02157bb7d2, {
  maxWidth: "180px",
  boxShadow: "$inflate24",
  textStyles: "metadata",
  paddingX: "$1",
  paddingY: "$half",
  borderRadius: "$1",
  zIndex: "$tooltip",
  backgroundColor: "$white",
  whiteSpace: "pre-line"
});
const StyledTooltipArrow = styled($a093c7e1ec25a057$export$21b07c8f274aebd5, {
  fill: "$white"
});
const StyledTooltipTrigger = styled($a093c7e1ec25a057$export$41fb9f06171c75f4, {
  background: "transparent",
  border: "none",
  margin: 0,
  padding: 0,
  variants: {
    activeBorderRadius: TooltipBorderRadiusVariant
  }
});
const TOOLTIP_WIDTH_PX = 10;
const TOOLTIP_HEIGHT_PX = 4;
const Tooltip = _ref34 => {
  let {
    children,
    content,
    side = "bottom",
    avoidCollisions = true,
    open: open2,
    sideOffset,
    triggerAsChild,
    activeBorderRadius,
    ...rest
  } = _ref34;
  if (!content) {
    return /* @__PURE__ */jsx$1(Fragment, {
      children
    });
  }
  return /* @__PURE__ */jsx$1($a093c7e1ec25a057$export$2881499e37b75b9a, {
    children: /* @__PURE__ */jsxs($a093c7e1ec25a057$export$be92b6f5f03c0fe9, {
      open: open2,
      children: [/* @__PURE__ */jsx$1(StyledTooltipTrigger, {
        asChild: triggerAsChild,
        activeBorderRadius,
        children
      }), /* @__PURE__ */jsxs(StyledTooltipContent, {
        ...rest,
        side,
        sideOffset: sideOffset || 4,
        avoidCollisions,
        children: [content, /* @__PURE__ */jsx$1(StyledTooltipArrow, {
          width: TOOLTIP_WIDTH_PX,
          height: TOOLTIP_HEIGHT_PX
        })]
      })]
    })
  });
};
var TooltipSideVariantEnum = /* @__PURE__ */(TooltipSideVariantEnum2 => {
  TooltipSideVariantEnum2["Top"] = "top";
  TooltipSideVariantEnum2["Right"] = "right";
  TooltipSideVariantEnum2["Bottom"] = "bottom";
  TooltipSideVariantEnum2["Left"] = "left";
  return TooltipSideVariantEnum2;
})(TooltipSideVariantEnum || {});
var TooltipBorderRadiusVariantEnum = /* @__PURE__ */(TooltipBorderRadiusVariantEnum2 => {
  TooltipBorderRadiusVariantEnum2["DEFAULT"] = "default";
  TooltipBorderRadiusVariantEnum2["ROUND"] = "round";
  return TooltipBorderRadiusVariantEnum2;
})(TooltipBorderRadiusVariantEnum || {});
var IconButtonSizeVariantEnum = /* @__PURE__ */(IconButtonSizeVariantEnum2 => {
  IconButtonSizeVariantEnum2["SMALL"] = "small";
  IconButtonSizeVariantEnum2["DEFAULT"] = "default";
  return IconButtonSizeVariantEnum2;
})(IconButtonSizeVariantEnum || {});
const IconButtonSizeVariant = {
  small: {
    width: "$3",
    height: "$3"
  },
  default: {
    width: "$4",
    height: "$4"
  }
};
const StyledButtonBase$1 = styled(ButtonBase, {
  paddingLeft: "0",
  paddingRight: "0",
  minWidth: "auto",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  variants: {
    size: IconButtonSizeVariant
  },
  defaultVariants: {
    size: "default"
  }
});
const IconButton = forwardRef((_ref35, forwardedRef) => {
  let {
    size = "default",
    variant = "tertiary",
    icon: icon3,
    iconVariant = "dark",
    css: css4,
    title,
    children,
    disabled: disabled2,
    hideTooltip,
    rootProps,
    ...props
  } = _ref35;
  const iconSize = size === IconButtonSizeVariantEnum.DEFAULT ? IconSizeVariantEnum.MEDIUM : IconSizeVariantEnum.SMALL;
  const calculatedIconVariant = disabled2 ? "disabled" : iconVariant;
  return /* @__PURE__ */jsx$1(Tooltip, {
    content: title,
    side: "top",
    hidden: hideTooltip || !title,
    triggerAsChild: true,
    children: /* @__PURE__ */jsxs(StyledButtonBase$1, {
      ref: forwardedRef,
      size,
      variant,
      css: css4,
      disabled: disabled2,
      rootProps,
      ...props,
      children: [isValidElement(icon3) && icon3, !isValidElement(icon3) && /* @__PURE__ */jsx$1(Icon, {
        icon: icon3,
        size: iconSize,
        variant: calculatedIconVariant
      }), children]
    })
  });
});
IconButton.displayName = "IconButton";
const $8927f6f2acc4f386$var$NODES$3 = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$3 = $8927f6f2acc4f386$var$NODES$3.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$6 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
const $ea1ef594cf570d83$export$439d29a4e110a164$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$3.span, _extends$1({}, props, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a164$1;
var faCheck$5 = {};
Object.defineProperty(faCheck$5, "__esModule", {
  value: true
});
var faCheck_2$2 = faCheck$5.faCheck = void 0;
const faCheck$4 = {
  prefix: "fal",
  iconName: "faCheck",
  icon: [512, 512, [], "", "M475.3 123.3l-272 272C200.2 398.4 196.1 400 192 400s-8.188-1.562-11.31-4.688l-144-144c-6.25-6.25-6.25-16.38 0-22.62s16.38-6.25 22.62 0L192 361.4l260.7-260.7c6.25-6.25 16.38-6.25 22.62 0S481.6 117.1 475.3 123.3z"]
};
faCheck_2$2 = faCheck$5.faCheck = faCheck$4;
var faInfo$1 = {};
Object.defineProperty(faInfo$1, "__esModule", {
  value: true
});
var faInfo_2 = faInfo$1.faInfo = void 0;
const faInfo = {
  prefix: "fal",
  iconName: "faInfo",
  icon: [192, 512, [], "", "M96 96c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99S64 46.33 64 64S78.33 96 96 96zM176 448h-64V176C112 167.2 104.8 160 96 160H48C39.16 160 32 167.2 32 176S39.16 192 48 192h32v256h-64C7.156 448 0 455.2 0 464S7.156 480 16 480h160c8.844 0 16-7.156 16-16S184.8 448 176 448z"]
};
faInfo_2 = faInfo$1.faInfo = faInfo;
var faMinus$3 = {};
Object.defineProperty(faMinus$3, "__esModule", {
  value: true
});
var faMinus_2$1 = faMinus$3.faMinus = void 0;
const faMinus$2 = {
  prefix: "fal",
  iconName: "faMinus",
  icon: [448, 512, [], "", "M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z"]
};
faMinus_2$1 = faMinus$3.faMinus = faMinus$2;
var faTriangleExclamation$1 = {};
Object.defineProperty(faTriangleExclamation$1, "__esModule", {
  value: true
});
var faTriangleExclamation_2 = faTriangleExclamation$1.faTriangleExclamation = void 0;
const faTriangleExclamation = {
  prefix: "fal",
  iconName: "faTriangleExclamation",
  icon: [512, 512, [], "", "M256 360c-13.25 0-23.1 10.74-23.1 24c0 13.25 10.75 24 23.1 24c13.25 0 23.1-10.75 23.1-24C280 370.7 269.3 360 256 360zM256 320c8.843 0 15.1-7.156 15.1-16V160c0-8.844-7.155-16-15.1-16S240 151.2 240 160v144C240 312.8 247.2 320 256 320zM504.3 397.3L304.5 59.38C294.4 42.27 276.2 32.03 256 32C235.8 32 217.7 42.22 207.5 59.36l-199.9 338c-10.05 16.97-10.2 37.34-.4218 54.5C17.29 469.5 35.55 480 56.1 480h399.9c20.51 0 38.75-10.53 48.81-28.17C514.6 434.7 514.4 414.3 504.3 397.3zM476.1 435.1C472.7 443.5 464.8 448 455.1 448H56.1c-8.906 0-16.78-4.484-21.08-12c-4.078-7.156-4.015-15.3 .1562-22.36L235.1 75.66C239.4 68.36 247.2 64 256 64c0 0-.0156 0 0 0c8.765 .0156 16.56 4.359 20.86 11.64l199.9 338C480.1 420.7 481.1 428.8 476.1 435.1z"]
};
faTriangleExclamation_2 = faTriangleExclamation$1.faTriangleExclamation = faTriangleExclamation;
var faXmark$3 = {};
Object.defineProperty(faXmark$3, "__esModule", {
  value: true
});
var faXmark_2$1 = faXmark$3.faXmark = void 0;
const faXmark$2 = {
  prefix: "fal",
  iconName: "faXmark",
  icon: [320, 512, [], "", "M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"]
};
faXmark_2$1 = faXmark$3.faXmark = faXmark$2;
const StatusIconContainerTypeVariant = {
  info: {
    backgroundColor: "$blue6"
  },
  success: {
    backgroundColor: "$green6"
  },
  error: {
    backgroundColor: "$red6"
  },
  warning: {
    paddingTop: "2px",
    paddingBottom: "$half",
    backgroundColor: "$yellow4"
  },
  archived: {
    backgroundColor: "$gray6"
  }
};
const StyledStatusIcon = styled(Flex, {
  size: "$2",
  minWidth: "$2",
  minHeight: "$2",
  borderRadius: "$round",
  variants: {
    variant: StatusIconContainerTypeVariant
  }
});
const StatusIconFillColorMap = {
  info: "light",
  success: "light",
  error: "light",
  warning: "dark",
  archived: "light"
};
const StatusIconMap = {
  info: faInfo_2,
  success: faCheck_2$2,
  error: faXmark_2$1,
  warning: faTriangleExclamation_2,
  archived: faMinus_2$1
};
const StatusIcon = forwardRef((_ref36, forwardedRef) => {
  let {
    variant = "info",
    ...props
  } = _ref36;
  return /* @__PURE__ */jsx$1(StyledStatusIcon, {
    variant,
    justifyContent: "center",
    alignItems: "center",
    ref: forwardedRef,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */jsx$1(Icon, {
      size: "extra-small",
      variant: StatusIconFillColorMap[variant],
      icon: StatusIconMap[variant]
    })
  });
});
StatusIcon.displayName = "StatusIcon";
var StatusIconVariantTypeEnum = /* @__PURE__ */(StatusIconVariantTypeEnum2 => {
  StatusIconVariantTypeEnum2["INFO"] = "info";
  StatusIconVariantTypeEnum2["SUCCESS"] = "success";
  StatusIconVariantTypeEnum2["ERROR"] = "error";
  StatusIconVariantTypeEnum2["WARNING"] = "warning";
  StatusIconVariantTypeEnum2["ARCHIVED"] = "archived";
  return StatusIconVariantTypeEnum2;
})(StatusIconVariantTypeEnum || {});
const StatusMessageLabelColorVariant = {
  info: {
    color: "$blue8"
  },
  success: {
    color: "$green8"
  },
  error: {
    color: "$red8"
  },
  warning: {
    color: "$yellow8"
  },
  archived: {
    color: "$gray8"
  }
};
const StatusMessageText = styled(Text, {
  variants: {
    color: StatusMessageLabelColorVariant
  }
});
const StatusMessageIconContainer = styled(Box, {
  alignSelf: "flex-start"
});
const StatusMessage = forwardRef((_ref37, forwardedRef) => {
  let {
    variant = "info",
    children,
    textId,
    rootProps
  } = _ref37;
  const ariaLive = variant === "error" ? "assertive" : "polite";
  return /* @__PURE__ */jsxs(Flex, {
    ref: forwardedRef,
    gap: "half",
    alignItems: "center",
    ...rootProps,
    children: [/* @__PURE__ */jsx$1(StatusMessageIconContainer, {
      children: /* @__PURE__ */jsx$1(StatusIcon, {
        variant
      })
    }), /* @__PURE__ */jsx$1(StatusMessageText, {
      id: textId,
      "aria-live": ariaLive,
      variant: "metadata",
      color: variant,
      children
    })]
  });
});
StatusMessage.displayName = "StatusMessage";
var StatusMessageVariantTypeEnum = /* @__PURE__ */(StatusMessageVariantTypeEnum2 => {
  StatusMessageVariantTypeEnum2["INFO"] = "info";
  StatusMessageVariantTypeEnum2["SUCCESS"] = "success";
  StatusMessageVariantTypeEnum2["ERROR"] = "error";
  StatusMessageVariantTypeEnum2["WARNING"] = "warning";
  StatusMessageVariantTypeEnum2["ARCHIVED"] = "archived";
  return StatusMessageVariantTypeEnum2;
})(StatusMessageVariantTypeEnum || {});
var InputSizeVariantEnum = /* @__PURE__ */(InputSizeVariantEnum2 => {
  InputSizeVariantEnum2["SMALL"] = "small";
  InputSizeVariantEnum2["MEDIUM"] = "medium";
  InputSizeVariantEnum2["LARGE"] = "large";
  InputSizeVariantEnum2["X_LARGE"] = "x-large";
  InputSizeVariantEnum2["FULL_WIDTH"] = "full-width";
  return InputSizeVariantEnum2;
})(InputSizeVariantEnum || {});
const InputContainerSizeVariant = {
  small: {
    width: "240px"
  },
  medium: {
    width: "280px"
  },
  large: {
    width: "372px"
  },
  "x-large": {
    width: "550px"
  },
  "full-width": {
    width: "100%"
  }
};
const InputSizeVariant = {
  small: {
    width: "120px"
  },
  medium: {
    width: "280px"
  },
  large: {
    width: "372px"
  },
  "x-large": {
    width: "550px"
  },
  "full-width": {
    width: "100%"
  }
};
const InputRoot = styled(Flex, {
  variants: {
    size: InputContainerSizeVariant
  },
  defaultVariants: {
    size: InputSizeVariantEnum.MEDIUM
  }
});
const StyledLabel$2 = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center"
});
const InputField = styled("input", {
  padding: 0,
  backgroundColor: "transparent",
  height: "100%",
  width: "100%",
  border: "none",
  display: "block",
  textStyles: "body",
  fontFamily: "$primary",
  boxSizing: "border-box",
  color: "$body",
  "&::placeholder": {
    color: "$gray8"
  },
  "&:focus": {
    outline: "none"
  },
  "&:disabled": {
    color: "inherit",
    cursor: "not-allowed"
  }
});
const InputContent = styled(Flex, {
  height: "$4",
  backgroundColor: "$white",
  border: "1px solid $blue3",
  borderRadius: "$1",
  textStyles: "body",
  padding: "$half $1",
  boxSizing: "border-box",
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:focus-visible": {
    outline: "1px solid $blue6"
  },
  "&:focus-within": {
    border: "1px solid $blue5",
    outlineOffset: 1
  },
  variants: {
    size: InputSizeVariant,
    isInvalid: {
      true: {
        borderColor: "$red6"
      }
    },
    isSuccessful: {
      true: {
        borderColor: "$green6"
      }
    },
    isDisabled: {
      true: {
        backgroundColor: "$gray2",
        borderColor: "$gray3",
        cursor: "not-allowed",
        "&:hover": {
          borderColor: "$gray3"
        },
        "& + label": {
          cursor: "not-allowed"
        }
      }
    }
  },
  defaultVariants: {
    size: InputSizeVariantEnum.MEDIUM
  }
});
const InputLabel = _ref38 => {
  let {
    id,
    label,
    htmlFor,
    hideLabel,
    showOptionalLabel
  } = _ref38;
  if (hideLabel) {
    return /* @__PURE__ */jsx$1($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
      children: label
    });
  }
  return /* @__PURE__ */jsxs(StyledLabel$2, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx$1(Text, {
      children: label
    }), showOptionalLabel && /* @__PURE__ */jsx$1(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const InputDescription = _ref39 => {
  let {
    id,
    children
  } = _ref39;
  if (!children) {
    return null;
  }
  return /* @__PURE__ */jsx$1(Text, {
    variant: "metadata",
    id,
    children
  });
};
const InputErrorState = _ref40 => {
  let {
    id,
    errorMessage
  } = _ref40;
  if (!errorMessage) {
    return null;
  }
  return /* @__PURE__ */jsx$1(StatusMessage, {
    textId: id,
    variant: "error",
    children: errorMessage
  });
};
const InputSuccessState = _ref41 => {
  let {
    id,
    successMessage
  } = _ref41;
  if (!successMessage) {
    return null;
  }
  return /* @__PURE__ */jsx$1(StatusMessage, {
    textId: id,
    variant: "success",
    children: successMessage
  });
};
const InputBase = {
  Root: InputRoot,
  Label: InputLabel,
  Content: InputContent,
  Field: InputField,
  Description: InputDescription,
  ErrorState: InputErrorState,
  SuccessState: InputSuccessState
};
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs$1() {
  for (var _len10 = arguments.length, refs = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    refs[_key10] = arguments[_key10];
  }
  return node2 => refs.forEach(ref => setRef(ref, node2));
}
function useComposedRefs$1() {
  for (var _len11 = arguments.length, refs = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    refs[_key11] = arguments[_key11];
  }
  return React.useCallback(composeRefs$1(...refs), refs);
}
const toHyphenCase = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (str === null) {
    return;
  }
  return str.trim().replace(/([A-Z])/g, "-$1").replace(/[-_\s]+/g, "-").toLowerCase();
};
var faAngleDown$1 = {};
Object.defineProperty(faAngleDown$1, "__esModule", {
  value: true
});
var faAngleDown_2 = faAngleDown$1.faAngleDown = void 0;
const faAngleDown = {
  prefix: "fat",
  iconName: "faAngleDown",
  icon: [384, 512, [], "", "M191.1 352c-1.1 0-3.969-.7344-5.531-2.219L34.47 205.8c-3.187-3.047-3.312-8.125-.25-11.31c3.094-3.188 8.156-3.281 11.31-.25l146.5 138.7l146.5-138.7c3.219-3.031 8.281-2.938 11.31 .25c3.062 3.188 2.937 8.266-.25 11.31l-151.1 144C195.1 351.3 193.1 352 191.1 352z"]
};
faAngleDown_2 = faAngleDown$1.faAngleDown = faAngleDown;
var faAngleUp$1 = {};
Object.defineProperty(faAngleUp$1, "__esModule", {
  value: true
});
var faAngleUp_2 = faAngleUp$1.faAngleUp = void 0;
const faAngleUp = {
  prefix: "fat",
  iconName: "faAngleUp",
  icon: [384, 512, [], "", "M192 160c1.1 0 3.969 .7344 5.531 2.219l151.1 144c3.187 3.047 3.312 8.125 .25 11.31c-3.094 3.188-8.156 3.281-11.31 .25L192 179.1L45.53 317.8c-3.219 3.031-8.281 2.938-11.31-.25c-3.062-3.188-2.937-8.266 .25-11.31l151.1-144C188 160.7 190 160 192 160z"]
};
faAngleUp_2 = faAngleUp$1.faAngleUp = faAngleUp;
const NumberInputField = styled(InputBase.Field, {
  appearance: "textfield",
  "&::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  },
  "&::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  }
});
const StyledNumberInputButton = styled(IconButton, {
  "&:disabled": {
    backgroundColor: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  defaultVariants: {
    size: void 0
  }
});
const NumberInputContent = styled(Flex, {
  width: "100%"
});
const NumberInputButton = _ref42 => {
  let {
    icon: icon3,
    title,
    onClick,
    disabled: disabled2
  } = _ref42;
  return /* @__PURE__ */jsx$1(StyledNumberInputButton, {
    title,
    icon: icon3,
    disabled: disabled2,
    iconVariant: "dark",
    onClick,
    css: {
      width: "$2",
      height: "12px",
      padding: "$half"
    }
  });
};
const InputNumber = forwardRef((_ref43, forwardedRef) => {
  let {
    ref,
    errorMessage = "",
    successMessage = "",
    label,
    labelOptional,
    hideLabel,
    description,
    disabled: disabled2,
    onChange: onChange3,
    value,
    step = 1,
    min: min2,
    max: max2,
    rootProps,
    size = "small",
    ...props
  } = _ref43;
  var _a, _b;
  const canIncreaseValue = max2 === void 0 || value === void 0 ? true : max2 > value;
  const canDecreaseValue = min2 === void 0 || value === void 0 ? true : min2 < value;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-number-input-element-${name}`;
  const inputLabelElementId = `dds-number-input-label-${name}`;
  const descriptionElementId = `dds-number-input-description-${name}`;
  const errorMessageElementId = `dds-number-input-error-message-${name}`;
  const successMessageElementId = `dds-number-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  const handleChange = updatedValue => {
    onChange3 && onChange3(updatedValue);
  };
  const decrementCount = () => {
    const inputValue = Number(value != null ? value : 0);
    handleChange(inputValue - Number(step));
  };
  const incrementCount = () => {
    const inputValue = Number(value != null ? value : 0);
    handleChange(inputValue + Number(step));
  };
  return /* @__PURE__ */jsx$1(InputBase.Root, {
    direction: "column",
    size,
    children: /* @__PURE__ */jsxs(NumberInputContent, {
      direction: "column",
      gap: "half",
      grow: "1",
      children: [/* @__PURE__ */jsx$1(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        hideLabel,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsxs(InputBase.Content, {
        alignItems: "center",
        isInvalid: !!errorMessage.length,
        isSuccessful: !!successMessage.length,
        isDisabled: disabled2,
        size,
        children: [/* @__PURE__ */jsx$1(NumberInputField, {
          ref: composedRefs,
          disabled: disabled2,
          onChange: evt => {
            var _a2;
            return handleChange((_a2 = evt == null ? void 0 : evt.target) == null ? void 0 : _a2.value);
          },
          type: "number",
          id: inputElementId,
          "aria-invalid": !!errorMessage.length,
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedById,
          value,
          min: min2,
          max: max2,
          onWheel: e2 => e2.currentTarget.blur(),
          ...props,
          ...rootProps
        }), /* @__PURE__ */jsxs(Flex, {
          direction: "column",
          gap: "half",
          children: [/* @__PURE__ */jsx$1(NumberInputButton, {
            title: "increase value",
            icon: faAngleUp_2,
            onClick: incrementCount,
            disabled: disabled2 || !canIncreaseValue
          }), /* @__PURE__ */jsx$1(NumberInputButton, {
            title: "decrease value",
            icon: faAngleDown_2,
            onClick: decrementCount,
            disabled: disabled2 || !canDecreaseValue
          })]
        })]
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputNumber.displayName = "InputNumber";
const inputContentWithPartials = css$4({
  variants: {
    hasPrefix: {
      true: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
    hasSuffix: {
      true: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  }
});
const InputPartialContentContainer = styled(Flex, {
  variants: {
    fullWidth: FullWidthVariant,
    size: InputSizeVariant
  }
});
const StyledPartialInputInfo = styled(Flex, {
  padding: "$1",
  backgroundColor: "$blue1",
  borderColor: "$blue3",
  borderWidth: "1px",
  borderStyle: "solid",
  height: "32px",
  whiteSpace: "nowrap",
  cursor: "default",
  boxSizing: "border-box",
  variants: {
    roundedBorder: {
      left: {
        borderTopLeftRadius: "$1",
        borderBottomLeftRadius: "$1",
        borderRightWidth: 0
      },
      right: {
        borderTopRightRadius: "$1",
        borderBottomRightRadius: "$1",
        borderLeftWidth: 0
      }
    }
  },
  defaultVariants: {
    roundedBorder: "left"
  }
});
const PartialInputInfo = _ref44 => {
  let {
    children,
    roundedBorder
  } = _ref44;
  return /* @__PURE__ */jsx$1(StyledPartialInputInfo, {
    roundedBorder,
    alignItems: "center",
    children: /* @__PURE__ */jsx$1(Text, {
      children
    })
  });
};
const InputPartial = forwardRef((_ref45, forwardedRef) => {
  let {
    ref,
    errorMessage = "",
    successMessage = "",
    label,
    hideLabel,
    labelOptional,
    description,
    disabled: disabled2,
    value,
    prefix: prefix2,
    suffix,
    size = "medium",
    enforceHardWidth = false,
    rootProps,
    ...props
  } = _ref45;
  var _a, _b;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-partial-input-element-${name}`;
  const inputLabelElementId = `dds-partial-input-label-${name}`;
  const descriptionElementId = `dds-partial-input-description-${name}`;
  const errorMessageElementId = `dds-partial-input-error-message-${name}`;
  const successMessageElementId = `dds-partial-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  return /* @__PURE__ */jsx$1(InputBase.Root, {
    direction: "column",
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      css: {
        width: "inherit"
      },
      children: [/* @__PURE__ */jsx$1(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        hideLabel,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsxs(InputPartialContentContainer, {
        fullWidth: size === "full-width",
        size: enforceHardWidth ? size : void 0,
        gap: 0,
        children: [prefix2 && /* @__PURE__ */jsx$1(PartialInputInfo, {
          roundedBorder: "left",
          children: prefix2
        }), /* @__PURE__ */jsx$1(InputBase.Content, {
          className: inputContentWithPartials({
            hasPrefix: !!prefix2,
            hasSuffix: !!suffix
          }),
          alignItems: "center",
          isInvalid: !!errorMessage.length,
          isSuccessful: !!successMessage.length,
          isDisabled: disabled2,
          size,
          children: /* @__PURE__ */jsx$1(InputBase.Field, {
            ref: composedRefs,
            disabled: disabled2,
            id: inputElementId,
            "aria-invalid": !!errorMessage.length,
            "aria-errormessage": errorMessageElementId,
            "aria-describedby": describedById,
            value,
            ...props,
            ...rootProps
          })
        }), suffix && /* @__PURE__ */jsx$1(PartialInputInfo, {
          roundedBorder: "right",
          children: suffix
        })]
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputPartial.displayName = "InputPartial";
const InputText = forwardRef((_ref46, forwardedRef) => {
  let {
    ref,
    size,
    errorMessage = "",
    successMessage = "",
    hideLabel,
    label,
    description,
    disabled: disabled2,
    labelOptional,
    rootProps,
    ...props
  } = _ref46;
  var _a, _b;
  const composedRefs = useComposedRefs$1(forwardedRef, ref);
  const name = toHyphenCase(label);
  const inputElementId = `dds-text-input-element-${name}`;
  const inputLabelElementId = `dds-text-input-label-${name}`;
  const descriptionElementId = `dds-text-input-description-${name}`;
  const errorMessageElementId = `dds-text-input-error-message-${name}`;
  const successMessageElementId = `dds-text-input-success-message-${name}`;
  const describedById = (_b = (_a = errorMessage && errorMessageElementId) != null ? _a : successMessage && successMessageElementId) != null ? _b : description && descriptionElementId;
  return /* @__PURE__ */jsx$1(InputBase.Root, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      grow: "1",
      children: [/* @__PURE__ */jsx$1(InputBase.Label, {
        id: inputLabelElementId,
        htmlFor: inputElementId,
        label,
        hideLabel,
        showOptionalLabel: labelOptional
      }), /* @__PURE__ */jsx$1(InputBase.Content, {
        isInvalid: !!(errorMessage == null ? void 0 : errorMessage.length),
        isSuccessful: !!(successMessage == null ? void 0 : successMessage.length),
        isDisabled: disabled2,
        size,
        children: /* @__PURE__ */jsx$1(InputBase.Field, {
          ref: composedRefs,
          disabled: disabled2,
          type: "text",
          name,
          id: inputElementId,
          "aria-invalid": !!(errorMessage == null ? void 0 : errorMessage.length),
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedById,
          ...props,
          ...rootProps
        })
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage
      })]
    })
  });
});
InputText.displayName = "InputText";
const CheckboxGroupContext = createContext$1({});
const useCheckboxGroupContext$1 = () => useContext(CheckboxGroupContext);
function composeRefs() {
  for (var _len12 = arguments.length, o2 = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    o2[_key12] = arguments[_key12];
  }
  return e2 => o2.forEach(o3 => function (o4, e3) {
    typeof o4 == "function" ? o4(e3) : o4 != null && (o4.current = e3);
  }(o3, e2));
}
function useComposedRefs() {
  for (var _len13 = arguments.length, e2 = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    e2[_key13] = arguments[_key13];
  }
  return React.useCallback(composeRefs(...e2), e2);
}
const Slot = /* @__PURE__ */React.forwardRef((e2, o2) => {
  const {
    children: a2,
    ...s2
  } = e2;
  return React.Children.toArray(a2).some(l$1) ? /* @__PURE__ */React.createElement(React.Fragment, null, React.Children.map(a2, e3 => l$1(e3) ? /* @__PURE__ */React.createElement(n$1, _extends$1({}, s2, {
    ref: o2
  }), e3.props.children) : e3)) : /* @__PURE__ */React.createElement(n$1, _extends$1({}, s2, {
    ref: o2
  }), a2);
});
Slot.displayName = "Slot";
const n$1 = /* @__PURE__ */React.forwardRef((r2, n2) => {
  const {
    children: l2,
    ...a2
  } = r2;
  return React.isValidElement(l2) ? /* @__PURE__ */React.cloneElement(l2, {
    ...o(a2, l2.props),
    ref: composeRefs(n2, l2.ref)
  }) : React.Children.count(l2) > 1 ? React.Children.only(null) : null;
});
n$1.displayName = "SlotClone";
const Slottable = _ref47 => {
  let {
    children: e2
  } = _ref47;
  return /* @__PURE__ */React.createElement(React.Fragment, null, e2);
};
function l$1(e2) {
  return React.isValidElement(e2) && e2.type === Slottable;
}
function o(e2, t2) {
  const r2 = {
    ...t2
  };
  for (const n2 in t2) {
    const l2 = e2[n2],
      o2 = t2[n2];
    /^on[A-Z]/.test(n2) ? r2[n2] = function () {
      o2 == null || o2(...arguments), l2 == null || l2(...arguments);
    } : n2 === "style" ? r2[n2] = {
      ...l2,
      ...o2
    } : n2 === "className" && (r2[n2] = [l2, o2].filter(Boolean).join(" "));
  }
  return {
    ...e2,
    ...r2
  };
}
const Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o2, i) => ({
  ...o2,
  [i]: /* @__PURE__ */React.forwardRef((o3, m2) => {
    const {
        asChild: a2,
        ...s2
      } = o3,
      n2 = a2 ? Slot : i;
    return React.useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []), /* @__PURE__ */React.createElement(n2, _extends$1({}, s2, {
      ref: m2
    }));
  })
}), {});
const useLayoutEffect = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? React.useLayoutEffect : () => {};
const Presence = u2 => {
  const {
      present: o2,
      children: i
    } = u2,
    s2 = function (n2) {
      const [u3, o3] = React.useState(),
        i2 = React.useRef({}),
        s3 = React.useRef(n2),
        c3 = React.useRef("none"),
        a3 = n2 ? "mounted" : "unmounted",
        [d2, m2] = function (e2, n3) {
          return React.useReducer((e3, t2) => {
            const r2 = n3[e3][t2];
            return r2 != null ? r2 : e3;
          }, e2);
        }(a3, {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        });
      return React.useEffect(() => {
        const e2 = r$1(i2.current);
        c3.current = d2 === "mounted" ? e2 : "none";
      }, [d2]), useLayoutEffect(() => {
        const e2 = i2.current,
          t2 = s3.current;
        if (t2 !== n2) {
          const u4 = c3.current,
            o4 = r$1(e2);
          if (n2) m2("MOUNT");else if (o4 === "none" || (e2 == null ? void 0 : e2.display) === "none") m2("UNMOUNT");else {
            const e3 = u4 !== o4;
            m2(t2 && e3 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          s3.current = n2;
        }
      }, [n2, m2]), useLayoutEffect(() => {
        if (u3) {
          const e2 = e3 => {
              const n4 = r$1(i2.current).includes(e3.animationName);
              e3.target === u3 && n4 && m2("ANIMATION_END");
            },
            n3 = e3 => {
              e3.target === u3 && (c3.current = r$1(i2.current));
            };
          return u3.addEventListener("animationstart", n3), u3.addEventListener("animationcancel", e2), u3.addEventListener("animationend", e2), () => {
            u3.removeEventListener("animationstart", n3), u3.removeEventListener("animationcancel", e2), u3.removeEventListener("animationend", e2);
          };
        }
        m2("ANIMATION_END");
      }, [u3, m2]), {
        isPresent: ["mounted", "unmountSuspended"].includes(d2),
        ref: React.useCallback(e2 => {
          e2 && (i2.current = getComputedStyle(e2)), o3(e2);
        }, [])
      };
    }(o2),
    c2 = typeof i == "function" ? i({
      present: s2.isPresent
    }) : React.Children.only(i),
    a2 = useComposedRefs(s2.ref, c2.ref);
  return typeof i == "function" || s2.isPresent ? /* @__PURE__ */React.cloneElement(c2, {
    ref: a2
  }) : null;
};
function r$1(e2) {
  return (e2 == null ? void 0 : e2.animationName) || "none";
}
Presence.displayName = "Presence";
function createContext(t2, n2) {
  const o2 = /* @__PURE__ */React.createContext(n2);
  function r2(t3) {
    const {
        children: n3,
        ...r3
      } = t3,
      c2 = React.useMemo(() => r3, Object.values(r3));
    return React.createElement(o2.Provider, {
      value: c2
    }, n3);
  }
  return r2.displayName = t2 + "Provider", [r2, function (r3) {
    const c2 = React.useContext(o2);
    if (c2) return c2;
    if (n2 !== void 0) return n2;
    throw new Error(`\`${r3}\` must be used within \`${t2}\``);
  }];
}
function createContextScope(n2) {
  let o2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let r2 = [];
  const c2 = () => {
    const t2 = r2.map(t3 => /* @__PURE__ */React.createContext(t3));
    return function (o3) {
      const r3 = (o3 == null ? void 0 : o3[n2]) || t2;
      return React.useMemo(() => ({
        [`__scope${n2}`]: {
          ...o3,
          [n2]: r3
        }
      }), [o3, r3]);
    };
  };
  return c2.scopeName = n2, [function (t2, o3) {
    const c3 = /* @__PURE__ */React.createContext(o3),
      u2 = r2.length;
    function s2(t3) {
      const {
          scope: o4,
          children: r3,
          ...s3
        } = t3,
        i = (o4 == null ? void 0 : o4[n2][u2]) || c3,
        a2 = React.useMemo(() => s3, Object.values(s3));
      return React.createElement(i.Provider, {
        value: a2
      }, r3);
    }
    return r2 = [...r2, o3], s2.displayName = t2 + "Provider", [s2, function (r3, s3) {
      const i = (s3 == null ? void 0 : s3[n2][u2]) || c3,
        a2 = React.useContext(i);
      if (a2) return a2;
      if (o3 !== void 0) return o3;
      throw new Error(`\`${r3}\` must be used within \`${t2}\``);
    }];
  }, t$1(c2, ...o2)];
}
function t$1() {
  for (var _len14 = arguments.length, t2 = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    t2[_key14] = arguments[_key14];
  }
  const n2 = t2[0];
  if (t2.length === 1) return n2;
  const o2 = () => {
    const o3 = t2.map(e2 => ({
      useScope: e2(),
      scopeName: e2.scopeName
    }));
    return function (t3) {
      const r2 = o3.reduce((e2, _ref48) => {
        let {
          useScope: n3,
          scopeName: o4
        } = _ref48;
        return {
          ...e2,
          ...n3(t3)[`__scope${o4}`]
        };
      }, {});
      return React.useMemo(() => ({
        [`__scope${n2.scopeName}`]: r2
      }), [r2]);
    };
  };
  return o2.scopeName = n2.scopeName, o2;
}
const [i$1, a] = createContext("Label", {
  id: void 0,
  controlRef: {
    current: null
  }
});
const useLabelContext = e2 => {
  const t2 = a("LabelConsumer"),
    {
      controlRef: r2
    } = t2;
  return React.useEffect(() => {
    e2 && (r2.current = e2);
  }, [e2, r2]), t2.id;
};
function useSize(r2) {
  const [i, t2] = React.useState(void 0);
  return React.useEffect(() => {
    if (r2) {
      const e2 = new ResizeObserver(e3 => {
        if (!Array.isArray(e3)) return;
        if (!e3.length) return;
        const i2 = e3[0];
        let o2, n2;
        if ("borderBoxSize" in i2) {
          const e4 = i2.borderBoxSize,
            r3 = Array.isArray(e4) ? e4[0] : e4;
          o2 = r3.inlineSize, n2 = r3.blockSize;
        } else {
          const e4 = r2.getBoundingClientRect();
          o2 = e4.width, n2 = e4.height;
        }
        t2({
          width: o2,
          height: n2
        });
      });
      return e2.observe(r2, {
        box: "border-box"
      }), () => e2.unobserve(r2);
    }
    t2(void 0);
  }, [r2]), i;
}
function usePrevious(r2) {
  const u2 = React.useRef({
    value: r2,
    previous: r2
  });
  return React.useMemo(() => (u2.current.value !== r2 && (u2.current.previous = u2.current.value, u2.current.value = r2), u2.current.previous), [r2]);
}
function useCallbackRef$2(r2) {
  const t2 = React.useRef(r2);
  return React.useEffect(() => {
    t2.current = r2;
  }), React.useMemo(() => function () {
    var r3;
    for (var _len15 = arguments.length, e2 = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      e2[_key15] = arguments[_key15];
    }
    return (r3 = t2.current) === null || r3 === void 0 ? void 0 : r3.call(t2, ...e2);
  }, []);
}
function useControllableState$1(_ref49) {
  let {
    prop: o2,
    defaultProp: r2,
    onChange: n2 = () => {}
  } = _ref49;
  const [a2, u2] = function (_ref50) {
      let {
        defaultProp: o3,
        onChange: r3
      } = _ref50;
      const n3 = React.useState(o3),
        [a3] = n3,
        u3 = React.useRef(a3),
        c3 = useCallbackRef$2(r3);
      return React.useEffect(() => {
        u3.current !== a3 && (c3(a3), u3.current = a3);
      }, [a3, u3, c3]), n3;
    }({
      defaultProp: r2,
      onChange: n2
    }),
    c2 = o2 !== void 0,
    f2 = c2 ? o2 : a2,
    l2 = useCallbackRef$2(n2);
  return [f2, React.useCallback(e2 => {
    if (c2) {
      const t2 = e2,
        r3 = typeof e2 == "function" ? t2(o2) : e2;
      r3 !== o2 && l2(r3);
    } else u2(e2);
  }, [c2, o2, u2, l2])];
}
function composeEventHandlers(e2, n2) {
  let {
    checkForDefaultPrevented: t2 = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (r2) {
    if (e2 == null || e2(r2), t2 === false || !r2.defaultPrevented) return n2 == null ? void 0 : n2(r2);
  };
}
const [u, p$1] = createContextScope("Checkbox");
const [m$1, b$1] = u("Checkbox");
const Checkbox$1 = /* @__PURE__ */React.forwardRef((t2, o2) => {
  const {
      __scopeCheckbox: a2,
      "aria-labelledby": i,
      name: u2,
      checked: p2,
      defaultChecked: b2,
      required: k2,
      disabled: C2,
      value: y2 = "on",
      onCheckedChange: v2,
      ...E2
    } = t2,
    [w2, g2] = React.useState(null),
    I2 = useComposedRefs(o2, e2 => g2(e2)),
    R2 = useLabelContext(w2),
    D2 = i || R2,
    P2 = React.useRef(false),
    _ = !w2 || Boolean(w2.closest("form")),
    [q2 = false, K] = useControllableState$1({
      prop: p2,
      defaultProp: b2,
      onChange: v2
    });
  return React.createElement(m$1, {
    scope: a2,
    state: q2,
    disabled: C2
  }, /* @__PURE__ */React.createElement(Primitive.button, _extends$1({
    type: "button",
    role: "checkbox",
    "aria-checked": x$1(q2) ? "mixed" : q2,
    "aria-labelledby": D2,
    "aria-required": k2,
    "data-state": h$1(q2),
    "data-disabled": C2 ? "" : void 0,
    disabled: C2,
    value: y2
  }, E2, {
    ref: I2,
    onKeyDown: composeEventHandlers(t2.onKeyDown, e2 => {
      e2.key === "Enter" && e2.preventDefault();
    }),
    onClick: composeEventHandlers(t2.onClick, e2 => {
      K(e3 => !!x$1(e3) || !e3), _ && (P2.current = e2.isPropagationStopped(), P2.current || e2.stopPropagation());
    })
  })), _ && /* @__PURE__ */React.createElement(f$1, {
    control: w2,
    bubbles: !P2.current,
    name: u2,
    value: y2,
    checked: q2,
    required: k2,
    disabled: C2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const CheckboxIndicator = /* @__PURE__ */React.forwardRef((r2, o2) => {
  const {
      __scopeCheckbox: a2,
      forceMount: n2,
      ...c2
    } = r2,
    i = b$1("CheckboxIndicator", a2);
  return React.createElement(Presence, {
    present: n2 || x$1(i.state) || i.state === true
  }, /* @__PURE__ */React.createElement(Primitive.span, _extends$1({
    "data-state": h$1(i.state),
    "data-disabled": i.disabled ? "" : void 0
  }, c2, {
    ref: o2,
    style: {
      pointerEvents: "none",
      ...r2.style
    }
  })));
});
const f$1 = e2 => {
  const {
      control: t2,
      checked: r2,
      bubbles: n2 = true,
      ...c2
    } = e2,
    i = React.useRef(null),
    s2 = usePrevious(r2),
    u2 = useSize(t2);
  return React.useEffect(() => {
    const e3 = i.current,
      t3 = window.HTMLInputElement.prototype,
      o2 = Object.getOwnPropertyDescriptor(t3, "checked").set;
    if (s2 !== r2 && o2) {
      const t4 = new Event("click", {
        bubbles: n2
      });
      e3.indeterminate = x$1(r2), o2.call(e3, !x$1(r2) && r2), e3.dispatchEvent(t4);
    }
  }, [s2, r2, n2]), /* @__PURE__ */React.createElement("input", _extends$1({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: !x$1(r2) && r2
  }, c2, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e2.style,
      ...u2,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function x$1(e2) {
  return e2 === "indeterminate";
}
function h$1(e2) {
  return x$1(e2) ? "indeterminate" : e2 ? "checked" : "unchecked";
}
const Root = Checkbox$1;
const Indicator = CheckboxIndicator;
var faCheck$3 = {};
Object.defineProperty(faCheck$3, "__esModule", {
  value: true
});
var faCheck_2$1 = faCheck$3.faCheck = void 0;
const faCheck$2 = {
  prefix: "fas",
  iconName: "faCheck",
  icon: [512, 512, [], "", "M480 128c0 8.188-3.125 16.38-9.375 22.62l-256 256C208.4 412.9 200.2 416 192 416s-16.38-3.125-22.62-9.375l-128-128C35.13 272.4 32 264.2 32 256c0-18.28 14.95-32 32-32c8.188 0 16.38 3.125 22.62 9.375L192 338.8l233.4-233.4C431.6 99.13 439.8 96 448 96C465.1 96 480 109.7 480 128z"]
};
faCheck_2$1 = faCheck$3.faCheck = faCheck$2;
var faMinus$1 = {};
Object.defineProperty(faMinus$1, "__esModule", {
  value: true
});
var faMinus_2 = faMinus$1.faMinus = void 0;
const faMinus = {
  prefix: "fas",
  iconName: "faMinus",
  icon: [448, 512, [], "", "M400 288h-352c-17.69 0-32-14.32-32-32.01s14.31-31.99 32-31.99h352c17.69 0 32 14.3 32 31.99S417.7 288 400 288z"]
};
faMinus_2 = faMinus$1.faMinus = faMinus;
var CheckboxClassNames = /* @__PURE__ */(CheckboxClassNames2 => {
  CheckboxClassNames2["CheckboxInCheckboxGroup"] = "dds--checkbox-group-item";
  CheckboxClassNames2["CheckboxHoverIndicator"] = "dds--checkbox-hover-indicator";
  return CheckboxClassNames2;
})(CheckboxClassNames || {});
const CheckboxRoot = styled(Box, {
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  gap: "$1",
  variants: {
    fullWidth: FullWidthVariant,
    disabled: {
      true: {
        "*": {
          cursor: "not-allowed",
          color: "$gray5"
        }
      }
    }
  }
});
const StyledIndicator$1 = styled(Indicator, {
  size: "$2",
  boxSizing: "border-box",
  alignItems: "center",
  display: "flex",
  justifyContent: "center"
});
const StyledCheckboxRoot = styled(Root, {
  size: "$2",
  minWidth: "$2",
  background: "$white",
  border: "1px solid $blue3",
  borderRadius: "$1",
  padding: 0,
  marginTop: "calc($half / 2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  '&[data-state="checked"]': {
    background: "$blue8",
    borderColor: "$blue8",
    color: "$white"
  },
  '&[data-state="indeterminate"]': {
    borderColor: "$blue8",
    color: "$gray12"
  },
  "&:focus": {
    borderColor: "$blue5"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  [`& .${CheckboxClassNames.CheckboxHoverIndicator}`]: {
    display: "none",
    color: "$blue2"
  },
  [`&[data-state="unchecked"]:not(:disabled):hover .${CheckboxClassNames.CheckboxHoverIndicator}`]: {
    display: "block"
  },
  [`&:not(.${CheckboxClassNames.CheckboxInCheckboxGroup})[aria-invalid="true"]`]: {
    borderColor: "$red6"
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    color: "$gray5",
    cursor: "not-allowed"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  variants: {
    success: {
      true: {
        [`&:not(.${CheckboxClassNames.CheckboxInCheckboxGroup})`]: {
          borderColor: "$green6"
        }
      }
    }
  }
});
const StyledLabel$1 = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center",
  cursor: "pointer"
});
const CheckboxLabel = _ref51 => {
  let {
    id,
    label,
    htmlFor,
    showOptionalLabel
  } = _ref51;
  return /* @__PURE__ */jsxs(StyledLabel$1, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx$1(Text, {
      variant: "body",
      children: label
    }), showOptionalLabel && /* @__PURE__ */jsx$1(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const StyledCheckboxBase = forwardRef((_ref52, forwardedRef) => {
  let {
    checked,
    disabled: disabled2,
    onChange: onChange3 = () => {},
    success,
    error: error2,
    descriptionElementId,
    label,
    labelElementId,
    optional,
    rootProps,
    ...props
  } = _ref52;
  return /* @__PURE__ */jsxs(StyledCheckboxRoot, {
    ref: forwardedRef,
    success: !!success,
    checked,
    disabled: disabled2,
    onCheckedChange: checkedEventValue => {
      if (typeof checkedEventValue === "boolean") {
        let newState = checkedEventValue;
        if (checked === "indeterminate") {
          newState = false;
        }
        onChange3(newState);
      }
    },
    required: !optional,
    role: "checkbox",
    "aria-checked": checked === "indeterminate" ? "mixed" : checked,
    "aria-invalid": !!error2,
    "aria-describedby": descriptionElementId,
    "aria-label": label,
    "aria-disabled": disabled2,
    "aria-labelledby": labelElementId,
    ...props,
    ...rootProps,
    children: [/* @__PURE__ */jsx$1(Icon, {
      className: CheckboxClassNames.CheckboxHoverIndicator,
      size: "small",
      icon: faCheck_2$1
    }), /* @__PURE__ */jsx$1(StyledIndicator$1, {
      children: /* @__PURE__ */jsx$1(Icon, {
        size: "small",
        icon: checked === true ? faCheck_2$1 : faMinus_2
      })
    })]
  });
});
StyledCheckboxBase.displayName = "StyledCheckboxBase";
const CheckboxBase = {
  Root: CheckboxRoot,
  Label: CheckboxLabel,
  Checkbox: StyledCheckboxBase,
  Description: InputBase.Description,
  ErrorState: InputBase.ErrorState,
  SuccessState: InputBase.SuccessState
};
const Checkbox = forwardRef((_ref53, forwardedRef) => {
  let {
    ariaLabel,
    label,
    description,
    success = "",
    error: error2 = "",
    disabled: disabled2 = false,
    checked,
    labelOptional,
    onChange: onChange3 = () => {},
    rootProps
  } = _ref53;
  var _a, _b;
  const {
    isInCheckboxGroup,
    checkboxGroupError,
    checkboxGroupErrorId,
    checkboxGroupSuccess,
    checkboxGroupSuccessId,
    checkboxGroupDisabled
  } = useCheckboxGroupContext$1();
  const name = toHyphenCase(label || ariaLabel);
  const checkboxElementId = `dds-checkbox-element-${name}`;
  const checkboxLabelElementId = `dds-checkbox-label-${name}`;
  const errorMessageElementId = checkboxGroupErrorId != null ? checkboxGroupErrorId : `dds-checkbox-error-message-${name}`;
  const descriptionElementId = `dds-checkbox-description-${name}`;
  const describedById = (_b = (_a = checkboxGroupError && checkboxGroupErrorId) != null ? _a : checkboxGroupSuccess && checkboxGroupSuccessId) != null ? _b : description && descriptionElementId;
  const showOptionalLabel = isInCheckboxGroup ? false : labelOptional;
  const isDisabled = checkboxGroupDisabled || disabled2;
  return /* @__PURE__ */jsxs(CheckboxBase.Root, {
    disabled: isDisabled,
    children: [/* @__PURE__ */jsx$1(CheckboxBase.Checkbox, {
      ref: forwardedRef,
      className: isInCheckboxGroup ? CheckboxClassNames.CheckboxInCheckboxGroup : "",
      disabled: isDisabled,
      checked,
      error: checkboxGroupError != null ? checkboxGroupError : error2,
      success: checkboxGroupSuccess != null ? checkboxGroupSuccess : success,
      onChange: onChange3,
      label: label || ariaLabel,
      labelElementId: label && checkboxLabelElementId,
      descriptionElementId: describedById,
      id: checkboxElementId,
      rootProps
    }), label && /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      css: {
        gap: "2px"
      },
      children: [/* @__PURE__ */jsx$1(CheckboxBase.Label, {
        id: checkboxLabelElementId,
        label,
        htmlFor: checkboxElementId,
        showOptionalLabel
      }), description && /* @__PURE__ */jsx$1(CheckboxBase.Description, {
        id: descriptionElementId,
        children: description
      }), !isInCheckboxGroup && /* @__PURE__ */jsx$1(CheckboxBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage: checkboxGroupError != null ? checkboxGroupError : error2
      }), !isInCheckboxGroup && /* @__PURE__ */jsx$1(CheckboxBase.SuccessState, {
        successMessage: error2 ? "" : success
      })]
    })]
  });
});
Checkbox.displayName = "Checkbox";
const CheckboxGroup = forwardRef((_ref54, forwardedRef) => {
  let {
    label,
    labelOptional,
    disabled: disabled2,
    children,
    error: error2 = "",
    success = "",
    rootProps
  } = _ref54;
  const name = toHyphenCase(label);
  const checkboxGroupLabelId = `dds-checkbox-group-label-${name}`;
  const checkboxGroupErrorId = `dds-checkbox-group-error-${name}`;
  const checkboxGroupSuccessId = `dds-checkbox-group-success-${name}`;
  return /* @__PURE__ */jsx$1(Flex, {
    ref: forwardedRef,
    ...rootProps,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 1,
      children: [/* @__PURE__ */jsxs(Flex, {
        direction: "column",
        css: {
          gap: "2px"
        },
        children: [/* @__PURE__ */jsx$1(CheckboxBase.Label, {
          id: checkboxGroupLabelId,
          label,
          htmlFor: checkboxGroupLabelId,
          showOptionalLabel: labelOptional
        }), /* @__PURE__ */jsx$1(CheckboxBase.ErrorState, {
          id: checkboxGroupErrorId,
          errorMessage: error2
        }), /* @__PURE__ */jsx$1(CheckboxBase.SuccessState, {
          successMessage: error2 ? "" : success
        })]
      }), /* @__PURE__ */jsx$1(CheckboxGroupContext.Provider, {
        value: {
          isInCheckboxGroup: true,
          checkboxGroupError: error2,
          checkboxGroupErrorId,
          checkboxGroupSuccess: success,
          checkboxGroupSuccessId,
          checkboxGroupDisabled: disabled2
        },
        children
      })]
    })
  });
});
CheckboxGroup.displayName = "CheckboxGroup";
const $b73a6c6685e72184$var$NAME = "Label";
const [$b73a6c6685e72184$var$LabelProvider, $b73a6c6685e72184$var$useLabelContextImpl] = $c512c27ab02ef895$export$fd42f52fd3ae1109($b73a6c6685e72184$var$NAME, {
  id: void 0,
  controlRef: {
    current: null
  }
});
const $b73a6c6685e72184$export$feddbbf47baabdb9 = element => {
  const context = $b73a6c6685e72184$var$useLabelContextImpl("LabelConsumer");
  const {
    controlRef
  } = context;
  useEffect(() => {
    if (element) controlRef.current = element;
  }, [element, controlRef]);
  return context.id;
};
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$3 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$3);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$3, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$3, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$3.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$3 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$3(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$3.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$3 = _ref55 => {
  let {
    children
  } = _ref55;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$3(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$3;
}
function $5e63c961fc1ce211$var$mergeProps$3(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$1(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */new Map()
  });
  const CollectionProvider = props => {
    const {
      scope,
      children
    } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef( /* @__PURE__ */new Map()).current;
    return /* @__PURE__ */React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children
    } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$3, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children,
      ...itemData
    } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$3, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort((a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current));
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}
const $f631663db3294ace$var$DirectionContext = /* @__PURE__ */createContext$1(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}
const $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$1($d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d7bdfb9eb0fdf311$var$GROUP_NAME, [$d7bdfb9eb0fdf311$var$createCollectionScope]);
const [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
const $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends$1({}, props, {
    ref: forwardedRef
  }))));
});
const $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    ...groupProps
  } = props;
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = useState(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = useRef(false);
  useEffect(() => {
    const node2 = ref.current;
    if (node2) {
      node2.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
      return () => node2.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: useCallback(tabStopId => setCurrentTabStopId(tabStopId), [setCurrentTabStopId]),
    onItemShiftTab: useCallback(() => setIsTabbingBackOut(true), [])
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    tabIndex: isTabbingBackOut ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, event => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(item => item.focusable);
          const activeItem = items.find(item => item.active);
          const currentItem = items.find(item => item.id === currentTabStopId);
          const candidateItems = [activeItem, currentItem, ...items].filter(Boolean);
          const candidateNodes = candidateItems.map(item => item.ref.current);
          $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, () => setIsTabbingBackOut(false))
  })));
});
const $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    focusable = true,
    active = false,
    ...itemProps
  } = props;
  const id = $1746a345f3d73bb7$export$f680877a34711e37();
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id,
    focusable,
    active
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, event => {
      if (!focusable) event.preventDefault();else context.onItemFocus(id);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => context.onItemFocus(id)),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(item => item.focusable);
        let candidateNodes = items.map(item => item.ref.current);
        if (focusIntent === "last") candidateNodes.reverse();else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(() => $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
      }
    })
  })));
});
const $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
const $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
const $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = useRef({
    value,
    previous: value
  });
  return useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}
const $ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$ce77a8961b41be9e$var$createRadioContext, $ce77a8961b41be9e$export$67d2296460f1b002] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($ce77a8961b41be9e$var$RADIO_NAME);
const [$ce77a8961b41be9e$var$RadioProvider, $ce77a8961b41be9e$var$useRadioContext] = $ce77a8961b41be9e$var$createRadioContext($ce77a8961b41be9e$var$RADIO_NAME);
const $ce77a8961b41be9e$export$d7b12c4107be0d61 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadio,
    "aria-labelledby": ariaLabelledby,
    name,
    checked = false,
    required,
    disabled: disabled2,
    value = "on",
    onCheck,
    ...radioProps
  } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setButton(node2));
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9(button);
  const labelledBy = ariaLabelledby || labelId;
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  return /* @__PURE__ */createElement$1($ce77a8961b41be9e$var$RadioProvider, {
    scope: __scopeRadio,
    checked,
    disabled: disabled2
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button",
    role: "radio",
    "aria-checked": checked,
    "aria-labelledby": labelledBy,
    "data-state": $ce77a8961b41be9e$var$getState(checked),
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    value
  }, radioProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      if (!checked) onCheck === null || onCheck === void 0 || onCheck();
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */createElement$1($ce77a8961b41be9e$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled: disabled2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadio,
    forceMount,
    ...indicatorProps
  } = props;
  const context = $ce77a8961b41be9e$var$useRadioContext($ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.checked
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({
    "data-state": $ce77a8961b41be9e$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, indicatorProps, {
    ref: forwardedRef
  })));
});
const $ce77a8961b41be9e$var$BubbleInput = props => {
  const {
    control,
    checked,
    bubbles = true,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */createElement$1("input", _extends$1({
    type: "radio",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $ce77a8961b41be9e$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
const $f99a8c78507165f7$var$ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
const $f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$f99a8c78507165f7$var$createRadioGroupContet, $f99a8c78507165f7$export$c547093f11b76da2] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($f99a8c78507165f7$var$RADIO_GROUP_NAME, [$d7bdfb9eb0fdf311$export$c7109489551a4f4, $ce77a8961b41be9e$export$67d2296460f1b002]);
const $f99a8c78507165f7$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const $f99a8c78507165f7$var$useRadioScope = $ce77a8961b41be9e$export$67d2296460f1b002();
const [$f99a8c78507165f7$var$RadioGroupProvider, $f99a8c78507165f7$var$useRadioGroupContext] = $f99a8c78507165f7$var$createRadioGroupContet($f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $f99a8c78507165f7$export$a98f0dcb43a68a25 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    name,
    "aria-labelledby": ariaLabelledby,
    defaultValue,
    value: valueProp,
    required = false,
    orientation,
    dir,
    loop = true,
    onValueChange,
    ...groupProps
  } = props;
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9();
  const labelledBy = ariaLabelledby || labelId;
  const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */createElement$1($f99a8c78507165f7$var$RadioGroupProvider, {
    scope: __scopeRadioGroup,
    name,
    required,
    value,
    onValueChange: setValue
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation,
    dir: direction,
    loop
  }), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    role: "radiogroup",
    "aria-required": required,
    "aria-orientation": orientation,
    "aria-labelledby": labelledBy,
    dir: direction
  }, groupProps, {
    ref: forwardedRef
  }))));
});
const $f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $f99a8c78507165f7$export$9f866c100ef519e4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    disabled: disabled2,
    ...itemProps
  } = props;
  const context = $f99a8c78507165f7$var$useRadioGroupContext($f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
  const rovingFocusGroupScope = $f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
  const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const checked = context.value === itemProps.value;
  const isArrowKeyPressedRef = useRef(false);
  useEffect(() => {
    const handleKeyDown = event => {
      if ($f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
    };
    const handleKeyUp = () => isArrowKeyPressedRef.current = false;
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2,
    active: checked
  }), /* @__PURE__ */createElement$1($ce77a8961b41be9e$export$d7b12c4107be0d61, _extends$1({
    disabled: disabled2,
    required: context.required,
    checked
  }, radioScope, itemProps, {
    name: context.name,
    ref: composedRefs,
    onCheck: () => context.onValueChange(itemProps.value),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(event => {
      if (event.key === "Enter") event.preventDefault();
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onFocus, () => {
      var _ref$current;
      if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
    })
  })));
});
const $f99a8c78507165f7$export$5fb54c671a65c88 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeRadioGroup,
    ...indicatorProps
  } = props;
  const radioScope = $f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
  return /* @__PURE__ */createElement$1($ce77a8961b41be9e$export$d35a9ffa9a04f9e7, _extends$1({}, radioScope, indicatorProps, {
    ref: forwardedRef
  }));
});
const $f99a8c78507165f7$export$be92b6f5f03c0fe9 = $f99a8c78507165f7$export$a98f0dcb43a68a25;
const $f99a8c78507165f7$export$6d08773d2e66f8f2 = $f99a8c78507165f7$export$9f866c100ef519e4;
const $f99a8c78507165f7$export$adb584737d712b70 = $f99a8c78507165f7$export$5fb54c671a65c88;
const StyledLabel = styled("label", {
  display: "flex",
  gap: "$half",
  alignItems: "center",
  cursor: "pointer"
});
const StyledRadioItem = styled($f99a8c78507165f7$export$6d08773d2e66f8f2, {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  size: "$2",
  borderRadius: "$round",
  border: "1px solid $blue3",
  background: "$white",
  cursor: "pointer",
  "&:hover": {
    borderColor: "$blue4"
  },
  "&::after": {
    background: "transparent",
    size: "10px",
    borderRadius: "50%",
    position: "absolute",
    top: "calc(50% - 5px)",
    left: "calc(50% - 5px)"
  },
  "&:not(:disabled):hover:after": {
    background: "$blue2"
  },
  '&[aria-checked="false"]:hover:after': {
    content: '""'
  },
  '&[aria-checked="true"]:disabled:after': {
    content: '""',
    background: "$gray5"
  },
  '&[aria-checked="true"]': {
    borderColor: "$blue8"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    cursor: "not-allowed"
  }
});
const StyledRadioIndicator$1 = styled($f99a8c78507165f7$export$adb584737d712b70, {
  display: "block",
  size: "10px",
  minWidth: "10px",
  background: "$blue8",
  borderRadius: "$round",
  "&:focus": {
    borderColor: "$blue5"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:disabled": {
    background: "$gray2",
    borderColor: "$gray3",
    color: "$gray5"
  }
});
const StyledRadioLabel = _ref56 => {
  let {
    id,
    label,
    htmlFor,
    optional
  } = _ref56;
  return /* @__PURE__ */jsxs(StyledLabel, {
    id,
    htmlFor,
    children: [/* @__PURE__ */jsx$1(Text, {
      children: label
    }), optional && /* @__PURE__ */jsx$1(Text, {
      variant: "metadata",
      children: "(optional)"
    })]
  });
};
const RadioItem$1 = forwardRef((_ref57, forwardedRef) => {
  let {
    value,
    disabled: disabled2,
    error: error2,
    descriptionElementId,
    label,
    labelElementId,
    children,
    ...props
  } = _ref57;
  return /* @__PURE__ */jsx$1(StyledRadioItem, {
    ref: forwardedRef,
    disabled: disabled2,
    role: "radio",
    value,
    "aria-invalid": !!error2,
    "aria-describedby": descriptionElementId,
    "aria-label": label,
    "aria-disabled": disabled2,
    "aria-labelledby": labelElementId,
    ...props,
    children
  });
});
RadioItem$1.displayName = "RadioItem";
const RadioGroupBase = {
  Root: $f99a8c78507165f7$export$be92b6f5f03c0fe9,
  Label: StyledRadioLabel,
  RadioItem: RadioItem$1,
  RadioIndicator: StyledRadioIndicator$1,
  Description: InputBase.Description,
  ErrorState: InputBase.ErrorState,
  SuccessState: InputBase.SuccessState
};
const RadioGroupContext = createContext$1({
  radioGroupError: "",
  radioGroupErrorId: "",
  radioGroupSuccess: "",
  radioGroupSuccessId: "",
  radioGroupDisabled: false
});
const useRadioGroupContext$1 = () => useContext(RadioGroupContext);
const RadioItemRoot = styled(Flex, {
  variants: {
    disabled: {
      true: {
        "*": {
          cursor: "not-allowed",
          color: "$gray5"
        }
      }
    }
  }
});
const RadioItem = forwardRef((_ref58, forwardedRef) => {
  let {
    value,
    label,
    description,
    disabled: disabled2
  } = _ref58;
  var _a, _b;
  const {
    radioGroupError,
    radioGroupErrorId,
    radioGroupSuccess,
    radioGroupSuccessId,
    radioGroupDisabled
  } = useRadioGroupContext$1();
  const radioElementId = `dds-radio-element-${value}`;
  const radioLabelElementId = `dds-radio-label-${value}`;
  const descriptionElementId = `dds-radio-description-${value}`;
  const describedById = (_b = (_a = radioGroupError && radioGroupErrorId) != null ? _a : radioGroupSuccess && radioGroupSuccessId) != null ? _b : description && descriptionElementId;
  const isDisabled = disabled2 != null ? disabled2 : radioGroupDisabled;
  return /* @__PURE__ */jsxs(RadioItemRoot, {
    disabled: isDisabled,
    children: [/* @__PURE__ */jsx$1(RadioGroupBase.RadioItem, {
      ref: forwardedRef,
      id: radioElementId,
      value,
      label: "Default",
      labelElementId: radioLabelElementId,
      descriptionElementId: describedById,
      error: radioGroupError,
      disabled: isDisabled,
      children: /* @__PURE__ */jsx$1(RadioGroupBase.RadioIndicator, {})
    }), /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 0,
      css: {
        gap: "2px"
      },
      children: [/* @__PURE__ */jsx$1(RadioGroupBase.Label, {
        id: radioLabelElementId,
        htmlFor: radioElementId,
        label
      }), description && /* @__PURE__ */jsx$1(RadioGroupBase.Description, {
        id: descriptionElementId,
        children: description
      })]
    })]
  });
});
RadioItem.displayName = "RadioItem";
const RadioGroup = forwardRef((_ref59, forwardedRef) => {
  let {
    label,
    value,
    onValueChange,
    disabled: disabled2 = false,
    labelOptional,
    children,
    error: error2 = "",
    success = "",
    ...props
  } = _ref59;
  const name = toHyphenCase(label);
  const radioGroupId = `dds-radio-group-${name}`;
  const radioGroupLabelId = `dds-radio-group-label-${name}`;
  const radioGroupErrorId = `dds-radio-group-error-${name}`;
  const radioGroupSuccessId = `dds-radio-group-success-${name}`;
  return /* @__PURE__ */jsx$1(RadioGroupBase.Root, {
    ref: forwardedRef,
    id: radioGroupId,
    name,
    value,
    onValueChange,
    role: "radiogroup",
    "aria-labelledby": radioGroupLabelId,
    ...props,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: 1,
      children: [/* @__PURE__ */jsxs(Flex, {
        direction: "column",
        gap: "half",
        children: [/* @__PURE__ */jsx$1(RadioGroupBase.Label, {
          id: radioGroupLabelId,
          label,
          htmlFor: radioGroupLabelId,
          optional: labelOptional
        }), /* @__PURE__ */jsx$1(RadioGroupBase.ErrorState, {
          id: radioGroupErrorId,
          errorMessage: error2
        }), /* @__PURE__ */jsx$1(RadioGroupBase.SuccessState, {
          successMessage: error2 ? "" : success
        })]
      }), /* @__PURE__ */jsx$1(RadioGroupContext.Provider, {
        value: {
          radioGroupError: error2,
          radioGroupErrorId,
          radioGroupSuccess: success,
          radioGroupSuccessId,
          radioGroupDisabled: disabled2
        },
        children
      })]
    })
  });
});
RadioGroup.displayName = "RadioGroup";
var LinkTypeVariantEnum = /* @__PURE__ */(LinkTypeVariantEnum2 => {
  LinkTypeVariantEnum2["SUBTLE"] = "subtle";
  LinkTypeVariantEnum2["INLINE"] = "inline";
  LinkTypeVariantEnum2["OBJECT"] = "object";
  LinkTypeVariantEnum2["DANGER"] = "danger";
  LinkTypeVariantEnum2["WHITE"] = "white";
  return LinkTypeVariantEnum2;
})(LinkTypeVariantEnum || {});
var LinkSizeVariantEnum = /* @__PURE__ */(LinkSizeVariantEnum2 => {
  LinkSizeVariantEnum2["SMALL"] = "small";
  LinkSizeVariantEnum2["MEDIUM"] = "medium";
  LinkSizeVariantEnum2["LARGE"] = "large";
  return LinkSizeVariantEnum2;
})(LinkSizeVariantEnum || {});
const LinkUnderlineVariant = {
  true: {
    textDecoration: "underline"
  }
};
const LinkSizeVariant = {
  small: {
    textStyles: "metadata"
  },
  medium: {
    textStyles: "body"
  },
  large: {
    textStyles: "h3"
  }
};
const LinkTypeVariant = {
  subtle: {
    color: "$gray9",
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: "$gray9"
    },
    "&:active": {
      color: "$gray10",
      textDecoration: "underline",
      textDecorationColor: "$gray10"
    }
  },
  inline: {
    color: "$blue8",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$blue9",
      textDecoration: "underline",
      textDecorationColor: "$blue9"
    },
    "&:active": {
      color: "$blue10",
      textDecoration: "underline",
      textDecorationColor: "$blue10"
    }
  },
  object: {
    color: "$gray12",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$gray12",
      textDecoration: "underline",
      textDecorationColor: "$gray12"
    },
    "&:active": {
      color: "$gray12",
      textDecoration: "underline",
      textDecorationColor: "$gray12"
    }
  },
  white: {
    color: "$white",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$white",
      textDecoration: "underline",
      textDecorationColor: "$white"
    },
    "&:active": {
      color: "$white",
      textDecoration: "underline",
      textDecorationColor: "$white"
    }
  },
  danger: {
    color: "$red8",
    fontWeight: "$semibold",
    "&:hover": {
      color: "$red9",
      textDecoration: "underline",
      textDecorationColor: "$red9"
    },
    "&:active": {
      color: "$red10",
      textDecoration: "underline",
      textDecorationColor: "$red10"
    }
  }
};
const StyledLinkBase = styled("a", {
  width: "max-content",
  margin: 0,
  cursor: "pointer",
  paddingLeft: 0,
  paddingRight: 0,
  minWidth: "auto",
  whiteSpace: "nowrap",
  color: "inherit",
  textDecoration: "none",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  variants: {
    size: LinkSizeVariant,
    variant: LinkTypeVariant,
    underline: LinkUnderlineVariant,
    ...TextTransformVariants
  },
  defaultVariants: {
    size: LinkSizeVariantEnum.MEDIUM,
    variant: LinkTypeVariantEnum.SUBTLE
  }
});
const Link = forwardRef((_ref60, forwardedRef) => {
  let {
    type: type3,
    size = "medium",
    variant = type3 != null ? type3 : "subtle",
    css: css4,
    children,
    href,
    target,
    rel,
    external,
    rootProps,
    underline = false,
    ...props
  } = _ref60;
  return /* @__PURE__ */jsx$1(StyledLinkBase, {
    ref: forwardedRef,
    size,
    variant,
    underline,
    css: css4,
    href,
    target: external ? "_blank" : target,
    role: "link",
    rel: external ? "noopener noreferrer" : rel,
    ...rootProps,
    ...props,
    children
  });
});
Link.displayName = "Link";
const $6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$6be4966fd9bbc698$var$createSwitchContext, $6be4966fd9bbc698$export$cf7f5f17f69cbd43] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6be4966fd9bbc698$var$SWITCH_NAME);
const [$6be4966fd9bbc698$var$SwitchProvider, $6be4966fd9bbc698$var$useSwitchContext] = $6be4966fd9bbc698$var$createSwitchContext($6be4966fd9bbc698$var$SWITCH_NAME);
const $6be4966fd9bbc698$export$b5d5cf8927ab7262 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSwitch,
    "aria-labelledby": ariaLabelledby,
    name,
    checked: checkedProp,
    defaultChecked,
    required,
    disabled: disabled2,
    value = "on",
    onCheckedChange,
    ...switchProps
  } = props;
  const [button, setButton] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setButton(node2));
  const labelId = $b73a6c6685e72184$export$feddbbf47baabdb9(button);
  const labelledBy = ariaLabelledby || labelId;
  const hasConsumerStoppedPropagationRef = useRef(false);
  const isFormControl = button ? Boolean(button.closest("form")) : true;
  const [checked = false, setChecked] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: checkedProp,
    defaultProp: defaultChecked,
    onChange: onCheckedChange
  });
  return /* @__PURE__ */createElement$1($6be4966fd9bbc698$var$SwitchProvider, {
    scope: __scopeSwitch,
    checked,
    disabled: disabled2
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button",
    role: "switch",
    "aria-checked": checked,
    "aria-labelledby": labelledBy,
    "aria-required": required,
    "data-state": $6be4966fd9bbc698$var$getState(checked),
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    value
  }, switchProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, event => {
      setChecked(prevChecked => !prevChecked);
      if (isFormControl) {
        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
      }
    })
  })), isFormControl && /* @__PURE__ */createElement$1($6be4966fd9bbc698$var$BubbleInput, {
    control: button,
    bubbles: !hasConsumerStoppedPropagationRef.current,
    name,
    value,
    checked,
    required,
    disabled: disabled2,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
const $6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $6be4966fd9bbc698$export$4d07bf653ea69106 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSwitch,
    ...thumbProps
  } = props;
  const context = $6be4966fd9bbc698$var$useSwitchContext($6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({
    "data-state": $6be4966fd9bbc698$var$getState(context.checked),
    "data-disabled": context.disabled ? "" : void 0
  }, thumbProps, {
    ref: forwardedRef
  }));
});
const $6be4966fd9bbc698$var$BubbleInput = props => {
  const {
    control,
    checked,
    bubbles = true,
    ...inputProps
  } = props;
  const ref = useRef(null);
  const prevChecked = $010c2913dbd2fe3d$export$5cae361ad82dce8b(checked);
  const controlSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(control);
  useEffect(() => {
    const input = ref.current;
    const inputProto = window.HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
    const setChecked = descriptor.set;
    if (prevChecked !== checked && setChecked) {
      const event = new Event("click", {
        bubbles
      });
      setChecked.call(input, checked);
      input.dispatchEvent(event);
    }
  }, [prevChecked, checked, bubbles]);
  return /* @__PURE__ */createElement$1("input", _extends$1({
    type: "checkbox",
    "aria-hidden": true,
    defaultChecked: checked
  }, inputProps, {
    tabIndex: -1,
    ref,
    style: {
      ...props.style,
      ...controlSize,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function $6be4966fd9bbc698$var$getState(checked) {
  return checked ? "checked" : "unchecked";
}
const $6be4966fd9bbc698$export$be92b6f5f03c0fe9 = $6be4966fd9bbc698$export$b5d5cf8927ab7262;
const $6be4966fd9bbc698$export$6521433ed15a34db = $6be4966fd9bbc698$export$4d07bf653ea69106;
var SwitchSizeVariantEnum = /* @__PURE__ */(SwitchSizeVariantEnum2 => {
  SwitchSizeVariantEnum2["SMALL"] = "small";
  SwitchSizeVariantEnum2["DEFAULT"] = "default";
  return SwitchSizeVariantEnum2;
})(SwitchSizeVariantEnum || {});
const SwitchContainerSizeVariant = {
  small: {
    width: "$4",
    height: "20px"
  },
  default: {
    width: "44px",
    height: "$3"
  }
};
const SwitchThumbSizeVariant = {
  small: {
    width: "$2",
    height: "$2",
    '&[data-state="checked"]': {
      transform: "translateX(14px)"
    }
  },
  default: {
    width: "20px",
    height: "20px",
    '&[data-state="checked"]': {
      transform: "translateX(22px)"
    }
  }
};
const StyledToggle = styled($6be4966fd9bbc698$export$be92b6f5f03c0fe9, {
  all: "unset",
  backgroundColor: "$gray3",
  borderRadius: "9999px",
  position: "relative",
  cursor: "pointer",
  "&:focus-visible": {
    outline: "solid 1px $blue6"
  },
  "&:disabled": {
    cursor: "not-allowed"
  },
  [`&:not([data-state="checked"]):not(:disabled):hover`]: {
    backgroundColor: "$gray4"
  },
  [`&:not([data-state="checked"]):disabled`]: {
    backgroundColor: "$gray2"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$blue8"
  },
  '&[data-state="checked"]:not(:disabled):hover': {
    backgroundColor: "$blue9"
  },
  '&[data-state="checked"]:disabled': {
    backgroundColor: "$blue3"
  },
  variants: {
    size: SwitchContainerSizeVariant
  },
  defaultVariants: {
    size: SwitchSizeVariantEnum.DEFAULT
  }
});
const StyledThumb = styled($6be4966fd9bbc698$export$6521433ed15a34db, {
  display: "block",
  backgroundColor: "white",
  borderRadius: "9999px",
  transition: "transform 100ms",
  transform: "translateX(2px)",
  willChange: "transform",
  variants: {
    size: SwitchThumbSizeVariant
  },
  defaultVariants: {
    size: SwitchSizeVariantEnum.DEFAULT
  }
});
const Toggle = forwardRef((_ref61, forwardedRef) => {
  let {
    size,
    onChange: onChange3,
    name,
    rootProps,
    ...props
  } = _ref61;
  return /* @__PURE__ */jsx$1(StyledToggle, {
    ref: forwardedRef,
    size,
    onCheckedChange: onChange3,
    "aria-label": name,
    name,
    ...props,
    ...rootProps,
    children: /* @__PURE__ */jsx$1(StyledThumb, {
      size
    })
  });
});
Toggle.displayName = "Toggle";
var faClone$1 = {};
Object.defineProperty(faClone$1, "__esModule", {
  value: true
});
var faClone_2 = faClone$1.faClone = void 0;
const faClone = {
  prefix: "fal",
  iconName: "faClone",
  icon: [512, 512, [], "", "M336 384c-8.836 0-16 7.162-16 16V448c0 17.67-14.33 32-32 32H64c-17.67 0-32-14.33-32-32V224c0-17.67 14.33-32 32-32h48C120.8 192 128 184.8 128 176C128 167.2 120.8 160 112 160H64C28.65 160 0 188.7 0 224v224c0 35.35 28.65 64 64 64h224c35.35 0 64-28.65 64-64v-48C352 391.2 344.8 384 336 384zM448 0H224C188.7 0 160 28.65 160 64v224c0 35.35 28.65 64 64 64h224c35.35 0 64-28.65 64-64V64C512 28.65 483.3 0 448 0zM480 288c0 17.64-14.36 32-32 32H224c-17.64 0-32-14.36-32-32V64c0-17.64 14.36-32 32-32h224c17.64 0 32 14.36 32 32V288z"]
};
faClone_2 = faClone$1.faClone = faClone;
const TextareaContainer = styled(Box, {
  width: "inherit",
  position: "relative"
});
const CopyTextButton = styled(IconButton, {
  position: "absolute",
  right: "$half",
  top: "$half"
});
const StyledTextarea = styled(TextareaAutosize, {
  border: "1px solid $blue3",
  borderRadius: "$1",
  padding: "6px $4 6px $1",
  minHeight: "100px",
  resize: "none",
  width: "100%",
  fontFamily: "$primary",
  boxSizing: "border-box",
  textStyles: "body",
  color: "$body",
  "&::placeholder": {
    color: "$gray8"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  "&:disabled": {
    backgroundColor: "$gray2",
    borderColor: "$gray3",
    cursor: "not-allowed",
    "&:hover": {
      borderColor: "$gray3"
    }
  },
  "&:active": {
    borderColor: "$blue5"
  },
  "&:focus": {
    borderColor: "$blue6"
  },
  "&:focus-visible": {
    borderColor: "$blue6",
    outline: "none"
  }
});
const Textarea = forwardRef((_ref62, forwardedRef) => {
  let {
    errorMessage = "",
    successMessage = "",
    label,
    description,
    disabled: disabled2,
    optional,
    value,
    rootProps,
    allowCopy,
    size = "medium",
    ...props
  } = _ref62;
  var _a;
  const name = toHyphenCase(label);
  const [inputElementId] = useState(() => `dds-textarea-element-${name}`);
  const [descriptionElementId] = useState(() => `dds-textarea-description-${name}`);
  const [errorMessageElementId] = useState(() => `dds-textarea-error-message-${name}`);
  const textareaRef = useRef(null);
  const composedRefs = useComposedRefs$1(forwardedRef, textareaRef);
  const describedByElementId = (_a = errorMessage && errorMessageElementId) != null ? _a : description && descriptionElementId;
  const onCopyIconClick = () => {
    if (!window || !value) {
      return;
    }
    window.navigator.clipboard.writeText(value.toString());
  };
  return /* @__PURE__ */jsx$1(InputBase.Root, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      fullWidth: true,
      children: [/* @__PURE__ */jsx$1(InputBase.Label, {
        htmlFor: inputElementId,
        label,
        showOptionalLabel: optional
      }), /* @__PURE__ */jsxs(TextareaContainer, {
        children: [/* @__PURE__ */jsx$1(StyledTextarea, {
          ref: composedRefs,
          disabled: disabled2,
          id: inputElementId,
          "aria-invalid": !!(errorMessage == null ? void 0 : errorMessage.length),
          "aria-errormessage": errorMessageElementId,
          "aria-describedby": describedByElementId,
          maxRows: 10,
          value,
          ...props,
          ...rootProps
        }), allowCopy && /* @__PURE__ */jsx$1(CopyTextButton, {
          title: "copy text to clipboard",
          icon: faClone_2,
          iconVariant: "dark",
          size: "small",
          disabled: disabled2,
          onClick: onCopyIconClick
        })]
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        successMessage: errorMessage ? "" : successMessage
      })]
    })
  });
});
Textarea.displayName = "Textarea";
const PaperElevationVariant = {
  1: {
    boxShadow: "$none"
  },
  2: {
    boxShadow: "$1"
  },
  3: {
    boxShadow: "$2"
  },
  4: {
    boxShadow: "$3"
  }
};
const StyledPaperBase = styled("div", {
  background: "$white",
  variants: {
    elevation: PaperElevationVariant
  },
  default: {
    elevation: 2
  }
});
const Paper = forwardRef((_ref63, forwardedRef) => {
  let {
    elevation,
    height,
    width,
    children,
    css: css4,
    rootProps,
    as = "div",
    ...props
  } = _ref63;
  return /* @__PURE__ */jsx$1(StyledPaperBase, {
    ref: forwardedRef,
    elevation,
    css: {
      height,
      width,
      ...css4
    },
    as,
    ...props,
    ...rootProps,
    children
  });
});
Paper.displayName = "Paper";
const CardStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "$2",
  borderRadius: "$1",
  paddingX: "$3",
  paddingY: "$3"
};
const CardTitle = _ref64 => {
  let {
    children
  } = _ref64;
  return /* @__PURE__ */jsx$1(Header, {
    variant: "h3",
    children
  });
};
const CardSubtitle = _ref65 => {
  let {
    children
  } = _ref65;
  return /* @__PURE__ */jsx$1(Text, {
    variant: "metadata",
    children
  });
};
const CardHeader = styled("div");
const CardContent = styled("div");
const StyledBase$2 = styled(StyledPaperBase, {
  ...CardStyles,
  defaultVariants: {
    elevation: 2
  }
});
const CardComponent = forwardRef((_ref66, forwardedRef) => {
  let {
    height,
    width,
    children,
    css: css4,
    rootProps,
    ...props
  } = _ref66;
  return /* @__PURE__ */jsx$1(StyledBase$2, {
    ref: forwardedRef,
    css: {
      height,
      width,
      ...css4
    },
    ...props,
    ...rootProps,
    children
  });
});
CardComponent.displayName = "Card";
const Card = {
  ...CardComponent,
  Header: CardHeader,
  Content: CardContent,
  Title: CardTitle,
  Subtitle: CardSubtitle
};
const SimpleGridGapVariant = {
  half: {
    gap: "$half"
  },
  0: {
    gap: "$0"
  },
  1: {
    gap: "$1"
  },
  2: {
    gap: "$2"
  },
  3: {
    gap: "$3"
  },
  4: {
    gap: "$4"
  },
  5: {
    gap: "$5"
  },
  6: {
    gap: "$6"
  },
  7: {
    gap: "$7"
  },
  8: {
    gap: "$8"
  }
};
const SimpleGridColumnsVariant = {
  1: {
    gridTemplateColumns: "repeat(1, 1fr)"
  },
  2: {
    gridTemplateColumns: "repeat(2, 1fr)"
  },
  3: {
    gridTemplateColumns: "repeat(3, 1fr)"
  },
  4: {
    gridTemplateColumns: "repeat(4, 1fr)"
  },
  5: {
    gridTemplateColumns: "repeat(5, 1fr)"
  },
  6: {
    gridTemplateColumns: "repeat(6, 1fr)"
  },
  7: {
    gridTemplateColumns: "repeat(7, 1fr)"
  },
  8: {
    gridTemplateColumns: "repeat(8, 1fr)"
  }
};
var SimpleGridAlignItemsVariantEnum = /* @__PURE__ */(SimpleGridAlignItemsVariantEnum2 => {
  SimpleGridAlignItemsVariantEnum2["START"] = "start";
  SimpleGridAlignItemsVariantEnum2["CENTER"] = "center";
  SimpleGridAlignItemsVariantEnum2["END"] = "end";
  SimpleGridAlignItemsVariantEnum2["STRETCH"] = "stretch";
  SimpleGridAlignItemsVariantEnum2["BASELINE"] = "baseline";
  return SimpleGridAlignItemsVariantEnum2;
})(SimpleGridAlignItemsVariantEnum || {});
const SimpleGridAlignItemsVariant = {
  start: {
    alignItems: "start"
  },
  center: {
    alignItems: "center"
  },
  end: {
    alignItems: "end"
  },
  stretch: {
    alignItems: "stretch"
  },
  baseline: {
    alignItems: "baseline"
  }
};
var SimpleGridJustifyItemsVariantEnum = /* @__PURE__ */(SimpleGridJustifyItemsVariantEnum2 => {
  SimpleGridJustifyItemsVariantEnum2["START"] = "start";
  SimpleGridJustifyItemsVariantEnum2["CENTER"] = "center";
  SimpleGridJustifyItemsVariantEnum2["END"] = "end";
  SimpleGridJustifyItemsVariantEnum2["STRETCH"] = "stretch";
  return SimpleGridJustifyItemsVariantEnum2;
})(SimpleGridJustifyItemsVariantEnum || {});
const SimpleGridJustifyItemsVariant = {
  start: {
    justifyItems: "start"
  },
  center: {
    justifyItems: "center"
  },
  end: {
    justifyItems: "end"
  },
  stretch: {
    justifyItems: "stretch"
  }
};
const StyledBase$1 = styled("div", {
  display: "grid",
  variants: {
    gap: SimpleGridGapVariant,
    columns: SimpleGridColumnsVariant,
    justifyItems: SimpleGridJustifyItemsVariant,
    alignItems: SimpleGridAlignItemsVariant,
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  }
});
const SimpleGrid = forwardRef((_ref67, forwardedRef) => {
  let {
    columns,
    gap,
    css: css4,
    as,
    children,
    alignItems,
    justifyItems,
    minChildWidth,
    height,
    width,
    rootProps,
    ...props
  } = _ref67;
  const simpleGridStyles = {
    ...(minChildWidth && {
      gridTemplateColumns: `repeat(auto-fit, minmax(${minChildWidth}px, 1fr))`
    }),
    height,
    width,
    ...css4
  };
  return /* @__PURE__ */jsx$1(StyledBase$1, {
    ref: forwardedRef,
    gap,
    columns,
    justifyItems,
    alignItems,
    as,
    css: simpleGridStyles,
    ...rootProps,
    ...props,
    children
  });
});
SimpleGrid.displayName = "SimpleGrid";
var faExclamation$1 = {};
Object.defineProperty(faExclamation$1, "__esModule", {
  value: true
});
var faExclamation_2 = faExclamation$1.faExclamation = void 0;
const faExclamation = {
  prefix: "fas",
  iconName: "faExclamation",
  icon: [128, 512, [], "", "M64 352c17.69 0 32-14.32 32-31.1V64.01c0-17.67-14.31-32.01-32-32.01S32 46.34 32 64.01v255.1C32 337.7 46.31 352 64 352zM64 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S86.09 400 64 400z"]
};
faExclamation_2 = faExclamation$1.faExclamation = faExclamation;
var StatusIndicatorColorVariantEnum = /* @__PURE__ */(StatusIndicatorColorVariantEnum2 => {
  StatusIndicatorColorVariantEnum2["INFO"] = "info";
  StatusIndicatorColorVariantEnum2["SUCCESS"] = "success";
  StatusIndicatorColorVariantEnum2["ERROR"] = "error";
  StatusIndicatorColorVariantEnum2["WARNING"] = "warning";
  StatusIndicatorColorVariantEnum2["ARCHIVED"] = "archive";
  StatusIndicatorColorVariantEnum2["AWAY"] = "away";
  StatusIndicatorColorVariantEnum2["CHAT_LIMIT"] = "chat-limit";
  return StatusIndicatorColorVariantEnum2;
})(StatusIndicatorColorVariantEnum || {});
const StatusIndicatorColorVariant = {
  info: {
    backgroundColor: "$blue6"
  },
  success: {
    backgroundColor: "$green6"
  },
  error: {
    backgroundColor: "$red6"
  },
  warning: {
    backgroundColor: "$yellow4"
  },
  archive: {
    backgroundColor: "$gray6"
  },
  away: {
    backgroundColor: "$white"
  },
  "chat-limit": {
    position: "relative",
    backgroundColor: "$yellow5"
  }
};
var StatusIndicatorSizeVariantEnum = /* @__PURE__ */(StatusIndicatorSizeVariantEnum2 => {
  StatusIndicatorSizeVariantEnum2["X_SMALL"] = "x-small";
  StatusIndicatorSizeVariantEnum2["SMALL"] = "small";
  StatusIndicatorSizeVariantEnum2["MEDIUM"] = "medium";
  StatusIndicatorSizeVariantEnum2["LARGE"] = "large";
  StatusIndicatorSizeVariantEnum2["X_LARGE"] = "x-large";
  return StatusIndicatorSizeVariantEnum2;
})(StatusIndicatorSizeVariantEnum || {});
const StatusIndicatorSizeVariant = {
  "x-small": {
    size: "$1"
  },
  small: {
    size: "10px"
  },
  medium: {
    size: "12px"
  },
  large: {
    size: "20px"
  },
  "x-large": {
    size: "30px"
  }
};
const ChatLimitBorderCompoundVariant = [{
  size: "x-small",
  variant: "away",
  css: {
    border: "1.5px solid $colors$gray10"
  }
}, {
  size: "small",
  variant: "away",
  css: {
    border: "2px solid $colors$gray10"
  }
}, {
  size: "medium",
  variant: "away",
  css: {
    border: "3px solid $colors$gray10"
  }
}, {
  size: "large",
  variant: "away",
  css: {
    border: "5px solid $colors$gray10"
  }
}, {
  size: "x-large",
  variant: "away",
  css: {
    border: "7px solid $colors$gray10"
  }
}];
const StyledIndicator = styled("span", {
  width: "$1",
  height: "$1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$round",
  variants: {
    variant: StatusIndicatorColorVariant,
    size: StatusIndicatorSizeVariant
  },
  defaultVariants: {
    variant: StatusIndicatorColorVariantEnum.INFO,
    size: StatusIndicatorSizeVariantEnum.MEDIUM
  },
  compoundVariants: [...ChatLimitBorderCompoundVariant]
});
const IndicatorIconStyles = {
  height: "70%",
  width: "100%",
  display: "block"
};
const StatusIndicatorVariantIcons = {
  "chat-limit": faExclamation_2
};
const StatusIndicator = _ref68 => {
  let {
    size,
    variant = "info",
    rootProps,
    ...props
  } = _ref68;
  const indicatorIcon = StatusIndicatorVariantIcons[variant];
  return /* @__PURE__ */jsx$1(StyledIndicator, {
    variant,
    size,
    "aria-hidden": true,
    ...rootProps,
    ...props,
    children: indicatorIcon && /* @__PURE__ */jsx$1(Icon, {
      icon: indicatorIcon,
      variant: "light",
      css: {
        ...IndicatorIconStyles
      }
    })
  });
};
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$2 = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$2 = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS$2 = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContainer(node2));
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function (event) {
          if (focusScope.paused || !container1) return;
          const target = event.target;
          if (container1.contains(target)) lastFocusedElementRef.current = target;else $d3863c46a17e8a28$var$focus$2(lastFocusedElementRef.current, {
            select: true
          });
        },
        handleFocusOut = function (event) {
          if (focusScope.paused || !container1) return;
          if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus$2(lastFocusedElementRef.current, {
            select: true
          });
        };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [trapped, container1, focusScope.paused]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack$2.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$2, $d3863c46a17e8a28$var$EVENT_OPTIONS$2);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$2, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst$2($d3863c46a17e8a28$var$removeLinks$2($d3863c46a17e8a28$var$getTabbableCandidates$2(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus$2(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$2, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$2, $d3863c46a17e8a28$var$EVENT_OPTIONS$2);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$2, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus$2(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$2, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack$2.remove(focusScope);
        }, 0);
      };
    }
  }, [container1, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = useCallback(event => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges$2(container);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus$2(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus$2(last, {
            select: true
          });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst$2(candidates) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus$2(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges$2(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates$2(container);
  const first = $d3863c46a17e8a28$var$findVisible$2(candidates, container);
  const last = $d3863c46a17e8a28$var$findVisible$2(candidates.reverse(), container);
  return [first, last];
}
function $d3863c46a17e8a28$var$getTabbableCandidates$2(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node2 => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible$2(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden$2(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden$2(node2, _ref69) {
  let {
    upTo
  } = _ref69;
  if (getComputedStyle(node2).visibility === "hidden") return true;
  while (node2) {
    if (upTo !== void 0 && node2 === upTo) return false;
    if (getComputedStyle(node2).display === "none") return true;
    node2 = node2.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput$2(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus$2(element) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput$2(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack$2 = $d3863c46a17e8a28$var$createFocusScopesStack$2();
function $d3863c46a17e8a28$var$createFocusScopesStack$2() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove$2(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove$2(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove$2(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks$2(items) {
  return items.filter(item => item.tagName !== "A");
}
let $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
    $3db38b7d1fb3fe6a$var$count++;
    return () => {
      if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(node2 => node2.remove());
      $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}
var __assign = function () {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2)) t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s2, e2) {
  var t2 = {};
  for (var p2 in s2) if (Object.prototype.hasOwnProperty.call(s2, p2) && e2.indexOf(p2) < 0) t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p2 = Object.getOwnPropertySymbols(s2); i < p2.length; i++) {
    if (e2.indexOf(p2[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i])) t2[p2[i]] = s2[p2[i]];
  }
  return t2;
}
function __spreadArray(to, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l2 = from2.length, ar; i < l2; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from2));
}
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
function useCallbackRef$1(initialValue, callback) {
  var ref = useState(function () {
    return {
      value: initialValue,
      callback,
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef$1(defaultValue || null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}
function ItoI(a2) {
  return a2;
}
function innerCreateMedium(defaults, middleware2) {
  if (middleware2 === void 0) {
    middleware2 = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function () {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function (data) {
      var item = middleware2(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x2) {
          return x2 !== item;
        });
      };
    },
    assignSyncMedium: function (cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function (x2) {
          return cb(x2);
        },
        filter: function () {
          return buffer;
        }
      };
    },
    assignMedium: function (cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function () {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function () {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function (x2) {
          pendingQueue.push(x2);
          cycle();
        },
        filter: function (filter2) {
          pendingQueue = pendingQueue.filter(filter2);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({
    async: true,
    ssr: false
  }, options);
  return medium;
}
var SideCar$3 = function (_a) {
  var sideCar = _a.sideCar,
    rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React.createElement(Target, __assign({}, rest));
};
SideCar$3.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar$3;
}
var effectCar$2 = createSidecarMedium();
var nothing$2 = function () {
  return;
};
var RemoveScroll$2 = React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing$2,
      onWheelCapture: nothing$2,
      onTouchMoveCapture: nothing$2
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? "div" : _b,
    rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(React.Fragment, null, enabled && React.createElement(SideCar2, {
    sideCar: effectCar$2,
    removeScrollBar,
    shards,
    noIsolation,
    inert,
    setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref
  }), forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), {
    ref: containerRef
  })) : React.createElement(Container, __assign({}, containerProps, {
    className,
    ref: containerRef
  }), children));
});
RemoveScroll$2.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll$2.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function () {
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};
function makeStyleTag() {
  if (!document) return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css4) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css4;
  } else {
    tag.appendChild(document.createTextNode(css4));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function () {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function (style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function () {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
var styleHookSingleton = function () {
  var sheet = stylesheetSingleton();
  return function (styles2, isDynamic) {
    React.useEffect(function () {
      sheet.add(styles2);
      return function () {
        sheet.remove();
      };
    }, [styles2 && isDynamic]);
  };
};
var styleSingleton = function () {
  var useStyle = styleHookSingleton();
  var Sheet = function (_a) {
    var styles2 = _a.styles,
      dynamic = _a.dynamic;
    useStyle(styles2, dynamic);
    return null;
  };
  return Sheet;
};
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse$1 = function (x2) {
  return parseInt(x2 || "", 10) || 0;
};
var getOffset = function (gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse$1(left), parse$1(top), parse$1(right)];
};
var getGapWidth = function (gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
var Style = styleSingleton();
var getStyles = function (_a, allowRelative, gapMode, important) {
  var left = _a.left,
    top = _a.top,
    right = _a.right,
    gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([allowRelative && "position: relative ".concat(important, ";"), gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "), gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var RemoveScrollBar = function (props) {
  var noRelative = props.noRelative,
    noImportant = props.noImportant,
    _a = props.gapMode,
    gapMode = _a === void 0 ? "margin" : _a;
  var gap = React.useMemo(function () {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React.createElement(Style, {
    styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
  });
};
var passiveSupported$3 = false;
if (typeof window !== "undefined") {
  try {
    var options$3 = Object.defineProperty({}, "passive", {
      get: function () {
        passiveSupported$3 = true;
        return true;
      }
    });
    window.addEventListener("test", options$3, options$3);
    window.removeEventListener("test", options$3, options$3);
  } catch (err) {
    passiveSupported$3 = false;
  }
}
var nonPassive$2 = passiveSupported$3 ? {
  passive: false
} : false;
var elementCouldBeVScrolled$2 = function (node2) {
  var styles2 = window.getComputedStyle(node2);
  return styles2.overflowY !== "hidden" && !(styles2.overflowY === styles2.overflowX && styles2.overflowY === "visible");
};
var elementCouldBeHScrolled$2 = function (node2) {
  var styles2 = window.getComputedStyle(node2);
  return styles2.overflowX !== "hidden" && !(styles2.overflowY === styles2.overflowX && styles2.overflowX === "visible");
};
var locationCouldBeScrolled$2 = function (axis, node2) {
  var current = node2;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled$2(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables$2(axis, current),
        s2 = _a[1],
        d2 = _a[2];
      if (s2 > d2) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables$2 = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables$2 = function (_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled$2 = function (axis, node2) {
  return axis === "v" ? elementCouldBeVScrolled$2(node2) : elementCouldBeHScrolled$2(node2);
};
var getScrollVariables$2 = function (axis, node2) {
  return axis === "v" ? getVScrollVariables$2(node2) : getHScrollVariables$2(node2);
};
var getDirectionFactor$2 = function (axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll$2 = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor$2(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables$2(axis, target),
      position2 = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position2;
    if (position2 || elementScroll) {
      if (elementCouldBeScrolled$2(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position2;
      }
    }
    target = target.parentNode;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY$2 = function (event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY$2 = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef$2 = function (ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare$2 = function (x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle$2 = function (id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter$2 = 0;
var lockStack$2 = [];
function RemoveScrollSideCar$2(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter$2++)[0];
  var Style2 = React.useState(function () {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef$2), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY$2(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled$2(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled$2(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll$2(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack$2.length || lockStack$2[lockStack$2.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY$2(event) : getTouchXY$2(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e2) {
      return e2.name === event.type && e2.target === event.target && deltaCompare$2(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      event.preventDefault();
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef$2).filter(Boolean).filter(function (node2) {
        return node2.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        event.preventDefault();
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = {
      name,
      delta,
      target,
      should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY$2(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY$2(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY$2(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function () {
    lockStack$2.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive$2);
    document.addEventListener("touchmove", shouldPrevent, nonPassive$2);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive$2);
    return function () {
      lockStack$2 = lockStack$2.filter(function (inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive$2);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive$2);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive$2);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return React.createElement(React.Fragment, null, inert ? React.createElement(Style2, {
    styles: generateStyle$2(id)
  }) : null, removeScrollBar ? React.createElement(RemoveScrollBar, {
    gapMode: "margin"
  }) : null);
}
var SideCar$2 = exportSidecar(effectCar$2, RemoveScrollSideCar$2);
var ReactRemoveScroll$2 = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll$2, __assign({}, props, {
    ref,
    sideCar: SideCar$2
  }));
});
ReactRemoveScroll$2.classNames = RemoveScroll$2.classNames;
var $epM9y$RemoveScroll = ReactRemoveScroll$2;
var getDefaultParent = function (originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */new WeakMap();
var uncontrolledNodes = /* @__PURE__ */new WeakMap();
var markerMap = {};
var lockCount = 0;
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
  var targets = Array.isArray(originalTarget) ? originalTarget : [originalTarget];
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */new Set();
  var elementsToStop = new Set(targets);
  var keep = function (el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function (parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node2) {
      if (elementsToKeep.has(node2)) {
        deep(node2);
      } else {
        var attr = node2.getAttribute(controlAttribute);
        var alreadyHidden = attr !== null && attr !== "false";
        var counterValue = (counterMap.get(node2) || 0) + 1;
        var markerValue = (markerCounter.get(node2) || 0) + 1;
        counterMap.set(node2, counterValue);
        markerCounter.set(node2, markerValue);
        hiddenNodes.push(node2);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node2, true);
        }
        if (markerValue === 1) {
          node2.setAttribute(markerName, "true");
        }
        if (!alreadyHidden) {
          node2.setAttribute(controlAttribute, "true");
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node2) {
      var counterValue = counterMap.get(node2) - 1;
      var markerValue = markerCounter.get(node2) - 1;
      counterMap.set(node2, counterValue);
      markerCounter.set(node2, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node2)) {
          node2.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node2);
      }
      if (!markerValue) {
        node2.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */new WeakMap();
      counterMap = /* @__PURE__ */new WeakMap();
      uncontrolledNodes = /* @__PURE__ */new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$2);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$2, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$2, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$2.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$2(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$2.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$2 = _ref70 => {
  let {
    children
  } = _ref70;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$2(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$2;
}
function $5e63c961fc1ce211$var$mergeProps$2(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$5d3850c4d0b4e6c7$var$createDialogContext, $5d3850c4d0b4e6c7$export$cc702773b8ea3e41] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$5d3850c4d0b4e6c7$var$DialogProvider, $5d3850c4d0b4e6c7$var$useDialogContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $5d3850c4d0b4e6c7$export$3ddf2d174ce01153 = props => {
  const {
    __scopeDialog,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const triggerRef = useRef(null);
  const contentRef = useRef(null);
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogProvider, {
    scope: __scopeDialog,
    triggerRef,
    contentRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    titleId: $1746a345f3d73bb7$export$f680877a34711e37(),
    descriptionId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open: open2,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    modal
  }, children);
};
const $5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...triggerProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
});
const $5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$5d3850c4d0b4e6c7$var$PortalProvider, $5d3850c4d0b4e6c7$var$usePortalContext] = $5d3850c4d0b4e6c7$var$createDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, {
  forceMount: void 0
});
const $5d3850c4d0b4e6c7$export$dad7c95542bacce0 = props => {
  const {
    __scopeDialog,
    forceMount,
    children,
    container
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$PortalProvider, {
    scope: __scopeDialog,
    forceMount
  }, Children.map(children, child => /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c$2, {
    asChild: true,
    container
  }, child))));
};
const $5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $5d3850c4d0b4e6c7$export$bd1d06c79be19e17 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  const {
    forceMount = portalContext.forceMount,
    ...overlayProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
  return context.modal ? /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogOverlayImpl, _extends$1({}, overlayProps, {
    ref: forwardedRef
  }))) : null;
});
const $5d3850c4d0b4e6c7$var$DialogOverlayImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...overlayProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($epM9y$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$2,
    allowPinchZoom: true,
    shards: [context.contentRef]
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, overlayProps, {
    ref: forwardedRef,
    style: {
      pointerEvents: "auto",
      ...overlayProps.style
    }
  })));
});
const $5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $5d3850c4d0b4e6c7$export$b6d9565de1e068cf = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $5d3850c4d0b4e6c7$var$usePortalContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const {
    forceMount = portalContext.forceMount,
    ...contentProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentNonModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })));
});
const $5d3850c4d0b4e6c7$var$DialogContentModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.contentRef, contentRef);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$1({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, event => {
      var _context$triggerRef$c;
      event.preventDefault();
      (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, event => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (isRightClick) event.preventDefault();
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, event => event.preventDefault())
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentNonModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */createElement$1($5d3850c4d0b4e6c7$var$DialogContentImpl, _extends$1({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: event => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: event => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) hasInteractedOutsideRef.current = true;
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
    }
  }));
});
const $5d3850c4d0b4e6c7$var$DialogContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    ...contentProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1($d3863c46a17e8a28$export$20e40289641fbbb6$2, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22$2, _extends$1({
    role: "dialog",
    id: context.contentId,
    "aria-describedby": context.descriptionId,
    "aria-labelledby": context.titleId,
    "data-state": $5d3850c4d0b4e6c7$var$getState(context.open)
  }, contentProps, {
    ref: composedRefs,
    onDismiss: () => context.onOpenChange(false)
  }))), false);
});
const $5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $5d3850c4d0b4e6c7$export$16f7638e4a34b909 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...titleProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.h2, _extends$1({
    id: context.titleId
  }, titleProps, {
    ref: forwardedRef
  }));
});
const $5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...descriptionProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.p, _extends$1({
    id: context.descriptionId
  }, descriptionProps, {
    ref: forwardedRef
  }));
});
const $5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDialog,
    ...closeProps
  } = props;
  const context = $5d3850c4d0b4e6c7$var$useDialogContext($5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, () => context.onOpenChange(false))
  }));
});
function $5d3850c4d0b4e6c7$var$getState(open2) {
  return open2 ? "open" : "closed";
}
const $5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
$c512c27ab02ef895$export$fd42f52fd3ae1109($5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
  contentName: $5d3850c4d0b4e6c7$var$CONTENT_NAME,
  titleName: $5d3850c4d0b4e6c7$var$TITLE_NAME,
  docsSlug: "dialog"
});
const $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9 = $5d3850c4d0b4e6c7$export$3ddf2d174ce01153;
const $5d3850c4d0b4e6c7$export$41fb9f06171c75f4 = $5d3850c4d0b4e6c7$export$2e1e1122cf0cba88;
const $5d3850c4d0b4e6c7$export$602eac185826482c = $5d3850c4d0b4e6c7$export$dad7c95542bacce0;
const $5d3850c4d0b4e6c7$export$c6fdb837b070b4ff = $5d3850c4d0b4e6c7$export$bd1d06c79be19e17;
const $5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2 = $5d3850c4d0b4e6c7$export$b6d9565de1e068cf;
const $5d3850c4d0b4e6c7$export$f99233281efd08a0 = $5d3850c4d0b4e6c7$export$16f7638e4a34b909;
const $5d3850c4d0b4e6c7$export$393edc798c47379d = $5d3850c4d0b4e6c7$export$94e94c2ec2c954d5;
const $5d3850c4d0b4e6c7$export$f39c2d165cd861fe = $5d3850c4d0b4e6c7$export$fba2fb7cd781b7ac;
const overlayShow = keyframes$1({
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 0.8
  }
});
const contentShow = keyframes$1({
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
});
const StyledModalBaseOverlay = styled($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, {
  backgroundColor: "$gray10",
  opacity: 0.8,
  position: "fixed",
  inset: 0,
  zIndex: "$modal",
  "@media (prefers-reduced-motion: no-preference)": {
    animation: `${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  }
});
const StyledModalBaseContentContainer = styled($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, {
  backgroundColor: "transparent",
  position: "fixed",
  inset: 0,
  zIndex: "$modal",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "$2",
  pointerEvents: "none !important",
  variants: {}
});
const StyledModalBaseContent = styled(Box, {
  background: "$white",
  position: "relative",
  pointerEvents: "auto",
  "@media (prefers-reduced-motion: no-preference)": {
    animation: `${contentShow} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
  }
});
const StyledModalBaseCloseIcon = styled($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, {
  textStyles: "button1",
  fontFamily: "$primary",
  height: "$4",
  width: "$4",
  color: "$gray12",
  margin: 0,
  padding: 0,
  background: "transparent",
  border: "none",
  position: "absolute",
  top: "$1",
  right: "$1",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "$gray2",
    borderColor: "$gray2"
  },
  "&:active": {
    backgroundColor: "$gray3",
    borderColor: "$gray3"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  }
});
const StyledModalBaseTitle = styled($5d3850c4d0b4e6c7$export$f99233281efd08a0, {
  textStyles: "h1",
  textColor: "h1",
  width: "90%",
  wordBreak: "break-word"
});
const StyledModalBaseDescription = styled($5d3850c4d0b4e6c7$export$393edc798c47379d, {
  textStyles: "subtitle1",
  textColor: "subtitle1",
  wordBreak: "break-word"
});
const ModalBaseCloseIcon = _ref71 => {
  let {
    onClose
  } = _ref71;
  return /* @__PURE__ */jsx$1(StyledModalBaseCloseIcon, {
    onClick: onClose,
    children: /* @__PURE__ */jsx$1(Icon, {
      icon: faXmark_2$1
    })
  });
};
const ModalBaseContentContainer = forwardRef((_ref72, forwardedRef) => {
  let {
    ariaTitle,
    ariaDescription,
    children,
    ...props
  } = _ref72;
  return /* @__PURE__ */jsxs(StyledModalBaseContentContainer, {
    ...props,
    ref: forwardedRef,
    children: [ariaTitle && /* @__PURE__ */jsx$1($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
      children: /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$f99233281efd08a0, {
        children: ariaTitle
      })
    }), ariaDescription && /* @__PURE__ */jsx$1($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
      children: /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$393edc798c47379d, {
        children: ariaDescription
      })
    }), children]
  });
});
ModalBaseContentContainer.displayName = "ModalBaseContentContainer";
const ModalBaseTrigger = _ref73 => {
  let {
    children
  } = _ref73;
  return /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, {
    asChild: true,
    children
  });
};
const ModalBase = {
  Root: $5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9,
  Portal: $5d3850c4d0b4e6c7$export$602eac185826482c,
  Overlay: StyledModalBaseOverlay,
  Title: StyledModalBaseTitle,
  Description: StyledModalBaseDescription,
  Trigger: ModalBaseTrigger,
  ContentContainer: ModalBaseContentContainer,
  Content: StyledModalBaseContent,
  CloseIcon: ModalBaseCloseIcon
};
var ModalSizeVariantEnum = /* @__PURE__ */(ModalSizeVariantEnum2 => {
  ModalSizeVariantEnum2["SM"] = "small";
  ModalSizeVariantEnum2["MD"] = "medium";
  ModalSizeVariantEnum2["LG"] = "large";
  ModalSizeVariantEnum2["XL"] = "x-large";
  return ModalSizeVariantEnum2;
})(ModalSizeVariantEnum || {});
const ModalSizeVariant = {
  small: {
    maxWidth: "28rem",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
      "dialog-bottom-padding"
    `
  },
  medium: {
    maxWidth: "36rem",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
      "dialog-bottom-padding"
    `
  },
  large: {
    maxWidth: "48rem",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateAreas: `
      "dialog-title"
      "dialog-content"
      "dialog-actions"
      "dialog-bottom-padding"
    `
  },
  "x-large": {
    maxWidth: "64rem",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateAreas: `
      "dialog-title xl-content"
      "dialog-content xl-content"
      "dialog-actions xl-content"
      "dialog-bottom-padding xl-content"
    `
  }
};
var ModalDialogAlertVariantEnum = /* @__PURE__ */(ModalDialogAlertVariantEnum2 => {
  ModalDialogAlertVariantEnum2["INFO"] = "info";
  ModalDialogAlertVariantEnum2["WARNING"] = "warning";
  ModalDialogAlertVariantEnum2["ERROR"] = "error";
  return ModalDialogAlertVariantEnum2;
})(ModalDialogAlertVariantEnum || {});
const ModalDialogAlertVariant = {
  info: {
    borderTop: "4px solid $gray12"
  },
  warning: {
    borderTop: "4px solid $yellow4"
  },
  error: {
    borderTop: "4px solid $red6"
  }
};
const ModalContentColumnSizingVariant = {
  "100-0": {
    gridTemplateColumns: "1fr 0fr"
  },
  "50-50": {
    gridTemplateColumns: "1fr 1fr"
  },
  "75-25": {
    gridTemplateColumns: "3fr 1fr"
  },
  "25-75": {
    gridTemplateColumns: "1fr 3fr"
  }
};
const ModalContentOverflowBehaviorVariant = {
  inside: {
    overflow: "auto"
  },
  outside: {
    overflow: "initial"
  }
};
const StyledModalContent = styled(ModalBase.Content, {
  borderRadius: "$1",
  boxShadow: "$3",
  maxHeight: "80vh",
  variants: {
    size: ModalSizeVariant,
    variant: ModalDialogAlertVariant,
    xlColumnSize: ModalContentColumnSizingVariant,
    fullWidth: FullWidthVariant,
    fullHeight: FullHeightVariant
  }
});
const StyledModalXlContent = styled(Box, {
  gridArea: "xl-content"
});
const StyledModalDialogTitle = styled(Flex, {
  gridArea: "dialog-title",
  paddingTop: "$3",
  paddingBottom: "$2",
  paddingX: "$3"
});
const StyledModalDialogContent = styled(Box, {
  gridArea: "dialog-content",
  paddingX: "$3",
  overflow: "auto",
  maxHeight: "60vh",
  WebkitOverflowScrolling: "touch",
  overflowScrolling: "touch",
  background: `
    linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    linear-gradient(180deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center top,
    linear-gradient(0deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center bottom
  `,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 40px, 100% 4px, 100% 4px",
  backgroundAttachment: "local, local, scroll, scroll",
  variants: {
    scrollOverflow: ModalContentOverflowBehaviorVariant
  }
});
const StyledModalDialogActions = styled(Flex, {
  gridArea: "dialog-actions",
  paddingX: "$3",
  paddingTop: "$2"
});
const StyledModalDialogBottomPadding = styled(Box, {
  gridArea: "dialog-bottom-padding",
  height: "$3"
});
const ModalContext = createContext$1({
  onClose: () => {},
  open: false
});
const useCloseModal = () => useContext(ModalContext).onClose;
const ModalRoot = _ref74 => {
  let {
    children,
    open: open2,
    onClose
  } = _ref74;
  return /* @__PURE__ */jsx$1(ModalBase.Root, {
    open: open2,
    children: /* @__PURE__ */jsx$1(ModalContext.Provider, {
      value: {
        open: open2,
        onClose
      },
      children
    })
  });
};
const ModalDialog = _ref75 => {
  let {
    children,
    size,
    variant,
    xlColumnSize = "100-0",
    fullWidth = false,
    fullHeight = false,
    css: css4,
    className,
    preventContentAutoFocusOnOpen,
    contentAs = "div"
  } = _ref75;
  const {
    onClose
  } = useContext(ModalContext);
  return /* @__PURE__ */jsxs(ModalBase.Portal, {
    children: [/* @__PURE__ */jsx$1(ModalBase.Overlay, {}), /* @__PURE__ */jsx$1(ModalBase.ContentContainer, {
      onEscapeKeyDown: onClose,
      onPointerDownOutside: onClose,
      onInteractOutside: onClose,
      onOpenAutoFocus: evt => preventContentAutoFocusOnOpen ? evt.preventDefault() : null,
      children: /* @__PURE__ */jsxs(StyledModalContent, {
        css: css4,
        className,
        size,
        variant,
        ...(size === ModalSizeVariantEnum.XL && {
          xlColumnSize
        }),
        fullWidth,
        fullHeight,
        as: contentAs,
        children: [children, /* @__PURE__ */jsx$1(StyledModalDialogBottomPadding, {}), /* @__PURE__ */jsx$1(ModalBase.CloseIcon, {
          onClose
        })]
      })
    })]
  });
};
const ModalDialogTitle = _ref76 => {
  let {
    title,
    subtitle,
    children
  } = _ref76;
  return /* @__PURE__ */jsxs(StyledModalDialogTitle, {
    direction: "column",
    gap: 0,
    children: [/* @__PURE__ */jsx$1(ModalBase.Title, {
      children: title
    }), subtitle && /* @__PURE__ */jsx$1(ModalBase.Description, {
      children: subtitle
    }), children]
  });
};
const ModalDialogActions = _ref77 => {
  let {
    children,
    justifyContent = "flex-end",
    ...props
  } = _ref77;
  return /* @__PURE__ */jsx$1(StyledModalDialogActions, {
    justifyContent,
    ...props,
    children
  });
};
const ModalDialogContent = forwardRef((_ref78, forwardedRef) => {
  let {
    children,
    scrollOverflow = "inside",
    ...props
  } = _ref78;
  return /* @__PURE__ */jsx$1(StyledModalDialogContent, {
    ref: forwardedRef,
    scrollOverflow,
    ...props,
    children
  });
});
ModalDialogContent.displayName = "ModalDialogContent";
const Modal = {
  Root: ModalRoot,
  Trigger: ModalBase.Trigger,
  Dialog: ModalDialog,
  Title: ModalDialogTitle,
  Content: ModalDialogContent,
  Actions: ModalDialogActions,
  XLContent: StyledModalXlContent
};
const ButtonGroupAlignmentMap = {
  left: "flex-start",
  right: "flex-end"
};
const ButtonGroupOrientationMap = {
  horizontal: "row",
  vertical: "column"
};
const ButtonGroup = forwardRef((_ref79, forwardedRef) => {
  let {
    as,
    align = "right",
    orientation = "horizontal",
    gap = 1,
    fullWidth,
    children,
    rootProps,
    ...props
  } = _ref79;
  return /* @__PURE__ */jsx$1(Flex, {
    as,
    ref: forwardedRef,
    gap,
    direction: ButtonGroupOrientationMap[orientation],
    justifyContent: ButtonGroupAlignmentMap[align],
    role: "group",
    fullWidth,
    ...rootProps,
    ...props,
    children
  });
});
ButtonGroup.displayName = "ButtonGroup";
var bolt$1 = {};
Object.defineProperty(bolt$1, "__esModule", {
  value: true
});
var bolt_2 = bolt$1.bolt = void 0;
const bolt = {
  prefix: "ddsCustom",
  iconName: "bolt",
  icon: [16, 16, [], "", "M13.2291 0C13.2859 0 13.3509 0.00840927 13.4078 0.0168181C13.6353 0.0672714 13.7327 0.285902 13.619 0.462488C13.5946 0.496124 13.5703 0.52976 13.5378 0.563395L9.69511 5.08737C9.69511 5.08737 9.62199 5.16305 9.59762 5.2051C9.45951 5.40691 9.59762 5.65918 9.86572 5.66759C9.90634 5.66759 9.98758 5.66759 9.98758 5.66759H11.3118C11.3118 5.66759 11.393 5.66759 11.4337 5.66759C11.6936 5.69281 11.8236 5.93667 11.6855 6.13848C11.653 6.18053 11.5799 6.27303 11.5799 6.27303L8.7446 9.57772C8.7121 9.61976 8.67961 9.6534 8.64711 9.70385C8.52525 9.90566 8.66336 10.1327 8.92333 10.1495C8.99644 10.1495 9.88196 10.1495 9.94696 10.1495C10.0851 10.1411 10.215 10.2168 10.28 10.3429C10.3369 10.4606 10.2963 10.6036 10.1988 10.6793C10.1744 10.7045 10.1176 10.7466 10.1176 10.7466L3.56148 15.8676C3.56148 15.8676 3.48024 15.9432 3.43962 15.9685C3.37462 16.0105 3.29338 16.0105 3.22839 15.9685C3.17152 15.9348 3.14715 15.8676 3.1634 15.8003C3.17965 15.7582 3.22027 15.6742 3.22027 15.6742L5.0238 11.8229L5.07254 11.7136C5.1944 11.4613 5.07254 11.2427 4.80445 11.209C4.77195 11.209 4.69884 11.209 4.69884 11.209H3.43962C3.39087 11.209 3.334 11.209 3.28526 11.2006C3.06591 11.167 2.94405 10.9736 3.02529 10.7802C3.04154 10.7381 3.09028 10.6541 3.09028 10.6541L5.33251 6.76074C5.33251 6.76074 5.35688 6.7187 5.37313 6.69347C5.49499 6.46643 5.34876 6.23939 5.06442 6.23098C4.95068 6.23098 4.71509 6.23098 4.71509 6.23098C4.71509 6.23098 4.11391 6.23098 3.71583 6.23098H3.59397C3.40712 6.23098 3.26901 6.13007 3.23652 5.97031C3.22839 5.88622 3.25276 5.81054 3.29338 5.74327L3.9758 4.49875L6.21803 0.412035L6.2749 0.319538C6.38863 0.109316 6.58361 0 6.84358 0H13.2291Z"]
};
bolt_2 = bolt$1.bolt = bolt;
var FeatureBadgeVariantEnum = /* @__PURE__ */(FeatureBadgeVariantEnum2 => {
  FeatureBadgeVariantEnum2["BETA"] = "beta";
  FeatureBadgeVariantEnum2["NEW"] = "new";
  FeatureBadgeVariantEnum2["UPGRADE"] = "upgrade";
  return FeatureBadgeVariantEnum2;
})(FeatureBadgeVariantEnum || {});
const FeatureBadgeVariant = {
  beta: {
    backgroundColor: "$purple9"
  },
  new: {
    backgroundColor: "$indigo11"
  },
  upgrade: {
    backgroundColor: "$pink9"
  }
};
var FeatureBadgeSizeVariantEnum = /* @__PURE__ */(FeatureBadgeSizeVariantEnum2 => {
  FeatureBadgeSizeVariantEnum2["SMALL"] = "small";
  FeatureBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return FeatureBadgeSizeVariantEnum2;
})(FeatureBadgeSizeVariantEnum || {});
const FeatureBadgeSizeVariant = {
  small: {
    textStyles: "h4",
    height: "$2"
  },
  medium: {
    textStyles: "bodyBold",
    height: "20px"
  }
};
const StyledFeatureBadge = styled("span", {
  position: "relative",
  display: "inline-block",
  textStyles: "h4",
  color: "$white",
  textAlign: "center",
  paddingX: "$1",
  "& svg": {
    size: "$2",
    position: "absolute",
    top: "-3px"
  },
  "& svg:first-child": {
    left: "-4px",
    color: "$black"
  },
  "& svg:last-child": {
    left: "-6px",
    color: "$lime3"
  },
  variants: {
    variant: FeatureBadgeVariant,
    size: FeatureBadgeSizeVariant
  },
  defaultVariants: {
    variant: "beta",
    size: "small"
  }
});
const FeatureBadge = forwardRef((_ref80, forwardedRef) => {
  let {
    variant,
    size = "small",
    css: css4,
    className,
    bolt: bolt2
  } = _ref80;
  return /* @__PURE__ */jsxs(StyledFeatureBadge, {
    ref: forwardedRef,
    css: css4,
    className,
    variant,
    size,
    children: [variant.toUpperCase(), bolt2 && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx$1(Icon, {
        name: "bolt",
        icon: bolt_2
      }), /* @__PURE__ */jsx$1(Icon, {
        name: "bolt",
        icon: bolt_2
      })]
    })]
  });
});
FeatureBadge.displayName = "FeatureBadge";
const NotificationBadgeDigitVariant = {
  true: {
    position: "absolute",
    top: "calc(0px - $1)",
    right: "calc(0px - $1)",
    minWidth: "$2",
    width: "inherit",
    height: "$2",
    paddingX: "$half",
    borderRadius: "16px"
  }
};
const NotificationBadgePositionVariant = {
  inline: {
    position: "relative",
    top: "auto",
    right: "auto"
  },
  topRight: {
    position: "absolute",
    top: "calc(0px - $half)",
    right: "calc(0px - $half)"
  }
};
const StyledNotificationBadge = styled(Box, {
  size: "$1",
  color: "$white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textStyles: "h4",
  lineHeight: 0,
  backgroundColor: "$red8",
  borderRadius: "$round",
  variants: {
    position: NotificationBadgePositionVariant,
    digits: NotificationBadgeDigitVariant
  },
  compoundVariants: [{
    position: "topRight",
    digits: true,
    css: NotificationBadgeDigitVariant.true
  }, {
    position: "inline",
    digits: true,
    css: {
      ...NotificationBadgeDigitVariant.true,
      ...NotificationBadgePositionVariant.inline
    }
  }]
});
const NotificationBadge = forwardRef((_ref81, forwardedRef) => {
  let {
    children,
    css: css4,
    className,
    position: position2 = "topRight"
  } = _ref81;
  if (children == null || children === "") {
    return /* @__PURE__ */jsx$1(StyledNotificationBadge, {
      ref: forwardedRef,
      css: css4,
      position: position2,
      className
    });
  }
  const stringChild = typeof children === "string" ? children : children.toString();
  return /* @__PURE__ */jsx$1(StyledNotificationBadge, {
    ref: forwardedRef,
    css: css4,
    position: position2,
    className,
    digits: true,
    children: stringChild.length > 2 ? `99+` : stringChild
  });
});
NotificationBadge.displayName = "NotificationBadge";
var StatusBadgeVariantEnum = /* @__PURE__ */(StatusBadgeVariantEnum2 => {
  StatusBadgeVariantEnum2["SUCCESS"] = "success";
  StatusBadgeVariantEnum2["WARNING"] = "warning";
  StatusBadgeVariantEnum2["ERROR"] = "error";
  StatusBadgeVariantEnum2["PENDING"] = "pending";
  StatusBadgeVariantEnum2["INACTIVE"] = "inactive";
  return StatusBadgeVariantEnum2;
})(StatusBadgeVariantEnum || {});
const StatusBadgeVariant = {
  success: {
    color: "$green12",
    backgroundColor: "$green2",
    "& svg": {
      color: "$green7"
    }
  },
  warning: {
    color: "$yellow12",
    backgroundColor: "$yellow2",
    "& svg": {
      color: "$yellow7"
    }
  },
  error: {
    color: "$red12",
    backgroundColor: "$red2",
    "& svg": {
      color: "$red7"
    }
  },
  pending: {
    color: "$blue12",
    backgroundColor: "$blue2",
    "& svg": {
      color: "$blue7"
    }
  },
  inactive: {
    color: "$gray12",
    backgroundColor: "$gray3",
    "& svg": {
      color: "gray7"
    }
  }
};
var StatusBadgeSizeVariantEnum = /* @__PURE__ */(StatusBadgeSizeVariantEnum2 => {
  StatusBadgeSizeVariantEnum2["SMALL"] = "small";
  StatusBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return StatusBadgeSizeVariantEnum2;
})(StatusBadgeSizeVariantEnum || {});
const StatusBadgeSizeVariant = {
  small: {
    textStyles: "metadata",
    "& svg": {
      size: "10px",
      paddingY: "3px"
    }
  },
  medium: {
    textStyles: "body",
    "& svg": {
      size: "12px",
      paddingY: "4px"
    }
  }
};
const StyledStatusBadge = styled("span", {
  display: "inline-flex",
  paddingX: "$half",
  borderRadius: "$1",
  "& svg": {
    marginRight: "$half"
  },
  variants: {
    variant: StatusBadgeVariant,
    size: StatusBadgeSizeVariant
  }
});
const DefaultTextMap = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  pending: "Pending",
  inactive: "Inactive"
};
const StatusBadge = forwardRef((_ref82, forwardedRef) => {
  let {
    variant,
    size = "small",
    children = DefaultTextMap[variant],
    css: css4,
    className,
    icon: icon3
  } = _ref82;
  return /* @__PURE__ */jsxs(StyledStatusBadge, {
    ref: forwardedRef,
    className,
    css: css4,
    variant,
    size,
    children: [icon3 && /* @__PURE__ */jsx$1(Icon, {
      icon: icon3
    }), children]
  });
});
StatusBadge.displayName = "StatusBadge";
var InfoBadgeVariantEnum = /* @__PURE__ */(InfoBadgeVariantEnum2 => {
  InfoBadgeVariantEnum2["PRIMARY"] = "primary";
  InfoBadgeVariantEnum2["SECONDARY"] = "secondary";
  InfoBadgeVariantEnum2["AI_INFO"] = "ai-info";
  return InfoBadgeVariantEnum2;
})(InfoBadgeVariantEnum || {});
const InfoBadgeVariant = {
  primary: {
    color: "$gray12",
    backgroundColor: "$gray3",
    "& svg": {
      color: "$gray7"
    }
  },
  secondary: {
    color: "$gray1",
    backgroundColor: "$gray10",
    "& svg": {
      color: "$gray3"
    }
  },
  "ai-info": {
    color: "$purple12",
    backgroundColor: "$purple2",
    "& svg": {
      color: "$purple7"
    }
  }
};
var InfoBadgeSizeVariantEnum = /* @__PURE__ */(InfoBadgeSizeVariantEnum2 => {
  InfoBadgeSizeVariantEnum2["SMALL"] = "small";
  InfoBadgeSizeVariantEnum2["MEDIUM"] = "medium";
  return InfoBadgeSizeVariantEnum2;
})(InfoBadgeSizeVariantEnum || {});
const InfoBadgeSizeVariant = {
  small: {
    textStyles: "metadata",
    height: "16px",
    "& svg": {
      size: "12px",
      paddingY: "2px"
    }
  },
  medium: {
    textStyles: "body",
    height: "20px",
    "& svg": {
      size: "14px",
      paddingY: "3px"
    }
  }
};
const StyledInfoBadge = styled("span", {
  display: "inline-flex",
  paddingX: "$half",
  borderRadius: "$1",
  "& svg": {
    marginRight: "$half"
  },
  variants: {
    variant: InfoBadgeVariant,
    size: InfoBadgeSizeVariant
  }
});
const InfoBadge = forwardRef((_ref83, forwardedRef) => {
  let {
    variant = "primary",
    size = "small",
    children,
    css: css4,
    className,
    icon: icon3
  } = _ref83;
  return /* @__PURE__ */jsxs(StyledInfoBadge, {
    ref: forwardedRef,
    variant,
    size,
    className,
    css: css4,
    children: [icon3 && /* @__PURE__ */jsx$1(Icon, {
      icon: icon3
    }), children]
  });
});
InfoBadge.displayName = "InfoBadge";
var HighlightTextColorVariantEnum = /* @__PURE__ */(HighlightTextColorVariantEnum2 => {
  HighlightTextColorVariantEnum2["PURPLE"] = "purple";
  HighlightTextColorVariantEnum2["BLUE"] = "blue";
  return HighlightTextColorVariantEnum2;
})(HighlightTextColorVariantEnum || {});
const HighlightTextColorVariant = {
  purple: {
    color: "$purple12",
    background: "$purple2",
    "& svg": {
      color: "$purple7"
    }
  },
  blue: {
    color: "$blue12",
    background: "$blue2",
    "& svg": {
      color: "$blue7"
    }
  }
};
const StyledHighlightText = styled("span", {
  paddingX: "$half",
  borderRadius: "$1",
  paddingY: "1.5px",
  "& svg": {
    marginRight: "$half",
    size: "12px"
  },
  variants: {
    color: HighlightTextColorVariant
  }
});
const HighlightText = forwardRef((_ref84, forwardedRef) => {
  let {
    children,
    color,
    css: css4,
    className,
    icon: icon3
  } = _ref84;
  return /* @__PURE__ */jsxs(StyledHighlightText, {
    ref: forwardedRef,
    css: css4,
    className,
    color,
    children: [icon3 && /* @__PURE__ */jsx$1(Icon, {
      icon: icon3
    }), children]
  });
});
HighlightText.displayName = "HighlightText";
const $cddcb0b647441e34$var$AVATAR_NAME = "Avatar";
const [$cddcb0b647441e34$var$createAvatarContext, $cddcb0b647441e34$export$90370d16b488820f] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cddcb0b647441e34$var$AVATAR_NAME);
const [$cddcb0b647441e34$var$AvatarProvider, $cddcb0b647441e34$var$useAvatarContext] = $cddcb0b647441e34$var$createAvatarContext($cddcb0b647441e34$var$AVATAR_NAME);
const $cddcb0b647441e34$export$e2255cf6045e8d47 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    ...avatarProps
  } = props;
  const [imageLoadingStatus, setImageLoadingStatus] = useState("idle");
  return /* @__PURE__ */createElement$1($cddcb0b647441e34$var$AvatarProvider, {
    scope: __scopeAvatar,
    imageLoadingStatus,
    onImageLoadingStatusChange: setImageLoadingStatus
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({}, avatarProps, {
    ref: forwardedRef
  })));
});
const $cddcb0b647441e34$var$IMAGE_NAME = "AvatarImage";
const $cddcb0b647441e34$export$2cd8ae1985206fe8 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    src,
    onLoadingStatusChange = () => {},
    ...imageProps
  } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$IMAGE_NAME, __scopeAvatar);
  const imageLoadingStatus = $cddcb0b647441e34$var$useImageLoadingStatus(src);
  const handleLoadingStatusChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(status => {
    onLoadingStatusChange(status);
    context.onImageLoadingStatusChange(status);
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
  }, [imageLoadingStatus, handleLoadingStatusChange]);
  return imageLoadingStatus === "loaded" ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.img, _extends$1({}, imageProps, {
    ref: forwardedRef,
    src
  })) : null;
});
const $cddcb0b647441e34$var$FALLBACK_NAME = "AvatarFallback";
const $cddcb0b647441e34$export$69fffb6a9571fbfe = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeAvatar,
    delayMs,
    ...fallbackProps
  } = props;
  const context = $cddcb0b647441e34$var$useAvatarContext($cddcb0b647441e34$var$FALLBACK_NAME, __scopeAvatar);
  const [canRender, setCanRender] = useState(delayMs === void 0);
  useEffect(() => {
    if (delayMs !== void 0) {
      const timerId = window.setTimeout(() => setCanRender(true), delayMs);
      return () => window.clearTimeout(timerId);
    }
  }, [delayMs]);
  return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({}, fallbackProps, {
    ref: forwardedRef
  })) : null;
});
function $cddcb0b647441e34$var$useImageLoadingStatus(src) {
  const [loadingStatus, setLoadingStatus] = useState("idle");
  useEffect(() => {
    if (!src) {
      setLoadingStatus("error");
      return;
    }
    let isMounted = true;
    const image = new window.Image();
    const updateStatus = status => () => {
      if (!isMounted) return;
      setLoadingStatus(status);
    };
    setLoadingStatus("loading");
    image.onload = updateStatus("loaded");
    image.onerror = updateStatus("error");
    image.src = src;
    return () => {
      isMounted = false;
    };
  }, [src]);
  return loadingStatus;
}
const $cddcb0b647441e34$export$be92b6f5f03c0fe9 = $cddcb0b647441e34$export$e2255cf6045e8d47;
const $cddcb0b647441e34$export$3e431a229df88919 = $cddcb0b647441e34$export$2cd8ae1985206fe8;
const $cddcb0b647441e34$export$fb8d7f40caaeea67 = $cddcb0b647441e34$export$69fffb6a9571fbfe;
var AvatarSizeVariantEnum = /* @__PURE__ */(AvatarSizeVariantEnum2 => {
  AvatarSizeVariantEnum2["X_SMALL"] = "x-small";
  AvatarSizeVariantEnum2["SMALL"] = "small";
  AvatarSizeVariantEnum2["MEDIUM"] = "medium";
  AvatarSizeVariantEnum2["LARGE"] = "large";
  AvatarSizeVariantEnum2["X_LARGE"] = "x-large";
  return AvatarSizeVariantEnum2;
})(AvatarSizeVariantEnum || {});
const AvatarSizeVariant = {
  "x-small": {
    size: "$3",
    fontSize: "0.714rem"
  },
  small: {
    size: "$4",
    fontSize: "$1"
  },
  medium: {
    size: "40px",
    fontSize: "$3"
  },
  large: {
    size: "$8",
    fontSize: "$5"
  },
  "x-large": {
    size: "96px",
    fontSize: "$6"
  }
};
const BaseAvatarRoot = styled($cddcb0b647441e34$export$be92b6f5f03c0fe9, {
  borderRadius: "$round",
  display: "flex",
  position: "relative",
  justifyContent: "center",
  alignItems: "center",
  userSelect: "none",
  cursor: "default",
  variants: {
    size: AvatarSizeVariant
  },
  defaultVariants: {
    size: AvatarSizeVariantEnum.MEDIUM
  }
});
const AvatarImage = styled($cddcb0b647441e34$export$3e431a229df88919, {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: "inherit"
});
const AvatarIndicator = styled(Box, {
  borderRadius: "$round",
  borderStyle: "solid",
  borderColor: "$white",
  position: "absolute",
  bottom: "-4px",
  right: "-4px",
  variants: {
    size: {
      "x-small": {
        borderWidth: "2px"
      },
      small: {
        borderWidth: "2px"
      },
      medium: {
        borderWidth: "2px"
      },
      large: {
        borderWidth: "4px"
      },
      "x-large": {
        borderWidth: "6px"
      }
    }
  }
});
const $8927f6f2acc4f386$var$NODES$2 = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$2 = $8927f6f2acc4f386$var$NODES$2.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$6 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f$1(target, event) {
  if (target) flushSync(() => target.dispatchEvent(event));
}
function $addc16e1bbe58fd0$export$3a72a57244d6e765$1(onEscapeKeyDownProp) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown);
  }, [onEscapeKeyDown, ownerDocument]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE$1 = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$1 = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE$1 = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents$1;
const $5cb92bef7577960e$var$DismissableLayerContext$1 = /* @__PURE__ */createContext$1({
  layers: /* @__PURE__ */new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
  branches: /* @__PURE__ */new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _node$ownerDocument;
  const {
    disableOutsidePointerEvents = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext$1);
  const [node1, setNode] = useState(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setNode(node2));
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside$1(event => {
    const target = event.target;
    const isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside$1(event => {
    const target = event.target;
    const isFocusInBranch = [...context.branches].some(branch => branch.contains(target));
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765$1(event => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents$1 = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate$1();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents$1;
    };
  }, [node1, ownerDocument, disableOutsidePointerEvents, context]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate$1();
    };
  }, [node1, context]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$1, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE$1, handleUpdate);
  }, []);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, _extends$1({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside$1(onPointerDownOutside) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {});
  useEffect(() => {
    const handlePointerDown = event => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function () {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE$1, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside$1(onFocusOutside) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1($5cb92bef7577960e$var$FOCUS_OUTSIDE$1, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate$1() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE$1);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent$1(name, handler, detail, _ref85) {
  let {
    discrete
  } = _ref85;
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f$1(target, event);else target.dispatchEvent(event);
}
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$1 = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$1 = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS$1 = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContainer(node2));
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function (event) {
          if (focusScope.paused || !container1) return;
          const target = event.target;
          if (container1.contains(target)) lastFocusedElementRef.current = target;else $d3863c46a17e8a28$var$focus$1(lastFocusedElementRef.current, {
            select: true
          });
        },
        handleFocusOut = function (event) {
          if (focusScope.paused || !container1) return;
          if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus$1(lastFocusedElementRef.current, {
            select: true
          });
        };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [trapped, container1, focusScope.paused]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack$1.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$1, $d3863c46a17e8a28$var$EVENT_OPTIONS$1);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$1, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst$1($d3863c46a17e8a28$var$removeLinks$1($d3863c46a17e8a28$var$getTabbableCandidates$1(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus$1(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT$1, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$1, $d3863c46a17e8a28$var$EVENT_OPTIONS$1);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$1, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus$1(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT$1, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack$1.remove(focusScope);
        }, 0);
      };
    }
  }, [container1, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = useCallback(event => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges$1(container);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus$1(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus$1(last, {
            select: true
          });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, _extends$1({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst$1(candidates) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus$1(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges$1(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates$1(container);
  const first = $d3863c46a17e8a28$var$findVisible$1(candidates, container);
  const last = $d3863c46a17e8a28$var$findVisible$1(candidates.reverse(), container);
  return [first, last];
}
function $d3863c46a17e8a28$var$getTabbableCandidates$1(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node2 => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible$1(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden$1(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden$1(node2, _ref86) {
  let {
    upTo
  } = _ref86;
  if (getComputedStyle(node2).visibility === "hidden") return true;
  while (node2) {
    if (upTo !== void 0 && node2 === upTo) return false;
    if (getComputedStyle(node2).display === "none") return true;
    node2 = node2.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput$1(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus$1(element) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput$1(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack$1 = $d3863c46a17e8a28$var$createFocusScopesStack$1();
function $d3863c46a17e8a28$var$createFocusScopesStack$1() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove$1(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove$1(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove$1(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks$1(items) {
  return items.filter(item => item.tagName !== "A");
}
const $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    width = 10,
    height = 5,
    ...arrowProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.svg, _extends$1({}, arrowProps, {
    ref: forwardedRef,
    width,
    height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */createElement$1("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
const $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;
const $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
const $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = props => {
  const {
    __scopePopper,
    children
  } = props;
  const [anchor, setAnchor] = useState(null);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
const $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopper,
    virtualRef,
    ...anchorProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, _extends$1({}, anchorProps, {
    ref: composedRefs
  }));
});
const $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
const [$cf1ac5d9fe0e8206$var$PositionContextProvider, $cf1ac5d9fe0e8206$var$usePositionContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */new Set()
});
const $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const {
    __scopePopper,
    side = "bottom",
    sideOffset = 0,
    align = "center",
    alignOffset = 0,
    arrowPadding = 0,
    collisionBoundary = [],
    collisionPadding: collisionPaddingProp = 0,
    sticky = "partial",
    hideWhenDetached = false,
    avoidCollisions = true,
    ...contentProps
  } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const [content, setContent] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContent(node2));
  const [arrow$12, setArrow] = useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow$12);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    altBoundary: hasExplicitBoundaries
  };
  const {
    reference,
    floating,
    strategy,
    x: x2,
    y: y2,
    placement,
    middlewareData,
    update
  } = useFloating({
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: autoUpdate$1,
    middleware: [offset({
      mainAxis: sideOffset + arrowHeight,
      alignmentAxis: alignOffset
    }), avoidCollisions ? shift({
      mainAxis: true,
      crossAxis: false,
      limiter: sticky === "partial" ? limitShift() : void 0,
      ...detectOverflowOptions
    }) : void 0, arrow$12 ? arrow({
      element: arrow$12,
      padding: arrowPadding
    }) : void 0, avoidCollisions ? flip2({
      ...detectOverflowOptions
    }) : void 0, $cf1ac5d9fe0e8206$var$transformOrigin({
      arrowWidth,
      arrowHeight
    }), hideWhenDetached ? hide$1({
      strategy: "referenceHidden"
    }) : void 0].filter($cf1ac5d9fe0e8206$var$isDefined)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    reference(context.anchor);
  }, [reference, context.anchor]);
  const isPlaced = x2 !== null && y2 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  const {
    hasParent,
    positionUpdateFns
  } = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const isRoot = !hasParent;
  useLayoutEffect$1(() => {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return () => {
        positionUpdateFns.delete(update);
      };
    }
  }, [isRoot, positionUpdateFns, update]);
  useLayoutEffect$1(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(fn => requestAnimationFrame(fn));
  }, [isRoot, isPlaced, positionUpdateFns]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      animation: !isPlaced ? "none" : void 0,
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */createElement$1("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x2)}px, ${Math.round(y2)}px, 0)` : "translate3d(0, -200%, 0)",
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(" ")
    }
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$var$PositionContextProvider, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, commonProps)) : /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, commonProps)));
});
const $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
const $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02 = /* @__PURE__ */forwardRef(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd03(props, forwardedRef) {
  const {
    __scopePopper,
    ...arrowProps
  } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return /* @__PURE__ */createElement$1("span", {
    ref: contentContext.onArrowChange,
    style: {
      position: "absolute",
      left: contentContext.arrowX,
      top: contentContext.arrowY,
      [baseSide]: 0,
      transformOrigin: {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[contentContext.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: `rotate(180deg)`,
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[contentContext.placedSide],
      visibility: contentContext.shouldHideArrow ? "hidden" : void 0
    }
  }, /* @__PURE__ */createElement$1($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends$1({}, arrowProps, {
    ref: forwardedRef,
    style: {
      ...arrowProps.style,
      display: "block"
    }
  })));
});
function $cf1ac5d9fe0e8206$var$isDefined(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}
const $cf1ac5d9fe0e8206$var$transformOrigin = options => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const {
      placement,
      rects,
      middlewareData
    } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x2 = "";
    let y2 = "";
    if (placedSide === "bottom") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x2 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y2 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x2 = `${-arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x2 = `${rects.floating.width + arrowHeight}px`;
      y2 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x2,
        y: y2
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
const $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
const $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
const $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;
const $cf1ac5d9fe0e8206$export$21b07c8f274aebd5 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02;
const $f1701beae083dbae$export$602eac185826482c$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const {
    container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body,
    ...portalProps
  } = props;
  return container ? /* @__PURE__ */$7SXl2$reactdom__default.createPortal( /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.div, _extends$1({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
var effectCar$1 = createSidecarMedium();
var nothing$1 = function () {
  return;
};
var RemoveScroll$1 = React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing$1,
      onWheelCapture: nothing$1,
      onTouchMoveCapture: nothing$1
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? "div" : _b,
    rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(React.Fragment, null, enabled && React.createElement(SideCar2, {
    sideCar: effectCar$1,
    removeScrollBar,
    shards,
    noIsolation,
    inert,
    setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref
  }), forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), {
    ref: containerRef
  })) : React.createElement(Container, __assign({}, containerProps, {
    className,
    ref: containerRef
  }), children));
});
RemoveScroll$1.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll$1.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var passiveSupported$2 = false;
if (typeof window !== "undefined") {
  try {
    var options$2 = Object.defineProperty({}, "passive", {
      get: function () {
        passiveSupported$2 = true;
        return true;
      }
    });
    window.addEventListener("test", options$2, options$2);
    window.removeEventListener("test", options$2, options$2);
  } catch (err) {
    passiveSupported$2 = false;
  }
}
var nonPassive$1 = passiveSupported$2 ? {
  passive: false
} : false;
var alwaysContainsScroll$1 = function (node2) {
  return node2.tagName === "TEXTAREA";
};
var elementCanBeScrolled$1 = function (node2, overflow) {
  var styles2 = window.getComputedStyle(node2);
  return styles2[overflow] !== "hidden" && !(styles2.overflowY === styles2.overflowX && !alwaysContainsScroll$1(node2) && styles2[overflow] === "visible");
};
var elementCouldBeVScrolled$1 = function (node2) {
  return elementCanBeScrolled$1(node2, "overflowY");
};
var elementCouldBeHScrolled$1 = function (node2) {
  return elementCanBeScrolled$1(node2, "overflowX");
};
var locationCouldBeScrolled$1 = function (axis, node2) {
  var current = node2;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled$1(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables$1(axis, current),
        s2 = _a[1],
        d2 = _a[2];
      if (s2 > d2) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables$1 = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables$1 = function (_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled$1 = function (axis, node2) {
  return axis === "v" ? elementCouldBeVScrolled$1(node2) : elementCouldBeHScrolled$1(node2);
};
var getScrollVariables$1 = function (axis, node2) {
  return axis === "v" ? getVScrollVariables$1(node2) : getHScrollVariables$1(node2);
};
var getDirectionFactor$1 = function (axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll$1 = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor$1(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables$1(axis, target),
      position2 = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position2;
    if (position2 || elementScroll) {
      if (elementCouldBeScrolled$1(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position2;
      }
    }
    target = target.parentNode;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY$1 = function (event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY$1 = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef$1 = function (ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare$1 = function (x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle$1 = function (id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter$1 = 0;
var lockStack$1 = [];
function RemoveScrollSideCar$1(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter$1++)[0];
  var Style2 = React.useState(function () {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef$1), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY$1(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled$1(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled$1(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll$1(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack$1.length || lockStack$1[lockStack$1.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY$1(event) : getTouchXY$1(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e2) {
      return e2.name === event.type && e2.target === event.target && deltaCompare$1(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef$1).filter(Boolean).filter(function (node2) {
        return node2.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = {
      name,
      delta,
      target,
      should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY$1(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY$1(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY$1(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function () {
    lockStack$1.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive$1);
    document.addEventListener("touchmove", shouldPrevent, nonPassive$1);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive$1);
    return function () {
      lockStack$1 = lockStack$1.filter(function (inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive$1);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive$1);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive$1);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return React.createElement(React.Fragment, null, inert ? React.createElement(Style2, {
    styles: generateStyle$1(id)
  }) : null, removeScrollBar ? React.createElement(RemoveScrollBar, {
    gapMode: "margin"
  }) : null);
}
var SideCar$1 = exportSidecar(effectCar$1, RemoveScrollSideCar$1);
var ReactRemoveScroll$1 = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll$1, __assign({}, props, {
    ref,
    sideCar: SideCar$1
  }));
});
ReactRemoveScroll$1.classNames = RemoveScroll$1.classNames;
var $am6gm$RemoveScroll = ReactRemoveScroll$1;
const $cb5cc270b50c6fcd$var$POPOVER_NAME = "Popover";
const [$cb5cc270b50c6fcd$var$createPopoverContext, $cb5cc270b50c6fcd$export$c8393c9e73286932] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cb5cc270b50c6fcd$var$POPOVER_NAME, [$cf1ac5d9fe0e8206$export$722aac194ae923]);
const $cb5cc270b50c6fcd$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
const [$cb5cc270b50c6fcd$var$PopoverProvider, $cb5cc270b50c6fcd$var$usePopoverContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$POPOVER_NAME);
const $cb5cc270b50c6fcd$export$5b6b19405a83ff9d = props => {
  const {
    __scopePopover,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = false
  } = props;
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const triggerRef = useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = useState(false);
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PopoverProvider, {
    scope: __scopePopover,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    triggerRef,
    open: open2,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    hasCustomAnchor,
    onCustomAnchorAdd: useCallback(() => setHasCustomAnchor(true), []),
    onCustomAnchorRemove: useCallback(() => setHasCustomAnchor(false), []),
    modal
  }, children));
};
const $cb5cc270b50c6fcd$var$ANCHOR_NAME = "PopoverAnchor";
const $cb5cc270b50c6fcd$export$96e5381f42521a79 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    ...anchorProps
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$ANCHOR_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const {
    onCustomAnchorAdd,
    onCustomAnchorRemove
  } = context;
  useEffect(() => {
    onCustomAnchorAdd();
    return () => onCustomAnchorRemove();
  }, [onCustomAnchorAdd, onCustomAnchorRemove]);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({}, popperScope, anchorProps, {
    ref: forwardedRef
  }));
});
const $cb5cc270b50c6fcd$var$TRIGGER_NAME = "PopoverTrigger";
const $cb5cc270b50c6fcd$export$7dacb05d26466c3 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    ...triggerProps
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$TRIGGER_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  const composedTriggerRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.triggerRef);
  const trigger = /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.button, _extends$1({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": context.open,
    "aria-controls": context.contentId,
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open)
  }, triggerProps, {
    ref: composedTriggerRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, context.onOpenToggle)
  }));
  return context.hasCustomAnchor ? trigger : /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends$1({
    asChild: true
  }, popperScope), trigger);
});
const $cb5cc270b50c6fcd$var$PORTAL_NAME = "PopoverPortal";
const [$cb5cc270b50c6fcd$var$PortalProvider, $cb5cc270b50c6fcd$var$usePortalContext] = $cb5cc270b50c6fcd$var$createPopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, {
  forceMount: void 0
});
const $cb5cc270b50c6fcd$export$dd679ffb4362d2d4 = props => {
  const {
    __scopePopover,
    forceMount,
    children,
    container
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$PORTAL_NAME, __scopePopover);
  return /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PortalProvider, {
    scope: __scopePopover,
    forceMount
  }, /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c$1, {
    asChild: true,
    container
  }, children)));
};
const $cb5cc270b50c6fcd$var$CONTENT_NAME = "PopoverContent";
const $cb5cc270b50c6fcd$export$d7e1f420b25549ff = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $cb5cc270b50c6fcd$var$usePortalContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const {
    forceMount = portalContext.forceMount,
    ...contentProps
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, context.modal ? /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PopoverContentModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PopoverContentNonModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef);
  const isRightClickOutsideRef = useRef(false);
  useEffect(() => {
    const content = contentRef.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */createElement$1($am6gm$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$6,
    allowPinchZoom: true
  }, /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: true,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, event => {
      var _context$triggerRef$c;
      event.preventDefault();
      if (!isRightClickOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
    }),
    onPointerDownOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownOutside, event => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      isRightClickOutsideRef.current = isRightClick;
    }, {
      checkForDefaultPrevented: false
    }),
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, event => event.preventDefault(), {
      checkForDefaultPrevented: false
    })
  })));
});
const $cb5cc270b50c6fcd$var$PopoverContentNonModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, props.__scopePopover);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */createElement$1($cb5cc270b50c6fcd$var$PopoverContentImpl, _extends$1({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    onCloseAutoFocus: event => {
      var _props$onCloseAutoFoc;
      (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
      if (!event.defaultPrevented) {
        var _context$triggerRef$c2;
        if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus();
        event.preventDefault();
      }
      hasInteractedOutsideRef.current = false;
    },
    onInteractOutside: event => {
      var _props$onInteractOuts, _context$triggerRef$c3;
      (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
      if (!event.defaultPrevented) hasInteractedOutsideRef.current = true;
      const target = event.target;
      const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
      if (targetIsTrigger) event.preventDefault();
    }
  }));
});
const $cb5cc270b50c6fcd$var$PopoverContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    ...contentProps
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CONTENT_NAME, __scopePopover);
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  return /* @__PURE__ */createElement$1($d3863c46a17e8a28$export$20e40289641fbbb6$1, {
    asChild: true,
    loop: true,
    trapped: trapFocus,
    onMountAutoFocus: onOpenAutoFocus,
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22$1, {
    asChild: true,
    disableOutsidePointerEvents,
    onInteractOutside,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onDismiss: () => context.onOpenChange(false)
  }, /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends$1({
    "data-state": $cb5cc270b50c6fcd$var$getState(context.open),
    role: "dialog",
    id: context.contentId
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      ["--radix-popover-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }))));
});
const $cb5cc270b50c6fcd$var$CLOSE_NAME = "PopoverClose";
const $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    ...closeProps
  } = props;
  const context = $cb5cc270b50c6fcd$var$usePopoverContext($cb5cc270b50c6fcd$var$CLOSE_NAME, __scopePopover);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$2.button, _extends$1({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, () => context.onOpenChange(false))
  }));
});
const $cb5cc270b50c6fcd$export$3152841115e061b2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopePopover,
    ...arrowProps
  } = props;
  const popperScope = $cb5cc270b50c6fcd$var$usePopperScope(__scopePopover);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$21b07c8f274aebd5, _extends$1({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $cb5cc270b50c6fcd$var$getState(open2) {
  return open2 ? "open" : "closed";
}
const $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9 = $cb5cc270b50c6fcd$export$5b6b19405a83ff9d;
const $cb5cc270b50c6fcd$export$b688253958b8dfe7 = $cb5cc270b50c6fcd$export$96e5381f42521a79;
const $cb5cc270b50c6fcd$export$41fb9f06171c75f4 = $cb5cc270b50c6fcd$export$7dacb05d26466c3;
const $cb5cc270b50c6fcd$export$602eac185826482c = $cb5cc270b50c6fcd$export$dd679ffb4362d2d4;
const $cb5cc270b50c6fcd$export$f39c2d165cd861fe = $cb5cc270b50c6fcd$export$d6ac43ebaa40d53e;
const $cb5cc270b50c6fcd$export$21b07c8f274aebd5 = $cb5cc270b50c6fcd$export$3152841115e061b2;
const StyledPopoverContent$2 = styled($cb5cc270b50c6fcd$export$d7e1f420b25549ff, {
  borderRadius: "$1",
  padding: "$4 $2 $2 $2",
  zIndex: "$tooltip",
  boxShadow: "$inflate24",
  backgroundColor: "$white",
  display: "flex",
  flexDirection: "column",
  gap: "$1",
  '&[data-side="top"] .dds--popover-arrow': {
    fill: "$white",
    filter: "drop-shadow(0px 6px 4px rgba(96, 110, 120, 0.24))"
  },
  '&[data-side="bottom"] .dds--popover-arrow': {
    fill: "var(--dds-popover-top-arrow-color)",
    filter: "drop-shadow(0px 6px 4px rgba(96, 110, 120, 0.24))"
  },
  '&[data-side="right"] .dds--popover-arrow': {
    fill: "$white",
    filter: "drop-shadow(0px 6px 4px rgba(96, 110, 120, 0.24))"
  },
  '&[data-side="left"] .dds--popover-arrow': {
    fill: "$white",
    filter: "drop-shadow(0px 6px 4px rgba(96, 110, 120, 0.24))"
  },
  variants: {
    hideCloseButton: {
      true: {
        padding: "$2"
      }
    }
  }
});
const StyledPopoverCloseIcon = styled($cb5cc270b50c6fcd$export$f39c2d165cd861fe, {
  position: "absolute",
  top: "$half",
  right: 0
});
const StyledPopoverArrow = styled($cb5cc270b50c6fcd$export$21b07c8f274aebd5, {
  variants: {
    size: {
      small: {
        height: "$1",
        width: "$2"
      },
      large: {
        height: "$2",
        width: "$3"
      }
    }
  },
  defaultVariants: {
    size: "small"
  }
});
const POPOVER_NO_ARROW_OFFSET = 8;
const PopoverCloseIcon = () => /* @__PURE__ */jsx$1(StyledPopoverCloseIcon, {
  asChild: true,
  children: /* @__PURE__ */jsx$1(IconButton, {
    title: "Dismiss",
    hideTooltip: true,
    icon: faXmark_2$1
  })
});
const PopoverTrigger = forwardRef((_ref87, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref87;
  return /* @__PURE__ */jsx$1($cb5cc270b50c6fcd$export$41fb9f06171c75f4, {
    ref: forwardedRef,
    asChild: true,
    ...props,
    children
  });
});
PopoverTrigger.displayName = "PopoverTrigger";
const PopoverContent = forwardRef((_ref88, forwardedRef) => {
  let {
    children,
    align = "start",
    side = "bottom",
    topBorderColor = "gray12",
    hideCloseButton = false,
    hideArrow = false,
    arrowSize,
    sideOffset,
    width,
    maxWidth,
    minWidth,
    ...props
  } = _ref88;
  return /* @__PURE__ */jsx$1($cb5cc270b50c6fcd$export$602eac185826482c, {
    children: /* @__PURE__ */jsxs(StyledPopoverContent$2, {
      align,
      ...props,
      ref: forwardedRef,
      asChild: false,
      side,
      hideCloseButton,
      sideOffset: hideArrow ? POPOVER_NO_ARROW_OFFSET : sideOffset,
      css: {
        width,
        minWidth,
        maxWidth,
        borderTop: `4px solid ${resolveColorFromTheme(topBorderColor)}`,
        "--dds-popover-top-arrow-color": resolveColorFromTheme(topBorderColor),
        ...props.css
      },
      children: [children, !hideCloseButton && /* @__PURE__ */jsx$1(PopoverCloseIcon, {}), !hideArrow && /* @__PURE__ */jsx$1(StyledPopoverArrow, {
        size: arrowSize,
        className: "dds--popover-arrow"
      })]
    })
  });
});
PopoverContent.displayName = "PopoverContent";
const Popover = {
  Root: $cb5cc270b50c6fcd$export$be92b6f5f03c0fe9,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Close: $cb5cc270b50c6fcd$export$f39c2d165cd861fe
};
var PopoverArrowSizeVariantEnum = /* @__PURE__ */(PopoverArrowSizeVariantEnum2 => {
  PopoverArrowSizeVariantEnum2["SMALL"] = "small";
  PopoverArrowSizeVariantEnum2["LARGE"] = "large";
  return PopoverArrowSizeVariantEnum2;
})(PopoverArrowSizeVariantEnum || {});
const FeatureTooltipContentOrientationVariant = {
  vertical: {
    display: "flex",
    gap: "$2",
    flexDirection: "column",
    maxWidth: "336px"
  },
  horizontal: {
    display: "flex",
    gap: "$4",
    flexDirection: "column",
    maxWidth: "336px",
    "@sm": {
      flexDirection: "row-reverse",
      flexBasis: "50%",
      maxWidth: "640px"
    }
  }
};
const StyledPopoverContent$1 = styled(Popover.Content, {
  variants: {
    orientation: FeatureTooltipContentOrientationVariant
  }
});
const StyledPopoverContentHeader = styled("h3", {
  textStyles: "h3",
  color: "$indigo11"
});
const StyledPopoverContentActions = styled("div", {
  width: "100%",
  flexGrow: 2,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  flexWrap: "nowrap",
  gap: "$1"
});
const FeatureTooltipRoot = Popover.Root;
const FeatureTooltipTrigger = Popover.Trigger;
const FeatureTooltipAnchor = $cb5cc270b50c6fcd$export$b688253958b8dfe7;
const FeatureTooltipContent = _ref89 => {
  let {
    children,
    image,
    orientation,
    side = "bottom",
    avoidCollisions = true,
    align = "center",
    ...rest
  } = _ref89;
  return /* @__PURE__ */jsxs(StyledPopoverContent$1, {
    ...rest,
    topBorderColor: "lime3",
    side,
    orientation,
    avoidCollisions,
    align,
    arrowSize: "large",
    children: [image && image, /* @__PURE__ */jsx$1(Flex, {
      fullWidth: orientation === "horizontal",
      gap: 2,
      direction: "column",
      children
    })]
  });
};
const FeatureTooltip = {
  Root: FeatureTooltipRoot,
  Trigger: FeatureTooltipTrigger,
  Anchor: FeatureTooltipAnchor,
  Content: FeatureTooltipContent,
  ContentHeader: StyledPopoverContentHeader,
  ContentActions: StyledPopoverContentActions
};
var FeatureTooltipContentOrientationVariantEnum = /* @__PURE__ */(FeatureTooltipContentOrientationVariantEnum2 => {
  FeatureTooltipContentOrientationVariantEnum2["Horizontal"] = "horizontal";
  FeatureTooltipContentOrientationVariantEnum2["Vertical"] = "vertical";
  return FeatureTooltipContentOrientationVariantEnum2;
})(FeatureTooltipContentOrientationVariantEnum || {});
var faUser$1 = {};
Object.defineProperty(faUser$1, "__esModule", {
  value: true
});
var faUser_2 = faUser$1.faUser = void 0;
const faUser = {
  prefix: "fas",
  iconName: "faUser",
  icon: [448, 512, [], "", "M224 256c70.7 0 128-57.31 128-128s-57.3-128-128-128C153.3 0 96 57.31 96 128S153.3 256 224 256zM274.7 304H173.3C77.61 304 0 381.6 0 477.3c0 19.14 15.52 34.67 34.66 34.67h378.7C432.5 512 448 496.5 448 477.3C448 381.6 370.4 304 274.7 304z"]
};
faUser_2 = faUser$1.faUser = faUser;
const AVATAR_FALLBACK_DELAY$1 = 600;
const UserAvatarStatusIndicatorMap = {
  available: "success",
  away: "away",
  "chat-limit": "chat-limit"
};
const UserAvatarStatusTooltipMap = {
  available: "available",
  away: "away",
  "chat-limit": "at chat limit"
};
const UserAvatarColorVariant = {
  blue: {
    backgroundColor: "$blue1",
    border: "1px solid $blue6",
    color: "$blue9"
  },
  yellow: {
    backgroundColor: "$orange2",
    border: "1px solid $orange6",
    color: "$orange9"
  },
  teal: {
    backgroundColor: "$teal1",
    border: "1px solid $teal6",
    color: "$teal9"
  },
  purple: {
    backgroundColor: "$purple1",
    border: "1px solid $purple6",
    color: "$purple9"
  },
  pink: {
    backgroundColor: "$pink1",
    border: "1px solid $pink6",
    color: "$pink9"
  }
};
const UserAvatarUnknownVariant = {
  gray: {
    backgroundColor: "$gray2",
    border: "1px solid $gray6",
    color: "$gray9"
  }
};
const KnownUserAvatarRoot = styled(BaseAvatarRoot, {
  variants: {
    color: {
      ...UserAvatarColorVariant,
      ...UserAvatarUnknownVariant
    }
  }
});
const UnknownUserAvatarRoot = styled(BaseAvatarRoot, {
  backgroundColor: "$gray2",
  border: "1px solid $gray6",
  color: "$gray9"
});
const InitialsText = styled("span", {
  lineHeight: "$body",
  letterSpacing: "$body",
  fontFamily: "$primary"
});
const DEFAULT_FALLBACK_COLOR = "blue";
const INVALID_INITIAL_REGEX = /[^\p{L}\p{Z}^$\n]/gu;
const BKDRHash = str => {
  const seed = 131;
  const seed2 = 137;
  let hash2 = 0;
  str += "x";
  const safeSeed = (Number.MAX_SAFE_INTEGER / seed2).toString();
  const MAX_SAFE_INTEGER = parseInt(safeSeed, 10);
  for (let i = 0; i < str.length; i++) {
    if (hash2 > MAX_SAFE_INTEGER) {
      const stringHash = (hash2 / seed2).toString();
      hash2 = parseInt(stringHash, 10);
    }
    hash2 = hash2 + seed + str.charCodeAt(i);
  }
  return hash2;
};
const getAvatarFallbackInitials = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  const namesByWhitespace = name.replace(INVALID_INITIAL_REGEX, "").split(" ").slice(0, 3).filter(x2 => !!x2);
  const calculatedInitials = namesByWhitespace.map(n2 => n2.charAt(0)).join().replaceAll(",", "").toUpperCase();
  return calculatedInitials;
};
const getAvatarFallbackColor = name => {
  if (!name) {
    return DEFAULT_FALLBACK_COLOR;
  }
  const nameHash = BKDRHash(name);
  const avatarColorKeys = Object.keys(UserAvatarColorVariant);
  return avatarColorKeys[nameHash % avatarColorKeys.length] || DEFAULT_FALLBACK_COLOR;
};
const UserAvatarFallback = _ref90 => {
  let {
    name,
    delayMs
  } = _ref90;
  return /* @__PURE__ */jsx$1($cddcb0b647441e34$export$fb8d7f40caaeea67, {
    delayMs,
    children: name ? /* @__PURE__ */jsx$1(InitialsText, {
      "data-private": true,
      children: getAvatarFallbackInitials(name)
    }) : /* @__PURE__ */jsx$1(Icon, {
      variant: "gray",
      size: "inherit",
      icon: faUser_2,
      rootProps: {
        role: "img",
        "aria-label": "Site visitor avatar"
      }
    })
  });
};
const UserAvatar = forwardRef((_ref91, forwardedRef) => {
  let {
    size,
    imageUrl,
    name,
    status,
    rootProps,
    ...props
  } = _ref91;
  const avatarColor = !imageUrl && !!name ? getAvatarFallbackColor(name) : void 0;
  const avatarStatus = status ? UserAvatarStatusIndicatorMap[status] : void 0;
  const tooltipContentStatus = status ? `(${UserAvatarStatusTooltipMap[status]})` : "";
  const tooltipContent = name ? `${name} ${tooltipContentStatus}` : "Site Visitor";
  const AvatarRoot = name ? KnownUserAvatarRoot : UnknownUserAvatarRoot;
  const fallbackDelay = imageUrl ? AVATAR_FALLBACK_DELAY$1 : 0;
  return /* @__PURE__ */jsx$1(Tooltip, {
    content: tooltipContent,
    activeBorderRadius: "round",
    children: /* @__PURE__ */jsxs(AvatarRoot, {
      size,
      color: avatarColor,
      ref: forwardedRef,
      ...props,
      ...rootProps,
      children: [/* @__PURE__ */jsx$1(AvatarImage, {
        src: imageUrl != null ? imageUrl : void 0,
        alt: `${name}'s avatar`
      }), /* @__PURE__ */jsx$1(UserAvatarFallback, {
        name: name != null ? name : void 0,
        delayMs: fallbackDelay
      }), status && /* @__PURE__ */jsx$1(AvatarIndicator, {
        size,
        children: /* @__PURE__ */jsx$1(StatusIndicator, {
          variant: avatarStatus,
          size
        })
      })]
    })
  });
});
UserAvatar.displayName = "UserAvatar";
var UserAvatarStatusEnum = /* @__PURE__ */(UserAvatarStatusEnum2 => {
  UserAvatarStatusEnum2["AVAILABLE"] = "available";
  UserAvatarStatusEnum2["AWAY"] = "away";
  UserAvatarStatusEnum2["CHAT_LIMIT"] = "chat-limit";
  return UserAvatarStatusEnum2;
})(UserAvatarStatusEnum || {});
var faBuildings$1 = {};
Object.defineProperty(faBuildings$1, "__esModule", {
  value: true
});
var faBuildings_2 = faBuildings$1.faBuildings = void 0;
const faBuildings = {
  prefix: "fas",
  iconName: "faBuildings",
  icon: [512, 512, [], "", "M464 0h-224C213.5 0 192 21.49 192 48v80.01L48 128c-26.51 0-48 21.49-48 48v304c0 17.67 14.33 32 32 32L480 512c17.67 0 32-14.33 32-32V48C512 21.49 490.5 0 464 0zM128 336c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 16-16h32c8.836 0 16 7.162 16 16V336zM128 240c0 8.836-7.164 16-16 16h-32c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 16-16h32c8.836 0 16 7.162 16 16V240zM320 304c0 8.836-7.164 16-16 16h-32C263.2 320 256 312.8 256 304v-32C256 263.2 263.2 256 272 256h32C312.8 256 320 263.2 320 272V304zM320 208C320 216.8 312.8 224 304 224h-32C263.2 224 256 216.8 256 208v-32C256 167.2 263.2 160 272 160h32C312.8 160 320 167.2 320 176V208zM320 112C320 120.8 312.8 128 304 128h-32C263.2 128 256 120.8 256 112v-32C256 71.16 263.2 64 272 64h32C312.8 64 320 71.16 320 80V112zM448 304c0 8.836-7.164 16-16 16h-32C391.2 320 384 312.8 384 304v-32C384 263.2 391.2 256 400 256h32C440.8 256 448 263.2 448 272V304zM448 208C448 216.8 440.8 224 432 224h-32C391.2 224 384 216.8 384 208v-32C384 167.2 391.2 160 400 160h32C440.8 160 448 167.2 448 176V208zM448 112C448 120.8 440.8 128 432 128h-32C391.2 128 384 120.8 384 112v-32C384 71.16 391.2 64 400 64h32C440.8 64 448 71.16 448 80V112z"]
};
faBuildings_2 = faBuildings$1.faBuildings = faBuildings;
const AccountAvatarRootWithImage = styled(BaseAvatarRoot);
const FallbackAccountAvatarRoot = styled(BaseAvatarRoot, {
  backgroundColor: "$gray2",
  border: "1px solid $gray6",
  color: "$gray9"
});
const AVATAR_FALLBACK_DELAY = 600;
const AccountAvatar = forwardRef((_ref92, forwardedRef) => {
  let {
    size,
    imageUrl,
    name,
    rootProps,
    ...props
  } = _ref92;
  const AccountAvatarRoot = imageUrl ? AccountAvatarRootWithImage : FallbackAccountAvatarRoot;
  const fallbackDelay = imageUrl ? AVATAR_FALLBACK_DELAY : 0;
  return /* @__PURE__ */jsx$1(Tooltip, {
    content: name,
    activeBorderRadius: "round",
    children: /* @__PURE__ */jsxs(AccountAvatarRoot, {
      size,
      ref: forwardedRef,
      ...props,
      ...rootProps,
      children: [/* @__PURE__ */jsx$1(AvatarImage, {
        src: imageUrl != null ? imageUrl : void 0,
        alt: `${name}'s avatar`
      }), /* @__PURE__ */jsx$1($cddcb0b647441e34$export$fb8d7f40caaeea67, {
        delayMs: fallbackDelay,
        children: /* @__PURE__ */jsx$1(Icon, {
          variant: "gray",
          size: "inherit",
          icon: faBuildings_2,
          rootProps: {
            role: "img",
            "aria-label": name ? `${name}'s avatar` : "unknown account avatar"
          }
        })
      })]
    })
  });
});
AccountAvatar.displayName = "AccountAvatar";
const BannerThemeVariant = {
  beta: {
    backgroundColor: "$purple2",
    borderBottom: "2px solid $purple9"
  },
  new: {
    backgroundColor: "$indigo2",
    borderBottom: "2px solid $indigo8"
  },
  upgrade: {
    backgroundColor: "$pink2",
    borderBottom: "2px solid $pink8"
  },
  info: {
    backgroundColor: "$blue2",
    borderBottom: "2px solid $blue8"
  },
  warning: {
    backgroundColor: "$yellow2",
    borderBottom: "2px solid $yellow8"
  },
  danger: {
    backgroundColor: "$red2",
    borderBottom: "2px solid $red8"
  }
};
const slideOut$2 = keyframes$1({
  from: {
    transform: "translateY(0)",
    opacity: 1
  },
  to: {
    transform: "translateY(-100%)",
    opacity: 0
  }
});
const StyledBannerContainer = styled(Box, {
  display: "grid",
  paddingX: "$1",
  gridTemplateColumns: "1fr $4",
  rowGap: "$1",
  columnGap: "$1",
  minHeight: "40px",
  width: "100%",
  justifyContent: "space-evenly",
  alignItems: "center",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  '&[data-state="dismissed"]': {
    animationIterationCount: 1,
    animation: `${slideOut$2} 400ms ease-out`
  },
  variants: {
    variant: BannerThemeVariant
  }
});
const StyledBannerContent = styled(Flex, {
  paddingY: "10px"
});
const BannerContent = _ref93 => {
  let {
    children
  } = _ref93;
  return /* @__PURE__ */jsx$1(StyledBannerContent, {
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    children
  });
};
const BannerActions = _ref94 => {
  let {
    children
  } = _ref94;
  return /* @__PURE__ */jsx$1(ButtonGroup, {
    children
  });
};
const BannerRoot = forwardRef((_ref95, forwardedRef) => {
  let {
    variant = "info",
    onClose,
    rootProps,
    children,
    ...props
  } = _ref95;
  const [dataState, setDataState] = useState("visible");
  const onBannerDismiss = useCallback(evt => {
    setDataState("dismissed");
    onClose && delay(() => onClose(evt), 400);
  }, [onClose]);
  return /* @__PURE__ */jsxs(StyledBannerContainer, {
    variant,
    ref: forwardedRef,
    ...props,
    ...rootProps,
    "data-state": dataState,
    children: [/* @__PURE__ */jsx$1(Flex, {
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      children
    }), /* @__PURE__ */jsx$1(Flex, {
      children: /* @__PURE__ */jsx$1(IconButton, {
        title: "dismiss banner",
        hideTooltip: true,
        icon: faXmark_2$1,
        onClick: onBannerDismiss
      })
    })]
  });
});
const Banner = {
  Root: BannerRoot,
  Actions: BannerActions,
  Content: BannerContent
};
BannerRoot.displayName = "Banner";
var BannerThemeVariantEnum = /* @__PURE__ */(BannerThemeVariantEnum2 => {
  BannerThemeVariantEnum2["BETA"] = "beta";
  BannerThemeVariantEnum2["NEW"] = "new";
  BannerThemeVariantEnum2["UPGRADE"] = "upgrade";
  BannerThemeVariantEnum2["INFO"] = "info";
  BannerThemeVariantEnum2["WARNING"] = "warning";
  BannerThemeVariantEnum2["DANGER"] = "danger";
  return BannerThemeVariantEnum2;
})(BannerThemeVariantEnum || {});
const $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.span, _extends$1({}, props, {
    ref: forwardedRef,
    style: {
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
const $054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$054eb8030ebde76e$var$Collection, $054eb8030ebde76e$var$useCollection, $054eb8030ebde76e$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$1("Toast");
const [$054eb8030ebde76e$var$createToastContext, $054eb8030ebde76e$export$8a359da18fbc9073] = $c512c27ab02ef895$export$50c7b4e9d9f19c1("Toast", [$054eb8030ebde76e$var$createCollectionScope]);
const [$054eb8030ebde76e$var$ToastProviderProvider, $054eb8030ebde76e$var$useToastProviderContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$PROVIDER_NAME);
const $054eb8030ebde76e$export$f5d03d415824e0e = props => {
  const {
    __scopeToast,
    label = "Notification",
    duration = 5e3,
    swipeDirection = "right",
    swipeThreshold = 50,
    children
  } = props;
  const [viewport, setViewport] = useState(null);
  const [toastCount, setToastCount] = useState(0);
  const isFocusedToastEscapeKeyDownRef = useRef(false);
  const isClosePausedRef = useRef(false);
  return /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.Provider, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastProviderProvider, {
    scope: __scopeToast,
    label,
    duration,
    swipeDirection,
    swipeThreshold,
    toastCount,
    viewport,
    onViewportChange: setViewport,
    onToastAdd: useCallback(() => setToastCount(prevCount => prevCount + 1), []),
    onToastRemove: useCallback(() => setToastCount(prevCount => prevCount - 1), []),
    isFocusedToastEscapeKeyDownRef,
    isClosePausedRef
  }, children));
};
$054eb8030ebde76e$export$f5d03d415824e0e.propTypes = {
  label(props) {
    if (props.label && typeof props.label === "string" && !props.label.trim()) {
      const error2 = `Invalid prop \`label\` supplied to \`${$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error2);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = ["F8"];
const $054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $054eb8030ebde76e$export$6192c2425ecfd989 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    hotkey = $054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY,
    label = "Notifications ({hotkey})",
    ...viewportProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
  const getItems = $054eb8030ebde76e$var$useCollection(__scopeToast);
  const wrapperRef = useRef(null);
  const headFocusProxyRef = useRef(null);
  const tailFocusProxyRef = useRef(null);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
  const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
  const hasToasts = context.toastCount > 0;
  useEffect(() => {
    const handleKeyDown = event => {
      var _ref$current;
      const isHotkeyPressed = hotkey.every(key => event[key] || event.code === key);
      if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [hotkey]);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    const viewport = ref.current;
    if (wrapper && viewport) {
      const handlePause = () => {
        const pauseEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_PAUSE);
        viewport.dispatchEvent(pauseEvent);
        context.isClosePausedRef.current = true;
      };
      const handleResume = () => {
        const resumeEvent = new CustomEvent($054eb8030ebde76e$var$VIEWPORT_RESUME);
        viewport.dispatchEvent(resumeEvent);
        context.isClosePausedRef.current = false;
      };
      wrapper.addEventListener("focusin", handlePause);
      wrapper.addEventListener("focusout", handleResume);
      wrapper.addEventListener("pointerenter", handlePause);
      wrapper.addEventListener("pointerleave", handleResume);
      window.addEventListener("blur", handlePause);
      window.addEventListener("focus", handleResume);
      return () => {
        wrapper.removeEventListener("focusin", handlePause);
        wrapper.removeEventListener("focusout", handleResume);
        wrapper.removeEventListener("pointerenter", handlePause);
        wrapper.removeEventListener("pointerleave", handleResume);
        window.removeEventListener("blur", handlePause);
        window.removeEventListener("focus", handleResume);
      };
    }
  }, [context.isClosePausedRef]);
  const getSortedTabbableCandidates = useCallback(_ref96 => {
    let {
      tabbingDirection
    } = _ref96;
    const toastItems = getItems();
    const tabbableCandidates = toastItems.map(toastItem => {
      const toastNode = toastItem.ref.current;
      const toastTabbableCandidates = [toastNode, ...$054eb8030ebde76e$var$getTabbableCandidates(toastNode)];
      return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
    });
    return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
  }, [getItems]);
  useEffect(() => {
    const viewport = ref.current;
    if (viewport) {
      const handleKeyDown = event => {
        const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
        const isTabKey = event.key === "Tab" && !isMetaKey;
        if (isTabKey) {
          const focusedElement = document.activeElement;
          const isTabbingBackwards = event.shiftKey;
          const targetIsViewport = event.target === viewport;
          if (targetIsViewport && isTabbingBackwards) {
            var _headFocusProxyRef$cu;
            (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
            return;
          }
          const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
          const sortedCandidates = getSortedTabbableCandidates({
            tabbingDirection
          });
          const index2 = sortedCandidates.findIndex(candidate => candidate === focusedElement);
          if ($054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index2 + 1))) event.preventDefault();else {
            var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
            isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
          }
        }
      };
      viewport.addEventListener("keydown", handleKeyDown);
      return () => viewport.removeEventListener("keydown", handleKeyDown);
    }
  }, [getItems, getSortedTabbableCandidates]);
  return /* @__PURE__ */createElement$1($5cb92bef7577960e$export$aecb2ddcb55c95be, {
    ref: wrapperRef,
    role: "region",
    "aria-label": label.replace("{hotkey}", hotkeyLabel),
    tabIndex: -1,
    style: {
      pointerEvents: hasToasts ? void 0 : "none"
    }
  }, hasToasts && /* @__PURE__ */createElement$1($054eb8030ebde76e$var$FocusProxy, {
    ref: headFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "forwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }), /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.Slot, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.ol, _extends$1({
    tabIndex: -1
  }, viewportProps, {
    ref: composedRefs
  }))), hasToasts && /* @__PURE__ */createElement$1($054eb8030ebde76e$var$FocusProxy, {
    ref: tailFocusProxyRef,
    onFocusFromOutsideViewport: () => {
      const tabbableCandidates = getSortedTabbableCandidates({
        tabbingDirection: "backwards"
      });
      $054eb8030ebde76e$var$focusFirst(tabbableCandidates);
    }
  }));
});
const $054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $054eb8030ebde76e$var$FocusProxy = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    onFocusFromOutsideViewport,
    ...proxyProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
  return /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$439d29a4e110a164, _extends$1({
    "aria-hidden": true,
    tabIndex: 0
  }, proxyProps, {
    ref: forwardedRef,
    style: {
      position: "fixed"
    },
    onFocus: event => {
      var _context$viewport;
      const prevFocusedElement = event.relatedTarget;
      const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
      if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
    }
  }));
});
const $054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $054eb8030ebde76e$export$8d8dc7d5f743331b = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    forceMount,
    open: openProp,
    defaultOpen,
    onOpenChange,
    ...toastProps
  } = props;
  const [open2 = true, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || open2
  }, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastImpl, _extends$1({
    open: open2
  }, toastProps, {
    ref: forwardedRef,
    onClose: () => setOpen(false),
    onSwipeStart: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeStart, event => {
      event.currentTarget.setAttribute("data-swipe", "start");
    }),
    onSwipeMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeMove, event => {
      const {
        x: x2,
        y: y2
      } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "move");
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y2}px`);
    }),
    onSwipeCancel: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeCancel, event => {
      event.currentTarget.setAttribute("data-swipe", "cancel");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
    }),
    onSwipeEnd: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onSwipeEnd, event => {
      const {
        x: x2,
        y: y2
      } = event.detail.delta;
      event.currentTarget.setAttribute("data-swipe", "end");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
      event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x2}px`);
      event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y2}px`);
      setOpen(false);
    })
  })));
});
const [$054eb8030ebde76e$var$ToastInteractiveProvider, $054eb8030ebde76e$var$useToastInteractiveContext] = $054eb8030ebde76e$var$createToastContext($054eb8030ebde76e$var$TOAST_NAME, {
  isInteractive: false,
  onClose() {}
});
const $054eb8030ebde76e$var$ToastImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    type: type3 = "foreground",
    duration: durationProp,
    open: open2,
    onClose,
    onEscapeKeyDown,
    onSwipeStart,
    onSwipeMove,
    onSwipeCancel,
    onSwipeEnd,
    ...toastProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const pointerStartRef = useRef(null);
  const swipeDeltaRef = useRef(null);
  const duration1 = durationProp || context.duration;
  const closeTimerStartTimeRef = useRef(0);
  const closeTimerRemainingTimeRef = useRef(duration1);
  const closeTimerRef = useRef(0);
  const {
    onToastAdd,
    onToastRemove
  } = context;
  const handleClose = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(() => {
    var _ref$current2, _context$viewport2;
    const isFocusInToast = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.contains(document.activeElement);
    if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
    onClose();
  });
  const startTimer = useCallback(duration => {
    if (!duration || duration === Infinity) return;
    window.clearTimeout(closeTimerRef.current);
    closeTimerStartTimeRef.current = new Date().getTime();
    closeTimerRef.current = window.setTimeout(handleClose, duration);
  }, [handleClose]);
  useEffect(() => {
    const viewport = context.viewport;
    if (viewport) {
      const handleResume = () => {
        startTimer(closeTimerRemainingTimeRef.current);
      };
      const handlePause = () => {
        const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
        closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
        window.clearTimeout(closeTimerRef.current);
      };
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
      viewport.addEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      return () => {
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
        viewport.removeEventListener($054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
      };
    }
  }, [context.viewport, duration1, startTimer]);
  useEffect(() => {
    if (open2 && !context.isClosePausedRef.current) startTimer(duration1);
  }, [open2, duration1, context.isClosePausedRef, startTimer]);
  useEffect(() => {
    onToastAdd();
    return () => onToastRemove();
  }, [onToastAdd, onToastRemove]);
  if (!context.viewport) return null;
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastAnnounce, {
    __scopeToast,
    role: "status",
    "aria-live": type3 === "foreground" ? "assertive" : "polite",
    "aria-atomic": true
  }, props.children), /* @__PURE__ */createElement$1($054eb8030ebde76e$var$ToastInteractiveProvider, {
    scope: __scopeToast,
    isInteractive: true,
    onClose: handleClose
  }, /* @__PURE__ */createPortal( /* @__PURE__ */createElement$1($054eb8030ebde76e$var$Collection.ItemSlot, {
    scope: __scopeToast
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$be92b6f5f03c0fe9, {
    asChild: true,
    onEscapeKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onEscapeKeyDown, () => {
      if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
      context.isFocusedToastEscapeKeyDownRef.current = false;
    })
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.li, _extends$1({
    tabIndex: 0,
    "data-state": open2 ? "open" : "closed",
    "data-swipe-direction": context.swipeDirection
  }, toastProps, {
    ref: composedRefs,
    style: {
      userSelect: "none",
      touchAction: "none",
      ...props.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if (event.key !== "Escape") return;
      onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
      if (!event.nativeEvent.defaultPrevented) {
        context.isFocusedToastEscapeKeyDownRef.current = true;
        handleClose();
      }
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, event => {
      if (event.button !== 0) return;
      pointerStartRef.current = {
        x: event.clientX,
        y: event.clientY
      };
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, event => {
      if (!pointerStartRef.current) return;
      const x2 = event.clientX - pointerStartRef.current.x;
      const y2 = event.clientY - pointerStartRef.current.y;
      const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
      const isHorizontalSwipe = ["left", "right"].includes(context.swipeDirection);
      const clamp = ["left", "up"].includes(context.swipeDirection) ? Math.min : Math.max;
      const clampedX = isHorizontalSwipe ? clamp(0, x2) : 0;
      const clampedY = !isHorizontalSwipe ? clamp(0, y2) : 0;
      const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
      const delta = {
        x: clampedX,
        y: clampedY
      };
      const eventDetail = {
        originalEvent: event,
        delta
      };
      if (hasSwipeMoveStarted) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
          discrete: false
        });
      } else if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
        swipeDeltaRef.current = delta;
        $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
          discrete: false
        });
        event.target.setPointerCapture(event.pointerId);
      } else if (Math.abs(x2) > moveStartBuffer || Math.abs(y2) > moveStartBuffer) pointerStartRef.current = null;
    }),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, event1 => {
      const delta = swipeDeltaRef.current;
      event1.target.releasePointerCapture(event1.pointerId);
      swipeDeltaRef.current = null;
      pointerStartRef.current = null;
      if (delta) {
        const toast = event1.currentTarget;
        const eventDetail = {
          originalEvent: event1,
          delta
        };
        if ($054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
          discrete: true
        });else $054eb8030ebde76e$var$handleAndDispatchCustomEvent($054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
          discrete: true
        });
        toast.addEventListener("click", event => event.preventDefault(), {
          once: true
        });
      }
    })
  })))), context.viewport)));
});
$054eb8030ebde76e$var$ToastImpl.propTypes = {
  type(props) {
    if (props.type && !["foreground", "background"].includes(props.type)) {
      const error2 = `Invalid prop \`type\` supplied to \`${$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
      return new Error(error2);
    }
    return null;
  }
};
const $054eb8030ebde76e$var$ToastAnnounce = props => {
  const {
    __scopeToast,
    children,
    ...announceProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastProviderContext($054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
  const [renderAnnounceText, setRenderAnnounceText] = useState(false);
  const [isAnnounced, setIsAnnounced] = useState(false);
  const [fragment, setFragment] = useState();
  const [rootFragmentNode, setRootFragmentNode] = useState(null);
  const announceTextContent = useMemo(() => {
    return rootFragmentNode ? $054eb8030ebde76e$var$getAnnounceTextContent(rootFragmentNode) : null;
  }, [rootFragmentNode]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    setFragment(new DocumentFragment());
  }, []);
  $054eb8030ebde76e$var$useNextFrame(() => setRenderAnnounceText(true));
  useEffect(() => {
    const timer = window.setTimeout(() => setIsAnnounced(true), 1e3);
    return () => window.clearTimeout(timer);
  }, []);
  return isAnnounced ? null : /* @__PURE__ */createElement$1(Fragment$1, null, fragment && /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c$2, {
    container: fragment,
    ref: setRootFragmentNode
  }, context.label, " ", children), /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c$2, {
    asChild: true
  }, /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$439d29a4e110a164, announceProps, renderAnnounceText && announceTextContent)));
};
const $054eb8030ebde76e$export$16d42d7c29b95a4 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...titleProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, titleProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$export$ecddd96c53621d9a = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...descriptionProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, descriptionProps, {
    ref: forwardedRef
  }));
});
const $054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $054eb8030ebde76e$export$3019feecfda683d2 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    altText,
    ...actionProps
  } = props;
  const context = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$ACTION_NAME, props.__scopeToast);
  if (!altText) return null;
  return context.isInteractive ? /* @__PURE__ */createElement$1($054eb8030ebde76e$export$811e70f61c205839, _extends$1({}, actionProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1("span", null, altText);
});
$054eb8030ebde76e$export$3019feecfda683d2.propTypes = {
  altText(props) {
    if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$054eb8030ebde76e$var$ACTION_NAME}\``);
    return null;
  }
};
const $054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $054eb8030ebde76e$export$811e70f61c205839 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeToast,
    ...closeProps
  } = props;
  const interactiveContext = $054eb8030ebde76e$var$useToastInteractiveContext($054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
  return interactiveContext.isInteractive ? /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button"
  }, closeProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, interactiveContext.onClose)
  })) : null;
});
function $054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, _ref97) {
  let {
    discrete
  } = _ref97;
  const currentTarget = detail.originalEvent.currentTarget;
  const event = new CustomEvent(name, {
    bubbles: true,
    cancelable: true,
    detail
  });
  if (handler) currentTarget.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f$2(currentTarget, event);else currentTarget.dispatchEvent(event);
}
const $054eb8030ebde76e$var$isDeltaInDirection = function (delta, direction) {
  let threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const deltaX = Math.abs(delta.x);
  const deltaY = Math.abs(delta.y);
  const isDeltaX = deltaX > deltaY;
  if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;else return !isDeltaX && deltaY > threshold;
};
function $054eb8030ebde76e$var$useNextFrame() {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  const fn = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    let raf1 = 0;
    let raf2 = 0;
    raf1 = window.requestAnimationFrame(() => raf2 = window.requestAnimationFrame(fn));
    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [fn]);
}
function $054eb8030ebde76e$var$getAnnounceTextContent(container) {
  const textContent = [];
  const childNodes = Array.from(container.childNodes);
  childNodes.forEach(node2 => {
    if (node2.nodeType === node2.TEXT_NODE && node2.textContent) textContent.push(node2.textContent);
    if ($054eb8030ebde76e$var$isHTMLElement(node2)) {
      const isHidden = node2.ariaHidden || node2.hidden || node2.style.display === "none";
      if (!isHidden) textContent.push(...$054eb8030ebde76e$var$getAnnounceTextContent(node2));
    }
  });
  return textContent;
}
function $054eb8030ebde76e$var$isHTMLElement(node2) {
  return node2.nodeType === node2.ELEMENT_NODE;
}
function $054eb8030ebde76e$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node2 => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $054eb8030ebde76e$var$focusFirst(candidates) {
  const previouslyFocusedElement = document.activeElement;
  return candidates.some(candidate => {
    if (candidate === previouslyFocusedElement) return true;
    candidate.focus();
    return document.activeElement !== previouslyFocusedElement;
  });
}
const $054eb8030ebde76e$export$2881499e37b75b9a = $054eb8030ebde76e$export$f5d03d415824e0e;
const $054eb8030ebde76e$export$d5c6c08dc2d3ca7 = $054eb8030ebde76e$export$6192c2425ecfd989;
const $054eb8030ebde76e$export$be92b6f5f03c0fe9 = $054eb8030ebde76e$export$8d8dc7d5f743331b;
const $054eb8030ebde76e$export$f99233281efd08a0 = $054eb8030ebde76e$export$16d42d7c29b95a4;
const $054eb8030ebde76e$export$393edc798c47379d = $054eb8030ebde76e$export$ecddd96c53621d9a;
const $054eb8030ebde76e$export$e19cd5f9376f8cee = $054eb8030ebde76e$export$3019feecfda683d2;
const $054eb8030ebde76e$export$f39c2d165cd861fe = $054eb8030ebde76e$export$811e70f61c205839;
const ToastVariant = {
  info: {
    backgroundColor: "$blue1",
    borderColor: "$blue6"
  },
  success: {
    backgroundColor: "$green1",
    borderColor: "$green6"
  },
  error: {
    backgroundColor: "$red1",
    borderColor: "$red6"
  },
  warning: {
    backgroundColor: "$yellow1",
    borderColor: "$yellow4"
  }
};
const VIEWPORT_PADDING = 25;
const hide = keyframes$1({
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
});
const slideIn$1 = keyframes$1({
  from: {
    transform: `translateY(calc(${VIEWPORT_PADDING}px - 100vh))`
  },
  to: {
    transform: "translateY(0)"
  }
});
const swipeOut = keyframes$1({
  from: {
    transform: "translateX(var(--radix-toast-swipe-end-x))"
  },
  to: {
    transform: `translateX(calc(100% + ${VIEWPORT_PADDING}px))`
  }
});
const StyledToastViewport = styled($054eb8030ebde76e$export$d5c6c08dc2d3ca7, {
  position: "absolute",
  transform: "translateX(-50%) !important",
  left: "50% !important",
  insetBlockStart: 0,
  insetInline: 0,
  display: "flex",
  flexDirection: "column-reverse",
  justifyItems: "center",
  justifyContent: "center",
  alignItems: "center",
  gap: "$1",
  zIndex: "$toast",
  listStyle: "none",
  maxWidth: "100%",
  width: "max-content"
});
const StyledToastRoot = styled($054eb8030ebde76e$export$be92b6f5f03c0fe9, {
  boxShadow: "$raised08",
  padding: "$1",
  display: "flex",
  alignItems: "center",
  gap: "$2",
  paddingX: "$2",
  border: "1px solid",
  borderLeft: "5px solid",
  borderRadius: "0px $1 $1 0px",
  maxInlineSize: "max-content",
  "@media (prefers-reduced-motion: no-preference)": {
    '&[data-state="open"]': {
      animation: `${slideIn$1} 150ms cubic-bezier(0.16, 1, 0.3, 1)`
    },
    '&[data-state="closed"]': {
      animation: `${hide} 100ms ease-in`
    },
    '&[data-swipe="move"]': {
      transform: "translateX(var(--radix-toast-swipe-move-x))"
    },
    '&[data-swipe="cancel"]': {
      transform: "translateX(0)",
      transition: "transform 200ms ease-out"
    },
    '&[data-swipe="end"]': {
      animation: `${swipeOut} 100ms ease-out`
    }
  }
}, {
  variants: {
    variant: ToastVariant
  },
  defaultVariants: {
    variant: "info"
  }
});
const StyledToastContent = styled(Flex, {
  marginY: "-1px"
});
const StyledToastAction = styled($054eb8030ebde76e$export$e19cd5f9376f8cee, {
  marginRight: "-$1",
  marginY: "-3px"
});
const StyledToastClose = styled($054eb8030ebde76e$export$f39c2d165cd861fe, {
  "button&:hover": {
    backgroundColor: "inherit",
    filter: "brightness(0.95)"
  }
});
const ToastBase = {
  Portal: $f1701beae083dbae$export$be92b6f5f03c0fe9,
  Provider: $054eb8030ebde76e$export$2881499e37b75b9a,
  Root: StyledToastRoot,
  Title: $054eb8030ebde76e$export$f99233281efd08a0,
  Description: $054eb8030ebde76e$export$393edc798c47379d,
  Action: StyledToastAction,
  Close: StyledToastClose,
  Viewport: StyledToastViewport
};
const ToastContext = createContext$1({
  setToasts: () => {}
});
const ToastTypeMap = {
  info: "background",
  success: "foreground",
  warning: "background",
  error: "foreground"
};
const Toast = _ref98 => {
  let {
    message,
    variant = "info",
    action,
    persisted = false,
    options
  } = _ref98;
  var _a, _b;
  const type3 = (_a = options == null ? void 0 : options.type) != null ? _a : ToastTypeMap[variant];
  const [open2, setOpen] = useState(true);
  return /* @__PURE__ */jsxs(ToastBase.Root, {
    variant,
    type: type3,
    duration: options == null ? void 0 : options.duration,
    open: open2,
    onOpenChange: open22 => {
      if (!persisted && !open22) {
        setOpen(false);
      }
    },
    children: [/* @__PURE__ */jsxs(StyledToastContent, {
      gap: 1,
      alignItems: "center",
      children: [/* @__PURE__ */jsx$1(StatusIcon, {
        variant
      }), /* @__PURE__ */jsx$1(StatusMessageText, {
        variant: "body",
        color: variant,
        children: message
      })]
    }), action && /* @__PURE__ */jsx$1(ToastBase.Action, {
      asChild: true,
      altText: (_b = action.alt) != null ? _b : action.label,
      children: /* @__PURE__ */jsx$1(Button, {
        onClick: () => {
          action.onClick();
          setOpen(false);
        },
        variant: "secondary",
        size: "small",
        children: action.label
      })
    }), persisted && /* @__PURE__ */jsx$1(ToastBase.Close, {
      "aria-label": "Close",
      asChild: true,
      onClick: () => setOpen(false),
      children: /* @__PURE__ */jsx$1(IconButton, {
        icon: faXmark_2$1,
        size: "small",
        title: "Dismiss toast"
      })
    })]
  }, message);
};
const Toasts = _ref99 => {
  let {
    toasts
  } = _ref99;
  return /* @__PURE__ */jsxs(ToastBase.Provider, {
    swipeDirection: "right",
    children: [toasts.map(_ref100 => {
      let {
        id,
        ...toastProps
      } = _ref100;
      return /* @__PURE__ */jsx$1(Toast, {
        ...toastProps
      }, id);
    }), /* @__PURE__ */jsx$1(ToastBase.Portal, {
      children: /* @__PURE__ */jsx$1(ToastBase.Viewport, {})
    })]
  });
};
const ToastProvider = _ref101 => {
  let {
    children
  } = _ref101;
  const [toasts, setToasts] = useState([]);
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx$1(ToastContext.Provider, {
      value: {
        setToasts
      },
      children
    }), /* @__PURE__ */jsx$1(Toasts, {
      toasts
    })]
  });
};
var ToastVariantEnum = /* @__PURE__ */(ToastVariantEnum2 => {
  ToastVariantEnum2["INFO"] = "info";
  ToastVariantEnum2["SUCCESS"] = "success";
  ToastVariantEnum2["ERROR"] = "error";
  ToastVariantEnum2["WARNING"] = "warning";
  return ToastVariantEnum2;
})(ToastVariantEnum || {});
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr) {
  let offset2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return (byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]]).toLowerCase();
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};
function v4(options, buf, offset2) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset2 = offset2 || 0;
    for (let i = 0; i < 16; ++i) {
      buf[offset2 + i] = rnds[i];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
const useToast = () => {
  const {
    setToasts
  } = useContext(ToastContext);
  if (!setToasts) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  const triggerToast = useCallback(args => {
    setToasts(curr => [...takeLast$1(2, curr), {
      id: v4(),
      ...args
    }]);
  }, [setToasts]);
  return triggerToast;
};
const InlineAlertThemeVariant = {
  beta: {
    border: "1px solid $purple6",
    borderTop: "4px solid $purple6"
  },
  new: {
    border: "1px solid $indigo6",
    borderTop: "4px solid $indigo6"
  },
  upgrade: {
    border: "1px solid $pink6",
    borderTop: "4px solid $pink6"
  },
  info: {
    backgroundColor: "$blue1",
    border: "1px solid $blue6",
    borderTop: "4px solid $blue6"
  },
  warning: {
    backgroundColor: "$yellow1",
    border: "1px solid $yellow4",
    borderTop: "4px solid $yellow4"
  },
  error: {
    backgroundColor: "$red1",
    border: "1px solid $red6",
    borderTop: "4px solid $red6"
  }
};
const slideOut$1 = keyframes$1({
  from: {
    transform: "translateY(0)",
    opacity: 1
  },
  to: {
    transform: "translateY(-100%)",
    opacity: 0
  }
});
const DescriptionText = styled(Text, {
  color: "$gray10"
});
const InlineAlertContent = styled(Flex, {
  paddingY: "$2"
});
const CloseButtonContainer = styled(Flex, {
  padding: "$half"
});
const InlineAlertActions = styled(Flex, {
  height: "100%",
  variants: {
    withPadding: {
      true: {
        paddingRight: "$2"
      }
    }
  }
});
const ScaledStatusIcon = styled(StatusIcon, {
  scale: 1.2
});
const StyledInlineAlertContainer = styled(Box, {
  display: "grid",
  paddingLeft: "$2",
  gridAutoFlow: "column",
  gap: "$3",
  minHeight: "$6",
  width: "100%",
  alignItems: "center",
  backgroundColor: "$white",
  borderTopRightRadius: "$1",
  borderTopLeftRadius: "$1",
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  '&[data-state="dismissed"]': {
    animationIterationCount: 1,
    animation: `${slideOut$1} 400ms ease-out`
  },
  variants: {
    variant: InlineAlertThemeVariant
  }
});
const FeatureBadgeTitlePrefixes = ["new", "beta", "upgrade"];
const StatusIconTitlePrefixes = ["info", "warning", "error"];
const InlineAlertTitleWithFeatureBadge = _ref102 => {
  let {
    title,
    variant
  } = _ref102;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx$1(FeatureBadge, {
      bolt: true,
      variant
    }), /* @__PURE__ */jsx$1(Header, {
      variant: "h3",
      children: title
    })]
  });
};
const InlineAlertTitleWithStatusIcon = _ref103 => {
  let {
    title,
    variant
  } = _ref103;
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx$1(ScaledStatusIcon, {
      variant
    }), /* @__PURE__ */jsx$1(Header, {
      variant: "h3",
      children: title
    })]
  });
};
const InlineAlertTitle = _ref104 => {
  let {
    title,
    variant
  } = _ref104;
  const typedVariant = variant;
  return /* @__PURE__ */jsxs(Flex, {
    alignItems: "center",
    children: [FeatureBadgeTitlePrefixes.includes(typedVariant) && /* @__PURE__ */jsx$1(InlineAlertTitleWithFeatureBadge, {
      title,
      variant
    }), StatusIconTitlePrefixes.includes(typedVariant) && /* @__PURE__ */jsx$1(InlineAlertTitleWithStatusIcon, {
      title,
      variant
    })]
  });
};
const InlineAlertDescription = _ref105 => {
  let {
    children
  } = _ref105;
  return /* @__PURE__ */jsx$1(DescriptionText, {
    children
  });
};
const InlineAlert = forwardRef((_ref106, forwardedRef) => {
  let {
    variant,
    title,
    dismissable,
    description,
    actionText,
    onActionClick,
    onClose,
    rootProps,
    ...props
  } = _ref106;
  const [dataState, setDataState] = useState("visible");
  const onAlertDismiss = useCallback(evt => {
    setDataState("dismissed");
    onClose && delay(() => onClose(evt), 400);
  }, [onClose]);
  return /* @__PURE__ */jsxs(StyledInlineAlertContainer, {
    "data-state": dataState,
    variant,
    ref: forwardedRef,
    ...props,
    ...rootProps,
    children: [/* @__PURE__ */jsxs(InlineAlertContent, {
      direction: "column",
      gap: "half",
      children: [/* @__PURE__ */jsx$1(InlineAlertTitle, {
        variant,
        title
      }), /* @__PURE__ */jsx$1(InlineAlertDescription, {
        children: description
      })]
    }), /* @__PURE__ */jsxs(InlineAlertActions, {
      alignItems: "stretch",
      justifyContent: "flex-end",
      gap: "half",
      withPadding: !!actionText && !dismissable,
      children: [actionText && /* @__PURE__ */jsx$1(Flex, {
        alignItems: "center",
        children: /* @__PURE__ */jsx$1(Button, {
          variant: "secondary",
          onClick: onActionClick,
          children: actionText
        })
      }), dismissable && /* @__PURE__ */jsx$1(CloseButtonContainer, {
        alignItems: "flex-start",
        children: /* @__PURE__ */jsx$1(IconButton, {
          title: "Dismiss",
          icon: faXmark_2$1,
          onClick: onAlertDismiss
        })
      })]
    })]
  });
});
InlineAlert.displayName = "InlineAlert";
var InlineAlertThemeVariantEnum = /* @__PURE__ */(InlineAlertThemeVariantEnum2 => {
  InlineAlertThemeVariantEnum2["BETA"] = "beta";
  InlineAlertThemeVariantEnum2["NEW"] = "new";
  InlineAlertThemeVariantEnum2["UPGRADE"] = "upgrade";
  InlineAlertThemeVariantEnum2["INFO"] = "info";
  InlineAlertThemeVariantEnum2["WARNING"] = "warning";
  InlineAlertThemeVariantEnum2["ERROR"] = "error";
  return InlineAlertThemeVariantEnum2;
})(InlineAlertThemeVariantEnum || {});
const $5e63c961fc1ce211$export$8c6ed5c666ac1360$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable$1);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$1, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone$1, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360$1.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone$1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps$1(slotProps, children.props),
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, children.ref)
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone$1.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1 = _ref107 => {
  let {
    children
  } = _ref107;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable$1(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45$1;
}
function $5e63c961fc1ce211$var$mergeProps$1(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) overrideProps[propName] = function () {
      childPropValue === null || childPropValue === void 0 || childPropValue(...arguments);
      slotPropValue === null || slotPropValue === void 0 || slotPropValue(...arguments);
    };else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $6cc32821e9371a1c$var$SELECTION_KEYS = ["Enter", " "];
const $6cc32821e9371a1c$var$FIRST_KEYS = ["ArrowDown", "PageUp", "Home"];
const $6cc32821e9371a1c$var$LAST_KEYS = ["ArrowUp", "PageDown", "End"];
const $6cc32821e9371a1c$var$FIRST_LAST_KEYS = [...$6cc32821e9371a1c$var$FIRST_KEYS, ...$6cc32821e9371a1c$var$LAST_KEYS];
const $6cc32821e9371a1c$var$MENU_NAME = "Menu";
const [$6cc32821e9371a1c$var$Collection, $6cc32821e9371a1c$var$useCollection, $6cc32821e9371a1c$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2$1($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$createMenuContext, $6cc32821e9371a1c$export$4027731b685e72eb] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($6cc32821e9371a1c$var$MENU_NAME, [$6cc32821e9371a1c$var$createCollectionScope, $cf1ac5d9fe0e8206$export$722aac194ae923$1, $d7bdfb9eb0fdf311$export$c7109489551a4f4]);
const $6cc32821e9371a1c$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923$1();
const $6cc32821e9371a1c$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$6cc32821e9371a1c$var$MenuProvider, $6cc32821e9371a1c$var$useMenuContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const [$6cc32821e9371a1c$var$MenuRootProvider, $6cc32821e9371a1c$var$useMenuRootContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$MENU_NAME);
const $6cc32821e9371a1c$export$d9b273488cd8ce6f = props => {
  const {
    __scopeMenu,
    open: open2 = false,
    children,
    dir,
    onOpenChange,
    modal = true
  } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const [content, setContent] = useState(null);
  const isUsingKeyboardRef = useRef(false);
  const handleOpenChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onOpenChange);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  useEffect(() => {
    const handleKeyDown = () => {
      isUsingKeyboardRef.current = true;
      document.addEventListener("pointerdown", handlePointer, {
        capture: true,
        once: true
      });
      document.addEventListener("pointermove", handlePointer, {
        capture: true,
        once: true
      });
    };
    const handlePointer = () => isUsingKeyboardRef.current = false;
    document.addEventListener("keydown", handleKeyDown, {
      capture: true
    });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, {
        capture: true
      });
      document.removeEventListener("pointerdown", handlePointer, {
        capture: true
      });
      document.removeEventListener("pointermove", handlePointer, {
        capture: true
      });
    };
  }, []);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9$1, popperScope, /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuProvider, {
    scope: __scopeMenu,
    open: open2,
    onOpenChange: handleOpenChange,
    content,
    onContentChange: setContent
  }, /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuRootProvider, {
    scope: __scopeMenu,
    onClose: useCallback(() => handleOpenChange(false), [handleOpenChange]),
    isUsingKeyboardRef,
    dir: direction,
    modal
  }, children)));
};
const $6cc32821e9371a1c$export$9fa5ebd18bee4d43 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    ...anchorProps
  } = props;
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  return /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$b688253958b8dfe7$1, _extends$1({}, popperScope, anchorProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$PORTAL_NAME = "MenuPortal";
const [$6cc32821e9371a1c$var$PortalProvider, $6cc32821e9371a1c$var$usePortalContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, {
  forceMount: void 0
});
const $6cc32821e9371a1c$export$793392f970497feb = props => {
  const {
    __scopeMenu,
    forceMount,
    children,
    container
  } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$PORTAL_NAME, __scopeMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$PortalProvider, {
    scope: __scopeMenu,
    forceMount
  }, /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c$2, {
    asChild: true,
    container
  }, children)));
};
const $6cc32821e9371a1c$var$CONTENT_NAME = "MenuContent";
const [$6cc32821e9371a1c$var$MenuContentProvider, $6cc32821e9371a1c$var$useMenuContentContext] = $6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$CONTENT_NAME);
const $6cc32821e9371a1c$export$479f0f2f71193efe = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const portalContext = $6cc32821e9371a1c$var$usePortalContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const {
    forceMount = portalContext.forceMount,
    ...contentProps
  } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$Collection.Provider, {
    scope: props.__scopeMenu
  }, /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || context.open
  }, /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$Collection.Slot, {
    scope: props.__scopeMenu
  }, rootContext.modal ? /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuRootContentModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuRootContentNonModal, _extends$1({}, contentProps, {
    ref: forwardedRef
  })))));
});
const $6cc32821e9371a1c$var$MenuRootContentModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  useEffect(() => {
    const content = ref.current;
    if (content) return hideOthers(content);
  }, []);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuContentImpl, _extends$1({}, props, {
    ref: composedRefs,
    trapFocus: context.open,
    disableOutsidePointerEvents: context.open,
    disableOutsideScroll: true,
    onFocusOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusOutside, event => event.preventDefault(), {
      checkForDefaultPrevented: false
    }),
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuRootContentNonModal = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, props.__scopeMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuContentImpl, _extends$1({}, props, {
    ref: forwardedRef,
    trapFocus: false,
    disableOutsidePointerEvents: false,
    disableOutsideScroll: false,
    onDismiss: () => context.onOpenChange(false)
  }));
});
const $6cc32821e9371a1c$var$MenuContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    loop = false,
    trapFocus,
    onOpenAutoFocus,
    onCloseAutoFocus,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    disableOutsideScroll,
    ...contentProps
  } = props;
  const context = $6cc32821e9371a1c$var$useMenuContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$CONTENT_NAME, __scopeMenu);
  const popperScope = $6cc32821e9371a1c$var$usePopperScope(__scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const getItems = $6cc32821e9371a1c$var$useCollection(__scopeMenu);
  const [currentItemId, setCurrentItemId] = useState(null);
  const contentRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentRef, context.onContentChange);
  const timerRef = useRef(0);
  const searchRef = useRef("");
  const pointerGraceTimerRef = useRef(0);
  const pointerGraceIntentRef = useRef(null);
  const pointerDirRef = useRef("right");
  const lastPointerXRef = useRef(0);
  const ScrollLockWrapper = disableOutsideScroll ? $epM9y$RemoveScroll : Fragment$1;
  const scrollLockWrapperProps = disableOutsideScroll ? {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$1,
    allowPinchZoom: true
  } : void 0;
  const handleTypeaheadSearch = key => {
    var _items$find, _items$find2;
    const search = searchRef.current + key;
    const items = getItems().filter(item => !item.disabled);
    const currentItem = document.activeElement;
    const currentMatch = (_items$find = items.find(item => item.ref.current === currentItem)) === null || _items$find === void 0 ? void 0 : _items$find.textValue;
    const values = items.map(item => item.textValue);
    const nextMatch = $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch);
    const newItem = (_items$find2 = items.find(item => item.textValue === nextMatch)) === null || _items$find2 === void 0 ? void 0 : _items$find2.ref.current;
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(() => updateSearch(""), 1e3);
    })(search);
    if (newItem) setTimeout(() => newItem.focus());
  };
  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const isPointerMovingToSubmenu = useCallback(event => {
    var _pointerGraceIntentRe, _pointerGraceIntentRe2;
    const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRe = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe === void 0 ? void 0 : _pointerGraceIntentRe.side);
    return isMovingTowards && $6cc32821e9371a1c$var$isPointerInGraceArea(event, (_pointerGraceIntentRe2 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRe2 === void 0 ? void 0 : _pointerGraceIntentRe2.area);
  }, []);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuContentProvider, {
    scope: __scopeMenu,
    searchRef,
    onItemEnter: useCallback(event => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [isPointerMovingToSubmenu]),
    onItemLeave: useCallback(event => {
      var _contentRef$current;
      if (isPointerMovingToSubmenu(event)) return;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
      setCurrentItemId(null);
    }, [isPointerMovingToSubmenu]),
    onTriggerLeave: useCallback(event => {
      if (isPointerMovingToSubmenu(event)) event.preventDefault();
    }, [isPointerMovingToSubmenu]),
    pointerGraceTimerRef,
    onPointerGraceIntentChange: useCallback(intent => {
      pointerGraceIntentRef.current = intent;
    }, [])
  }, /* @__PURE__ */createElement$1(ScrollLockWrapper, scrollLockWrapperProps, /* @__PURE__ */createElement$1($d3863c46a17e8a28$export$20e40289641fbbb6$2, {
    asChild: true,
    trapped: trapFocus,
    onMountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onOpenAutoFocus, event => {
      var _contentRef$current2;
      event.preventDefault();
      (_contentRef$current2 = contentRef.current) === null || _contentRef$current2 === void 0 || _contentRef$current2.focus();
    }),
    onUnmountAutoFocus: onCloseAutoFocus
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22$2, {
    asChild: true,
    disableOutsidePointerEvents,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    dir: rootContext.dir,
    orientation: "vertical",
    loop,
    currentTabStopId: currentItemId,
    onCurrentTabStopIdChange: setCurrentItemId,
    onEntryFocus: event => {
      if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
    }
  }), /* @__PURE__ */createElement$1($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2$1, _extends$1({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": $6cc32821e9371a1c$var$getOpenState(context.open),
    dir: rootContext.dir
  }, popperScope, contentProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...contentProps.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onKeyDown, event => {
      const target = event.target;
      const isKeyDownInside = target.closest('[role="menu"]') === event.currentTarget;
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      const isCharacterKey = event.key.length === 1;
      if (isKeyDownInside) {
        if (event.key === "Tab") event.preventDefault();
        if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
      }
      const content = contentRef.current;
      if (event.target !== content) return;
      if (!$6cc32821e9371a1c$var$FIRST_LAST_KEYS.includes(event.key)) return;
      event.preventDefault();
      const items = getItems().filter(item => !item.disabled);
      const candidateNodes = items.map(item => item.ref.current);
      if ($6cc32821e9371a1c$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
      $6cc32821e9371a1c$var$focusFirst(candidateNodes);
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, event => {
      if (!event.currentTarget.contains(event.target)) {
        window.clearTimeout(timerRef.current);
        searchRef.current = "";
      }
    }),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse(event => {
      const target = event.target;
      const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
      if (event.currentTarget.contains(target) && pointerXHasChanged) {
        const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
        pointerDirRef.current = newDir;
        lastPointerXRef.current = event.clientX;
      }
    }))
  })))))));
});
const $6cc32821e9371a1c$export$22a631d1f72787bb = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    ...groupProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    role: "group"
  }, groupProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$export$dd37bec0e8a99143 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    ...labelProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({}, labelProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$ITEM_NAME = "MenuItem";
const $6cc32821e9371a1c$var$ITEM_SELECT = "menu.itemSelect";
const $6cc32821e9371a1c$export$2ce376c2cc3355c8 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    disabled: disabled2 = false,
    onSelect,
    ...itemProps
  } = props;
  const ref = useRef(null);
  const rootContext = $6cc32821e9371a1c$var$useMenuRootContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, props.__scopeMenu);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const isPointerDownRef = useRef(false);
  const handleSelect = () => {
    const menuItem = ref.current;
    if (!disabled2 && menuItem) {
      const itemSelectEvent = new CustomEvent($6cc32821e9371a1c$var$ITEM_SELECT, {
        bubbles: true,
        cancelable: true
      });
      menuItem.addEventListener($6cc32821e9371a1c$var$ITEM_SELECT, event => onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
        once: true
      });
      $8927f6f2acc4f386$export$6d1a0317bde7de7f$2(menuItem, itemSelectEvent);
      if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;else rootContext.onClose();
    }
  };
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$MenuItemImpl, _extends$1({}, itemProps, {
    ref: composedRefs,
    disabled: disabled2,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onClick, handleSelect),
    onPointerDown: event => {
      var _props$onPointerDown;
      (_props$onPointerDown = props.onPointerDown) === null || _props$onPointerDown === void 0 || _props$onPointerDown.call(props, event);
      isPointerDownRef.current = true;
    },
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, event => {
      var _event$currentTarget;
      if (!isPointerDownRef.current) (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || _event$currentTarget.click();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      const isTypingAhead = contentContext.searchRef.current !== "";
      if (disabled2 || isTypingAhead && event.key === " ") return;
      if ($6cc32821e9371a1c$var$SELECTION_KEYS.includes(event.key)) {
        event.currentTarget.click();
        event.preventDefault();
      }
    })
  }));
});
const $6cc32821e9371a1c$var$MenuItemImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    disabled: disabled2 = false,
    textValue,
    ...itemProps
  } = props;
  const contentContext = $6cc32821e9371a1c$var$useMenuContentContext($6cc32821e9371a1c$var$ITEM_NAME, __scopeMenu);
  const rovingFocusGroupScope = $6cc32821e9371a1c$var$useRovingFocusGroupScope(__scopeMenu);
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const [isFocused, setIsFocused] = useState(false);
  const [textContent, setTextContent] = useState("");
  useEffect(() => {
    const menuItem = ref.current;
    if (menuItem) {
      var _menuItem$textContent;
      setTextContent(((_menuItem$textContent = menuItem.textContent) !== null && _menuItem$textContent !== void 0 ? _menuItem$textContent : "").trim());
    }
  }, [itemProps.children]);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$var$Collection.ItemSlot, {
    scope: __scopeMenu,
    disabled: disabled2,
    textValue: textValue !== null && textValue !== void 0 ? textValue : textContent
  }, /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2
  }), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    role: "menuitem",
    "data-highlighted": isFocused ? "" : void 0,
    "aria-disabled": disabled2 || void 0,
    "data-disabled": disabled2 ? "" : void 0
  }, itemProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, $6cc32821e9371a1c$var$whenMouse(event => {
      if (disabled2) contentContext.onItemLeave(event);else {
        contentContext.onItemEnter(event);
        if (!event.defaultPrevented) {
          const item = event.currentTarget;
          item.focus();
        }
      }
    })),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, $6cc32821e9371a1c$var$whenMouse(event => contentContext.onItemLeave(event))),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => setIsFocused(true)),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlur, () => setIsFocused(false))
  }))));
});
const $6cc32821e9371a1c$var$RADIO_GROUP_NAME = "MenuRadioGroup";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$RADIO_GROUP_NAME, {
  value: void 0,
  onValueChange: () => {}
});
const $6cc32821e9371a1c$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$ITEM_INDICATOR_NAME, {
  checked: false
});
const $6cc32821e9371a1c$export$1cec7dcdd713e220 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeMenu,
    ...separatorProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    role: "separator",
    "aria-orientation": "horizontal"
  }, separatorProps, {
    ref: forwardedRef
  }));
});
const $6cc32821e9371a1c$var$SUB_NAME = "MenuSub";
$6cc32821e9371a1c$var$createMenuContext($6cc32821e9371a1c$var$SUB_NAME);
function $6cc32821e9371a1c$var$getOpenState(open2) {
  return open2 ? "open" : "closed";
}
function $6cc32821e9371a1c$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $6cc32821e9371a1c$var$wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
function $6cc32821e9371a1c$var$getNextMatch(values, search, currentMatch) {
  const isRepeated = search.length > 1 && Array.from(search).every(char2 => char2 === search[0]);
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
  let wrappedValues = $6cc32821e9371a1c$var$wrapArray(values, Math.max(currentMatchIndex, 0));
  const excludeCurrentMatch = normalizedSearch.length === 1;
  if (excludeCurrentMatch) wrappedValues = wrappedValues.filter(v2 => v2 !== currentMatch);
  const nextMatch = wrappedValues.find(value => value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
  return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $6cc32821e9371a1c$var$isPointInPolygon(point, polygon) {
  const {
    x: x2,
    y: y2
  } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $6cc32821e9371a1c$var$isPointerInGraceArea(event, area) {
  if (!area) return false;
  const cursorPos = {
    x: event.clientX,
    y: event.clientY
  };
  return $6cc32821e9371a1c$var$isPointInPolygon(cursorPos, area);
}
function $6cc32821e9371a1c$var$whenMouse(handler) {
  return event => event.pointerType === "mouse" ? handler(event) : void 0;
}
const $6cc32821e9371a1c$export$be92b6f5f03c0fe9 = $6cc32821e9371a1c$export$d9b273488cd8ce6f;
const $6cc32821e9371a1c$export$b688253958b8dfe7 = $6cc32821e9371a1c$export$9fa5ebd18bee4d43;
const $6cc32821e9371a1c$export$602eac185826482c = $6cc32821e9371a1c$export$793392f970497feb;
const $6cc32821e9371a1c$export$7c6e2c02157bb7d2 = $6cc32821e9371a1c$export$479f0f2f71193efe;
const $6cc32821e9371a1c$export$eb2fcfdbd7ba97d4 = $6cc32821e9371a1c$export$22a631d1f72787bb;
const $6cc32821e9371a1c$export$b04be29aa201d4f5 = $6cc32821e9371a1c$export$dd37bec0e8a99143;
const $6cc32821e9371a1c$export$6d08773d2e66f8f2 = $6cc32821e9371a1c$export$2ce376c2cc3355c8;
const $6cc32821e9371a1c$export$1ff3c3f08ae963c0 = $6cc32821e9371a1c$export$1cec7dcdd713e220;
const $d08ef79370b62062$var$DROPDOWN_MENU_NAME = "DropdownMenu";
const [$d08ef79370b62062$var$createDropdownMenuContext, $d08ef79370b62062$export$c0623cd925aeb687] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($d08ef79370b62062$var$DROPDOWN_MENU_NAME, [$6cc32821e9371a1c$export$4027731b685e72eb]);
const $d08ef79370b62062$var$useMenuScope = $6cc32821e9371a1c$export$4027731b685e72eb();
const [$d08ef79370b62062$var$DropdownMenuProvider, $d08ef79370b62062$var$useDropdownMenuContext] = $d08ef79370b62062$var$createDropdownMenuContext($d08ef79370b62062$var$DROPDOWN_MENU_NAME);
const $d08ef79370b62062$export$e44a253a59704894 = props => {
  const {
    __scopeDropdownMenu,
    children,
    dir,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const triggerRef = useRef(null);
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */createElement$1($d08ef79370b62062$var$DropdownMenuProvider, {
    scope: __scopeDropdownMenu,
    triggerId: $1746a345f3d73bb7$export$f680877a34711e37(),
    triggerRef,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open: open2,
    onOpenChange: setOpen,
    onOpenToggle: useCallback(() => setOpen(prevOpen => !prevOpen), [setOpen]),
    modal
  }, /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$be92b6f5f03c0fe9, _extends$1({}, menuScope, {
    open: open2,
    onOpenChange: setOpen,
    dir,
    modal
  }), children));
};
const $d08ef79370b62062$var$TRIGGER_NAME = "DropdownMenuTrigger";
const $d08ef79370b62062$export$d2469213b3befba9 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    disabled: disabled2 = false,
    ...triggerProps
  } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$TRIGGER_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$b688253958b8dfe7, _extends$1({
    asChild: true
  }, menuScope), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button",
    id: context.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": context.open ? true : void 0,
    "aria-controls": context.open ? context.contentId : void 0,
    "data-state": context.open ? "open" : "closed",
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2
  }, triggerProps, {
    ref: $6ed0406888f73fc4$export$43e446d32b3d21af$1(forwardedRef, context.triggerRef),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, event => {
      if (!disabled2 && event.button === 0 && event.ctrlKey === false) {
        context.onOpenToggle();
        if (!context.open) event.preventDefault();
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if (disabled2) return;
      if (["Enter", " "].includes(event.key)) context.onOpenToggle();
      if (event.key === "ArrowDown") context.onOpenChange(true);
      if ([" ", "ArrowDown"].includes(event.key)) event.preventDefault();
    })
  })));
});
const $d08ef79370b62062$export$cd369b4d4d54efc9 = props => {
  const {
    __scopeDropdownMenu,
    ...portalProps
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$602eac185826482c, _extends$1({}, menuScope, portalProps));
};
const $d08ef79370b62062$var$CONTENT_NAME = "DropdownMenuContent";
const $d08ef79370b62062$export$6e76d93a37c01248 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    ...contentProps
  } = props;
  const context = $d08ef79370b62062$var$useDropdownMenuContext($d08ef79370b62062$var$CONTENT_NAME, __scopeDropdownMenu);
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  const hasInteractedOutsideRef = useRef(false);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$7c6e2c02157bb7d2, _extends$1({
    id: context.contentId,
    "aria-labelledby": context.triggerId
  }, menuScope, contentProps, {
    ref: forwardedRef,
    onCloseAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onCloseAutoFocus, event => {
      var _context$triggerRef$c;
      if (!hasInteractedOutsideRef.current) (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
      hasInteractedOutsideRef.current = false;
      event.preventDefault();
    }),
    onInteractOutside: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onInteractOutside, event => {
      const originalEvent = event.detail.originalEvent;
      const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
      const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
      if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
    }),
    style: {
      ...props.style,
      ["--radix-dropdown-menu-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }));
});
const $d08ef79370b62062$export$246bebaba3a2f70e = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    ...groupProps
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$eb2fcfdbd7ba97d4, _extends$1({}, menuScope, groupProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$76e48c5b57f24495 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    ...labelProps
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$b04be29aa201d4f5, _extends$1({}, menuScope, labelProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$ed97964d1871885d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    ...itemProps
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$6d08773d2e66f8f2, _extends$1({}, menuScope, itemProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$da160178fd3bc7e9 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeDropdownMenu,
    ...separatorProps
  } = props;
  const menuScope = $d08ef79370b62062$var$useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */createElement$1($6cc32821e9371a1c$export$1ff3c3f08ae963c0, _extends$1({}, menuScope, separatorProps, {
    ref: forwardedRef
  }));
});
const $d08ef79370b62062$export$be92b6f5f03c0fe9 = $d08ef79370b62062$export$e44a253a59704894;
const $d08ef79370b62062$export$41fb9f06171c75f4 = $d08ef79370b62062$export$d2469213b3befba9;
const $d08ef79370b62062$export$602eac185826482c = $d08ef79370b62062$export$cd369b4d4d54efc9;
const $d08ef79370b62062$export$7c6e2c02157bb7d2 = $d08ef79370b62062$export$6e76d93a37c01248;
const $d08ef79370b62062$export$eb2fcfdbd7ba97d4 = $d08ef79370b62062$export$246bebaba3a2f70e;
const $d08ef79370b62062$export$b04be29aa201d4f5 = $d08ef79370b62062$export$76e48c5b57f24495;
const $d08ef79370b62062$export$6d08773d2e66f8f2 = $d08ef79370b62062$export$ed97964d1871885d;
const $d08ef79370b62062$export$1ff3c3f08ae963c0 = $d08ef79370b62062$export$da160178fd3bc7e9;
const DropdownMenuItemThemeVariant = {
  default: {
    color: "$gray10"
  },
  danger: {
    color: "$red8"
  },
  warning: {
    color: "$yellow8"
  },
  success: {
    color: "$green8"
  }
};
const slideDown = keyframes$1({
  "0%": {
    opacity: 0,
    transform: "translateY(-10px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateY(0)"
  }
});
const slideUp = keyframes$1({
  "0%": {
    opacity: 0,
    transform: "translateY(10px)"
  },
  "100%": {
    opacity: 1,
    transform: "translateY(0)"
  }
});
const StyledDropdownGroupSeparator = styled($d08ef79370b62062$export$1ff3c3f08ae963c0, {
  height: "1px",
  backgroundColor: "$gray3",
  margin: "$half"
});
const StyledDropdownGroupLabel = styled($d08ef79370b62062$export$b04be29aa201d4f5, {
  paddingX: "$1",
  paddingTop: "$1",
  paddingBottom: "$half",
  textStyles: "h4",
  color: "$gray10",
  maxWidth: "260px"
});
const StyledDropdownMenuContentContainer = styled($d08ef79370b62062$export$7c6e2c02157bb7d2, {
  boxShadow: "$3",
  display: "flex",
  flexDirection: "column",
  width: "auto",
  borderRadius: "$1",
  backgroundColor: "$white",
  zIndex: "$menu",
  animationDuration: "0.6s",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  '&[data-side="top"]': {
    animationName: slideUp
  },
  '&[data-side="bottom"]': {
    animationName: slideDown
  }
});
const StyledDropdownMenuItem = styled($d08ef79370b62062$export$6d08773d2e66f8f2, {
  paddingX: "$1",
  minHeight: "$4",
  display: "flex",
  flexDirection: "column",
  minWidth: "80px",
  paddingY: "$1",
  maxWidth: "260px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "$blue1"
  },
  "&:active": {
    backgroundColor: "$blue2",
    color: "$gray12"
  },
  "&:focus-visible": {
    outline: "none",
    backgroundColor: "$blue1"
  },
  "&[data-disabled]": {
    color: "$gray5",
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "$white"
    },
    "&:active": {
      backgroundColor: "$white"
    }
  },
  variants: {
    textColor: DropdownMenuItemThemeVariant
  },
  defaultVariants: {
    textColor: "default"
  }
});
const StyledDropdownItemDescriptionText = styled(Text, {
  clampLines: 2
});
const isDropdownItemGroup = item => {
  return Object.prototype.hasOwnProperty.call(item, "options");
};
const isArrayOfItemGroups = options => isDropdownItemGroup(options[0]);
const DropdownMenuOptionFactory = _ref108 => {
  let {
    options = []
  } = _ref108;
  if (isArrayOfItemGroups(options)) {
    return /* @__PURE__ */jsx$1(Fragment, {
      children: options.map(optionGroup => {
        var _a;
        return /* @__PURE__ */jsxs($d08ef79370b62062$export$eb2fcfdbd7ba97d4, {
          children: [/* @__PURE__ */jsx$1(StyledDropdownGroupLabel, {
            children: (_a = optionGroup == null ? void 0 : optionGroup.label) == null ? void 0 : _a.toUpperCase()
          }), /* @__PURE__ */jsx$1(StyledDropdownGroupSeparator, {}), /* @__PURE__ */jsx$1(DropdownMenuOptionList, {
            options: optionGroup.options
          })]
        }, optionGroup.label);
      })
    });
  }
  return /* @__PURE__ */jsx$1(DropdownMenuOptionList, {
    options
  });
};
const DropdownMenuOptionList = _ref109 => {
  let {
    options
  } = _ref109;
  return /* @__PURE__ */jsx$1(Fragment, {
    children: options.map(option => /* @__PURE__ */jsxs(StyledDropdownMenuItem, {
      onSelect: option.action,
      disabled: option.disabled,
      textColor: option.textColor,
      children: [option.name, option.description && /* @__PURE__ */jsx$1(StyledDropdownItemDescriptionText, {
        variant: "metadata",
        children: option.description
      })]
    }, `dropdown-item-${option.name.toLowerCase()}`))
  });
};
const DropdownMenuContent = forwardRef((_ref110, forwardedRef) => {
  let {
    options = [],
    align = "end"
  } = _ref110;
  return /* @__PURE__ */jsx$1($d08ef79370b62062$export$602eac185826482c, {
    children: /* @__PURE__ */jsx$1(StyledDropdownMenuContentContainer, {
      ref: forwardedRef,
      align,
      avoidCollisions: false,
      children: /* @__PURE__ */jsx$1(DropdownMenuOptionFactory, {
        options
      })
    })
  });
});
DropdownMenuContent.displayName = "DropdownMenuContent";
const DropdownMenu = {
  Root: $d08ef79370b62062$export$be92b6f5f03c0fe9,
  Content: DropdownMenuContent,
  Trigger: $d08ef79370b62062$export$41fb9f06171c75f4
};
var faChevronDown$1 = {};
Object.defineProperty(faChevronDown$1, "__esModule", {
  value: true
});
var faChevronDown_2 = faChevronDown$1.faChevronDown = void 0;
const faChevronDown = {
  prefix: "fal",
  iconName: "faChevronDown",
  icon: [448, 512, [], "", "M4.251 181.1C7.392 177.7 11.69 175.1 16 175.1c3.891 0 7.781 1.406 10.86 4.25l197.1 181.1l197.1-181.1c6.5-6 16.64-5.625 22.61 .9062c6 6.5 5.594 16.59-.8906 22.59l-208 192c-6.156 5.688-15.56 5.688-21.72 0l-208-192C-1.343 197.7-1.749 187.6 4.251 181.1z"]
};
faChevronDown_2 = faChevronDown$1.faChevronDown = faChevronDown;
const MenuButton = forwardRef((_ref111, forwardedRef) => {
  let {
    align = "end",
    buttonText,
    loading = false,
    disabled: disabled2 = false,
    options = [],
    rootProps
  } = _ref111;
  return /* @__PURE__ */jsxs(DropdownMenu.Root, {
    children: [/* @__PURE__ */jsx$1(DropdownMenu.Trigger, {
      disabled: disabled2 || loading,
      asChild: true,
      children: /* @__PURE__ */jsxs(Button, {
        loading,
        disabled: disabled2,
        variant: "primary",
        rootProps,
        children: [buttonText, /* @__PURE__ */jsx$1(Button.Icon, {
          icon: faChevronDown_2
        })]
      })
    }), /* @__PURE__ */jsx$1(DropdownMenu.Content, {
      ref: forwardedRef,
      options,
      align
    })]
  });
});
MenuButton.displayName = "MenuButton";
var faEllipsis$1 = {};
Object.defineProperty(faEllipsis$1, "__esModule", {
  value: true
});
var faEllipsis_2 = faEllipsis$1.faEllipsis = void 0;
const faEllipsis = {
  prefix: "fal",
  iconName: "faEllipsis",
  icon: [512, 512, [], "", "M256 224C238.3 224 224 238.3 224 256c0 17.67 14.33 32 32 32s32-14.33 32-32C288 238.3 273.7 224 256 224zM96 224C78.33 224 64 238.3 64 256c0 17.67 14.33 32 32 32s32-14.33 32-32C128 238.3 113.7 224 96 224zM416 224c-17.67 0-32 14.33-32 32c0 17.67 14.33 32 32 32s32-14.33 32-32C448 238.3 433.7 224 416 224z"]
};
faEllipsis_2 = faEllipsis$1.faEllipsis = faEllipsis;
var faGear$1 = {};
Object.defineProperty(faGear$1, "__esModule", {
  value: true
});
var faGear_2 = faGear$1.faGear = void 0;
const faGear = {
  prefix: "fal",
  iconName: "faGear",
  icon: [512, 512, [], "", "M255.1 512c-56.05 0-75.99-11.33-75.99-35.94V436.5c-15.17-6.375-29.35-14.53-42.36-24.41l-34.3 19.78c-4.621 2.703-9.976 4.013-15.36 4.013c-36.71 0-76.25-92.87-76.25-108.6c0-10.85 5.806-21.34 15.71-27.07l34.17-19.72C60.52 272.1 59.99 264 59.99 255.1s.5313-16.13 1.625-24.47L27.42 211.8C17.53 206.1 11.73 195.6 11.73 184.7c0-12.58 37.98-108.7 76.2-108.7c5.417 0 10.82 1.338 15.52 4.111L137.6 99.88C150.6 90.01 164.8 81.85 179.1 75.47V35.91C179.1 4.335 215.7 0 256 0c39.71 0 75.1 4.083 75.1 35.91v39.56c15.17 6.375 29.35 14.53 42.36 24.41l34.3-19.78c4.621-2.703 9.981-4.013 15.37-4.013c36.47 0 76.24 92.55 76.24 108.6c0 10.85-5.806 21.34-15.71 27.07l-34.17 19.72c1.094 8.344 1.625 16.44 1.625 24.47s-.5313 16.13-1.625 24.47l34.19 19.75c9.895 5.703 15.7 16.19 15.7 27.05c0 12.59-37.98 108.7-76.21 108.7c-5.42 0-10.83-1.338-15.51-4.111l-34.19-19.72c-13.02 9.876-27.19 18.03-42.36 24.41v39.56C332 500.6 312.1 512 255.1 512zM140.9 373.2c35.92 30.82 52.34 34.36 71.05 41v61.85c14.11 2.344 28.82 3.727 43.76 3.727c14.95 0 30.13-1.383 45.19-4.571l-.9532-61c16.07-5.702 35.18-10.22 71.05-41l53.61 30.97c18.78-22.06 33.77-47.97 43.39-76.57l-52.94-30.56c2.745-14.99 4.859-25.43 4.859-39.07c0-10.95-1.364-23.97-4.859-43.06l53.46-30.85c-9.829-27.75-24.92-53.97-45.1-76.72l-52.43 31.41c-35.92-30.82-52.34-34.36-71.05-41V35.91c-14.11-2.344-28.82-3.727-43.76-3.727c-14.95 0-30.13 1.383-45.19 4.571l.9532 61C195.9 103.5 176.8 107.1 140.9 138.8L87.33 107.8c-18.99 22.31-34.08 48.53-43.69 77.47l53.24 29.66C94.14 229.9 92.02 240.4 92.02 253.1c0 10.95 1.364 23.97 4.859 43.06l-53.46 30.85c9.829 27.75 24.92 53.97 45.1 76.72L140.9 373.2zM256 351.1c-52.94 0-96-43.06-96-96S203.1 159.1 256 159.1s96 43.06 96 96S308.9 351.1 256 351.1zM256 191.1c-35.3 0-64 28.72-64 64S220.7 319.1 256 319.1s64-28.72 64-64S291.3 191.1 256 191.1z"]
};
faGear_2 = faGear$1.faGear = faGear;
const IconMenuVariantMap = {
  settings: faGear_2,
  chevron: faChevronDown_2,
  spillover: faEllipsis_2
};
const IconMenuButton = forwardRef((_ref112, forwardedRef) => {
  let {
    disabled: disabled2 = false,
    options = [],
    iconVariant,
    title,
    rootProps
  } = _ref112;
  return /* @__PURE__ */jsxs(DropdownMenu.Root, {
    children: [/* @__PURE__ */jsx$1(DropdownMenu.Trigger, {
      disabled: disabled2,
      asChild: true,
      children: /* @__PURE__ */jsx$1(IconButton, {
        title,
        disabled: disabled2,
        icon: IconMenuVariantMap[iconVariant],
        rootProps
      })
    }), /* @__PURE__ */jsx$1(DropdownMenu.Content, {
      ref: forwardedRef,
      options,
      align: "end"
    })]
  });
});
IconMenuButton.displayName = "IconMenuButton";
var IconMenuButtonIconVariantEnum = /* @__PURE__ */(IconMenuButtonIconVariantEnum2 => {
  IconMenuButtonIconVariantEnum2["SETTINGS"] = "settings";
  IconMenuButtonIconVariantEnum2["CHEVRON"] = "chevron";
  IconMenuButtonIconVariantEnum2["SPILLOVER"] = "spillover";
  return IconMenuButtonIconVariantEnum2;
})(IconMenuButtonIconVariantEnum || {});
const SplitButtonGroupStyles = {
  gap: "1px"
};
const SplitButtonLeft = styled(Button, {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0
});
const SplitButtonIconStyles = {
  backgroundColor: "$blue8",
  borderTopRightRadius: "$1",
  borderBottomRightRadius: "$1",
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  "&:hover": {
    backgroundColor: "$blue9",
    borderColor: "$blue9"
  },
  "&:active": {
    backgroundColor: "$blue10",
    borderColor: "$blue10"
  },
  "&:disabled": {
    backgroundColor: "$gray3",
    borderColor: "$gray3",
    cursor: "not-allowed"
  },
  "> svg": {
    color: "$white"
  }
};
const SplitMenuButton = forwardRef((_ref113, forwardedRef) => {
  let {
    loading = false,
    disabled: disabled2 = false,
    options = [],
    onButtonClick,
    buttonText,
    rootProps
  } = _ref113;
  return /* @__PURE__ */jsxs(ButtonGroup, {
    css: SplitButtonGroupStyles,
    rootProps,
    children: [/* @__PURE__ */jsx$1(SplitButtonLeft, {
      loading,
      disabled: disabled2,
      variant: "primary",
      onClick: onButtonClick,
      children: buttonText
    }), /* @__PURE__ */jsxs(DropdownMenu.Root, {
      children: [/* @__PURE__ */jsx$1(DropdownMenu.Trigger, {
        disabled: disabled2 || loading,
        asChild: true,
        children: /* @__PURE__ */jsx$1(IconButton, {
          title: "activate to show additional options",
          hideTooltip: true,
          disabled: disabled2 || loading,
          icon: faChevronDown_2,
          iconVariant: "light",
          css: SplitButtonIconStyles
        })
      }), /* @__PURE__ */jsx$1(DropdownMenu.Content, {
        ref: forwardedRef,
        options,
        align: "end"
      })]
    })]
  });
});
SplitMenuButton.displayName = "SplitMenuButton";
const $69cb30bb0017df05$var$TABS_NAME = "Tabs";
const [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($69cb30bb0017df05$var$TABS_NAME, [$d7bdfb9eb0fdf311$export$c7109489551a4f4]);
const $69cb30bb0017df05$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
const [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
const $69cb30bb0017df05$export$b2539bed5023c21c = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTabs,
    value: valueProp,
    onValueChange,
    defaultValue,
    orientation = "horizontal",
    dir,
    activationMode = "automatic",
    ...tabsProps
  } = props;
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    onChange: onValueChange,
    defaultProp: defaultValue
  });
  return /* @__PURE__ */createElement$1($69cb30bb0017df05$var$TabsProvider, {
    scope: __scopeTabs,
    baseId: $1746a345f3d73bb7$export$f680877a34711e37(),
    value,
    onValueChange: setValue,
    orientation,
    dir: direction,
    activationMode
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    dir: direction,
    "data-orientation": orientation
  }, tabsProps, {
    ref: forwardedRef
  })));
});
const $69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
const $69cb30bb0017df05$export$9712d22edc0d78c1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTabs,
    loop = true,
    ...listProps
  } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: context.orientation,
    dir: context.dir,
    loop
  }), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
    role: "tablist",
    "aria-orientation": context.orientation
  }, listProps, {
    ref: forwardedRef
  })));
});
const $69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
const $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTabs,
    value,
    disabled: disabled2 = false,
    ...triggerProps
  } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  return /* @__PURE__ */createElement$1($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends$1({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2,
    active: isSelected
  }), /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.button, _extends$1({
    type: "button",
    role: "tab",
    "aria-selected": isSelected,
    "aria-controls": contentId,
    "data-state": isSelected ? "active" : "inactive",
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    id: triggerId
  }, triggerProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onMouseDown, event => {
      if (!disabled2 && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);else event.preventDefault();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, event => {
      if ([" ", "Enter"].includes(event.key)) context.onValueChange(value);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocus, () => {
      const isAutomaticActivation = context.activationMode !== "manual";
      if (!isSelected && !disabled2 && isAutomaticActivation) context.onValueChange(value);
    })
  })));
});
const $69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
const $69cb30bb0017df05$export$bd905d70e8fd2ebb = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeTabs,
    value,
    forceMount,
    children,
    ...contentProps
  } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  const isMountAnimationPreventedRef = useRef(isSelected);
  useEffect(() => {
    const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
    return () => cancelAnimationFrame(rAF);
  }, []);
  return /* @__PURE__ */createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
    present: forceMount || isSelected
  }, _ref114 => {
    let {
      present
    } = _ref114;
    return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$4.div, _extends$1({
      "data-state": isSelected ? "active" : "inactive",
      "data-orientation": context.orientation,
      role: "tabpanel",
      "aria-labelledby": triggerId,
      hidden: !present,
      id: contentId,
      tabIndex: 0
    }, contentProps, {
      ref: forwardedRef,
      style: {
        ...props.style,
        animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
      }
    }), present && children);
  });
});
function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
const $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
const $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
const $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
const $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;
const TabContentScrollVariant = {
  true: {
    overflow: "scroll"
  }
};
const StyledTabsRoot = styled($69cb30bb0017df05$export$be92b6f5f03c0fe9, {
  height: "100%",
  width: "100%"
});
const StyledTabsList = styled($69cb30bb0017df05$export$54c2e3dc7acea9f5, {
  width: "100%",
  borderBottom: "1px solid $gray3",
  display: "flex",
  gap: "$3",
  marginBottom: "$3"
});
const StyledTabsTrigger = styled($69cb30bb0017df05$export$41fb9f06171c75f4, {
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "$half",
  paddingBottom: "6px",
  background: "$white",
  textStyles: "h3",
  boxSizing: "border-box",
  color: "$gray8",
  fontFamily: "$primary",
  marginBottom: "-1px",
  paddingX: "$half",
  border: "none",
  backgroundColor: "transparent",
  outline: 0,
  cursor: "pointer",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  "&:hover": {
    color: "$gray9",
    position: "relative",
    borderBottom: "none",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "2px",
      background: "$gray9"
    }
  },
  [`&[data-state="active"]`]: {
    boxShadow: "none",
    color: "$gray12",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "2px",
      background: "$gray12"
    }
  }
});
const StyledTabsContent = styled($69cb30bb0017df05$export$7c6e2c02157bb7d2, {
  display: "flex",
  flexDirection: "column",
  gap: "$2",
  height: "100%",
  "&[hidden]": {
    height: 0
  },
  variants: {
    scrollOnContent: TabContentScrollVariant
  }
});
const StyledTabs = {
  Root: StyledTabsRoot,
  List: StyledTabsList,
  Trigger: StyledTabsTrigger,
  Content: StyledTabsContent
};
const TabTrigger = _ref115 => {
  let {
    badge,
    children,
    ...props
  } = _ref115;
  return /* @__PURE__ */jsx$1(StyledTabs.Trigger, {
    ...props,
    children: /* @__PURE__ */jsxs(Fragment, {
      children: [children, badge]
    })
  });
};
const TabParts = {
  Root: StyledTabs.Root,
  List: StyledTabs.List,
  Trigger: TabTrigger,
  Content: StyledTabs.Content
};
const Tabs = _ref116 => {
  let {
    options,
    defaultValue = options[0].value,
    value,
    onValueChange,
    scrollOnContent,
    tabListProps,
    ...rest
  } = _ref116;
  return /* @__PURE__ */jsxs(TabParts.Root, {
    defaultValue,
    value,
    onValueChange,
    ...rest,
    children: [/* @__PURE__ */jsx$1(TabParts.List, {
      ...tabListProps,
      children: options.map(tab => /* @__PURE__ */jsx$1(TabParts.Trigger, {
        value: tab.value,
        children: /* @__PURE__ */jsxs(Fragment, {
          children: [tab.label, tab.badge]
        })
      }, tab.value))
    }), options.map(tab => /* @__PURE__ */jsx$1(TabParts.Content, {
      value: tab.value,
      scrollOnContent,
      children: tab.content
    }, tab.value))]
  });
};
const ListContainer = styled("ul", {
  listStyle: "none",
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  boxShadow: "$raised08",
  borderRadius: "$1",
  zIndex: "$drawer"
});
const List = forwardRef((_ref117, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref117;
  return /* @__PURE__ */jsx$1(ListContainer, {
    ref: forwardedRef,
    ...props,
    children
  });
});
List.displayName = "List";
const DDSPrefix = "dds--";
const useInputLabels = (label, name) => {
  return useMemo(() => {
    const hyphenLabel = toHyphenCase(label);
    const elementId = `${DDSPrefix}${name}-${label}`;
    const descriptionElementId = `${DDSPrefix}${name}-description-${hyphenLabel}`;
    const errorMessageElementId = `${DDSPrefix}${name}-error-message-${hyphenLabel}`;
    const successMessageElementId = `${DDSPrefix}${name}-success-message-${hyphenLabel}`;
    return {
      elementId,
      descriptionElementId,
      successMessageElementId,
      errorMessageElementId
    };
  }, [label, name]);
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys4 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2) return;
  if (typeof o2 === "string") return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor) n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o2, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$5 = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue,
    defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu,
    _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen,
    defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
    _ref$defaultValue = _ref3.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
    propsInputValue = _ref3.inputValue,
    propsMenuIsOpen = _ref3.menuIsOpen,
    propsOnChange = _ref3.onChange,
    propsOnInputChange = _ref3.onInputChange,
    propsOnMenuClose = _ref3.onMenuClose,
    propsOnMenuOpen = _ref3.onMenuOpen,
    propsValue = _ref3.value,
    restSelectProps = _objectWithoutProperties(_ref3, _excluded$5);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateInputValue = _useState2[0],
    setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen),
    _useState4 = _slicedToArray(_useState3, 2),
    stateMenuIsOpen = _useState4[0],
    setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    stateValue = _useState6[0],
    setStateValue = _useState6[1];
  var onChange3 = useCallback(function (value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange3,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e2) {
    return false;
  }
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (obj2) {
    return typeof obj2;
  } : function (obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */function () {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function (tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace2(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin3, end3) {
  return value.slice(begin3, end3);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append2(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type3, props, children, length2) {
  return {
    value,
    root,
    parent,
    type: type3,
    props,
    children,
    line,
    column,
    length: length2,
    return: ""
  };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, {
    length: -root.length
  }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10) column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10) column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice2(begin3, end3) {
  return substr(characters, begin3, end3);
}
function token(type3) {
  switch (type3) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type3) {
  return trim(slice2(position - 1, delimiter(type3 === 91 ? type3 + 2 : type3 === 40 ? type3 + 1 : type3)));
}
function whitespace(type3) {
  while (character = peek()) if (character < 33) next();else break;
  return token(type3) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count2) {
  while (--count2 && next()) if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97) break;
  return slice2(index2, caret() + (count2 < 6 && peek() == 32 && next() == 32));
}
function delimiter(type3) {
  while (next()) switch (character) {
    case type3:
      return position;
    case 34:
    case 39:
      if (type3 !== 34 && type3 !== 39) delimiter(character);
      break;
    case 40:
      if (type3 === 41) delimiter(type3);
      break;
    case 92:
      next();
      break;
  }
  return position;
}
function commenter(type3, index2) {
  while (next()) if (type3 + character === 47 + 10) break;else if (type3 + character === 42 + 42 && peek() === 47) break;
  return "/*" + slice2(index2, position - 1) + "*" + from(type3 === 47 ? type3 : next());
}
function identifier(index2) {
  while (!token(peek())) next();
  return slice2(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type3 = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type3;
  while (scanning) switch (previous = character2, character2 = next()) {
    case 40:
      if (previous != 108 && characters2.charCodeAt(length2 - 1) == 58) {
        if (indexof(characters2 += replace2(delimit(character2), "&", "&\f"), "&\f") != -1) ampersand = -1;
        break;
      }
    case 34:
    case 39:
    case 91:
      characters2 += delimit(character2);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      characters2 += whitespace(previous);
      break;
    case 92:
      characters2 += escaping(caret() - 1, 7);
      continue;
    case 47:
      switch (peek()) {
        case 42:
        case 47:
          append2(comment(commenter(next(), caret()), root, parent), declarations);
          break;
        default:
          characters2 += "/";
      }
      break;
    case 123 * variable:
      points[index2++] = strlen(characters2) * ampersand;
    case 125 * variable:
    case 59:
    case 0:
      switch (character2) {
        case 0:
        case 125:
          scanning = 0;
        case 59 + offset2:
          if (property > 0 && strlen(characters2) - length2) append2(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace2(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
          break;
        case 59:
          characters2 += ";";
        default:
          append2(reference = ruleset(characters2, root, parent, index2, offset2, rules, points, type3, props = [], children = [], length2), rulesets);
          if (character2 === 123) if (offset2 === 0) parse(characters2, root, reference, reference, props, rulesets, length2, points, children);else switch (atrule) {
            case 100:
            case 109:
            case 115:
              parse(value, reference, reference, rule && append2(ruleset(value, reference, reference, 0, 0, rules, points, type3, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
              break;
            default:
              parse(characters2, reference, reference, reference, [""], children, 0, points, children);
          }
      }
      index2 = offset2 = property = 0, variable = ampersand = 1, type3 = characters2 = "", length2 = pseudo;
      break;
    case 58:
      length2 = 1 + strlen(characters2), property = previous;
    default:
      if (variable < 1) {
        if (character2 == 123) --variable;else if (character2 == 125 && variable++ == 0 && prev() == 125) continue;
      }
      switch (characters2 += from(character2), character2 * variable) {
        case 38:
          ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
          break;
        case 44:
          points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
          break;
        case 64:
          if (peek() === 45) characters2 += delimit(next());
          atrule = peek(), offset2 = length2 = strlen(type3 = characters2 += identifier(caret())), character2++;
          break;
        case 45:
          if (previous === 45 && strlen(characters2) == 2) variable = 0;
      }
  }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset2, rules, points, type3, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index2; ++i) for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size; ++x2) if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace2(y2, /&\f/g, rule[x2]))) props[k2++] = z2;
  return node(value, root, parent, offset2 === 0 ? RULESET : type3, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace2(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace2(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace2(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace2(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace2(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace2(value, "-grow", "") + WEBKIT + value + MS + replace2(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace2(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace2(replace2(replace2(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace2(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace2(replace2(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace2(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6) switch (charat(value, length2 + 1)) {
        case 109:
          if (charat(value, length2 + 4) !== 45) break;
        case 102:
          return replace2(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
        case 115:
          return ~indexof(value, "stretch") ? prefix(replace2(value, "stretch", "fill-available"), length2) + value : value;
      }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115) break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace2(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace2(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace2(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace2(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace2(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++) output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function (element, index2, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++) output += collection[i](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function (element) {
    if (!element.root) {
      if (element = element.return) callback(element);
    }
  };
}
function prefixer(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element.return) switch (element.type) {
      case DECLARATION:
        element.return = prefix(element.value, element.length);
        break;
      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace2(element.value, "@", "@" + WEBKIT)
        })], callback);
      case RULESET:
        if (element.length) return combine(element.props, function (value) {
          switch (match(value, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return serialize([copy(element, {
                props: [replace2(value, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], callback);
            case "::placeholder":
              return serialize([copy(element, {
                props: [replace2(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(element, {
                props: [replace2(value, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(element, {
                props: [replace2(value, /:(plac\w+)/, MS + "input-$1")]
              })], callback);
          }
          return "";
        });
    }
  }
}
function memoize(fn) {
  var cache = /* @__PURE__ */Object.create(null);
  return function (arg) {
    if (cache[arg] === void 0) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin3, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice2(begin3, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value,
    parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent) return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function (node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function (node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");
      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }
      nodesToHydrate.push(node2);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = typeof Symbol === "function" && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w$1 = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a2) {
  if (typeof a2 === "object" && a2 !== null) {
    var u2 = a2.$$typeof;
    switch (u2) {
      case c:
        switch (a2 = a2.type, a2) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a2;
          default:
            switch (a2 = a2 && a2.$$typeof, a2) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a2;
              default:
                return u2;
            }
        }
      case d:
        return u2;
    }
  }
}
function A(a2) {
  return z(a2) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function (a2) {
  return A(a2) || z(a2) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function (a2) {
  return z(a2) === k;
};
reactIs_production_min.isContextProvider = function (a2) {
  return z(a2) === h;
};
reactIs_production_min.isElement = function (a2) {
  return typeof a2 === "object" && a2 !== null && a2.$$typeof === c;
};
reactIs_production_min.isForwardRef = function (a2) {
  return z(a2) === n;
};
reactIs_production_min.isFragment = function (a2) {
  return z(a2) === e;
};
reactIs_production_min.isLazy = function (a2) {
  return z(a2) === t;
};
reactIs_production_min.isMemo = function (a2) {
  return z(a2) === r;
};
reactIs_production_min.isPortal = function (a2) {
  return z(a2) === d;
};
reactIs_production_min.isProfiler = function (a2) {
  return z(a2) === g;
};
reactIs_production_min.isStrictMode = function (a2) {
  return z(a2) === f;
};
reactIs_production_min.isSuspense = function (a2) {
  return z(a2) === p;
};
reactIs_production_min.isValidElementType = function (a2) {
  return typeof a2 === "string" || typeof a2 === "function" || a2 === e || a2 === m || a2 === g || a2 === f || a2 === p || a2 === q || typeof a2 === "object" && a2 !== null && (a2.$$typeof === t || a2.$$typeof === r || a2.$$typeof === h || a2.$$typeof === k || a2.$$typeof === n || a2.$$typeof === w$1 || a2.$$typeof === x || a2.$$typeof === y || a2.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function (className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName":
      {
        if (typeof value === "string") {
          return value.replace(animationRegex, function (match2, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean":
      {
        return "";
      }
    case "object":
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== void 0) {
          var next2 = interpolation.next;
          if (next2 !== void 0) {
            while (next2 !== void 0) {
              cursor = {
                name: next2.name,
                styles: next2.styles,
                next: cursor
              };
              next2 = next2.next;
            }
          }
          var styles2 = interpolation.styles + ";";
          return styles2;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case "function":
      {
        if (mergedProps !== void 0) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }
        break;
      }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName":
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles2 += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      styles2 += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect = React["useInsertionEffect"] ? React["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var hasOwnProperty = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */createContext$1(typeof HTMLElement !== "undefined" ? /* @__PURE__ */createCache({
  key: "css"
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */forwardRef(function (props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */createContext$1({});
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type3, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type3;
  return newProps;
};
var Insertion$1 = function Insertion(_ref3) {
  var cache = _ref3.cache,
    serialized = _ref3.serialized,
    isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1(Insertion$1, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */createElement$1(WrappedComponent, newProps));
});
var jsx = function jsx2(type3, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, "css")) {
    return createElement$1.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type3, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return createElement$1.apply(null, createElementArgArray);
};
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString3() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames2(args) {
  var len = args.length;
  var i = 0;
  var cls = "";
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object":
        {
          if (Array.isArray(arg)) {
            toAdd = classnames2(arg);
          } else {
            toAdd = "";
            for (var k2 in arg) {
              if (arg[k2] && k2) {
                toAdd && (toAdd += " ");
                toAdd += k2;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css4, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css4(registeredStyles);
}
var Insertion2 = function Insertion3(_ref3) {
  var cache = _ref3.cache,
    serializedArr = _ref3.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {
    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];
  var css4 = function css5() {
    if (hasRendered && false) {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized);
    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && false) {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge(cache.registered, css4, classnames(args));
  };
  var content = {
    css: css4,
    cx,
    theme: useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1(Insertion2, {
    cache,
    serializedArr
  }), ele);
});
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function isWindow(value) {
  return value && value.document && value.location && value.alert && value.setInterval;
}
function getWindow(node2) {
  if (node2 == null) {
    return window;
  }
  if (!isWindow(node2)) {
    const ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeName(node2) {
  return isWindow(node2) ? "" : node2 ? (node2.nodeName || "").toLowerCase() : "";
}
function getUAString() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(item => item.brand + "/" + item.version).join(" ");
  }
  return navigator.userAgent;
}
function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
const round = Math.round;
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  let scaleX = 1;
  let scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  const win = isElement(element) ? getWindow(element) : window;
  const addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  const x2 = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scaleX;
  const y2 = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scaleY;
  const width = clientRect.width / scaleX;
  const height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getDocumentElement(node2) {
  return ((isNode(node2) ? node2.ownerDocument : node2.document) || window.document).documentElement;
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  return node2.assignedSlot || node2.parentNode || (isShadowRoot(node2) ? node2.host : null) || getDocumentElement(node2);
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (["html", "body", "#document"].includes(getNodeName(parentNode))) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  const target = isBody ? [win].concat(win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []) : scrollableAncestor;
  const updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(getOverflowAncestors(target));
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll: _ancestorScroll = true,
    ancestorResize: _ancestorResize = true,
    elementResize = true,
    animationFrame = false
  } = options;
  const ancestorScroll = _ancestorScroll && !animationFrame;
  const ancestorResize = _ancestorResize && !animationFrame;
  const ancestors = ancestorScroll || ancestorResize ? [...(isElement(reference) ? getOverflowAncestors(reference) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  let observer = null;
  if (elementResize) {
    let initialUpdate = true;
    observer = new ResizeObserver(() => {
      if (!initialUpdate) {
        update();
      }
      initialUpdate = false;
    });
    isElement(reference) && !animationFrame && observer.observe(reference);
    observer.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _observer;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    (_observer = observer) == null ? void 0 : _observer.disconnect();
    observer = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var index = useLayoutEffect$1;
var _excluded$3 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop4 = function noop5() {};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state, className) {
  var arr = [className];
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === "object" && value !== null) return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties(props, _excluded$3);
  return _objectSpread2({}, innerProps);
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }
  el.scrollTop = top;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed") return document.documentElement;
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop4;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options$1 = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop4, options$1);
  w.removeEventListener("p", noop4, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
  return item != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }
  var propsMap = Object.entries(propsObj).filter(function (_ref3) {
    var _ref22 = _slicedToArray(_ref3, 1),
      key = _ref22[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function (newProps, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight,
    menuEl = _ref3.menuEl,
    minHeight = _ref3.minHeight,
    preferredPlacement = _ref3.placement,
    shouldScroll = _ref3.shouldScroll,
    isFixedPosition = _ref3.isFixedPosition,
    controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent) return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
    scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
    menuBottom = _menuEl$getBoundingCl.bottom,
    menuHeight = _menuEl$getBoundingCl.height,
    menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
    containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22) {
  var _ref3;
  var placement = _ref22.placement,
    _ref2$theme = _ref22.theme,
    borderRadius2 = _ref2$theme.borderRadius,
    spacing2 = _ref2$theme.spacing,
    colors2 = _ref2$theme.colors;
  return _ref3 = {
    label: "menu"
  }, _defineProperty(_ref3, alignToControl(placement), "100%"), _defineProperty(_ref3, "backgroundColor", colors2.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius2), _defineProperty(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), _defineProperty(_ref3, "marginBottom", spacing2.menuGutter), _defineProperty(_ref3, "marginTop", spacing2.menuGutter), _defineProperty(_ref3, "position", "absolute"), _defineProperty(_ref3, "width", "100%"), _defineProperty(_ref3, "zIndex", 1), _ref3;
};
var PortalPlacementContext = /* @__PURE__ */createContext$1(null);
var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children,
    minMenuHeight = props.minMenuHeight,
    maxMenuHeight = props.maxMenuHeight,
    menuPlacement = props.menuPlacement,
    menuPosition = props.menuPosition,
    menuShouldScrollIntoView = props.menuShouldScrollIntoView,
    theme2 = props.theme;
  var _ref4 = useContext(PortalPlacementContext) || {},
    setPortalPlacement = _ref4.setPortalPlacement;
  var ref = useRef(null);
  var _useState = useState(maxMenuHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    placement = _useState4[0],
    setPlacement = _useState4[1];
  var controlHeight2 = theme2.spacing.controlHeight;
  index(function () {
    var menuEl = ref.current;
    if (!menuEl) return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll,
      isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight
    })
  });
};
var Menu = function Menu2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("menu", props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var menuListCSS = function menuListCSS2(_ref5) {
  var maxHeight = _ref5.maxHeight,
    baseUnit2 = _ref5.theme.spacing.baseUnit;
  return {
    maxHeight,
    overflowY: "auto",
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2,
    position: "relative",
    WebkitOverflowScrolling: "touch"
  };
};
var MenuList = function MenuList2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    isMulti = props.isMulti;
  return jsx("div", _extends({
    css: getStyles2("menuList", props),
    className: cx({
      "menu-list": true,
      "menu-list--is-multi": isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref6) {
  var _ref6$theme = _ref6.theme,
    baseUnit2 = _ref6$theme.spacing.baseUnit,
    colors2 = _ref6$theme.colors;
  return {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px"),
    textAlign: "center"
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("noOptionsMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--no-options": true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("loadingMessage", props),
    className: cx({
      "menu-notice": true,
      "menu-notice--loading": true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref7) {
  var rect = _ref7.rect,
    offset2 = _ref7.offset,
    position2 = _ref7.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal2(_ref8) {
  var appendTo = _ref8.appendTo,
    children = _ref8.children,
    className = _ref8.className,
    controlElement = _ref8.controlElement,
    cx = _ref8.cx,
    innerProps = _ref8.innerProps,
    menuPlacement = _ref8.menuPlacement,
    menuPosition = _ref8.menuPosition,
    getStyles2 = _ref8.getStyles;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)),
    _useState6 = _slicedToArray(_useState5, 2),
    placement = _useState6[0],
    setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function () {
    return {
      setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    computedPosition = _useState8[0],
    setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function () {
    if (!controlElement) return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset2 = rect[placement] + scrollDistance;
    if (offset2 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset2,
        rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index(function () {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function () {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index(function () {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function (menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
  var menuWrapper = jsx("div", _extends({
    ref: setMenuPortalElement,
    css: getStyles2("menuPortal", {
      offset: computedPosition.offset,
      position: menuPosition,
      rect: computedPosition.rect
    }),
    className: cx({
      "menu-portal": true
    }, className)
  }, innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /* @__PURE__ */createPortal(menuWrapper, appendTo) : menuWrapper);
};
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled,
    isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles2("container", props),
    className: cx({
      "--is-disabled": isDisabled,
      "--is-rtl": isRtl
    }, className)
  }, innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing,
    isMulti = _ref22.isMulti,
    hasValue = _ref22.hasValue,
    controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return {
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px"),
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  };
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    getStyles2 = props.getStyles,
    hasValue = props.hasValue;
  return jsx("div", _extends({
    css: getStyles2("valueContainer", props),
    className: cx({
      "value-container": true,
      "value-container--is-multi": isMulti,
      "value-container--has-value": hasValue
    }, className)
  }, innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    innerProps = props.innerProps,
    getStyles2 = props.getStyles;
  return jsx("div", _extends({
    css: getStyles2("indicatorsContainer", props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};
var _templateObject;
var _excluded$2 = ["size"];
var _ref2$2 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size,
    props = _objectWithoutProperties(_ref3, _excluded$2);
  return jsx("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3) {
  var isFocused = _ref3.isFocused,
    _ref3$theme = _ref3.theme,
    baseUnit2 = _ref3$theme.spacing.baseUnit,
    colors2 = _ref3$theme.colors;
  return {
    label: "indicatorContainer",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  };
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("dropdownIndicator", props),
    className: cx({
      indicator: true,
      "dropdown-indicator": true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("clearIndicator", props),
    className: cx({
      indicator: true,
      "clear-indicator": true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4) {
  var isDisabled = _ref4.isDisabled,
    _ref4$theme = _ref4.theme,
    baseUnit2 = _ref4$theme.spacing.baseUnit,
    colors2 = _ref4$theme.colors;
  return {
    label: "indicatorSeparator",
    alignSelf: "stretch",
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("span", _extends({}, innerProps, {
    css: getStyles2("indicatorSeparator", props),
    className: cx({
      "indicator-separator": true
    }, className)
  }));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5) {
  var isFocused = _ref5.isFocused,
    size = _ref5.size,
    _ref5$theme = _ref5.theme,
    colors2 = _ref5$theme.colors,
    baseUnit2 = _ref5$theme.spacing.baseUnit;
  return {
    label: "loadingIndicator",
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    display: "flex",
    padding: baseUnit2 * 2,
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  };
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay2 = _ref6.delay,
    offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay2, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps,
    isRtl = props.isRtl;
  return jsx("div", _extends({
    css: getStyles2("loadingIndicator", props),
    className: cx({
      indicator: true,
      "loading-indicator": true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref3) {
  var isDisabled = _ref3.isDisabled,
    isFocused = _ref3.isFocused,
    _ref$theme = _ref3.theme,
    colors2 = _ref$theme.colors,
    borderRadius2 = _ref$theme.borderRadius,
    spacing2 = _ref$theme.spacing;
  return {
    label: "control",
    alignItems: "center",
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms",
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  };
};
var Control = function Control2(props) {
  var children = props.children,
    cx = props.cx,
    getStyles2 = props.getStyles,
    className = props.className,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    innerRef = props.innerRef,
    innerProps = props.innerProps,
    menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends({
    ref: innerRef,
    css: getStyles2("control", props),
    className: cx({
      control: true,
      "control--is-disabled": isDisabled,
      "control--is-focused": isFocused,
      "control--menu-is-open": menuIsOpen
    }, className)
  }, innerProps), children);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3) {
  var spacing2 = _ref3.theme.spacing;
  return {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    Heading = props.Heading,
    headingProps = props.headingProps,
    innerProps = props.innerProps,
    label = props.label,
    theme2 = props.theme,
    selectProps = props.selectProps;
  return jsx("div", _extends({
    css: getStyles2("group", props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps,
    theme: theme2,
    getStyles: getStyles2,
    cx
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22) {
  var spacing2 = _ref22.theme.spacing;
  return {
    label: "group",
    color: "#999",
    cursor: "default",
    display: "block",
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  };
};
var GroupHeading = function GroupHeading2(props) {
  var getStyles2 = props.getStyles,
    cx = props.cx,
    className = props.className;
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends({
    css: getStyles2("groupHeading", props),
    className: cx({
      "group-heading": true
    }, className)
  }, innerProps));
};
var _excluded$4 = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled,
    value = _ref3.value,
    _ref$theme = _ref3.theme,
    spacing2 = _ref$theme.spacing,
    colors2 = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    visibility: isDisabled ? "hidden" : "visible",
    color: colors2.neutral80,
    transform: value ? "translateZ(0)" : ""
  }, containerStyle);
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input = function Input2(props) {
  var className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    value = props.value;
  var _cleanCommonProps = cleanCommonProps(props),
    innerRef = _cleanCommonProps.innerRef,
    isDisabled = _cleanCommonProps.isDisabled,
    isHidden = _cleanCommonProps.isHidden,
    inputClassName = _cleanCommonProps.inputClassName,
    innerProps = _objectWithoutProperties(_cleanCommonProps, _excluded$4);
  return jsx("div", {
    className: cx({
      "input-container": true
    }, className),
    css: getStyles2("input", props),
    "data-value": value || ""
  }, jsx("input", _extends({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS2(_ref3) {
  var _ref$theme = _ref3.theme,
    spacing2 = _ref$theme.spacing,
    borderRadius2 = _ref$theme.borderRadius,
    colors2 = _ref$theme.colors;
  return {
    label: "multiValue",
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    display: "flex",
    margin: spacing2.baseUnit / 2,
    minWidth: 0
  };
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22) {
  var _ref2$theme = _ref22.theme,
    borderRadius2 = _ref2$theme.borderRadius,
    colors2 = _ref2$theme.colors,
    cropWithEllipsis = _ref22.cropWithEllipsis;
  return {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    overflow: "hidden",
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3) {
  var _ref3$theme = _ref3.theme,
    spacing2 = _ref3$theme.spacing,
    borderRadius2 = _ref3$theme.borderRadius,
    colors2 = _ref3$theme.colors,
    isFocused = _ref3.isFocused;
  return {
    alignItems: "center",
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    display: "flex",
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
    innerProps = _ref5.innerProps;
  return jsx("div", _extends({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children,
    className = props.className,
    components2 = props.components,
    cx = props.cx,
    data = props.data,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    removeProps3 = props.removeProps,
    selectProps = props.selectProps;
  var Container = components2.Container,
    Label = components2.Label,
    Remove = components2.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css4 = _ref6.css,
      emotionCx = _ref6.cx;
    return jsx(Container, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles2("multiValue", props)), cx({
          "multi-value": true,
          "multi-value--is-disabled": isDisabled
        }, className))
      }, innerProps),
      selectProps
    }, jsx(Label, {
      data,
      innerProps: {
        className: emotionCx(css4(getStyles2("multiValueLabel", props)), cx({
          "multi-value__label": true
        }, className))
      },
      selectProps
    }, children), jsx(Remove, {
      data,
      innerProps: _objectSpread2({
        className: emotionCx(css4(getStyles2("multiValueRemove", props)), cx({
          "multi-value__remove": true
        }, className)),
        "aria-label": "Remove ".concat(children || "option")
      }, removeProps3),
      selectProps
    }));
  });
};
var optionCSS = function optionCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled,
    isFocused = _ref3.isFocused,
    isSelected = _ref3.isSelected,
    _ref$theme = _ref3.theme,
    spacing2 = _ref$theme.spacing,
    colors2 = _ref$theme.colors;
  return {
    label: "option",
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  };
};
var Option = function Option2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    isDisabled = props.isDisabled,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    innerRef = props.innerRef,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("option", props),
    className: cx({
      option: true,
      "option--is-disabled": isDisabled,
      "option--is-focused": isFocused,
      "option--is-selected": isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS2(_ref3) {
  var _ref$theme = _ref3.theme,
    spacing2 = _ref$theme.spacing,
    colors2 = _ref$theme.colors;
  return {
    label: "placeholder",
    color: colors2.neutral50,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  };
};
var Placeholder = function Placeholder2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("placeholder", props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};
var css2 = function css3(_ref3) {
  var isDisabled = _ref3.isDisabled,
    _ref$theme = _ref3.theme,
    spacing2 = _ref$theme.spacing,
    colors2 = _ref$theme.colors;
  return {
    label: "singleValue",
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    gridArea: "1 / 1 / 2 / 3",
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  };
};
var SingleValue = function SingleValue2(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles2 = props.getStyles,
    isDisabled = props.isDisabled,
    innerProps = props.innerProps;
  return jsx("div", _extends({
    css: getStyles2("singleValue", props),
    className: cx({
      "single-value": true,
      "single-value--is-disabled": isDisabled
    }, className)
  }, innerProps), children);
};
var components$1 = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input,
  LoadingIndicator,
  Menu,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components$1), props.components);
};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual(newInputs[i], lastInputs[i])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual2) {
  if (isEqual2 === void 0) {
    isEqual2 = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual2(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
      isMulti = props.isMulti,
      isDisabled = props.isDisabled,
      tabSelectsValue = props.tabSelectsValue,
      context = props.context;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange2(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? "" : _props$label,
      labels = props.labels,
      isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
      focused = props.focused,
      options = props.options,
      _props$label2 = props.label,
      label = _props$label2 === void 0 ? "" : _props$label2,
      selectValue = props.selectValue,
      isDisabled = props.isDisabled,
      isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex2(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu") {
      var disabled2 = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled2);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection,
    focusedOption = props.focusedOption,
    focusedValue = props.focusedValue,
    focusableOptions = props.focusableOptions,
    isFocused = props.isFocused,
    selectValue = props.selectValue,
    selectProps = props.selectProps,
    id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
    getOptionLabel4 = selectProps.getOptionLabel,
    inputValue = selectProps.inputValue,
    isMulti = selectProps.isMulti,
    isOptionDisabled3 = selectProps.isOptionDisabled,
    isSearchable = selectProps.isSearchable,
    menuIsOpen = selectProps.menuIsOpen,
    options = selectProps.options,
    screenReaderStatus2 = selectProps.screenReaderStatus,
    tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function () {
    var message = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
        selectedOptions = ariaSelection.options,
        removedValue = ariaSelection.removedValue,
        removedValues = ariaSelection.removedValues,
        value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel4(selected) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        isDisabled: selected && isOptionDisabled3(selected, selectValue),
        label,
        labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function () {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? "menu" : "value",
        selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue]);
  var ariaResults = useMemo(function () {
    var resultsMsg = "";
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus2]);
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(Fragment$1, null, jsx(A11yText, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function (d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics = function stripDiacritics2(str) {
  return str.replace(anyDiacritic, function (match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config2) {
  return function (option, rawInput) {
    if (option.data.__isNew__) return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: "any"
      }, config2),
      ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
      ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
      stringify2 = _ignoreCase$ignoreAcc.stringify,
      trim2 = _ignoreCase$ignoreAcc.trim,
      matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};
var _excluded$1 = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef,
    props = _objectWithoutProperties(_ref3, _excluded$1);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled,
    onBottomArrive = _ref3.onBottomArrive,
    onBottomLeave = _ref3.onBottomLeave,
    onTopArrive = _ref3.onTopArrive,
    onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
      scrollTop = _scrollTarget$current.scrollTop,
      scrollHeight = _scrollTarget$current.scrollHeight,
      clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    if (!el) return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;
  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled,
    _ref$accountForScroll = _ref3.accountForScrollbars,
    accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM) return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2$1 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children = _ref3.children,
    lockEnabled = _ref3.lockEnabled,
    _ref$captureEnabled = _ref3.captureEnabled,
    captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
    onBottomArrive = _ref3.onBottomArrive,
    onBottomLeave = _ref3.onBottomLeave,
    onTopArrive = _ref3.onTopArrive,
    onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
var _ref2 = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput2(_ref3) {
  var name = _ref3.name,
    onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name,
    tabIndex: -1,
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange3() {}
  });
};
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps$1 = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count2 = _ref3.count;
    return "".concat(count2, " result").concat(count2 !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};
function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption2) {
        return isFocusable(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
    inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data,
    isSelected = categorizedOption.isSelected,
    label = categorizedOption.label,
    value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
    lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel2 = function getOptionLabel3(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function (i) {
    return getOptionValue2(props, i) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
    isMulti = props.isMulti;
  if (hideSelectedOptions === void 0) return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select$1 = /* @__PURE__ */function (_Component) {
  _inherits(Select2, _Component);
  var _super = _createSuper(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
        onChange3 = _this$props.onChange,
        name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange3(newValue, actionMeta);
    };
    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
        closeMenuOnSelect = _this$props2.closeMenuOnSelect,
        isMulti = _this$props2.isMulti,
        inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
        blurInputOnSelect = _this$props3.blurInputOnSelect,
        isMulti = _this$props3.isMulti,
        name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function () {
      return _this.state.selectValue;
    };
    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function (data) {
      return getOptionLabel2(_this.props, data);
    };
    _this.getOptionValue = function (data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function (event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function (event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
        isMulti = _this$props4.isMulti,
        menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function (event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };
    _this.onTouchStart = function (_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function (e2) {
      e2.preventDefault();
      e2.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
        isMulti = _this$props5.isMulti,
        backspaceRemovesValue = _this$props5.backspaceRemovesValue,
        escapeClearsValue = _this$props5.escapeClearsValue,
        inputValue = _this$props5.inputValue,
        isClearable = _this$props5.isClearable,
        isDisabled = _this$props5.isDisabled,
        menuIsOpen = _this$props5.menuIsOpen,
        onKeyDown = _this$props5.onKeyDown,
        tabSelectsValue = _this$props5.tabSelectsValue,
        openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
        focusedOption = _this$state.focusedOption,
        focusedValue = _this$state.focusedValue,
        selectValue = _this$state.selectValue;
      if (isDisabled) return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue) return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue) return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue) return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing) return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption) return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen) return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen) return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen) return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen) return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }
    return _this;
  }
  _createClass(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
        isDisabled = _this$props6.isDisabled,
        menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state,
        selectValue = _this$state2.selectValue,
        isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0;
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === "last") {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
        cx = this.cx,
        getStyles2 = this.getStyles,
        getValue = this.getValue,
        selectOption = this.selectOption,
        setValue = this.setValue,
        props = this.props;
      var isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx,
        getStyles: getStyles2,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
        isClearable2 = _this$props7.isClearable,
        isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0) return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props,
        isDisabled = _this$props8.isDisabled,
        isSearchable = _this$props8.isSearchable,
        inputId = _this$props8.inputId,
        inputValue = _this$props8.inputValue,
        tabIndex = _this$props8.tabIndex,
        form = _this$props8.form,
        menuIsOpen = _this$props8.menuIsOpen,
        required = _this$props8.required;
      var _this$getComponents = this.getComponents(),
        Input3 = _this$getComponents.Input;
      var _this$state4 = this.state,
        inputIsHidden = _this$state4.inputIsHidden,
        ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId("input");
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": required,
        role: "combobox"
      }, menuIsOpen && {
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox")
      }), !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      if (!isSearchable) {
        return /* @__PURE__ */React.createElement(DummyInput, _extends({
          id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop4,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex,
          inputMode: "none",
          form,
          value: ""
        }, ariaAttributes));
      }
      return /* @__PURE__ */React.createElement(Input3, _extends({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex,
        form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(),
        MultiValue3 = _this$getComponents2.MultiValue,
        MultiValueContainer2 = _this$getComponents2.MultiValueContainer,
        MultiValueLabel2 = _this$getComponents2.MultiValueLabel,
        MultiValueRemove2 = _this$getComponents2.MultiValueRemove,
        SingleValue3 = _this$getComponents2.SingleValue,
        Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props,
        controlShouldRenderValue = _this$props9.controlShouldRenderValue,
        isDisabled = _this$props9.isDisabled,
        isMulti = _this$props9.isMulti,
        inputValue = _this$props9.inputValue,
        placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
        selectValue = _this$state5.selectValue,
        focusedValue = _this$state5.focusedValue,
        isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */React.createElement(Placeholder3, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function (opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */React.createElement(MultiValue3, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */React.createElement(SingleValue3, _extends({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
        ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props,
        isDisabled = _this$props10.isDisabled,
        isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */React.createElement(ClearIndicator3, _extends({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
        LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props,
        isDisabled = _this$props11.isDisabled,
        isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading) return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */React.createElement(LoadingIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
        DropdownIndicator3 = _this$getComponents5.DropdownIndicator,
        IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */React.createElement(IndicatorSeparator3, _extends({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
        DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */React.createElement(DropdownIndicator3, _extends({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(),
        Group3 = _this$getComponents7.Group,
        GroupHeading3 = _this$getComponents7.GroupHeading,
        Menu3 = _this$getComponents7.Menu,
        MenuList3 = _this$getComponents7.MenuList,
        MenuPortal3 = _this$getComponents7.MenuPortal,
        LoadingMessage3 = _this$getComponents7.LoadingMessage,
        NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage,
        Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
        captureMenuScroll = _this$props12.captureMenuScroll,
        inputValue = _this$props12.inputValue,
        isLoading = _this$props12.isLoading,
        loadingMessage2 = _this$props12.loadingMessage,
        minMenuHeight = _this$props12.minMenuHeight,
        maxMenuHeight = _this$props12.maxMenuHeight,
        menuIsOpen = _this$props12.menuIsOpen,
        menuPlacement = _this$props12.menuPlacement,
        menuPosition = _this$props12.menuPosition,
        menuPortalTarget = _this$props12.menuPortalTarget,
        menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
        noOptionsMessage2 = _this$props12.noOptionsMessage,
        onMenuScrollToTop = _this$props12.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null;
      var render3 = function render4(props, id) {
        var type3 = props.type,
          data = props.data,
          isDisabled = props.isDisabled,
          isSelected = props.isSelected,
          label = props.label,
          value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /* @__PURE__ */React.createElement(Option3, _extends({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type: type3,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === "group") {
            var _data = item.data,
              options = item.options,
              groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */React.createElement(Group3, _extends({}, commonProps, {
              key: groupId,
              data: _data,
              options,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render3(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === "option") {
            return render3(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null) return null;
        menuUI = /* @__PURE__ */React.createElement(LoadingMessage3, commonProps, message);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null) return null;
        menuUI = /* @__PURE__ */React.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */React.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
          _ref4$placerProps = _ref4.placerProps,
          placement = _ref4$placerProps.placement,
          maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */React.createElement(Menu3, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId("listbox")
          },
          isLoading,
          placement
        }), /* @__PURE__ */React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /* @__PURE__ */React.createElement(MenuList3, _extends({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */React.createElement(MenuPortal3, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props,
        delimiter2 = _this$props13.delimiter,
        isDisabled = _this$props13.isDisabled,
        isMulti = _this$props13.isMulti,
        name = _this$props13.name,
        required = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;
      if (required && !this.hasValue()) {
        return /* @__PURE__ */React.createElement(RequiredInput, {
          name,
          onFocus: this.onValueInputFocus
        });
      }
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */React.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /* @__PURE__ */React.createElement("input", {
              key: "i-".concat(i),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */React.createElement("input", {
            name,
            type: "hidden",
            value: ""
          });
          return /* @__PURE__ */React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */React.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
        ariaSelection = _this$state6.ariaSelection,
        focusedOption = _this$state6.focusedOption,
        focusedValue = _this$state6.focusedValue,
        isFocused = _this$state6.isFocused,
        selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */React.createElement(LiveRegion, _extends({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render3() {
      var _this$getComponents8 = this.getComponents(),
        Control3 = _this$getComponents8.Control,
        IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer,
        SelectContainer3 = _this$getComponents8.SelectContainer,
        ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props,
        className = _this$props14.className,
        id = _this$props14.id,
        isDisabled = _this$props14.isDisabled,
        menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */React.createElement(SelectContainer3, _extends({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */React.createElement(Control3, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */React.createElement(ValueContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */React.createElement(IndicatorsContainer3, _extends({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
        clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
        inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
        ariaSelection = state.ariaSelection,
        isFocused = state.isFocused,
        prevWasFocused = state.prevWasFocused;
      var options = props.options,
        value = props.value,
        menuIsOpen = props.menuIsOpen,
        inputValue = props.inputValue,
        isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select$1.defaultProps = defaultProps$1;
var StateManagedSelect = /* @__PURE__ */forwardRef(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */React.createElement(Select$1, _extends({
    ref
  }, baseSelectProps));
});
var ReactSelect = StateManagedSelect;
const ListItemClickableVariant = {
  true: {
    cursor: "pointer",
    "&:hover": {
      '&[data-state="selected"]': {
        backgroundColor: "$blue2"
      },
      backgroundColor: "$blue1"
    }
  }
};
const ListItemContainer = styled("li", {
  padding: "$1",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "$1",
  color: "$gray10",
  '&[data-state="focused"]': {
    backgroundColor: "$blue1"
  },
  '&[data-state="selected"]': {
    backgroundColor: "$blue2",
    color: "$gray12"
  },
  '&[data-state="disabled"]': {
    color: "$gray5"
  },
  variants: {
    clickable: ListItemClickableVariant
  }
});
const ListItemLabel = styled("p", {
  textStyles: "body"
});
const ListItemDescription = styled("p", {
  textStyles: "metadata",
  overflowWrap: "anywhere"
});
const ListItem = forwardRef((_ref118, forwardedRef) => {
  let {
    label,
    description,
    prefix: prefix2,
    suffix,
    clickable,
    focused,
    selected,
    disabled: disabled2,
    onClick,
    ...props
  } = _ref118;
  const [isFocused, setIsFocused] = useState(false);
  const state = disabled2 ? "disabled" : selected ? "selected" : isFocused || focused ? "focused" : "default";
  const handleKeyDown = e2 => {
    if (onClick) {
      if (e2.key === "Enter") {
        onClick(e2);
      }
      if (e2.key === " ") {
        onClick(e2);
      }
    }
  };
  return /* @__PURE__ */jsxs(ListItemContainer, {
    ref: forwardedRef,
    clickable,
    ...(clickable && {
      tabIndex: 0
    }),
    "data-state": state,
    onClick,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    onKeyDown: handleKeyDown,
    ...props,
    children: [/* @__PURE__ */jsxs(Flex, {
      alignItems: "center",
      children: [prefix2 && (description ? /* @__PURE__ */jsx$1(Flex.Item, {
        alignSelf: "start",
        children: prefix2
      }) : prefix2), /* @__PURE__ */jsxs(Flex, {
        direction: "column",
        gap: 0,
        children: [/* @__PURE__ */jsx$1(ListItemLabel, {
          children: label
        }), description && /* @__PURE__ */jsx$1(ListItemDescription, {
          children: description
        })]
      })]
    }), suffix && suffix]
  });
});
ListItem.displayName = "ListItem";
const SelectSizeVariant = {
  small: {
    width: 120
  },
  medium: {
    width: 280
  },
  large: {
    width: 372
  },
  "x-large": {
    width: 550
  },
  fullWidth: {
    width: "100%"
  }
};
const SelectSizeVariantStitches = SelectSizeVariant;
const StyledIndicatorIcon = styled(Icon, {
  paddingX: 7,
  color: "$gray12",
  variants: {
    isDisabled: {
      true: {
        color: "$gray5"
      }
    }
  }
});
const StyledClearIcon = styled(Flex, {
  padding: "$1",
  marginLeft: "-$1",
  "&:hover": {
    backgroundColor: "$gray2"
  }
});
const StyledGroupHeadingContainer = styled(Flex, {
  padding: "$1"
});
const StyledGroupDivider = styled(Box, {
  marginX: "$1",
  width: "calc(100% - $2)",
  height: "1px",
  backgroundColor: "$gray3"
});
const StyledGroupHeader = styled(Header, {
  color: "$gray10"
});
const StyledMoreText = styled(Text, {
  minWidth: "$7",
  textAlign: "end",
  color: "$gray8",
  "&:hover": {
    textDecoration: "underline",
    textDecorationColor: "$gray9"
  }
});
const useReactSelectStyles = _ref119 => {
  let {
    size,
    error: error2,
    success
  } = _ref119;
  return useMemo(() => ({
    container: provided => ({
      ...provided,
      boxSizing: "border-box",
      color: "var(--drift-dds-colors-gray12)",
      ...SelectSizeVariant[size]
    }),
    valueContainer: (provided, state) => {
      const {
        maxMultiChipThreshold,
        menuIsOpen
      } = state.selectProps;
      const isConcatDisabled = maxMultiChipThreshold == null;
      return {
        ...provided,
        paddingTop: 2,
        paddingBottom: 2,
        ...(!isConcatDisabled && !menuIsOpen && {
          flexWrap: "nowrap"
        })
      };
    },
    control: (provided, state) => ({
      ...provided,
      margin: 0,
      minHeight: "var(--drift-dds-sizes-4)",
      boxSizing: "border-box",
      color: "var(--drift-dds-colors-gray8)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderRadius: "var(--drift-dds-radii-1)",
      borderColor: error2 ? "var(--drift-dds-colors-red5)" : success ? "var(--drift-dds-colors-green5)" : state.isFocused ? "var(--drift-dds-colors-blue5)" : "var(--drift-dds-colors-blue3)",
      "&:hover": {
        borderColor: "var(--drift-dds-colors-blue4)"
      },
      ...(state.isDisabled && {
        backgroundColor: "var(--drift-dds-colors-gray2)",
        borderColor: "var(--drift-dds-colors-gray3)"
      })
    }),
    input: provided => ({
      ...provided,
      padding: 0,
      margin: 0,
      color: "var(--drift-dds-colors-gray12)"
    }),
    placeholder: (provided, _ref120) => {
      let {
        isDisabled
      } = _ref120;
      return {
        ...provided,
        color: "var(--drift-dds-colors-gray8)",
        ...(isDisabled && {
          color: "var(--drift-dds-colors-gray5)"
        })
      };
    },
    indicatorsContainer: provided => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }),
    dropdownIndicator: provided => ({
      ...provided
    }),
    indicatorSeparator: (provided, _ref121) => {
      let {
        isDisabled
      } = _ref121;
      return {
        ...provided,
        backgroundColor: "var(--drift-dds-colors-blue3)",
        marginTop: "var(--drift-dds-sizes-half)",
        marginBottom: "var(--drift-dds-sizes-half)",
        width: 1,
        height: "calc(100% - 8px)",
        alignSelf: "center",
        ...(isDisabled && {
          backgroundColor: "var(--drift-dds-colors-gray3)",
          cursor: "not-allowed"
        })
      };
    },
    clearIndicator: provided => ({
      ...provided
    }),
    group: provided => ({
      ...provided
    }),
    groupHeading: provided => ({
      ...provided
    }),
    loadingIndicator: provided => ({
      ...provided
    }),
    loadingMessage: provided => ({
      ...provided
    }),
    menu: provided => ({
      ...provided,
      zIndex: "var(--drift-dds-zIndices-tooltip)"
    }),
    menuList: (provided, _ref122) => {
      let {
        selectProps
      } = _ref122;
      return {
        ...provided,
        ...(selectProps.isMulti && {
          display: "flex",
          flexDirection: "column",
          gap: "var(--drift-dds-sizes-1)"
        })
      };
    },
    menuPortal: provided => ({
      ...provided
    }),
    multiValue: (provided, state) => {
      const {
        maxMultiChipThreshold,
        menuIsOpen
      } = state.selectProps;
      const isConcatDisabled = maxMultiChipThreshold == null;
      const hideChip = !isConcatDisabled && state.index >= maxMultiChipThreshold;
      return {
        ...provided,
        ...(!menuIsOpen && hideChip && {
          display: "none"
        }),
        borderRadius: "25px",
        color: "var(--drift-dds-colors-blue12)",
        backgroundColor: "var(--drift-dds-colors-blue2)",
        border: "1px solid var(--drift-dds-colors-blue5)",
        fontFamily: "var(--drift-dds-fonts-primary)",
        fontSize: "var(--drift-dds-fontSizes-body)",
        fontWeight: "var(--drift-dds-fontWeights-body)",
        lineHeight: "var(--drift-dds-lineHeights-body)",
        letterSpacing: "var(--drift-dds-letterSpacings-body)",
        "& :first-child:hover": state.data.isFixed ? "inherit" : {
          backgroundColor: "var(--drift-dds-colors-blue3)",
          "& + div": {
            backgroundColor: "var(--drift-dds-colors-blue3)"
          }
        },
        "& :last-child:hover": state.data.isFixed ? "inherit" : {
          backgroundColor: "var(--drift-dds-colors-blue3)",
          color: "var(--drift-dds-colors-blue12)"
        }
      };
    },
    multiValueLabel: provided => ({
      ...provided,
      padding: 0,
      paddingLeft: "var(--drift-dds-sizes-1)",
      paddingRight: 6,
      borderTopLeftRadius: "25px",
      borderBottomLeftRadius: "25px"
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      width: "var(--drift-dds-sizes-2)",
      borderTopRightRadius: "25px",
      borderBottomRightRadius: "25px",
      display: state.data.isFixed ? "none" : "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadiusTopRight: "25px",
      borderRadiusBottomRight: "25px"
    }),
    noOptionsMessage: provided => ({
      ...provided
    }),
    option: provided => ({
      ...provided
    }),
    singleValue: provided => ({
      ...provided
    })
  }), [error2, size, success]);
};
var SelectSizeVariantEnum = /* @__PURE__ */(SelectSizeVariantEnum2 => {
  SelectSizeVariantEnum2["SMALL"] = "small";
  SelectSizeVariantEnum2["MEDIUM"] = "medium";
  SelectSizeVariantEnum2["LARGE"] = "large";
  SelectSizeVariantEnum2["X_LARGE"] = "x-large";
  SelectSizeVariantEnum2["FULL_WIDTH"] = "fullWidth";
  return SelectSizeVariantEnum2;
})(SelectSizeVariantEnum || {});
const SelectIndicatorWidth = 50 + 20;
const SelectXMoreTextWidth = 56;
const AvgCharWidth = 5.8;
const ChipExtraWidth = 30;
const calculateChipWidth = label => {
  return label.length * AvgCharWidth + ChipExtraWidth;
};
const deriveMaxChipThreshold = (selectedOptions, width) => {
  let inputAreaSize = width - SelectIndicatorWidth;
  for (let i = 0; i < selectedOptions.length; i++) {
    const {
      label
    } = selectedOptions[i];
    const isLastChip = i === selectedOptions.length - 1;
    const chipWidth = calculateChipWidth(label.toString());
    if (isLastChip && chipWidth < inputAreaSize) {
      return selectedOptions.length;
    }
    if (chipWidth > inputAreaSize - SelectXMoreTextWidth) {
      return i > 1 ? i : 1;
    }
    inputAreaSize -= chipWidth;
  }
  return selectedOptions.length;
};
const SelectRoot = styled(Flex, {
  variants: {
    size: SelectSizeVariantStitches
  },
  defaultVariants: {
    size: SelectSizeVariantEnum.MEDIUM
  }
});
const CustomMultiValueRemove = props => {
  return /* @__PURE__ */jsx$1("div", {
    ...props.innerProps,
    children: /* @__PURE__ */jsx$1(Icon, {
      size: "extra-small",
      icon: faXmark_2$1
    })
  });
};
const CustomDropdownIndicator = props => {
  return /* @__PURE__ */jsx$1(StyledIndicatorIcon, {
    icon: faChevronDown_2,
    isDisabled: props.isDisabled
  });
};
const CustomClearIndicator = _ref123 => {
  let {
    innerProps
  } = _ref123;
  return /* @__PURE__ */jsx$1(StyledClearIcon, {
    ...innerProps,
    ref: innerProps.ref,
    children: /* @__PURE__ */jsx$1(Icon, {
      icon: faXmark_2$1,
      size: "small"
    })
  });
};
const CustomOption = _ref124 => {
  let {
    innerRef,
    innerProps,
    data,
    isMulti,
    isSelected,
    isFocused,
    isDisabled
  } = _ref124;
  const {
    label,
    description,
    prefix: prefix2,
    suffix,
    isFixed
  } = data;
  const selected = useMemo(() => isMulti ? false : isSelected, [isMulti, isSelected]);
  const labelText = label.toString();
  const checkbox = useMemo(() => /* @__PURE__ */jsx$1(Checkbox, {
    checked: isSelected,
    ariaLabel: labelText
  }), [isSelected, labelText]);
  const selectPrefix = useMemo(() => {
    if (isMulti) {
      return checkbox;
    }
    return prefix2;
  }, [checkbox, isMulti, prefix2]);
  return isFixed ? /* @__PURE__ */jsx$1(Fragment, {}) : /* @__PURE__ */jsx$1(ListItem, {
    ref: innerRef,
    ...innerProps,
    onClick: innerProps.onClick,
    label,
    description,
    clickable: true,
    selected,
    focused: isFocused,
    disabled: isDisabled,
    prefix: selectPrefix,
    suffix
  });
};
const CustomGroupHeading = _ref125 => {
  let {
    data
  } = _ref125;
  return /* @__PURE__ */jsx$1(StyledGroupHeader, {
    variant: "h4",
    children: data.label
  });
};
const CustomGroup = _ref126 => {
  let {
    Heading,
    headingProps,
    selectProps,
    cx,
    getStyles: getStyles2,
    theme: theme2,
    children,
    isMulti,
    options,
    setValue,
    getValue
  } = _ref126;
  var _a, _b;
  const {
    allowSelectAll
  } = selectProps;
  const isMultiSelectAll = isMulti && allowSelectAll;
  const allSelected = useMemo(() => {
    return options.every(option => option.isSelected);
  }, [options]);
  const selectAllTitle = useMemo(() => {
    var _a2, _b2;
    if ((_a2 = headingProps == null ? void 0 : headingProps.data) == null ? void 0 : _a2.label) {
      return (_b2 = headingProps == null ? void 0 : headingProps.data) == null ? void 0 : _b2.label;
    }
    return `${allSelected ? "Deselect" : "Select"} All`;
  }, [allSelected, (_a = headingProps == null ? void 0 : headingProps.data) == null ? void 0 : _a.label]);
  const handleSelectDeselectGroup = () => {
    const currentValues = getValue();
    if (allSelected) {
      setValue([...currentValues.filter(_ref127 => {
        let {
          data
        } = _ref127;
        return !options.find(option => option.value === data.value);
      })], "deselect-option");
    } else {
      setValue([...currentValues, ...options.filter(_ref128 => {
        let {
          data
        } = _ref128;
        return !currentValues.find(currentValue => currentValue.value === data.value);
      })], "select-option");
    }
  };
  return /* @__PURE__ */jsxs(Box, {
    children: [/* @__PURE__ */jsxs(StyledGroupHeadingContainer, {
      alignItems: "center",
      children: [isMultiSelectAll && /* @__PURE__ */jsx$1(Checkbox, {
        ariaLabel: `Select All Options in group: ${(_b = headingProps == null ? void 0 : headingProps.data) == null ? void 0 : _b.label}`,
        checked: allSelected,
        onChange: handleSelectDeselectGroup
      }), isMultiSelectAll ? /* @__PURE__ */jsx$1(StyledGroupHeader, {
        variant: "h3",
        children: selectAllTitle
      }) : /* @__PURE__ */jsx$1(Heading, {
        selectProps,
        cx,
        theme: theme2,
        getStyles: getStyles2,
        ...headingProps
      })]
    }), /* @__PURE__ */jsx$1(StyledGroupDivider, {}), /* @__PURE__ */jsx$1(List, {
      css: {
        boxShadow: "none"
      },
      children
    })]
  });
};
const CustomValueContainer = _ref129 => {
  let {
    children,
    selectProps,
    ...props
  } = _ref129;
  const {
    maxMultiChipThreshold,
    value
  } = selectProps;
  const amountOfHiddenChips = useMemo(() => {
    if (!maxMultiChipThreshold || !value) {
      return 0;
    }
    const currentValueOptionsLength = value.length;
    return currentValueOptionsLength - maxMultiChipThreshold;
  }, [maxMultiChipThreshold, value]);
  const showMoreText = !selectProps.menuIsOpen && maxMultiChipThreshold != null && amountOfHiddenChips > 0;
  return /* @__PURE__ */jsxs(components$1.ValueContainer, {
    ...props,
    selectProps,
    children: [children, showMoreText && /* @__PURE__ */jsxs(StyledMoreText, {
      children: ["+", amountOfHiddenChips, " more"]
    })]
  });
};
const Select = _ref130 => {
  let {
    options = [],
    label,
    description,
    hideLabel,
    size = "medium",
    placeholder,
    error: error2 = "",
    success = "",
    multi,
    menuIsOpen,
    allowSelectAll = false,
    disableMultiSelectConcat = false,
    isClearable = true,
    onBlur,
    defaultValue,
    rootProps,
    allowResetValueWhenValueIsFalsy,
    ...props
  } = _ref130;
  const fixedOptions = useMemo(() => [...options].filter(o2 => o2.isFixed), [options]);
  const selectRef = useRef(null);
  const [maxMultiChipThreshold, setMaxMultiChipThreshold] = useState(null);
  const [uncontrolledValue, setUncontrolledValue] = useState(fixedOptions.length > 0 ? fixedOptions : void 0);
  const {
    elementId: selectId,
    descriptionElementId,
    successMessageElementId,
    errorMessageElementId
  } = useInputLabels(label, "select");
  const describedById = error2 && errorMessageElementId || success && successMessageElementId || description && descriptionElementId;
  const reactSelectStyles = useReactSelectStyles({
    size,
    error: !!error2,
    success: !!success
  });
  const calculateChipCount = useCallback(() => {
    var _a, _b, _c;
    if (!disableMultiSelectConcat && multi) {
      const values = (_a = selectRef.current) == null ? void 0 : _a.getValue();
      const width = (_c = (_b = selectRef.current) == null ? void 0 : _b.controlRef) == null ? void 0 : _c.clientWidth;
      if (values && width) {
        return deriveMaxChipThreshold([...values], width);
      }
    }
    return null;
  }, [disableMultiSelectConcat, multi]);
  const handleBlur = e2 => {
    if (onBlur) {
      onBlur(e2);
    }
    setMaxMultiChipThreshold(calculateChipCount());
  };
  useLayoutEffect$1(() => {
    setMaxMultiChipThreshold(calculateChipCount());
  }, [calculateChipCount]);
  const onSelectChange = (newValue, actionMeta) => {
    if (multi && actionMeta.action === "clear" && Array.isArray(newValue)) {
      setUncontrolledValue(fixedOptions.concat(newValue));
      props.onChange && props.onChange(fixedOptions.concat(newValue), actionMeta);
      return;
    }
    if (Array.isArray(newValue)) {
      setUncontrolledValue(newValue);
    }
    props.onChange && props.onChange(newValue, actionMeta);
  };
  const hasSelectedNonFixedOptions = Array.isArray(uncontrolledValue) && uncontrolledValue.length > fixedOptions.length;
  const selectValue = useMemo(() => {
    if (allowResetValueWhenValueIsFalsy) {
      const isValueFalsy = (props == null ? void 0 : props.value) === null || (props == null ? void 0 : props.value) === void 0 || (props == null ? void 0 : props.value) === "";
      if (isValueFalsy) {
        return null;
      }
    }
    if (props == null ? void 0 : props.value) {
      return props == null ? void 0 : props.value;
    }
    if (!multi && uncontrolledValue) {
      return uncontrolledValue;
    }
    return multi && Array.isArray(uncontrolledValue) && uncontrolledValue.length > 0 ? uncontrolledValue : void 0;
  }, [allowResetValueWhenValueIsFalsy, props == null ? void 0 : props.value, multi, uncontrolledValue]);
  return /* @__PURE__ */jsx$1(SelectRoot, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      fullWidth: true,
      children: [!hideLabel && /* @__PURE__ */jsx$1(InputBase.Label, {
        htmlFor: selectId,
        label
      }), /* @__PURE__ */jsx$1(ReactSelect, {
        ...props,
        ...rootProps,
        ref: selectRef,
        allowSelectAll,
        maxMultiChipThreshold,
        inputId: selectId,
        name: selectId,
        hideSelectedOptions: false,
        tabSelectsValue: false,
        backspaceRemovesValue: hasSelectedNonFixedOptions,
        isClearable: isClearable && hasSelectedNonFixedOptions,
        onBlur: handleBlur,
        onChange: onSelectChange,
        value: selectValue,
        styles: reactSelectStyles,
        isSearchable: true,
        isMulti: multi,
        options,
        placeholder,
        "aria-label": label,
        "aria-invalid": !!(error2 == null ? void 0 : error2.length),
        "aria-errormessage": errorMessageElementId,
        "aria-describedby": describedById,
        closeMenuOnSelect: !multi,
        escapeClearsValue: false,
        menuIsOpen,
        defaultValue,
        components: {
          DropdownIndicator: CustomDropdownIndicator,
          ClearIndicator: CustomClearIndicator,
          Option: CustomOption,
          GroupHeading: CustomGroupHeading,
          Group: CustomGroup,
          MultiValueRemove: CustomMultiValueRemove,
          ValueContainer: CustomValueContainer
        }
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage: error2
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage: error2 ? "" : success
      })]
    })
  });
};
const SelectionBlockGroupContainer = styled("div", {
  display: "flex",
  gap: "$1",
  flexDirection: "column",
  width: "100%"
});
const SelectionBlockTriggerContainer = styled("div", {
  display: "flex",
  gap: "$1"
});
const SelectionBlockTriggerHeader = styled("span", {
  textStyles: "body",
  textColor: "body",
  '&[data-disabled="true"]': {
    textColor: "$gray5"
  }
});
const SelectionBlockTriggerSubheader = styled("span", {
  textStyles: "metadata",
  textColor: "metadata",
  '&[data-disabled="true"]': {
    textColor: "$gray5"
  }
});
const StyledRadioSelectionBlockItemRoot = styled($f99a8c78507165f7$export$6d08773d2e66f8f2, {
  border: "1px solid $blue3",
  backgroundColor: "$white",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingX: "$2",
  paddingY: 12,
  gap: "$2",
  borderRadius: "$1",
  textAlign: "left",
  "&:hover": {
    borderColor: "$blue4"
  },
  '&[data-state="checked"]': {
    borderColor: "$blue8",
    backgroundColor: "$blue1"
  },
  "&[data-disabled]": {
    cursor: "not-allowed",
    borderColor: "$gray3",
    color: "$gray5",
    backgroundColor: "$white"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  }
});
const StyledRadioIndicator = styled($f99a8c78507165f7$export$adb584737d712b70, {
  display: "block",
  size: "10px",
  minWidth: "10px",
  background: "$blue8",
  borderRadius: "$round",
  "&:focus": {
    borderColor: "$blue5"
  },
  "&:hover": {
    borderColor: "$blue4"
  },
  "&[data-disabled]": {
    background: "$gray2",
    borderColor: "$gray3",
    color: "$gray5"
  }
});
const StyledRadioHeaderContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
});
const StyledRadioIndicatorContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  size: "$2",
  cursor: "pointer",
  borderRadius: "$round",
  border: "1px solid $blue3",
  background: "$white",
  "&:hover": {
    borderColor: "$blue4"
  },
  "&::after": {
    background: "transparent",
    size: "10px",
    borderRadius: "50%",
    position: "absolute",
    top: "calc(50% - 5px)",
    left: "calc(50% - 5px)"
  },
  '&:not([data-disabled="true"]):hover:after': {
    background: "$blue2"
  },
  '&[data-checked="false"]:hover:after': {
    content: '""'
  },
  '&[data-checked="true"]:disabled:after': {
    content: '""',
    background: "$gray5"
  },
  '&[data-checked="true"]': {
    borderColor: "$blue8"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1
  },
  '&[data-disabled="true"]': {
    background: "$gray2",
    borderColor: "$gray3",
    cursor: "not-allowed"
  }
});
const RADIO_SELECTION_BLOCK_COMPONENT_NAME = "RadioSelectionBlock";
const [RadioSelectionBlockProvider, useRadioGroupContext] = createComponentContext(RADIO_SELECTION_BLOCK_COMPONENT_NAME, {
  selectedValue: ""
});
const RadioSelectionBlockGroup = forwardRef((_ref131, forwardedRef) => {
  let {
    children,
    defaultValue = "",
    onChange: onChange3 = () => {},
    value
  } = _ref131;
  const [uncontrolledValue, setUncontrolledValue] = useState(defaultValue);
  const onSelectedValueChange = useCallback(selectedValue => {
    setUncontrolledValue(selectedValue);
    onChange3(selectedValue);
  }, [onChange3]);
  const valueActual = value != null ? value : uncontrolledValue;
  return /* @__PURE__ */jsx$1(RadioSelectionBlockProvider, {
    selectedValue: valueActual,
    children: /* @__PURE__ */jsx$1($f99a8c78507165f7$export$be92b6f5f03c0fe9, {
      ref: forwardedRef,
      onValueChange: onSelectedValueChange,
      orientation: "vertical",
      value: valueActual,
      asChild: true,
      children: /* @__PURE__ */jsx$1(SelectionBlockGroupContainer, {
        children
      })
    })
  });
});
RadioSelectionBlockGroup.displayName = "RadioSelectionBlockGroup";
const RadioSelectionBlockItem = forwardRef((_ref132, forwardedRef) => {
  let {
    header,
    subheader,
    children,
    value,
    disabled: disabled2
  } = _ref132;
  var _a;
  const selectedItem = (_a = useRadioGroupContext(RADIO_SELECTION_BLOCK_COMPONENT_NAME)) == null ? void 0 : _a.selectedValue;
  const isSelected = selectedItem === value;
  return /* @__PURE__ */jsxs(StyledRadioSelectionBlockItemRoot, {
    ref: forwardedRef,
    value,
    disabled: disabled2,
    "aria-label": header,
    children: [/* @__PURE__ */jsxs(SelectionBlockTriggerContainer, {
      children: [/* @__PURE__ */jsx$1(StyledRadioIndicatorContainer, {
        "data-disabled": disabled2,
        "data-checked": isSelected,
        children: isSelected && /* @__PURE__ */jsx$1(StyledRadioIndicator, {
          "data-disabled": disabled2,
          forceMount: true
        })
      }), /* @__PURE__ */jsxs(StyledRadioHeaderContainer, {
        children: [/* @__PURE__ */jsx$1(SelectionBlockTriggerHeader, {
          "data-disabled": disabled2,
          children: header
        }), subheader && /* @__PURE__ */jsx$1(SelectionBlockTriggerSubheader, {
          "data-disabled": disabled2,
          children: subheader
        })]
      })]
    }), isSelected && children]
  });
});
RadioSelectionBlockItem.displayName = "RadioSelectionBlock";
const RadioSelectionBlock = {
  Group: RadioSelectionBlockGroup,
  Item: RadioSelectionBlockItem
};
const StyledCheckboxSelectionBlockItemRoot = styled("div", {
  border: "1px solid $blue3",
  backgroundColor: "$white",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingX: "$2",
  paddingY: 12,
  gap: "$2",
  borderRadius: "$1",
  "&:hover": {
    borderColor: "$blue4"
  },
  '&[data-checked="true"]': {
    borderColor: "$blue8",
    backgroundColor: "$blue1"
  },
  '&[data-disabled="true"]': {
    cursor: "not-allowed",
    borderColor: "$gray3",
    color: "$gray5",
    backgroundColor: "$white"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  }
});
const CHECKBOX_SELECTION_BLOCK_COMPONENT_NAME = "CheckboxSelectionBlock";
const [CheckboxSelectionBlockProvider, useCheckboxGroupContext] = createComponentContext(CHECKBOX_SELECTION_BLOCK_COMPONENT_NAME, {
  selectedValues: [],
  setSelectedValues: () => {},
  onChange: () => {}
});
const CheckboxSelectionBlockGroup = forwardRef((_ref133, forwardedRef) => {
  let {
    children,
    defaultValue,
    onChange: onChange3 = () => null
  } = _ref133;
  const [selectedValues, setSelectedValues] = useState(defaultValue ? [defaultValue] : []);
  return /* @__PURE__ */jsx$1(CheckboxSelectionBlockProvider, {
    selectedValues,
    setSelectedValues,
    onChange: onChange3,
    children: /* @__PURE__ */jsx$1(SelectionBlockGroupContainer, {
      ref: forwardedRef,
      children
    })
  });
});
CheckboxSelectionBlockGroup.displayName = "CheckboxSelectionBlockGroup";
const CheckboxSelectionBlockItem = forwardRef((_ref134, forwardedRef) => {
  let {
    header,
    subheader,
    children,
    value,
    disabled: disabled2
  } = _ref134;
  const {
    selectedValues = [],
    setSelectedValues = () => {},
    onChange: onChange3 = () => null
  } = useCheckboxGroupContext(CHECKBOX_SELECTION_BLOCK_COMPONENT_NAME);
  const isSelected = selectedValues == null ? void 0 : selectedValues.includes(value);
  const onChecked = isChecked => {
    if ((selectedValues == null ? void 0 : selectedValues.includes(value)) && !isChecked) {
      setSelectedValues(without$1([value], selectedValues));
      onChange3(without$1([value], selectedValues));
    } else {
      setSelectedValues(append$2(value, selectedValues));
      onChange3(append$2(value, selectedValues));
    }
  };
  return /* @__PURE__ */jsxs(StyledCheckboxSelectionBlockItemRoot, {
    ref: forwardedRef,
    "data-checked": isSelected,
    "data-disabled": disabled2,
    "aria-label": header,
    children: [/* @__PURE__ */jsx$1(SelectionBlockTriggerContainer, {
      children: /* @__PURE__ */jsx$1(Checkbox, {
        disabled: disabled2,
        checked: isSelected,
        onChange: onChecked,
        label: header,
        description: subheader,
        rootProps: {
          "aria-label": header
        }
      })
    }), isSelected && children]
  });
});
CheckboxSelectionBlockItem.displayName = "CheckboxSelectionBlockItem";
const CheckboxSelectionBlock = {
  Group: CheckboxSelectionBlockGroup,
  Item: CheckboxSelectionBlockItem
};
const StyledBreadcrumbNavRoot = styled("nav", {
  height: "$3",
  display: "flex",
  alignItems: "center"
});
const StyledOrderedList = styled("ol", {
  margin: 0,
  padding: 0,
  display: "flex",
  gap: "6px",
  flexWrap: "nowrap",
  listStyle: "none"
});
const StyledListItem = styled("li", {
  listStyle: "none",
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  gap: "$half"
});
const StyledBreadcrumbLink = styled(StyledLinkBase, {
  color: "$gray8 !important",
  defaultVariants: {
    size: "small"
  }
});
const BreadcrumbRoot = forwardRef((_ref135, forwardedRef) => {
  let {
    children,
    rootProps,
    ...props
  } = _ref135;
  const olRef = useRef(null);
  const childCount = Children.count(children);
  const [collapsed, setCollapsed] = useState(childCount > 4);
  useEffect(() => {
    setCollapsed(childCount > 4);
  }, [childCount]);
  return /* @__PURE__ */jsx$1(StyledBreadcrumbNavRoot, {
    ref: forwardedRef,
    "aria-label": "breadcrumbs",
    ...rootProps,
    ...props,
    children: /* @__PURE__ */jsx$1(StyledOrderedList, {
      ref: olRef,
      children: Children.toArray(children).map((child, index2) => {
        if (collapsed && index2 === 1) {
          return /* @__PURE__ */jsxs(StyledListItem, {
            children: [/* @__PURE__ */jsx$1(IconButton, {
              title: "Show hidden breadcrumb items",
              icon: faEllipsis_2,
              onClick: () => {
                var _a;
                setCollapsed(false);
                (_a = olRef.current) == null ? void 0 : _a.focus();
              },
              size: "small"
            }), /* @__PURE__ */jsx$1(Icon, {
              size: "extra-small",
              "aria-hidden": "true",
              icon: faChevronRight_2$1
            })]
          });
        }
        if (collapsed && index2 === childCount - 2) {
          return /* @__PURE__ */jsxs(StyledListItem, {
            children: [child, /* @__PURE__ */jsx$1(Icon, {
              size: "extra-small",
              "aria-hidden": "true",
              icon: faChevronRight_2$1
            })]
          });
        }
        if (index2 === childCount - 1) {
          return /* @__PURE__ */jsx$1(StyledListItem, {
            children: cloneElement(child, {
              "aria-current": "page"
            })
          });
        }
        if (collapsed && index2 > 1 && index2 < childCount - 1) {
          return /* @__PURE__ */jsxs(StyledListItem, {
            css: {
              display: "none"
            },
            children: [child, /* @__PURE__ */jsx$1(Icon, {
              size: "extra-small",
              "aria-hidden": "true",
              icon: faChevronRight_2$1
            })]
          });
        }
        return /* @__PURE__ */jsxs(StyledListItem, {
          children: [child, /* @__PURE__ */jsx$1(Icon, {
            size: "extra-small",
            "aria-hidden": "true",
            icon: faChevronRight_2$1
          })]
        });
      })
    })
  });
});
BreadcrumbRoot.displayName = "Breadcrumb";
const Breadcrumb = {
  Root: BreadcrumbRoot,
  Link: StyledBreadcrumbLink
};
const LinkTileContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  position: "relative",
  cursor: "pointer",
  border: "1px solid $gray3",
  borderRadius: "$1",
  textColor: "body",
  padding: "$2",
  background: "$white",
  "&:hover": {
    border: "1px solid $gray4",
    boxShadow: "$raised08"
  },
  "&:active": {
    border: "1px solid $gray5",
    boxShadow: "$raised08",
    background: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  '&[data-disabled="true"]': {
    border: "1px solid $gray3",
    cursor: "not-allowed",
    color: "$gray5",
    "&:active": {
      boxShadow: "none",
      background: "$white"
    },
    "&:hover": {
      boxShadow: "none"
    },
    "* > p,a": {
      color: "$gray5"
    }
  }
});
const StyledLinkTileHeaderLink = styled("a", {
  color: "inherit",
  textDecoration: "none",
  textStyles: "h3",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  "&::after": {
    position: "absolute",
    content: "",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
});
const COMPONENT_NAME = "LinkTileList";
const [LinkTileListProvider, useLinkTileListContext] = createComponentContext(COMPONENT_NAME, {
  isListDisabled: false
});
const LinkTileList = forwardRef((_ref136, forwardedRef) => {
  let {
    children,
    isDisabled,
    rootProps,
    ...props
  } = _ref136;
  return /* @__PURE__ */jsx$1(LinkTileListProvider, {
    isListDisabled: isDisabled,
    children: /* @__PURE__ */jsx$1(Box, {
      role: "list",
      ref: forwardedRef,
      ...props,
      ...rootProps,
      children
    })
  });
});
LinkTileList.displayName = "LinkTileList";
const LinkTileItem = forwardRef((_ref137, forwardedRef) => {
  let {
    isDisabled = false,
    id,
    children,
    rootProps,
    ...props
  } = _ref137;
  const {
    isListDisabled
  } = useLinkTileListContext(COMPONENT_NAME);
  const isTileDisabled = isListDisabled != null ? isListDisabled : isDisabled;
  return /* @__PURE__ */jsx$1(LinkTileContainer, {
    role: "listitem",
    "data-id": id,
    "data-disabled": isTileDisabled,
    ref: forwardedRef,
    ...props,
    ...rootProps,
    children
  });
});
LinkTileItem.displayName = "LinkTileItem";
const LinkTileHeader = forwardRef((_ref138, forwardedRef) => {
  let {
    isDisabled,
    href,
    children,
    ...props
  } = _ref138;
  const {
    isListDisabled
  } = useLinkTileListContext(COMPONENT_NAME);
  const isTileDisabled = isListDisabled != null ? isListDisabled : isDisabled;
  return /* @__PURE__ */jsx$1(StyledLinkTileHeaderLink, {
    href: isTileDisabled ? void 0 : href,
    ref: forwardedRef,
    ...props,
    children
  });
});
LinkTileHeader.displayName = "LinkTileHeader";
const LinkTile = {
  Group: LinkTileList,
  Item: LinkTileItem,
  Header: LinkTileHeader
};
const StyledSelectionTile = styled("button", {
  display: "flex",
  flexDirection: "column",
  position: "relative",
  cursor: "pointer",
  border: "1px solid $blue3",
  borderRadius: "$1",
  padding: "$2",
  background: "$white",
  flexGrow: 1,
  "&:hover": {
    border: "1px solid $blue4"
  },
  "&:active": {
    border: "1px solid $blue8",
    background: "$blue1"
  },
  '&[data-selected="true"]': {
    border: "1px solid $blue8",
    background: "$blue1"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  "&:disabled": {
    border: "1px solid $gray3",
    cursor: "not-allowed",
    "& > p,span": {
      color: "$gray5"
    }
  }
});
const [SelectionTileListProvider, useSelectionTileListContext] = createComponentContext("SelectionTileList", {
  selectedValue: void 0,
  isListDisabled: false,
  onTileSelected: () => null
});
const SelectionTileList = forwardRef((_ref139, forwardedRef) => {
  let {
    defaultValue = "",
    onChange: onChange3 = () => null,
    children,
    isDisabled,
    rootProps,
    ...props
  } = _ref139;
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const onTileSelected = useCallback(value => {
    setSelectedValue(value);
    onChange3(value);
  }, [onChange3]);
  return /* @__PURE__ */jsx$1(SelectionTileListProvider, {
    selectedValue,
    isListDisabled: isDisabled,
    onTileSelected,
    children: /* @__PURE__ */jsx$1(Box, {
      ref: forwardedRef,
      ...props,
      ...rootProps,
      fullWidth: true,
      children
    })
  });
});
SelectionTileList.displayName = "SelectionTileList";
const SelectionTileItem = forwardRef((_ref140, forwardedRef) => {
  let {
    isDisabled = false,
    onClick = () => null,
    id,
    children,
    rootProps,
    ...props
  } = _ref140;
  const {
    selectedValue = [],
    isListDisabled,
    onTileSelected = () => null
  } = useSelectionTileListContext("SelectionTileList");
  const onSelected = useCallback(evt => {
    onTileSelected(id);
    onClick(evt);
  }, [id, onClick, onTileSelected]);
  return /* @__PURE__ */jsx$1(StyledSelectionTile, {
    ref: forwardedRef,
    "data-selected": id === selectedValue,
    onClick: onSelected,
    disabled: isListDisabled != null ? isListDisabled : isDisabled,
    ...props,
    ...rootProps,
    children
  });
});
SelectionTileItem.displayName = "SelectionTile";
const SelectionTile = {
  Group: SelectionTileList,
  Item: SelectionTileItem
};
const StyledTagVariant = {
  indigo: {
    color: "$indigo10",
    backgroundColor: "$indigo1",
    border: "1px solid $indigo6",
    "& button": {
      "&:hover": {
        backgroundColor: "$indigo3"
      }
    }
  },
  blue: {
    color: "$blue10",
    backgroundColor: "$blue1",
    border: "1px solid $blue6",
    "& button": {
      "&:hover": {
        backgroundColor: "$blue3"
      }
    }
  },
  teal: {
    color: "$teal10",
    backgroundColor: "$teal1",
    border: "1px solid $teal6",
    "& button": {
      "&:hover": {
        backgroundColor: "$teal3"
      }
    }
  },
  yellow: {
    color: "$yellow10",
    backgroundColor: "$yellow1",
    border: "1px solid $yellow6",
    "& button": {
      "&:hover": {
        backgroundColor: "$yellow3"
      }
    }
  },
  pink: {
    color: "$pink10",
    backgroundColor: "$pink1",
    border: "1px solid $pink6",
    "& button": {
      "&:hover": {
        backgroundColor: "$pink3"
      }
    }
  },
  gray: {
    color: "$gray10",
    backgroundColor: "$gray1",
    border: "1px solid $gray6",
    "& button": {
      "&:hover": {
        backgroundColor: "$gray3"
      }
    }
  },
  purple: {
    color: "$purple10",
    backgroundColor: "$purple1",
    border: "1px solid $purple6",
    "& button": {
      "&:hover": {
        backgroundColor: "$purple3"
      }
    }
  },
  green: {
    color: "$green10",
    backgroundColor: "$green1",
    border: "1px solid $green6",
    "& button": {
      "&:hover": {
        backgroundColor: "$green3"
      }
    }
  }
};
const StyledBase = styled("div", {
  display: "flex",
  gap: "$half",
  alignItems: "center",
  borderRadius: "$4",
  paddingX: "$1",
  height: "20px",
  width: "max-content",
  maxWidth: "21ch",
  minWidth: "32px",
  position: "relative",
  justifyContent: "center",
  variants: {
    variant: StyledTagVariant,
    isDismissable: {
      true: {
        paddingRight: 0
      }
    }
  }
});
const StyledTagDismissButton = styled("button", {
  border: "none",
  height: "18px",
  width: "$2",
  minWidth: "$2",
  padding: 0,
  cursor: "pointer",
  margin: 0,
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  borderTopRightRadius: "$round",
  borderBottomRightRadius: "$round"
});
const StyledTagText = styled("span", {
  textStyles: "metadata",
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflowWrap: "break-word",
  wordBreak: "break-all",
  maxWidth: "100%"
});
const Tag = forwardRef((_ref141, forwardedRef) => {
  let {
    children,
    variant,
    isDismissable,
    onDismiss = () => null,
    rootProps = {},
    ...props
  } = _ref141;
  return /* @__PURE__ */jsxs(StyledBase, {
    variant,
    ref: forwardedRef,
    isDismissable,
    ...rootProps,
    ...props,
    children: [/* @__PURE__ */jsx$1(StyledTagText, {
      children
    }), isDismissable && /* @__PURE__ */jsx$1(StyledTagDismissButton, {
      onClick: onDismiss,
      "aria-label": "delete tag",
      children: /* @__PURE__ */jsx$1(Icon, {
        icon: faXmark_2$1,
        size: "extra-small",
        variant: "dark"
      })
    })]
  });
});
Tag.displayName = "Tag";
var StatusTagVariantEnum = /* @__PURE__ */(StatusTagVariantEnum2 => {
  StatusTagVariantEnum2["INDIGO"] = "indigo";
  StatusTagVariantEnum2["TEAL"] = "teal";
  StatusTagVariantEnum2["YELLOW"] = "yellow";
  StatusTagVariantEnum2["PINK"] = "pink";
  StatusTagVariantEnum2["GREEN"] = "green";
  StatusTagVariantEnum2["BLUE"] = "blue";
  StatusTagVariantEnum2["GRAY"] = "gray";
  StatusTagVariantEnum2["PURPLE"] = "purple";
  return StatusTagVariantEnum2;
})(StatusTagVariantEnum || {});
const ToggleButtonAppearances = {
  ["outline"]: {
    border: "1px solid $gray3",
    "&:hover": {
      '&[aria-checked="false"]': {
        "&:not([disabled])": {
          borderColor: "$gray4"
        }
      }
    }
  },
  ["subtle"]: {
    border: "none"
  }
};
const ToggleButtonSizes = {
  ["small"]: {
    height: "$3",
    textStyles: "button2"
  },
  ["medium"]: {
    height: "$4",
    textStyles: "button1"
  }
};
const ToggleButtonColors = {
  ["blue"]: {
    '&[aria-checked="true"]': {
      "&:not([disabled])": {
        backgroundColor: "$blue1",
        borderColor: "$blue8",
        color: "$blue8",
        "& svg": {
          path: {
            fill: "$blue8"
          }
        }
      }
    }
  },
  ["green"]: {
    '&[aria-checked="true"]': {
      "&:not([disabled])": {
        backgroundColor: "$green1",
        borderColor: "$green8",
        color: "$green8",
        "& svg": {
          path: {
            fill: "$green8"
          }
        }
      }
    }
  },
  ["red"]: {
    '&[aria-checked="true"]': {
      "&:not([disabled])": {
        backgroundColor: "$red1",
        color: "$red8",
        borderColor: "$red8",
        "& svg": {
          path: {
            fill: "$red8"
          }
        }
      }
    }
  },
  ["yellow"]: {
    '&[aria-checked="true"]': {
      "&:not([disabled])": {
        backgroundColor: "$yellow1",
        color: "$yellow8",
        borderColor: "$yellow4",
        "& svg": {
          path: {
            fill: "$yellow4"
          }
        }
      }
    }
  }
};
const StyledToggleButtonItem = styled("button", {
  backgroundColor: "$white",
  color: "$gray12",
  width: "max-content",
  paddingX: "$2",
  display: "flex",
  alignItems: "center",
  borderRadius: "$1",
  cursor: "pointer",
  gap: "$1",
  "&:hover": {
    backgroundColor: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  "&:disabled": {
    cursor: "not-allowed",
    '&[aria-checked="false"]': {
      opacity: "0.5",
      backgroundColor: "$white",
      color: "$gray05"
    },
    '&[aria-checked="true"]': {
      backgroundColor: "$gray2",
      borderColor: "$gray5",
      color: "$gray5"
    }
  },
  variants: {
    size: ToggleButtonSizes,
    color: ToggleButtonColors,
    appearance: ToggleButtonAppearances,
    iconOnly: {
      true: {}
    }
  },
  compoundVariants: [{
    iconOnly: true,
    size: "small",
    css: {
      paddingX: 6
    }
  }, {
    iconOnly: true,
    size: "medium",
    css: {
      paddingX: 9
    }
  }]
});
const ToggleButton = forwardRef((_ref142, forwardedRef) => {
  let {
    color,
    icon: icon3,
    selectedIcon,
    value,
    selected,
    size = "medium",
    isDisabled,
    appearance = "subtle",
    rootProps,
    children,
    title,
    onChange: onChange3 = () => null
  } = _ref142;
  const toggleButtonIcon = selected ? selectedIcon : icon3;
  const onToggleButtonClick = useCallback(() => {
    onChange3(value);
  }, [value, onChange3]);
  return /* @__PURE__ */jsx$1(Tooltip, {
    content: title,
    side: "top",
    hidden: !title || !!children,
    triggerAsChild: true,
    children: /* @__PURE__ */jsxs(StyledToggleButtonItem, {
      disabled: isDisabled,
      appearance,
      ref: forwardedRef,
      color,
      size,
      onClick: onToggleButtonClick,
      "aria-checked": selected,
      role: "switch",
      "aria-label": title,
      iconOnly: !children && !!icon3,
      ...rootProps,
      children: [toggleButtonIcon && /* @__PURE__ */jsx$1(Icon, {
        size,
        icon: toggleButtonIcon,
        title: value
      }), children]
    })
  });
});
ToggleButton.displayName = "ToggleButton";
const StyledToggleButtonGroup = styled(ButtonGroup, {
  width: "max-content",
  "& button:first-child": {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  "& button:last-child": {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
  "& button:not(:first-child)": {
    "&:not(:last-child)": {
      borderRadius: 0
    }
  }
});
styled("button", {
  backgroundColor: "$white",
  width: "max-content",
  paddingX: "$2",
  display: "flex",
  alignItems: "center",
  borderRadius: "$1",
  border: "none",
  cursor: "pointer",
  gap: "$1",
  "&:hover": {
    backgroundColor: "$gray2"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1"
  },
  "&:disabled": {
    cursor: "not-allowed",
    opacity: "0.5",
    backgroundColor: "$white"
  },
  variants: {
    size: {
      small: {
        height: "$3",
        textStyles: "button2"
      },
      medium: {
        height: "$4",
        textStyles: "button1"
      }
    },
    withBorder: {
      true: {
        border: "1px solid $gray3"
      }
    },
    appearance: {
      outline: {
        border: "1px solid $gray3"
      },
      subtle: {}
    },
    color: {
      red: {
        '&[aria-pressed="true"]': {
          backgroundColor: "$red1",
          color: "$red8",
          borderColor: "$red8",
          "& svg": {
            path: {
              fill: "$red8"
            }
          }
        }
      },
      blue: {
        '&[aria-pressed="true"]': {
          backgroundColor: "$blue1",
          borderColor: "$blue8",
          color: "$blue8",
          "& svg": {
            path: {
              fill: "$blue8"
            }
          }
        }
      },
      green: {
        '&[aria-pressed="true"]': {
          backgroundColor: "$green1",
          borderColor: "$green8",
          color: "$green8",
          "& svg": {
            path: {
              fill: "$green8"
            }
          }
        }
      },
      yellow: {
        '&[aria-pressed="true"]': {
          backgroundColor: "$yellow1",
          color: "$yellow8",
          borderColor: "$yellow4",
          "& svg": {
            path: {
              fill: "$yellow4"
            }
          }
        }
      }
    }
  }
});
const ToggleButtonGroup = forwardRef((_ref143, forwardedRef) => {
  let {
    children,
    isDisabled,
    color,
    appearance,
    exclusive = false,
    size,
    onChange: onChange3 = () => null,
    rootProps,
    initialSelectedValues = [],
    controlledSelectedValues,
    ...props
  } = _ref143;
  const [uncontrolledSelectedValues, setUncontrolledSelectedValues] = useState(exclusive ? [initialSelectedValues[0]] : initialSelectedValues);
  const onToggleButtonClick = useCallback(value => {
    const selectedValues = controlledSelectedValues || uncontrolledSelectedValues;
    const exclusiveSelectionValues = selectedValues.includes(value) ? [] : [value];
    const inexclusiveButtonSelectionValues = selectedValues.includes(value) ? without$1([value], selectedValues) : [...selectedValues, value];
    if (exclusive) {
      setUncontrolledSelectedValues(exclusiveSelectionValues);
      onChange3(exclusiveSelectionValues);
    } else {
      setUncontrolledSelectedValues(inexclusiveButtonSelectionValues);
      onChange3(inexclusiveButtonSelectionValues);
    }
  }, [controlledSelectedValues, uncontrolledSelectedValues, exclusive, onChange3]);
  return /* @__PURE__ */jsx$1(StyledToggleButtonGroup, {
    gap: 0,
    align: "left",
    ref: forwardedRef,
    ...props,
    ...rootProps,
    children: React__default.Children.map(children, (child, index2) => {
      const item = child;
      return React__default.cloneElement(item, {
        onChange: onToggleButtonClick,
        selected: controlledSelectedValues ? controlledSelectedValues.includes(item.props.value) : uncontrolledSelectedValues.includes(item.props.value),
        isDisabled,
        key: `${item.props.value}-${index2}`,
        color: color || item.props.color,
        appearance: appearance || item.props.appearance,
        size: size || item.props.size
      });
    })
  });
});
ToggleButtonGroup.displayName = "ToggleButtonGroup";
/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function makeStateUpdater(key, instance) {
  return updater => {
    instance.setState(old => {
      return {
        ...old,
        [key]: functionalUpdate(updater, old[key])
      };
    });
  };
}
function isFunction$1(d2) {
  return d2 instanceof Function;
}
function flattenBy(arr, getChildren) {
  const flat = [];
  const recurse = subArr => {
    subArr.forEach(item => {
      flat.push(item);
      const children = getChildren(item);
      if (children != null && children.length) {
        recurse(children);
      }
    });
  };
  recurse(arr);
  return flat;
}
function memo(getDeps, fn, opts) {
  let deps = [];
  let result;
  return () => {
    let depTime;
    if (opts.key && opts.debug) depTime = Date.now();
    const newDeps = getDeps();
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && opts.debug) resultTime = Date.now();
    result = fn(...newDeps);
    opts == null ? void 0 : opts.onChange == null ? void 0 : opts.onChange(result);
    if (opts.key && opts.debug) {
      if (opts != null && opts.debug()) {
        const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
        const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
        const resultFpsPercentage = resultEndTime / 16;
        const pad3 = (str, num) => {
          str = String(str);
          while (str.length < num) {
            str = " " + str;
          }
          return str;
        };
        console.info(`%c\u23F1 ${pad3(resultEndTime, 5)} /${pad3(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
      }
    }
    return result;
  };
}
function createColumn(table, columnDef, depth, parent) {
  var _ref3, _resolvedColumnDef$id;
  const defaultColumn = table._getDefaultColumnDef();
  const resolvedColumnDef = {
    ...defaultColumn,
    ...columnDef
  };
  const accessorKey = resolvedColumnDef.accessorKey;
  let id = (_ref3 = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : void 0) != null ? _ref3 : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : void 0;
  let accessorFn;
  if (resolvedColumnDef.accessorFn) {
    accessorFn = resolvedColumnDef.accessorFn;
  } else if (accessorKey) {
    if (accessorKey.includes(".")) {
      accessorFn = originalRow => {
        let result = originalRow;
        for (const key of accessorKey.split(".")) {
          result = result[key];
        }
        return result;
      };
    } else {
      accessorFn = originalRow => originalRow[resolvedColumnDef.accessorKey];
    }
  }
  if (!id) {
    throw new Error();
  }
  let column2 = {
    id: `${String(id)}`,
    accessorFn,
    parent,
    depth,
    columnDef: resolvedColumnDef,
    columns: [],
    getFlatColumns: memo(() => [true], () => {
      var _column$columns;
      return [column2, ...((_column$columns = column2.columns) == null ? void 0 : _column$columns.flatMap(d2 => d2.getFlatColumns()))];
    }, {
      key: "column.getFlatColumns",
      debug: () => {
        var _table$options$debugA;
        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
      }
    }),
    getLeafColumns: memo(() => [table._getOrderColumnsFn()], orderColumns2 => {
      var _column$columns2;
      if ((_column$columns2 = column2.columns) != null && _column$columns2.length) {
        let leafColumns = column2.columns.flatMap(column3 => column3.getLeafColumns());
        return orderColumns2(leafColumns);
      }
      return [column2];
    }, {
      key: "column.getLeafColumns",
      debug: () => {
        var _table$options$debugA2;
        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
      }
    })
  };
  column2 = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.createColumn == null ? void 0 : feature.createColumn(column2, table));
  }, column2);
  return column2;
}
function createHeader(table, column2, options) {
  var _options$id;
  const id = (_options$id = options.id) != null ? _options$id : column2.id;
  let header = {
    id,
    column: column2,
    index: options.index,
    isPlaceholder: !!options.isPlaceholder,
    placeholderId: options.placeholderId,
    depth: options.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const leafHeaders = [];
      const recurseHeader = h2 => {
        if (h2.subHeaders && h2.subHeaders.length) {
          h2.subHeaders.map(recurseHeader);
        }
        leafHeaders.push(h2);
      };
      recurseHeader(header);
      return leafHeaders;
    },
    getContext: () => ({
      table,
      header,
      column: column2
    })
  };
  table._features.forEach(feature => {
    Object.assign(header, feature.createHeader == null ? void 0 : feature.createHeader(header, table));
  });
  return header;
}
const Headers = {
  createTable: table => {
    return {
      getHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
        var _left$map$filter, _right$map$filter;
        const leftColumns = (_left$map$filter = left == null ? void 0 : left.map(columnId => leafColumns.find(d2 => d2.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
        const rightColumns = (_right$map$filter = right == null ? void 0 : right.map(columnId => leafColumns.find(d2 => d2.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
        const centerColumns = leafColumns.filter(column2 => !(left != null && left.includes(column2.id)) && !(right != null && right.includes(column2.id)));
        const headerGroups = buildHeaderGroups(allColumns, [...leftColumns, ...centerColumns, ...rightColumns], table);
        return headerGroups;
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA;
          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugHeaders;
        }
      }),
      getCenterHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
        leafColumns = leafColumns.filter(column2 => !(left != null && left.includes(column2.id)) && !(right != null && right.includes(column2.id)));
        return buildHeaderGroups(allColumns, leafColumns, table, "center");
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA2;
          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugHeaders;
        }
      }),
      getLeftHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left], (allColumns, leafColumns, left) => {
        var _left$map$filter2;
        const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map(columnId => leafColumns.find(d2 => d2.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, "left");
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA3;
          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugHeaders;
        }
      }),
      getRightHeaderGroups: memo(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.right], (allColumns, leafColumns, right) => {
        var _right$map$filter2;
        const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map(columnId => leafColumns.find(d2 => d2.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
        return buildHeaderGroups(allColumns, orderedLeafColumns, table, "right");
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA4;
          return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugHeaders;
        }
      }),
      getFooterGroups: memo(() => [table.getHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA5;
          return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugHeaders;
        }
      }),
      getLeftFooterGroups: memo(() => [table.getLeftHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA6;
          return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugHeaders;
        }
      }),
      getCenterFooterGroups: memo(() => [table.getCenterHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA7;
          return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugHeaders;
        }
      }),
      getRightFooterGroups: memo(() => [table.getRightHeaderGroups()], headerGroups => {
        return [...headerGroups].reverse();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA8;
          return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugHeaders;
        }
      }),
      getFlatHeaders: memo(() => [table.getHeaderGroups()], headerGroups => {
        return headerGroups.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA9;
          return (_table$options$debugA9 = table.options.debugAll) != null ? _table$options$debugA9 : table.options.debugHeaders;
        }
      }),
      getLeftFlatHeaders: memo(() => [table.getLeftHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA10;
          return (_table$options$debugA10 = table.options.debugAll) != null ? _table$options$debugA10 : table.options.debugHeaders;
        }
      }),
      getCenterFlatHeaders: memo(() => [table.getCenterHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA11;
          return (_table$options$debugA11 = table.options.debugAll) != null ? _table$options$debugA11 : table.options.debugHeaders;
        }
      }),
      getRightFlatHeaders: memo(() => [table.getRightHeaderGroups()], left => {
        return left.map(headerGroup => {
          return headerGroup.headers;
        }).flat();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA12;
          return (_table$options$debugA12 = table.options.debugAll) != null ? _table$options$debugA12 : table.options.debugHeaders;
        }
      }),
      getCenterLeafHeaders: memo(() => [table.getCenterFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders;
          return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
        });
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA13;
          return (_table$options$debugA13 = table.options.debugAll) != null ? _table$options$debugA13 : table.options.debugHeaders;
        }
      }),
      getLeftLeafHeaders: memo(() => [table.getLeftFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders2;
          return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
        });
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA14;
          return (_table$options$debugA14 = table.options.debugAll) != null ? _table$options$debugA14 : table.options.debugHeaders;
        }
      }),
      getRightLeafHeaders: memo(() => [table.getRightFlatHeaders()], flatHeaders => {
        return flatHeaders.filter(header => {
          var _header$subHeaders3;
          return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
        });
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA15;
          return (_table$options$debugA15 = table.options.debugAll) != null ? _table$options$debugA15 : table.options.debugHeaders;
        }
      }),
      getLeafHeaders: memo(() => [table.getLeftHeaderGroups(), table.getCenterHeaderGroups(), table.getRightHeaderGroups()], (left, center, right) => {
        var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
        return [...((_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : []), ...((_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : []), ...((_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : [])].map(header => {
          return header.getLeafHeaders();
        }).flat();
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA16;
          return (_table$options$debugA16 = table.options.debugAll) != null ? _table$options$debugA16 : table.options.debugHeaders;
        }
      })
    };
  }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
  var _headerGroups$0$heade, _headerGroups$;
  let maxDepth = 0;
  const findMaxDepth = function (columns, depth) {
    if (depth === void 0) {
      depth = 1;
    }
    maxDepth = Math.max(maxDepth, depth);
    columns.filter(column2 => column2.getIsVisible()).forEach(column2 => {
      var _column$columns;
      if ((_column$columns = column2.columns) != null && _column$columns.length) {
        findMaxDepth(column2.columns, depth + 1);
      }
    }, 0);
  };
  findMaxDepth(allColumns);
  let headerGroups = [];
  const createHeaderGroup = (headersToGroup, depth) => {
    const headerGroup = {
      depth,
      id: [headerFamily, `${depth}`].filter(Boolean).join("_"),
      headers: []
    };
    const pendingParentHeaders = [];
    headersToGroup.forEach(headerToGroup => {
      const latestPendingParentHeader = [...pendingParentHeaders].reverse()[0];
      const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
      let column2;
      let isPlaceholder = false;
      if (isLeafHeader && headerToGroup.column.parent) {
        column2 = headerToGroup.column.parent;
      } else {
        column2 = headerToGroup.column;
        isPlaceholder = true;
      }
      if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column2) {
        latestPendingParentHeader.subHeaders.push(headerToGroup);
      } else {
        const header = createHeader(table, column2, {
          id: [headerFamily, depth, column2.id, headerToGroup == null ? void 0 : headerToGroup.id].filter(Boolean).join("_"),
          isPlaceholder,
          placeholderId: isPlaceholder ? `${pendingParentHeaders.filter(d2 => d2.column === column2).length}` : void 0,
          depth,
          index: pendingParentHeaders.length
        });
        header.subHeaders.push(headerToGroup);
        pendingParentHeaders.push(header);
      }
      headerGroup.headers.push(headerToGroup);
      headerToGroup.headerGroup = headerGroup;
    });
    headerGroups.push(headerGroup);
    if (depth > 0) {
      createHeaderGroup(pendingParentHeaders, depth - 1);
    }
  };
  const bottomHeaders = columnsToGroup.map((column2, index2) => createHeader(table, column2, {
    depth: maxDepth,
    index: index2
  }));
  createHeaderGroup(bottomHeaders, maxDepth - 1);
  headerGroups.reverse();
  const recurseHeadersForSpans = headers => {
    const filteredHeaders = headers.filter(header => header.column.getIsVisible());
    return filteredHeaders.map(header => {
      let colSpan = 0;
      let rowSpan = 0;
      let childRowSpans = [0];
      if (header.subHeaders && header.subHeaders.length) {
        childRowSpans = [];
        recurseHeadersForSpans(header.subHeaders).forEach(_ref3 => {
          let {
            colSpan: childColSpan,
            rowSpan: childRowSpan
          } = _ref3;
          colSpan += childColSpan;
          childRowSpans.push(childRowSpan);
        });
      } else {
        colSpan = 1;
      }
      const minChildRowSpan = Math.min(...childRowSpans);
      rowSpan = rowSpan + minChildRowSpan;
      header.colSpan = colSpan;
      header.rowSpan = rowSpan;
      return {
        colSpan,
        rowSpan
      };
    });
  };
  recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
  return headerGroups;
}
const defaultColumnSizing = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
};
const getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: false,
  columnSizingStart: []
});
const ColumnSizing = {
  getDefaultColumnDef: () => {
    return defaultColumnSizing;
  },
  getInitialState: state => {
    return {
      columnSizing: {},
      columnSizingInfo: getDefaultColumnSizingInfoState(),
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      columnResizeMode: "onEnd",
      onColumnSizingChange: makeStateUpdater("columnSizing", table),
      onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", table)
    };
  },
  createColumn: (column2, table) => {
    return {
      getSize: () => {
        var _column$columnDef$min, _ref3, _column$columnDef$max;
        const columnSize = table.getState().columnSizing[column2.id];
        return Math.min(Math.max((_column$columnDef$min = column2.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref3 = columnSize != null ? columnSize : column2.columnDef.size) != null ? _ref3 : defaultColumnSizing.size), (_column$columnDef$max = column2.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
      },
      getStart: position2 => {
        const columns = !position2 ? table.getVisibleLeafColumns() : position2 === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
        const index2 = columns.findIndex(d2 => d2.id === column2.id);
        if (index2 > 0) {
          const prevSiblingColumn = columns[index2 - 1];
          return prevSiblingColumn.getStart(position2) + prevSiblingColumn.getSize();
        }
        return 0;
      },
      resetSize: () => {
        table.setColumnSizing(_ref22 => {
          let {
            [column2.id]: _,
            ...rest
          } = _ref22;
          return rest;
        });
      },
      getCanResize: () => {
        var _column$columnDef$ena, _table$options$enable;
        return ((_column$columnDef$ena = column2.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
      },
      getIsResizing: () => {
        return table.getState().columnSizingInfo.isResizingColumn === column2.id;
      }
    };
  },
  createHeader: (header, table) => {
    return {
      getSize: () => {
        let sum2 = 0;
        const recurse = header2 => {
          if (header2.subHeaders.length) {
            header2.subHeaders.forEach(recurse);
          } else {
            var _header$column$getSiz;
            sum2 += (_header$column$getSiz = header2.column.getSize()) != null ? _header$column$getSiz : 0;
          }
        };
        recurse(header);
        return sum2;
      },
      getStart: () => {
        if (header.index > 0) {
          const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
          return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
        }
        return 0;
      },
      getResizeHandler: () => {
        const column2 = table.getColumn(header.column.id);
        const canResize = column2.getCanResize();
        return e2 => {
          if (!canResize) {
            return;
          }
          e2.persist == null ? void 0 : e2.persist();
          if (isTouchStartEvent(e2)) {
            if (e2.touches && e2.touches.length > 1) {
              return;
            }
          }
          const startSize = header.getSize();
          const columnSizingStart = header ? header.getLeafHeaders().map(d2 => [d2.column.id, d2.column.getSize()]) : [[column2.id, column2.getSize()]];
          const clientX = isTouchStartEvent(e2) ? Math.round(e2.touches[0].clientX) : e2.clientX;
          const newColumnSizing = {};
          const updateOffset = (eventType, clientXPos) => {
            if (typeof clientXPos !== "number") {
              return;
            }
            table.setColumnSizingInfo(old => {
              var _old$startOffset, _old$startSize;
              const deltaOffset = clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0);
              const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
              old.columnSizingStart.forEach(_ref3 => {
                let [columnId, headerSize] = _ref3;
                newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
              });
              return {
                ...old,
                deltaOffset,
                deltaPercentage
              };
            });
            if (table.options.columnResizeMode === "onChange" || eventType === "end") {
              table.setColumnSizing(old => ({
                ...old,
                ...newColumnSizing
              }));
            }
          };
          const onMove = clientXPos => updateOffset("move", clientXPos);
          const onEnd = clientXPos => {
            updateOffset("end", clientXPos);
            table.setColumnSizingInfo(old => ({
              ...old,
              isResizingColumn: false,
              startOffset: null,
              startSize: null,
              deltaOffset: null,
              deltaPercentage: null,
              columnSizingStart: []
            }));
          };
          const mouseEvents = {
            moveHandler: e3 => onMove(e3.clientX),
            upHandler: e3 => {
              document.removeEventListener("mousemove", mouseEvents.moveHandler);
              document.removeEventListener("mouseup", mouseEvents.upHandler);
              onEnd(e3.clientX);
            }
          };
          const touchEvents = {
            moveHandler: e3 => {
              if (e3.cancelable) {
                e3.preventDefault();
                e3.stopPropagation();
              }
              onMove(e3.touches[0].clientX);
              return false;
            },
            upHandler: e3 => {
              var _e$touches$;
              document.removeEventListener("touchmove", touchEvents.moveHandler);
              document.removeEventListener("touchend", touchEvents.upHandler);
              if (e3.cancelable) {
                e3.preventDefault();
                e3.stopPropagation();
              }
              onEnd((_e$touches$ = e3.touches[0]) == null ? void 0 : _e$touches$.clientX);
            }
          };
          const passiveIfSupported = passiveEventSupported() ? {
            passive: false
          } : false;
          if (isTouchStartEvent(e2)) {
            document.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
            document.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
          } else {
            document.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
            document.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
          }
          table.setColumnSizingInfo(old => ({
            ...old,
            startOffset: clientX,
            startSize,
            deltaOffset: 0,
            deltaPercentage: 0,
            columnSizingStart,
            isResizingColumn: column2.id
          }));
        };
      }
    };
  },
  createTable: table => {
    return {
      setColumnSizing: updater => table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater),
      setColumnSizingInfo: updater => table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater),
      resetColumnSizing: defaultState => {
        var _table$initialState$c;
        table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
      },
      resetHeaderSizeInfo: defaultState => {
        var _table$initialState$c2;
        table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
      },
      getTotalSize: () => {
        var _table$getHeaderGroup, _table$getHeaderGroup2;
        return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum2, header) => {
          return sum2 + header.getSize();
        }, 0)) != null ? _table$getHeaderGroup : 0;
      },
      getLeftTotalSize: () => {
        var _table$getLeftHeaderG, _table$getLeftHeaderG2;
        return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum2, header) => {
          return sum2 + header.getSize();
        }, 0)) != null ? _table$getLeftHeaderG : 0;
      },
      getCenterTotalSize: () => {
        var _table$getCenterHeade, _table$getCenterHeade2;
        return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum2, header) => {
          return sum2 + header.getSize();
        }, 0)) != null ? _table$getCenterHeade : 0;
      },
      getRightTotalSize: () => {
        var _table$getRightHeader, _table$getRightHeader2;
        return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum2, header) => {
          return sum2 + header.getSize();
        }, 0)) != null ? _table$getRightHeader : 0;
      }
    };
  }
};
let passiveSupported$1 = null;
function passiveEventSupported() {
  if (typeof passiveSupported$1 === "boolean") return passiveSupported$1;
  let supported = false;
  try {
    const options = {
      get passive() {
        supported = true;
        return false;
      }
    };
    const noop6 = () => {};
    window.addEventListener("test", noop6, options);
    window.removeEventListener("test", noop6);
  } catch (err) {
    supported = false;
  }
  passiveSupported$1 = supported;
  return passiveSupported$1;
}
function isTouchStartEvent(e2) {
  return e2.type === "touchstart";
}
const Expanding = {
  getInitialState: state => {
    return {
      expanded: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onExpandedChange: makeStateUpdater("expanded", table),
      paginateExpandedRows: true
    };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    return {
      _autoResetExpanded: () => {
        var _ref3, _table$options$autoRe;
        if (!registered) {
          table._queue(() => {
            registered = true;
          });
          return;
        }
        if ((_ref3 = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref3 : !table.options.manualExpanding) {
          if (queued) return;
          queued = true;
          table._queue(() => {
            table.resetExpanded();
            queued = false;
          });
        }
      },
      setExpanded: updater => table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater),
      toggleAllRowsExpanded: expanded => {
        if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) {
          table.setExpanded(true);
        } else {
          table.setExpanded({});
        }
      },
      resetExpanded: defaultState => {
        var _table$initialState$e, _table$initialState;
        table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
      },
      getCanSomeRowsExpand: () => {
        return table.getRowModel().flatRows.some(row => row.getCanExpand());
      },
      getToggleAllRowsExpandedHandler: () => {
        return e2 => {
          e2.persist == null ? void 0 : e2.persist();
          table.toggleAllRowsExpanded();
        };
      },
      getIsSomeRowsExpanded: () => {
        const expanded = table.getState().expanded;
        return expanded === true || Object.values(expanded).some(Boolean);
      },
      getIsAllRowsExpanded: () => {
        const expanded = table.getState().expanded;
        if (typeof expanded === "boolean") {
          return expanded === true;
        }
        if (!Object.keys(expanded).length) {
          return false;
        }
        if (table.getRowModel().flatRows.some(row => !row.getIsExpanded())) {
          return false;
        }
        return true;
      },
      getExpandedDepth: () => {
        let maxDepth = 0;
        const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
        rowIds.forEach(id => {
          const splitId = id.split(".");
          maxDepth = Math.max(maxDepth, splitId.length);
        });
        return maxDepth;
      },
      getPreExpandedRowModel: () => table.getSortedRowModel(),
      getExpandedRowModel: () => {
        if (!table._getExpandedRowModel && table.options.getExpandedRowModel) {
          table._getExpandedRowModel = table.options.getExpandedRowModel(table);
        }
        if (table.options.manualExpanding || !table._getExpandedRowModel) {
          return table.getPreExpandedRowModel();
        }
        return table._getExpandedRowModel();
      }
    };
  },
  createRow: (row, table) => {
    return {
      toggleExpanded: expanded => {
        table.setExpanded(old => {
          var _expanded;
          const exists = old === true ? true : !!(old != null && old[row.id]);
          let oldExpanded = {};
          if (old === true) {
            Object.keys(table.getRowModel().rowsById).forEach(rowId => {
              oldExpanded[rowId] = true;
            });
          } else {
            oldExpanded = old;
          }
          expanded = (_expanded = expanded) != null ? _expanded : !exists;
          if (!exists && expanded) {
            return {
              ...oldExpanded,
              [row.id]: true
            };
          }
          if (exists && !expanded) {
            const {
              [row.id]: _,
              ...rest
            } = oldExpanded;
            return rest;
          }
          return old;
        });
      },
      getIsExpanded: () => {
        var _table$options$getIsR;
        const expanded = table.getState().expanded;
        return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
      },
      getCanExpand: () => {
        var _table$options$getRow, _table$options$enable, _row$subRows;
        return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
      },
      getToggleExpandedHandler: () => {
        const canExpand = row.getCanExpand();
        return () => {
          if (!canExpand) return;
          row.toggleExpanded();
        };
      }
    };
  }
};
const includesString = (row, columnId, filterValue) => {
  var _row$getValue;
  const search = filterValue.toLowerCase();
  return Boolean((_row$getValue = row.getValue(columnId)) == null ? void 0 : _row$getValue.toLowerCase().includes(search));
};
includesString.autoRemove = val => testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue) => {
  var _row$getValue2;
  return Boolean((_row$getValue2 = row.getValue(columnId)) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = val => testFalsey(val);
const equalsString = (row, columnId, filterValue) => {
  var _row$getValue3;
  return ((_row$getValue3 = row.getValue(columnId)) == null ? void 0 : _row$getValue3.toLowerCase()) === filterValue.toLowerCase();
};
equalsString.autoRemove = val => testFalsey(val);
const arrIncludes = (row, columnId, filterValue) => {
  var _row$getValue4;
  return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = val => testFalsey(val) || !(val != null && val.length);
const arrIncludesAll = (row, columnId, filterValue) => {
  return !filterValue.some(val => {
    var _row$getValue5;
    return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
  });
};
arrIncludesAll.autoRemove = val => testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue) => {
  return filterValue.some(val => {
    var _row$getValue6;
    return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
  });
};
arrIncludesSome.autoRemove = val => testFalsey(val) || !(val != null && val.length);
const equals2 = (row, columnId, filterValue) => {
  return row.getValue(columnId) === filterValue;
};
equals2.autoRemove = val => testFalsey(val);
const weakEquals = (row, columnId, filterValue) => {
  return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = val => testFalsey(val);
const inNumberRange = (row, columnId, filterValue) => {
  let [min2, max2] = filterValue;
  const rowValue = row.getValue(columnId);
  return rowValue >= min2 && rowValue <= max2;
};
inNumberRange.resolveFilterValue = val => {
  let [unsafeMin, unsafeMax] = val;
  let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
  let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
  let min2 = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
  let max2 = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
  if (min2 > max2) {
    const temp = min2;
    min2 = max2;
    max2 = temp;
  }
  return [min2, max2];
};
inNumberRange.autoRemove = val => testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals: equals2,
  weakEquals,
  inNumberRange
};
function testFalsey(val) {
  return val === void 0 || val === null || val === "";
}
const Filters = {
  getDefaultColumnDef: () => {
    return {
      filterFn: "auto"
    };
  },
  getInitialState: state => {
    return {
      columnFilters: [],
      globalFilter: void 0,
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnFiltersChange: makeStateUpdater("columnFilters", table),
      onGlobalFilterChange: makeStateUpdater("globalFilter", table),
      filterFromLeafRows: false,
      maxLeafRowFilterDepth: 100,
      globalFilterFn: "auto",
      getColumnCanGlobalFilter: column2 => {
        var _table$getCoreRowMode, _table$getCoreRowMode2;
        const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null ? void 0 : (_table$getCoreRowMode2 = _table$getCoreRowMode._getAllCellsByColumnId()[column2.id]) == null ? void 0 : _table$getCoreRowMode2.getValue();
        return typeof value === "string" || typeof value === "number";
      }
    };
  },
  createColumn: (column2, table) => {
    return {
      getAutoFilterFn: () => {
        const firstRow = table.getCoreRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column2.id);
        if (typeof value === "string") {
          return filterFns.includesString;
        }
        if (typeof value === "number") {
          return filterFns.inNumberRange;
        }
        if (typeof value === "boolean") {
          return filterFns.equals;
        }
        if (value !== null && typeof value === "object") {
          return filterFns.equals;
        }
        if (Array.isArray(value)) {
          return filterFns.arrIncludes;
        }
        return filterFns.weakEquals;
      },
      getFilterFn: () => {
        var _table$options$filter, _table$options$filter2;
        return isFunction$1(column2.columnDef.filterFn) ? column2.columnDef.filterFn : column2.columnDef.filterFn === "auto" ? column2.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column2.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column2.columnDef.filterFn];
      },
      getCanFilter: () => {
        var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
        return ((_column$columnDef$ena = column2.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column2.accessorFn;
      },
      getCanGlobalFilter: () => {
        var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
        return ((_column$columnDef$ena2 = column2.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column2)) != null ? _table$options$getCol : true) && !!column2.accessorFn;
      },
      getIsFiltered: () => column2.getFilterIndex() > -1,
      getFilterValue: () => {
        var _table$getState$colum, _table$getState$colum2;
        return (_table$getState$colum = table.getState().columnFilters) == null ? void 0 : (_table$getState$colum2 = _table$getState$colum.find(d2 => d2.id === column2.id)) == null ? void 0 : _table$getState$colum2.value;
      },
      getFilterIndex: () => {
        var _table$getState$colum3, _table$getState$colum4;
        return (_table$getState$colum3 = (_table$getState$colum4 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum4.findIndex(d2 => d2.id === column2.id)) != null ? _table$getState$colum3 : -1;
      },
      setFilterValue: value => {
        table.setColumnFilters(old => {
          const filterFn = column2.getFilterFn();
          const previousfilter = old == null ? void 0 : old.find(d2 => d2.id === column2.id);
          const newFilter = functionalUpdate(value, previousfilter ? previousfilter.value : void 0);
          if (shouldAutoRemoveFilter(filterFn, newFilter, column2)) {
            var _old$filter;
            return (_old$filter = old == null ? void 0 : old.filter(d2 => d2.id !== column2.id)) != null ? _old$filter : [];
          }
          const newFilterObj = {
            id: column2.id,
            value: newFilter
          };
          if (previousfilter) {
            var _old$map;
            return (_old$map = old == null ? void 0 : old.map(d2 => {
              if (d2.id === column2.id) {
                return newFilterObj;
              }
              return d2;
            })) != null ? _old$map : [];
          }
          if (old != null && old.length) {
            return [...old, newFilterObj];
          }
          return [newFilterObj];
        });
      },
      _getFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column2.id),
      getFacetedRowModel: () => {
        if (!column2._getFacetedRowModel) {
          return table.getPreFilteredRowModel();
        }
        return column2._getFacetedRowModel();
      },
      _getFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column2.id),
      getFacetedUniqueValues: () => {
        if (!column2._getFacetedUniqueValues) {
          return /* @__PURE__ */new Map();
        }
        return column2._getFacetedUniqueValues();
      },
      _getFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column2.id),
      getFacetedMinMaxValues: () => {
        if (!column2._getFacetedMinMaxValues) {
          return void 0;
        }
        return column2._getFacetedMinMaxValues();
      }
    };
  },
  createRow: (row, table) => {
    return {
      columnFilters: {},
      columnFiltersMeta: {}
    };
  },
  createTable: table => {
    return {
      getGlobalAutoFilterFn: () => {
        return filterFns.includesString;
      },
      getGlobalFilterFn: () => {
        var _table$options$filter3, _table$options$filter4;
        const {
          globalFilterFn
        } = table.options;
        return isFunction$1(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : filterFns[globalFilterFn];
      },
      setColumnFilters: updater => {
        const leafColumns = table.getAllLeafColumns();
        const updateFn = old => {
          var _functionalUpdate;
          return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter(filter2 => {
            const column2 = leafColumns.find(d2 => d2.id === filter2.id);
            if (column2) {
              const filterFn = column2.getFilterFn();
              if (shouldAutoRemoveFilter(filterFn, filter2.value, column2)) {
                return false;
              }
            }
            return true;
          });
        };
        table.options.onColumnFiltersChange == null ? void 0 : table.options.onColumnFiltersChange(updateFn);
      },
      setGlobalFilter: updater => {
        table.options.onGlobalFilterChange == null ? void 0 : table.options.onGlobalFilterChange(updater);
      },
      resetGlobalFilter: defaultState => {
        table.setGlobalFilter(defaultState ? void 0 : table.initialState.globalFilter);
      },
      resetColumnFilters: defaultState => {
        var _table$initialState$c, _table$initialState;
        table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
      },
      getPreFilteredRowModel: () => table.getCoreRowModel(),
      getFilteredRowModel: () => {
        if (!table._getFilteredRowModel && table.options.getFilteredRowModel) {
          table._getFilteredRowModel = table.options.getFilteredRowModel(table);
        }
        if (table.options.manualFiltering || !table._getFilteredRowModel) {
          return table.getPreFilteredRowModel();
        }
        return table._getFilteredRowModel();
      },
      _getGlobalFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__"),
      getGlobalFacetedRowModel: () => {
        if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) {
          return table.getPreFilteredRowModel();
        }
        return table._getGlobalFacetedRowModel();
      },
      _getGlobalFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__"),
      getGlobalFacetedUniqueValues: () => {
        if (!table._getGlobalFacetedUniqueValues) {
          return /* @__PURE__ */new Map();
        }
        return table._getGlobalFacetedUniqueValues();
      },
      _getGlobalFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__"),
      getGlobalFacetedMinMaxValues: () => {
        if (!table._getGlobalFacetedMinMaxValues) {
          return;
        }
        return table._getGlobalFacetedMinMaxValues();
      }
    };
  }
};
function shouldAutoRemoveFilter(filterFn, value, column2) {
  return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column2) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const sum = (columnId, _leafRows, childRows) => {
  return childRows.reduce((sum2, next2) => {
    const nextValue = next2.getValue(columnId);
    return sum2 + (typeof nextValue === "number" ? nextValue : 0);
  }, 0);
};
const min = (columnId, _leafRows, childRows) => {
  let min2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
      min2 = value;
    }
  });
  return min2;
};
const max = (columnId, _leafRows, childRows) => {
  let max2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
      max2 = value;
    }
  });
  return max2;
};
const extent = (columnId, _leafRows, childRows) => {
  let min2;
  let max2;
  childRows.forEach(row => {
    const value = row.getValue(columnId);
    if (value != null) {
      if (min2 === void 0) {
        if (value >= value) min2 = max2 = value;
      } else {
        if (min2 > value) min2 = value;
        if (max2 < value) max2 = value;
      }
    }
  });
  return [min2, max2];
};
const mean = (columnId, leafRows) => {
  let count2 = 0;
  let sum2 = 0;
  leafRows.forEach(row => {
    let value = row.getValue(columnId);
    if (value != null && (value = +value) >= value) {
      ++count2, sum2 += value;
    }
  });
  if (count2) return sum2 / count2;
  return;
};
const median = (columnId, leafRows) => {
  if (!leafRows.length) {
    return;
  }
  let min2 = 0;
  let max2 = 0;
  leafRows.forEach(row => {
    let value = row.getValue(columnId);
    if (typeof value === "number") {
      min2 = Math.min(min2, value);
      max2 = Math.max(max2, value);
    }
  });
  return (min2 + max2) / 2;
};
const unique = (columnId, leafRows) => {
  return Array.from(new Set(leafRows.map(d2 => d2.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows) => {
  return new Set(leafRows.map(d2 => d2.getValue(columnId))).size;
};
const count = (_columnId, leafRows) => {
  return leafRows.length;
};
const aggregationFns = {
  sum,
  min,
  max,
  extent,
  mean,
  median,
  unique,
  uniqueCount,
  count
};
const Grouping = {
  getDefaultColumnDef: () => {
    return {
      aggregatedCell: props => {
        var _toString2, _props$getValue;
        return (_toString2 = (_props$getValue = props.getValue()) == null ? void 0 : _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString2 : null;
      },
      aggregationFn: "auto"
    };
  },
  getInitialState: state => {
    return {
      grouping: [],
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onGroupingChange: makeStateUpdater("grouping", table),
      groupedColumnMode: "reorder"
    };
  },
  createColumn: (column2, table) => {
    return {
      toggleGrouping: () => {
        table.setGrouping(old => {
          if (old != null && old.includes(column2.id)) {
            return old.filter(d2 => d2 !== column2.id);
          }
          return [...(old != null ? old : []), column2.id];
        });
      },
      getCanGroup: () => {
        var _ref3, _ref22, _ref32, _column$columnDef$ena;
        return (_ref3 = (_ref22 = (_ref32 = (_column$columnDef$ena = column2.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref32 : table.options.enableGrouping) != null ? _ref22 : true) != null ? _ref3 : !!column2.accessorFn;
      },
      getIsGrouped: () => {
        var _table$getState$group;
        return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column2.id);
      },
      getGroupedIndex: () => {
        var _table$getState$group2;
        return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column2.id);
      },
      getToggleGroupingHandler: () => {
        const canGroup = column2.getCanGroup();
        return () => {
          if (!canGroup) return;
          column2.toggleGrouping();
        };
      },
      getAutoAggregationFn: () => {
        const firstRow = table.getCoreRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column2.id);
        if (typeof value === "number") {
          return aggregationFns.sum;
        }
        if (Object.prototype.toString.call(value) === "[object Date]") {
          return aggregationFns.extent;
        }
      },
      getAggregationFn: () => {
        var _table$options$aggreg, _table$options$aggreg2;
        if (!column2) {
          throw new Error();
        }
        return isFunction$1(column2.columnDef.aggregationFn) ? column2.columnDef.aggregationFn : column2.columnDef.aggregationFn === "auto" ? column2.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column2.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column2.columnDef.aggregationFn];
      }
    };
  },
  createTable: table => {
    return {
      setGrouping: updater => table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater),
      resetGrouping: defaultState => {
        var _table$initialState$g, _table$initialState;
        table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
      },
      getPreGroupedRowModel: () => table.getFilteredRowModel(),
      getGroupedRowModel: () => {
        if (!table._getGroupedRowModel && table.options.getGroupedRowModel) {
          table._getGroupedRowModel = table.options.getGroupedRowModel(table);
        }
        if (table.options.manualGrouping || !table._getGroupedRowModel) {
          return table.getPreGroupedRowModel();
        }
        return table._getGroupedRowModel();
      }
    };
  },
  createRow: row => {
    return {
      getIsGrouped: () => !!row.groupingColumnId,
      _groupingValuesCache: {}
    };
  },
  createCell: (cell, column2, row, table) => {
    return {
      getIsGrouped: () => column2.getIsGrouped() && column2.id === row.groupingColumnId,
      getIsPlaceholder: () => !cell.getIsGrouped() && column2.getIsGrouped(),
      getIsAggregated: () => {
        var _row$subRows;
        return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
      }
    };
  }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
  if (!(grouping != null && grouping.length) || !groupedColumnMode) {
    return leafColumns;
  }
  const nonGroupingColumns = leafColumns.filter(col => !grouping.includes(col.id));
  if (groupedColumnMode === "remove") {
    return nonGroupingColumns;
  }
  const groupingColumns = grouping.map(g2 => leafColumns.find(col => col.id === g2)).filter(Boolean);
  return [...groupingColumns, ...nonGroupingColumns];
}
const Ordering = {
  getInitialState: state => {
    return {
      columnOrder: [],
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnOrderChange: makeStateUpdater("columnOrder", table)
    };
  },
  createTable: table => {
    return {
      setColumnOrder: updater => table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater),
      resetColumnOrder: defaultState => {
        var _table$initialState$c;
        table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
      },
      _getOrderColumnsFn: memo(() => [table.getState().columnOrder, table.getState().grouping, table.options.groupedColumnMode], (columnOrder, grouping, groupedColumnMode) => columns => {
        let orderedColumns = [];
        if (!(columnOrder != null && columnOrder.length)) {
          orderedColumns = columns;
        } else {
          const columnOrderCopy = [...columnOrder];
          const columnsCopy = [...columns];
          while (columnsCopy.length && columnOrderCopy.length) {
            const targetColumnId = columnOrderCopy.shift();
            const foundIndex = columnsCopy.findIndex(d2 => d2.id === targetColumnId);
            if (foundIndex > -1) {
              orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
            }
          }
          orderedColumns = [...orderedColumns, ...columnsCopy];
        }
        return orderColumns(orderedColumns, grouping, groupedColumnMode);
      }, {
        key: false
      })
    };
  }
};
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize
});
const Pagination = {
  getInitialState: state => {
    return {
      ...state,
      pagination: {
        ...getDefaultPaginationState(),
        ...(state == null ? void 0 : state.pagination)
      }
    };
  },
  getDefaultOptions: table => {
    return {
      onPaginationChange: makeStateUpdater("pagination", table)
    };
  },
  createTable: table => {
    let registered = false;
    let queued = false;
    return {
      _autoResetPageIndex: () => {
        var _ref3, _table$options$autoRe;
        if (!registered) {
          table._queue(() => {
            registered = true;
          });
          return;
        }
        if ((_ref3 = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref3 : !table.options.manualPagination) {
          if (queued) return;
          queued = true;
          table._queue(() => {
            table.resetPageIndex();
            queued = false;
          });
        }
      },
      setPagination: updater => {
        const safeUpdater = old => {
          let newState = functionalUpdate(updater, old);
          return newState;
        };
        return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
      },
      resetPagination: defaultState => {
        var _table$initialState$p;
        table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
      },
      setPageIndex: updater => {
        table.setPagination(old => {
          let pageIndex = functionalUpdate(updater, old.pageIndex);
          const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
          pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
          return {
            ...old,
            pageIndex
          };
        });
      },
      resetPageIndex: defaultState => {
        var _table$initialState$p2, _table$initialState, _table$initialState$p3;
        table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null ? void 0 : (_table$initialState$p3 = _table$initialState.pagination) == null ? void 0 : _table$initialState$p3.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
      },
      resetPageSize: defaultState => {
        var _table$initialState$p4, _table$initialState2, _table$initialState2$;
        table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p4 = (_table$initialState2 = table.initialState) == null ? void 0 : (_table$initialState2$ = _table$initialState2.pagination) == null ? void 0 : _table$initialState2$.pageSize) != null ? _table$initialState$p4 : defaultPageSize);
      },
      setPageSize: updater => {
        table.setPagination(old => {
          const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
          const topRowIndex = old.pageSize * old.pageIndex;
          const pageIndex = Math.floor(topRowIndex / pageSize);
          return {
            ...old,
            pageIndex,
            pageSize
          };
        });
      },
      setPageCount: updater => table.setPagination(old => {
        var _table$options$pageCo;
        let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
        if (typeof newPageCount === "number") {
          newPageCount = Math.max(-1, newPageCount);
        }
        return {
          ...old,
          pageCount: newPageCount
        };
      }),
      getPageOptions: memo(() => [table.getPageCount()], pageCount => {
        let pageOptions = [];
        if (pageCount && pageCount > 0) {
          pageOptions = [...new Array(pageCount)].fill(null).map((_, i) => i);
        }
        return pageOptions;
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA;
          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
        }
      }),
      getCanPreviousPage: () => table.getState().pagination.pageIndex > 0,
      getCanNextPage: () => {
        const {
          pageIndex
        } = table.getState().pagination;
        const pageCount = table.getPageCount();
        if (pageCount === -1) {
          return true;
        }
        if (pageCount === 0) {
          return false;
        }
        return pageIndex < pageCount - 1;
      },
      previousPage: () => {
        return table.setPageIndex(old => old - 1);
      },
      nextPage: () => {
        return table.setPageIndex(old => {
          return old + 1;
        });
      },
      getPrePaginationRowModel: () => table.getExpandedRowModel(),
      getPaginationRowModel: () => {
        if (!table._getPaginationRowModel && table.options.getPaginationRowModel) {
          table._getPaginationRowModel = table.options.getPaginationRowModel(table);
        }
        if (table.options.manualPagination || !table._getPaginationRowModel) {
          return table.getPrePaginationRowModel();
        }
        return table._getPaginationRowModel();
      },
      getPageCount: () => {
        var _table$options$pageCo2;
        return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
      }
    };
  }
};
const getDefaultPinningState = () => ({
  left: [],
  right: []
});
const Pinning = {
  getInitialState: state => {
    return {
      columnPinning: getDefaultPinningState(),
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnPinningChange: makeStateUpdater("columnPinning", table)
    };
  },
  createColumn: (column2, table) => {
    return {
      pin: position2 => {
        const columnIds = column2.getLeafColumns().map(d2 => d2.id).filter(Boolean);
        table.setColumnPinning(old => {
          var _old$left3, _old$right3;
          if (position2 === "right") {
            var _old$left, _old$right;
            return {
              left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter(d2 => !(columnIds != null && columnIds.includes(d2))),
              right: [...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter(d2 => !(columnIds != null && columnIds.includes(d2))), ...columnIds]
            };
          }
          if (position2 === "left") {
            var _old$left2, _old$right2;
            return {
              left: [...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter(d2 => !(columnIds != null && columnIds.includes(d2))), ...columnIds],
              right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter(d2 => !(columnIds != null && columnIds.includes(d2)))
            };
          }
          return {
            left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter(d2 => !(columnIds != null && columnIds.includes(d2))),
            right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter(d2 => !(columnIds != null && columnIds.includes(d2)))
          };
        });
      },
      getCanPin: () => {
        const leafColumns = column2.getLeafColumns();
        return leafColumns.some(d2 => {
          var _d$columnDef$enablePi, _table$options$enable;
          return ((_d$columnDef$enablePi = d2.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_table$options$enable = table.options.enablePinning) != null ? _table$options$enable : true);
        });
      },
      getIsPinned: () => {
        const leafColumnIds = column2.getLeafColumns().map(d2 => d2.id);
        const {
          left,
          right
        } = table.getState().columnPinning;
        const isLeft = leafColumnIds.some(d2 => left == null ? void 0 : left.includes(d2));
        const isRight = leafColumnIds.some(d2 => right == null ? void 0 : right.includes(d2));
        return isLeft ? "left" : isRight ? "right" : false;
      },
      getPinnedIndex: () => {
        var _table$getState$colum, _table$getState$colum2, _table$getState$colum3;
        const position2 = column2.getIsPinned();
        return position2 ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null ? void 0 : (_table$getState$colum3 = _table$getState$colum2[position2]) == null ? void 0 : _table$getState$colum3.indexOf(column2.id)) != null ? _table$getState$colum : -1 : 0;
      }
    };
  },
  createRow: (row, table) => {
    return {
      getCenterVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allCells, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allCells.filter(d2 => !leftAndRight.includes(d2.column.id));
      }, {
        key: "row.getCenterVisibleCells",
        debug: () => {
          var _table$options$debugA;
          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
        }
      }),
      getLeftVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.left,,], (allCells, left) => {
        const cells = (left != null ? left : []).map(columnId => allCells.find(cell => cell.column.id === columnId)).filter(Boolean).map(d2 => ({
          ...d2,
          position: "left"
        }));
        return cells;
      }, {
        key: "row.getLeftVisibleCells",
        debug: () => {
          var _table$options$debugA2;
          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
        }
      }),
      getRightVisibleCells: memo(() => [row._getAllVisibleCells(), table.getState().columnPinning.right], (allCells, right) => {
        const cells = (right != null ? right : []).map(columnId => allCells.find(cell => cell.column.id === columnId)).filter(Boolean).map(d2 => ({
          ...d2,
          position: "right"
        }));
        return cells;
      }, {
        key: "row.getRightVisibleCells",
        debug: () => {
          var _table$options$debugA3;
          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugRows;
        }
      })
    };
  },
  createTable: table => {
    return {
      setColumnPinning: updater => table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater),
      resetColumnPinning: defaultState => {
        var _table$initialState$c, _table$initialState;
        return table.setColumnPinning(defaultState ? getDefaultPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultPinningState());
      },
      getIsSomeColumnsPinned: position2 => {
        var _pinningState$positio;
        const pinningState = table.getState().columnPinning;
        if (!position2) {
          var _pinningState$left, _pinningState$right;
          return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
        }
        return Boolean((_pinningState$positio = pinningState[position2]) == null ? void 0 : _pinningState$positio.length);
      },
      getLeftLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.left], (allColumns, left) => {
        return (left != null ? left : []).map(columnId => allColumns.find(column2 => column2.id === columnId)).filter(Boolean);
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA4;
          return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
        }
      }),
      getRightLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.right], (allColumns, right) => {
        return (right != null ? right : []).map(columnId => allColumns.find(column2 => column2.id === columnId)).filter(Boolean);
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA5;
          return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
        }
      }),
      getCenterLeafColumns: memo(() => [table.getAllLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, left, right) => {
        const leftAndRight = [...(left != null ? left : []), ...(right != null ? right : [])];
        return allColumns.filter(d2 => !leftAndRight.includes(d2.id));
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA6;
          return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugColumns;
        }
      })
    };
  }
};
const RowSelection = {
  getInitialState: state => {
    return {
      rowSelection: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onRowSelectionChange: makeStateUpdater("rowSelection", table),
      enableRowSelection: true,
      enableMultiRowSelection: true,
      enableSubRowSelection: true
    };
  },
  createTable: table => {
    return {
      setRowSelection: updater => table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater),
      resetRowSelection: defaultState => {
        var _table$initialState$r;
        return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
      },
      toggleAllRowsSelected: value => {
        table.setRowSelection(old => {
          value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
          const rowSelection = {
            ...old
          };
          const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
          if (value) {
            preGroupedFlatRows.forEach(row => {
              if (!row.getCanSelect()) {
                return;
              }
              rowSelection[row.id] = true;
            });
          } else {
            preGroupedFlatRows.forEach(row => {
              delete rowSelection[row.id];
            });
          }
          return rowSelection;
        });
      },
      toggleAllPageRowsSelected: value => table.setRowSelection(old => {
        const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
        const rowSelection = {
          ...old
        };
        table.getRowModel().rows.forEach(row => {
          mutateRowIsSelected(rowSelection, row.id, resolvedValue, table);
        });
        return rowSelection;
      }),
      getPreSelectedRowModel: () => table.getCoreRowModel(),
      getSelectedRowModel: memo(() => [table.getState().rowSelection, table.getCoreRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }
        return selectRowsFn(table, rowModel);
      }, {
        key: false,
        debug: () => {
          var _table$options$debugA;
          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
        }
      }),
      getFilteredSelectedRowModel: memo(() => [table.getState().rowSelection, table.getFilteredRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }
        return selectRowsFn(table, rowModel);
      }, {
        key: "getFilteredSelectedRowModel",
        debug: () => {
          var _table$options$debugA2;
          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugTable;
        }
      }),
      getGroupedSelectedRowModel: memo(() => [table.getState().rowSelection, table.getSortedRowModel()], (rowSelection, rowModel) => {
        if (!Object.keys(rowSelection).length) {
          return {
            rows: [],
            flatRows: [],
            rowsById: {}
          };
        }
        return selectRowsFn(table, rowModel);
      }, {
        key: "getGroupedSelectedRowModel",
        debug: () => {
          var _table$options$debugA3;
          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugTable;
        }
      }),
      getIsAllRowsSelected: () => {
        const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
        const {
          rowSelection
        } = table.getState();
        let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
        if (isAllRowsSelected) {
          if (preGroupedFlatRows.some(row => row.getCanSelect() && !rowSelection[row.id])) {
            isAllRowsSelected = false;
          }
        }
        return isAllRowsSelected;
      },
      getIsAllPageRowsSelected: () => {
        const paginationFlatRows = table.getPaginationRowModel().flatRows;
        const {
          rowSelection
        } = table.getState();
        let isAllPageRowsSelected = !!paginationFlatRows.length;
        if (isAllPageRowsSelected && paginationFlatRows.some(row => !rowSelection[row.id])) {
          isAllPageRowsSelected = false;
        }
        return isAllPageRowsSelected;
      },
      getIsSomeRowsSelected: () => {
        var _table$getState$rowSe;
        const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
        return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
      },
      getIsSomePageRowsSelected: () => {
        const paginationFlatRows = table.getPaginationRowModel().flatRows;
        return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.some(d2 => d2.getIsSelected() || d2.getIsSomeSelected());
      },
      getToggleAllRowsSelectedHandler: () => {
        return e2 => {
          table.toggleAllRowsSelected(e2.target.checked);
        };
      },
      getToggleAllPageRowsSelectedHandler: () => {
        return e2 => {
          table.toggleAllPageRowsSelected(e2.target.checked);
        };
      }
    };
  },
  createRow: (row, table) => {
    return {
      toggleSelected: value => {
        const isSelected = row.getIsSelected();
        table.setRowSelection(old => {
          value = typeof value !== "undefined" ? value : !isSelected;
          if (isSelected === value) {
            return old;
          }
          const selectedRowIds = {
            ...old
          };
          mutateRowIsSelected(selectedRowIds, row.id, value, table);
          return selectedRowIds;
        });
      },
      getIsSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isRowSelected(row, rowSelection);
      },
      getIsSomeSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isSubRowSelected(row, rowSelection) === "some";
      },
      getIsAllSubRowsSelected: () => {
        const {
          rowSelection
        } = table.getState();
        return isSubRowSelected(row, rowSelection) === "all";
      },
      getCanSelect: () => {
        var _table$options$enable;
        if (typeof table.options.enableRowSelection === "function") {
          return table.options.enableRowSelection(row);
        }
        return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
      },
      getCanSelectSubRows: () => {
        var _table$options$enable2;
        if (typeof table.options.enableSubRowSelection === "function") {
          return table.options.enableSubRowSelection(row);
        }
        return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
      },
      getCanMultiSelect: () => {
        var _table$options$enable3;
        if (typeof table.options.enableMultiRowSelection === "function") {
          return table.options.enableMultiRowSelection(row);
        }
        return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
      },
      getToggleSelectedHandler: () => {
        const canSelect = row.getCanSelect();
        return e2 => {
          var _target;
          if (!canSelect) return;
          row.toggleSelected((_target = e2.target) == null ? void 0 : _target.checked);
        };
      }
    };
  }
};
const mutateRowIsSelected = (selectedRowIds, id, value, table) => {
  var _row$subRows;
  const row = table.getRow(id);
  if (value) {
    if (!row.getCanMultiSelect()) {
      Object.keys(selectedRowIds).forEach(key => delete selectedRowIds[key]);
    }
    if (row.getCanSelect()) {
      selectedRowIds[id] = true;
    }
  } else {
    delete selectedRowIds[id];
  }
  if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) {
    row.subRows.forEach(row2 => mutateRowIsSelected(selectedRowIds, row2.id, value, table));
  }
};
function selectRowsFn(table, rowModel) {
  const rowSelection = table.getState().rowSelection;
  const newSelectedFlatRows = [];
  const newSelectedRowsById = {};
  const recurseRows = function (rows, depth) {
    return rows.map(row => {
      var _row$subRows2;
      const isSelected = isRowSelected(row, rowSelection);
      if (isSelected) {
        newSelectedFlatRows.push(row);
        newSelectedRowsById[row.id] = row;
      }
      if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) {
        row = {
          ...row,
          subRows: recurseRows(row.subRows)
        };
      }
      if (isSelected) {
        return row;
      }
    }).filter(Boolean);
  };
  return {
    rows: recurseRows(rowModel.rows),
    flatRows: newSelectedFlatRows,
    rowsById: newSelectedRowsById
  };
}
function isRowSelected(row, selection) {
  var _selection$row$id;
  return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
  if (row.subRows && row.subRows.length) {
    let allChildrenSelected = true;
    let someSelected = false;
    row.subRows.forEach(subRow => {
      if (someSelected && !allChildrenSelected) {
        return;
      }
      if (isRowSelected(subRow, selection)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
  }
  return false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString2(rowA.getValue(columnId)).toLowerCase(), toString2(rowB.getValue(columnId)).toLowerCase());
};
const alphanumericCaseSensitive = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString2(rowA.getValue(columnId)), toString2(rowB.getValue(columnId)));
};
const text = (rowA, rowB, columnId) => {
  return compareBasic(toString2(rowA.getValue(columnId)).toLowerCase(), toString2(rowB.getValue(columnId)).toLowerCase());
};
const textCaseSensitive = (rowA, rowB, columnId) => {
  return compareBasic(toString2(rowA.getValue(columnId)), toString2(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId) => {
  const a2 = rowA.getValue(columnId);
  const b2 = rowB.getValue(columnId);
  return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
};
const basic = (rowA, rowB, columnId) => {
  return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
function compareBasic(a2, b2) {
  return a2 === b2 ? 0 : a2 > b2 ? 1 : -1;
}
function toString2(a2) {
  if (typeof a2 === "number") {
    if (isNaN(a2) || a2 === Infinity || a2 === -Infinity) {
      return "";
    }
    return String(a2);
  }
  if (typeof a2 === "string") {
    return a2;
  }
  return "";
}
function compareAlphanumeric(aStr, bStr) {
  const a2 = aStr.split(reSplitAlphaNumeric).filter(Boolean);
  const b2 = bStr.split(reSplitAlphaNumeric).filter(Boolean);
  while (a2.length && b2.length) {
    const aa = a2.shift();
    const bb = b2.shift();
    const an = parseInt(aa, 10);
    const bn = parseInt(bb, 10);
    const combo = [an, bn].sort();
    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }
      if (bb > aa) {
        return -1;
      }
      continue;
    }
    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    }
    if (an > bn) {
      return 1;
    }
    if (bn > an) {
      return -1;
    }
  }
  return a2.length - b2.length;
}
const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic
};
const Sorting = {
  getInitialState: state => {
    return {
      sorting: [],
      ...state
    };
  },
  getDefaultColumnDef: () => {
    return {
      sortingFn: "auto"
    };
  },
  getDefaultOptions: table => {
    return {
      onSortingChange: makeStateUpdater("sorting", table),
      isMultiSortEvent: e2 => {
        return e2.shiftKey;
      }
    };
  },
  createColumn: (column2, table) => {
    return {
      getAutoSortingFn: () => {
        const firstRows = table.getFilteredRowModel().flatRows.slice(10);
        let isString = false;
        for (const row of firstRows) {
          const value = row == null ? void 0 : row.getValue(column2.id);
          if (Object.prototype.toString.call(value) === "[object Date]") {
            return sortingFns.datetime;
          }
          if (typeof value === "string") {
            isString = true;
            if (value.split(reSplitAlphaNumeric).length > 1) {
              return sortingFns.alphanumeric;
            }
          }
        }
        if (isString) {
          return sortingFns.text;
        }
        return sortingFns.basic;
      },
      getAutoSortDir: () => {
        const firstRow = table.getFilteredRowModel().flatRows[0];
        const value = firstRow == null ? void 0 : firstRow.getValue(column2.id);
        if (typeof value === "string") {
          return "asc";
        }
        return "desc";
      },
      getSortingFn: () => {
        var _table$options$sortin, _table$options$sortin2;
        if (!column2) {
          throw new Error();
        }
        return isFunction$1(column2.columnDef.sortingFn) ? column2.columnDef.sortingFn : column2.columnDef.sortingFn === "auto" ? column2.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column2.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column2.columnDef.sortingFn];
      },
      toggleSorting: (desc, multi) => {
        const nextSortingOrder = column2.getNextSortingOrder();
        const hasManualValue = typeof desc !== "undefined" && desc !== null;
        table.setSorting(old => {
          const existingSorting = old == null ? void 0 : old.find(d2 => d2.id === column2.id);
          const existingIndex = old == null ? void 0 : old.findIndex(d2 => d2.id === column2.id);
          let newSorting = [];
          let sortAction;
          let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
          if (old != null && old.length && column2.getCanMultiSort() && multi) {
            if (existingSorting) {
              sortAction = "toggle";
            } else {
              sortAction = "add";
            }
          } else {
            if (old != null && old.length && existingIndex !== old.length - 1) {
              sortAction = "replace";
            } else if (existingSorting) {
              sortAction = "toggle";
            } else {
              sortAction = "replace";
            }
          }
          if (sortAction === "toggle") {
            if (!hasManualValue) {
              if (!nextSortingOrder) {
                sortAction = "remove";
              }
            }
          }
          if (sortAction === "add") {
            var _table$options$maxMul;
            newSorting = [...old, {
              id: column2.id,
              desc: nextDesc
            }];
            newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
          } else if (sortAction === "toggle") {
            newSorting = old.map(d2 => {
              if (d2.id === column2.id) {
                return {
                  ...d2,
                  desc: nextDesc
                };
              }
              return d2;
            });
          } else if (sortAction === "remove") {
            newSorting = old.filter(d2 => d2.id !== column2.id);
          } else {
            newSorting = [{
              id: column2.id,
              desc: nextDesc
            }];
          }
          return newSorting;
        });
      },
      getFirstSortDir: () => {
        var _ref3, _column$columnDef$sor;
        const sortDescFirst = (_ref3 = (_column$columnDef$sor = column2.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref3 : column2.getAutoSortDir() === "desc";
        return sortDescFirst ? "desc" : "asc";
      },
      getNextSortingOrder: multi => {
        var _table$options$enable, _table$options$enable2;
        const firstSortDirection = column2.getFirstSortDir();
        const isSorted = column2.getIsSorted();
        if (!isSorted) {
          return firstSortDirection;
        }
        if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true)) {
          return false;
        }
        return isSorted === "desc" ? "asc" : "desc";
      },
      getCanSort: () => {
        var _column$columnDef$ena, _table$options$enable3;
        return ((_column$columnDef$ena = column2.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column2.accessorFn;
      },
      getCanMultiSort: () => {
        var _ref22, _column$columnDef$ena2;
        return (_ref22 = (_column$columnDef$ena2 = column2.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref22 : !!column2.accessorFn;
      },
      getIsSorted: () => {
        var _table$getState$sorti;
        const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find(d2 => d2.id === column2.id);
        return !columnSort ? false : columnSort.desc ? "desc" : "asc";
      },
      getSortIndex: () => {
        var _table$getState$sorti2, _table$getState$sorti3;
        return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex(d2 => d2.id === column2.id)) != null ? _table$getState$sorti2 : -1;
      },
      clearSorting: () => {
        table.setSorting(old => old != null && old.length ? old.filter(d2 => d2.id !== column2.id) : []);
      },
      getToggleSortingHandler: () => {
        const canSort = column2.getCanSort();
        return e2 => {
          if (!canSort) return;
          e2.persist == null ? void 0 : e2.persist();
          column2.toggleSorting == null ? void 0 : column2.toggleSorting(void 0, column2.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e2) : false);
        };
      }
    };
  },
  createTable: table => {
    return {
      setSorting: updater => table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater),
      resetSorting: defaultState => {
        var _table$initialState$s, _table$initialState;
        table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
      },
      getPreSortedRowModel: () => table.getGroupedRowModel(),
      getSortedRowModel: () => {
        if (!table._getSortedRowModel && table.options.getSortedRowModel) {
          table._getSortedRowModel = table.options.getSortedRowModel(table);
        }
        if (table.options.manualSorting || !table._getSortedRowModel) {
          return table.getPreSortedRowModel();
        }
        return table._getSortedRowModel();
      }
    };
  }
};
const Visibility = {
  getInitialState: state => {
    return {
      columnVisibility: {},
      ...state
    };
  },
  getDefaultOptions: table => {
    return {
      onColumnVisibilityChange: makeStateUpdater("columnVisibility", table)
    };
  },
  createColumn: (column2, table) => {
    return {
      toggleVisibility: value => {
        if (column2.getCanHide()) {
          table.setColumnVisibility(old => ({
            ...old,
            [column2.id]: value != null ? value : !column2.getIsVisible()
          }));
        }
      },
      getIsVisible: () => {
        var _table$getState$colum, _table$getState$colum2;
        return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column2.id]) != null ? _table$getState$colum : true;
      },
      getCanHide: () => {
        var _column$columnDef$ena, _table$options$enable;
        return ((_column$columnDef$ena = column2.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
      },
      getToggleVisibilityHandler: () => {
        return e2 => {
          column2.toggleVisibility == null ? void 0 : column2.toggleVisibility(e2.target.checked);
        };
      }
    };
  },
  createRow: (row, table) => {
    return {
      _getAllVisibleCells: memo(() => [row.getAllCells(), table.getState().columnVisibility], cells => {
        return cells.filter(cell => cell.column.getIsVisible());
      }, {
        key: "row._getAllVisibleCells",
        debug: () => {
          var _table$options$debugA;
          return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
        }
      }),
      getVisibleCells: memo(() => [row.getLeftVisibleCells(), row.getCenterVisibleCells(), row.getRightVisibleCells()], (left, center, right) => [...left, ...center, ...right], {
        key: false,
        debug: () => {
          var _table$options$debugA2;
          return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
        }
      })
    };
  },
  createTable: table => {
    const makeVisibleColumnsMethod = (key, getColumns) => {
      return memo(() => [getColumns(), getColumns().filter(d2 => d2.getIsVisible()).map(d2 => d2.id).join("_")], columns => {
        return columns.filter(d2 => d2.getIsVisible == null ? void 0 : d2.getIsVisible());
      }, {
        key,
        debug: () => {
          var _table$options$debugA3;
          return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
        }
      });
    };
    return {
      getVisibleFlatColumns: makeVisibleColumnsMethod("getVisibleFlatColumns", () => table.getAllFlatColumns()),
      getVisibleLeafColumns: makeVisibleColumnsMethod("getVisibleLeafColumns", () => table.getAllLeafColumns()),
      getLeftVisibleLeafColumns: makeVisibleColumnsMethod("getLeftVisibleLeafColumns", () => table.getLeftLeafColumns()),
      getRightVisibleLeafColumns: makeVisibleColumnsMethod("getRightVisibleLeafColumns", () => table.getRightLeafColumns()),
      getCenterVisibleLeafColumns: makeVisibleColumnsMethod("getCenterVisibleLeafColumns", () => table.getCenterLeafColumns()),
      setColumnVisibility: updater => table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater),
      resetColumnVisibility: defaultState => {
        var _table$initialState$c;
        table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
      },
      toggleAllColumnsVisible: value => {
        var _value;
        value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
        table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column2) => ({
          ...obj,
          [column2.id]: !value ? !(column2.getCanHide != null && column2.getCanHide()) : value
        }), {}));
      },
      getIsAllColumnsVisible: () => !table.getAllLeafColumns().some(column2 => !(column2.getIsVisible != null && column2.getIsVisible())),
      getIsSomeColumnsVisible: () => table.getAllLeafColumns().some(column2 => column2.getIsVisible == null ? void 0 : column2.getIsVisible()),
      getToggleAllColumnsVisibilityHandler: () => {
        return e2 => {
          var _target;
          table.toggleAllColumnsVisible((_target = e2.target) == null ? void 0 : _target.checked);
        };
      }
    };
  }
};
const features = [Headers, Visibility, Ordering, Pinning, Filters, Sorting, Grouping, Expanding, Pagination, RowSelection, ColumnSizing];
function createTable(options) {
  var _options$initialState;
  if (options.debugAll || options.debugTable) {
    console.info("Creating Table Instance...");
  }
  let table = {
    _features: features
  };
  const defaultOptions = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
  }, {});
  const mergeOptions = options2 => {
    if (table.options.mergeOptions) {
      return table.options.mergeOptions(defaultOptions, options2);
    }
    return {
      ...defaultOptions,
      ...options2
    };
  };
  const coreInitialState = {};
  let initialState = {
    ...coreInitialState,
    ...((_options$initialState = options.initialState) != null ? _options$initialState : {})
  };
  table._features.forEach(feature => {
    var _feature$getInitialSt;
    initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
  });
  const queued = [];
  let queuedTimeout = false;
  const coreInstance = {
    _features: features,
    options: {
      ...defaultOptions,
      ...options
    },
    initialState,
    _queue: cb => {
      queued.push(cb);
      if (!queuedTimeout) {
        queuedTimeout = true;
        Promise.resolve().then(() => {
          while (queued.length) {
            queued.shift()();
          }
          queuedTimeout = false;
        }).catch(error2 => setTimeout(() => {
          throw error2;
        }));
      }
    },
    reset: () => {
      table.setState(table.initialState);
    },
    setOptions: updater => {
      const newOptions = functionalUpdate(updater, table.options);
      table.options = mergeOptions(newOptions);
    },
    getState: () => {
      return table.options.state;
    },
    setState: updater => {
      table.options.onStateChange == null ? void 0 : table.options.onStateChange(updater);
    },
    _getRowId: (row, index2, parent) => {
      var _table$options$getRow;
      return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index2, parent)) != null ? _table$options$getRow : `${parent ? [parent.id, index2].join(".") : index2}`;
    },
    getCoreRowModel: () => {
      if (!table._getCoreRowModel) {
        table._getCoreRowModel = table.options.getCoreRowModel(table);
      }
      return table._getCoreRowModel();
    },
    getRowModel: () => {
      return table.getPaginationRowModel();
    },
    getRow: id => {
      const row = table.getRowModel().rowsById[id];
      if (!row) {
        throw new Error();
      }
      return row;
    },
    _getDefaultColumnDef: memo(() => [table.options.defaultColumn], defaultColumn => {
      var _defaultColumn;
      defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
      return {
        header: props => {
          const resolvedColumnDef = props.header.column.columnDef;
          if (resolvedColumnDef.accessorKey) {
            return resolvedColumnDef.accessorKey;
          }
          if (resolvedColumnDef.accessorFn) {
            return resolvedColumnDef.id;
          }
          return null;
        },
        cell: props => {
          var _props$renderValue$to, _props$renderValue;
          return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null ? void 0 : _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
        },
        ...table._features.reduce((obj, feature) => {
          return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
        }, {}),
        ...defaultColumn
      };
    }, {
      debug: () => {
        var _table$options$debugA;
        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
      },
      key: false
    }),
    _getColumnDefs: () => table.options.columns,
    getAllColumns: memo(() => [table._getColumnDefs()], columnDefs => {
      const recurseColumns = function (columnDefs2, parent, depth) {
        if (depth === void 0) {
          depth = 0;
        }
        return columnDefs2.map(columnDef => {
          const column2 = createColumn(table, columnDef, depth, parent);
          const groupingColumnDef = columnDef;
          column2.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column2, depth + 1) : [];
          return column2;
        });
      };
      return recurseColumns(columnDefs);
    }, {
      key: false,
      debug: () => {
        var _table$options$debugA2;
        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
      }
    }),
    getAllFlatColumns: memo(() => [table.getAllColumns()], allColumns => {
      return allColumns.flatMap(column2 => {
        return column2.getFlatColumns();
      });
    }, {
      key: false,
      debug: () => {
        var _table$options$debugA3;
        return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
      }
    }),
    _getAllFlatColumnsById: memo(() => [table.getAllFlatColumns()], flatColumns => {
      return flatColumns.reduce((acc, column2) => {
        acc[column2.id] = column2;
        return acc;
      }, {});
    }, {
      key: false,
      debug: () => {
        var _table$options$debugA4;
        return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
      }
    }),
    getAllLeafColumns: memo(() => [table.getAllColumns(), table._getOrderColumnsFn()], (allColumns, orderColumns2) => {
      let leafColumns = allColumns.flatMap(column2 => column2.getLeafColumns());
      return orderColumns2(leafColumns);
    }, {
      key: false,
      debug: () => {
        var _table$options$debugA5;
        return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
      }
    }),
    getColumn: columnId => {
      const column2 = table._getAllFlatColumnsById()[columnId];
      if (!column2) {
        throw new Error();
      }
      return column2;
    }
  };
  Object.assign(table, coreInstance);
  table._features.forEach(feature => {
    return Object.assign(table, feature.createTable == null ? void 0 : feature.createTable(table));
  });
  return table;
}
function createCell(table, row, column2, columnId) {
  const getRenderValue = () => {
    var _cell$getValue;
    return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
  };
  const cell = {
    id: `${row.id}_${column2.id}`,
    row,
    column: column2,
    getValue: () => row.getValue(columnId),
    renderValue: getRenderValue,
    getContext: memo(() => [table, column2, row, cell], (table2, column3, row2, cell2) => ({
      table: table2,
      column: column3,
      row: row2,
      cell: cell2,
      getValue: cell2.getValue,
      renderValue: cell2.renderValue
    }), {
      key: false,
      debug: () => table.options.debugAll
    })
  };
  table._features.forEach(feature => {
    Object.assign(cell, feature.createCell == null ? void 0 : feature.createCell(cell, column2, row, table));
  }, {});
  return cell;
}
const createRow = (table, id, original, rowIndex, depth, subRows) => {
  let row = {
    id,
    index: rowIndex,
    original,
    depth,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: columnId => {
      if (row._valuesCache.hasOwnProperty(columnId)) {
        return row._valuesCache[columnId];
      }
      const column2 = table.getColumn(columnId);
      if (!column2.accessorFn) {
        return void 0;
      }
      row._valuesCache[columnId] = column2.accessorFn(row.original, rowIndex);
      return row._valuesCache[columnId];
    },
    getUniqueValues: columnId => {
      if (row._uniqueValuesCache.hasOwnProperty(columnId)) {
        return row._uniqueValuesCache[columnId];
      }
      const column2 = table.getColumn(columnId);
      if (!column2.accessorFn) {
        return void 0;
      }
      if (!column2.columnDef.getUniqueValues) {
        row._uniqueValuesCache[columnId] = [row.getValue(columnId)];
        return row._uniqueValuesCache[columnId];
      }
      row._uniqueValuesCache[columnId] = column2.columnDef.getUniqueValues(row.original, rowIndex);
      return row._uniqueValuesCache[columnId];
    },
    renderValue: columnId => {
      var _row$getValue;
      return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
    },
    subRows: subRows != null ? subRows : [],
    getLeafRows: () => flattenBy(row.subRows, d2 => d2.subRows),
    getAllCells: memo(() => [table.getAllLeafColumns()], leafColumns => {
      return leafColumns.map(column2 => {
        return createCell(table, row, column2, column2.id);
      });
    }, {
      key: false,
      debug: () => {
        var _table$options$debugA;
        return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
      }
    }),
    _getAllCellsByColumnId: memo(() => [row.getAllCells()], allCells => {
      return allCells.reduce((acc, cell) => {
        acc[cell.column.id] = cell;
        return acc;
      }, {});
    }, {
      key: "row.getAllCellsByColumnId",
      debug: () => {
        var _table$options$debugA2;
        return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
      }
    })
  };
  for (let i = 0; i < table._features.length; i++) {
    const feature = table._features[i];
    Object.assign(row, feature == null ? void 0 : feature.createRow == null ? void 0 : feature.createRow(row, table));
  }
  return row;
};
function getCoreRowModel() {
  return table => memo(() => [table.options.data], data => {
    const rowModel = {
      rows: [],
      flatRows: [],
      rowsById: {}
    };
    const accessRows = function (originalRows, depth, parent) {
      if (depth === void 0) {
        depth = 0;
      }
      const rows = [];
      for (let i = 0; i < originalRows.length; i++) {
        const row = createRow(table, table._getRowId(originalRows[i], i, parent), originalRows[i], i, depth);
        rowModel.flatRows.push(row);
        rowModel.rowsById[row.id] = row;
        rows.push(row);
        if (table.options.getSubRows) {
          var _row$originalSubRows;
          row.originalSubRows = table.options.getSubRows(originalRows[i], i);
          if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) {
            row.subRows = accessRows(row.originalSubRows, depth + 1, row);
          }
        }
      }
      return rows;
    };
    rowModel.rows = accessRows(data);
    return rowModel;
  }, {
    key: false,
    debug: () => {
      var _table$options$debugA;
      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    },
    onChange: () => {
      table._autoResetPageIndex();
    }
  });
}
function getSortedRowModel() {
  return table => memo(() => [table.getState().sorting, table.getPreSortedRowModel()], (sorting, rowModel) => {
    if (!rowModel.rows.length || !(sorting != null && sorting.length)) {
      return rowModel;
    }
    const sortingState = table.getState().sorting;
    const sortedFlatRows = [];
    const availableSorting = sortingState.filter(sort => table.getColumn(sort.id).getCanSort());
    const columnInfoById = {};
    availableSorting.forEach(sortEntry => {
      const column2 = table.getColumn(sortEntry.id);
      columnInfoById[sortEntry.id] = {
        sortUndefined: column2.columnDef.sortUndefined,
        invertSorting: column2.columnDef.invertSorting,
        sortingFn: column2.getSortingFn()
      };
    });
    const sortData = rows => {
      const sortedData = [...rows];
      sortedData.sort((rowA, rowB) => {
        for (let i = 0; i < availableSorting.length; i += 1) {
          var _sortEntry$desc;
          const sortEntry = availableSorting[i];
          const columnInfo = columnInfoById[sortEntry.id];
          const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
          if (columnInfo.sortUndefined) {
            const aValue = rowA.getValue(sortEntry.id);
            const bValue = rowB.getValue(sortEntry.id);
            const aUndefined = typeof aValue === "undefined";
            const bUndefined = typeof bValue === "undefined";
            if (aUndefined || bUndefined) {
              return aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
            }
          }
          let sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
          if (sortInt !== 0) {
            if (isDesc) {
              sortInt *= -1;
            }
            if (columnInfo.invertSorting) {
              sortInt *= -1;
            }
            return sortInt;
          }
        }
        return rowA.index - rowB.index;
      });
      sortedData.forEach(row => {
        var _row$subRows;
        sortedFlatRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length) {
          row.subRows = sortData(row.subRows);
        }
      });
      return sortedData;
    };
    return {
      rows: sortData(rowModel.rows),
      flatRows: sortedFlatRows,
      rowsById: rowModel.rowsById
    };
  }, {
    key: false,
    debug: () => {
      var _table$options$debugA;
      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    },
    onChange: () => {
      table._autoResetPageIndex();
    }
  });
}
function getExpandedRowModel() {
  return table => memo(() => [table.getState().expanded, table.getPreExpandedRowModel(), table.options.paginateExpandedRows], (expanded, rowModel, paginateExpandedRows) => {
    if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) {
      return rowModel;
    }
    if (!paginateExpandedRows) {
      return rowModel;
    }
    return expandRows(rowModel);
  }, {
    key: false,
    debug: () => {
      var _table$options$debugA;
      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    }
  });
}
function expandRows(rowModel) {
  const expandedRows = [];
  const handleRow = row => {
    var _row$subRows;
    expandedRows.push(row);
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) {
      row.subRows.forEach(handleRow);
    }
  };
  rowModel.rows.forEach(handleRow);
  return {
    rows: expandedRows,
    flatRows: rowModel.flatRows,
    rowsById: rowModel.rowsById
  };
}
function getPaginationRowModel(opts) {
  return table => memo(() => [table.getState().pagination, table.getPrePaginationRowModel(), table.options.paginateExpandedRows ? void 0 : table.getState().expanded], (pagination, rowModel) => {
    if (!rowModel.rows.length) {
      return rowModel;
    }
    const {
      pageSize,
      pageIndex
    } = pagination;
    let {
      rows,
      flatRows,
      rowsById
    } = rowModel;
    const pageStart = pageSize * pageIndex;
    const pageEnd = pageStart + pageSize;
    rows = rows.slice(pageStart, pageEnd);
    let paginatedRowModel;
    if (!table.options.paginateExpandedRows) {
      paginatedRowModel = expandRows({
        rows,
        flatRows,
        rowsById
      });
    } else {
      paginatedRowModel = {
        rows,
        flatRows,
        rowsById
      };
    }
    paginatedRowModel.flatRows = [];
    const handleRow = row => {
      paginatedRowModel.flatRows.push(row);
      if (row.subRows.length) {
        row.subRows.forEach(handleRow);
      }
    };
    paginatedRowModel.rows.forEach(handleRow);
    return paginatedRowModel;
  }, {
    key: false,
    debug: () => {
      var _table$options$debugA;
      return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
    }
  });
}
/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ? /* @__PURE__ */React.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
  return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent(component) {
  return typeof component === "function" && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}
function isExoticComponent(component) {
  return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
}
function useReactTable(options) {
  const resolvedOptions = {
    state: {},
    onStateChange: () => {},
    renderFallbackValue: null,
    ...options
  };
  const [tableRef] = React.useState(() => ({
    current: createTable(resolvedOptions)
  }));
  const [state, setState] = React.useState(() => tableRef.current.initialState);
  tableRef.current.setOptions(prev2 => ({
    ...prev2,
    ...options,
    state: {
      ...state,
      ...options.state
    },
    onStateChange: updater => {
      setState(updater);
      options.onStateChange == null ? void 0 : options.onStateChange(updater);
    }
  }));
  return tableRef.current;
}
const SkeletonKeyframes = keyframes$1({
  "0%": {
    backgroundPosition: "-100%"
  },
  "100%": {
    backgroundPosition: "100%"
  }
});
const StyledSkeletonBase = styled(Box, {
  height: 40,
  width: "100%",
  animation: `1.5s linear infinite ${SkeletonKeyframes}`,
  background: "linear-gradient(to right, rgba(163, 174, 181, 0.3) 0%, rgba(223, 228, 232, 0.3) 48.44%, rgba(163, 174, 181, 0.3) 100%)",
  backgroundSize: "200%"
});
const defaultSkeletonSize = 40;
const Skeleton = _ref144 => {
  let {
    isLoading,
    children,
    height = defaultSkeletonSize,
    width = "100%",
    round: round2 = false,
    size,
    css: css4
  } = _ref144;
  if (isLoading) {
    return /* @__PURE__ */jsx$1(StyledSkeletonBase, {
      css: round2 ? {
        height: size || height || defaultSkeletonSize,
        width: size || width || defaultSkeletonSize,
        borderRadius: "100%",
        ...css4
      } : {
        height: size || height,
        width: size || width,
        borderRadius: "3px",
        ...css4
      }
    });
  }
  return /* @__PURE__ */jsx$1(Fragment, {
    children
  });
};
const InlineInputVariant = {
  input: {
    borderBottom: "1px dashed $blue8",
    "&:hover": {
      border: "1px solid $blue4",
      borderRadius: "$1"
    },
    "&:focus-visible": {
      outline: "solid 1px $blue6",
      outlineOffset: 1,
      borderRadius: "$1"
    },
    "&:active": {
      borderRadius: "$1",
      outline: "none",
      border: "1px solid $blue5",
      backgroundColor: "$blue1"
    },
    "&:disabled": {
      color: "$gray5",
      backgroundColor: "transparent",
      borderBottom: "1px dashed $gray5",
      "&::placeholder": {
        color: "$gray5"
      },
      "&:hover, &:active": {
        border: "1px solid transparent",
        borderBottom: "1px dashed $gray5",
        borderRadius: 0
      }
    }
  },
  edit: {
    "&:hover": {
      borderBottom: "1px dashed $blue8"
    },
    "&:focus-visible": {
      outline: "solid 1px $blue6",
      outlineOffset: 1,
      borderRadius: "$1"
    },
    "&:active": {
      borderRadius: "$1",
      outline: "none",
      border: "1px solid $blue5",
      backgroundColor: "$blue1"
    }
  }
};
const StyledInlineInput = styled("input", {
  textColor: "inherit",
  textStyles: "inherit",
  border: "1px solid transparent",
  paddingX: "2px",
  textOverflow: "ellipsis",
  "&::placeholder": {
    color: "$gray8"
  },
  variants: {
    variant: InlineInputVariant
  }
});
const InlineInputVariantEnum = {
  input: "input",
  edit: "edit"
};
const InlineInput = forwardRef((_ref145, forwardedRef) => {
  let {
    label,
    variant = "edit",
    disabled: disabled2,
    rootProps,
    onChange: onChange3,
    placeholder,
    value,
    type: type3 = "text",
    ...props
  } = _ref145;
  return /* @__PURE__ */jsx$1(StyledInlineInput, {
    "aria-label": label,
    ref: forwardedRef,
    variant,
    value,
    onChange: onChange3,
    placeholder,
    disabled: variant === InlineInputVariantEnum.input ? disabled2 : false,
    type: type3,
    ...rootProps,
    ...props
  });
});
InlineInput.displayName = "InlineInput";
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, _ref146) {
  let [min2, max2] = _ref146;
  return Math.min(max2, Math.max(min2, value));
}
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c1(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */new Map()
  });
  const CollectionProvider = props => {
    const {
      scope,
      children
    } = props;
    const ref = React__default.useRef(null);
    const itemMap = React__default.useRef( /* @__PURE__ */new Map()).current;
    return /* @__PURE__ */React__default.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children
    } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$6, {
      ref: composedRefs
    }, children);
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */React__default.forwardRef((props, forwardedRef) => {
    const {
      scope,
      children,
      ...itemData
    } = props;
    const ref = React__default.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    React__default.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */React__default.createElement($5e63c961fc1ce211$export$8c6ed5c666ac1360$6, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = React__default.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort((a2, b2) => orderedNodes.indexOf(a2.ref.current) - orderedNodes.indexOf(b2.ref.current));
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}
const $8927f6f2acc4f386$var$NODES$1 = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034$1 = $8927f6f2acc4f386$var$NODES$1.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360$6 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
  if (target) flushSync(() => target.dispatchEvent(event));
}
function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onEscapeKeyDownProp);
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown);
  }, [onEscapeKeyDown, ownerDocument]);
}
const $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $5cb92bef7577960e$var$originalBodyPointerEvents;
const $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */createContext$1({
  layers: /* @__PURE__ */new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */new Set(),
  branches: /* @__PURE__ */new Set()
});
const $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _node$ownerDocument;
  const {
    disableOutsidePointerEvents = false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside,
    onInteractOutside,
    onDismiss,
    ...layerProps
  } = props;
  const context = useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const [node1, setNode] = useState(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setNode(node2));
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index2 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside(event => {
    const target = event.target;
    const isPointerDownOnBranch = [...context.branches].some(branch => branch.contains(target));
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside(event => {
    const target = event.target;
    const isFocusInBranch = [...context.branches].some(branch => branch.contains(target));
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765(event => {
    const isHighestLayer = index2 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
    };
  }, [node1, ownerDocument, disableOutsidePointerEvents, context]);
  useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate();
    };
  }, [node1, context]);
  useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$1({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onPointerDownOutside);
  const isPointerInsideReactTreeRef = useRef(false);
  const handleClickRef = useRef(() => {});
  useEffect(() => {
    const handlePointerDown = event => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent = function () {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
  let ownerDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onFocusOutside);
  const isFocusInsideReactTreeRef = useRef(false);
  useEffect(() => {
    const handleFocus = event => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, _ref147) {
  let {
    discrete
  } = _ref147;
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);else target.dispatchEvent(event);
}
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
const $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container1, setContainer] = useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onUnmountAutoFocusProp);
  const lastFocusedElementRef = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContainer(node2));
  const focusScope = useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  useEffect(() => {
    if (trapped) {
      let handleFocusIn = function (event) {
          if (focusScope.paused || !container1) return;
          const target = event.target;
          if (container1.contains(target)) lastFocusedElementRef.current = target;else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
            select: true
          });
        },
        handleFocusOut = function (event) {
          if (focusScope.paused || !container1) return;
          if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
            select: true
          });
        };
      document.addEventListener("focusin", handleFocusIn);
      document.addEventListener("focusout", handleFocusOut);
      return () => {
        document.removeEventListener("focusin", handleFocusIn);
        document.removeEventListener("focusout", handleFocusOut);
      };
    }
  }, [trapped, container1, focusScope.paused]);
  useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container1, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = useCallback(event => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(last, {
            select: true
          });
        }
      }
    }
  }, [loop, trapped, focusScope.paused]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$1({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst(candidates) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
  const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
  const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
  return [first, last];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: node2 => {
      const isHiddenInput = node2.tagName === "INPUT" && node2.type === "hidden";
      if (node2.disabled || node2.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node2.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden(node2, _ref148) {
  let {
    upTo
  } = _ref148;
  if (getComputedStyle(node2).visibility === "hidden") return true;
  while (node2) {
    if (upTo !== void 0 && node2 === upTo) return false;
    if (getComputedStyle(node2).display === "none") return true;
    node2 = node2.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus(element) {
  let {
    select = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
  }
}
const $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) updatedArray.splice(index2, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
  return items.filter(item => item.tagName !== "A");
}
const $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const {
    container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body,
    ...portalProps
  } = props;
  return container ? /* @__PURE__ */$7SXl2$reactdom__default.createPortal( /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$1({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});
var effectCar = createSidecarMedium();
var nothing = function () {
  return;
};
var RemoveScroll = React.forwardRef(function (props, parentRef) {
  var ref = React.useRef(null);
  var _a = React.useState({
      onScrollCapture: nothing,
      onWheelCapture: nothing,
      onTouchMoveCapture: nothing
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? "div" : _b,
    rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React.createElement(React.Fragment, null, enabled && React.createElement(SideCar2, {
    sideCar: effectCar,
    removeScrollBar,
    shards,
    noIsolation,
    inert,
    setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref
  }), forwardProps ? React.cloneElement(React.Children.only(children), __assign(__assign({}, containerProps), {
    ref: containerRef
  })) : React.createElement(Container, __assign({}, containerProps, {
    className,
    ref: containerRef
  }), children));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function () {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? {
  passive: false
} : false;
var alwaysContainsScroll = function (node2) {
  return node2.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function (node2, overflow) {
  var styles2 = window.getComputedStyle(node2);
  return styles2[overflow] !== "hidden" && !(styles2.overflowY === styles2.overflowX && !alwaysContainsScroll(node2) && styles2[overflow] === "visible");
};
var elementCouldBeVScrolled = function (node2) {
  return elementCanBeScrolled(node2, "overflowY");
};
var elementCouldBeHScrolled = function (node2) {
  return elementCanBeScrolled(node2, "overflowX");
};
var locationCouldBeScrolled = function (axis, node2) {
  var current = node2;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current),
        s2 = _a[1],
        d2 = _a[2];
      if (s2 > d2) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node2) {
  return axis === "v" ? elementCouldBeVScrolled(node2) : elementCouldBeHScrolled(node2);
};
var getScrollVariables = function (axis, node2) {
  return axis === "v" ? getVScrollVariables(node2) : getHScrollVariables(node2);
};
var getDirectionFactor = function (axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target),
      position2 = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position2;
    if (position2 || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position2;
      }
    }
    target = target.parentNode;
  } while (!targetInLock && target !== document.body || targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
var getTouchXY = function (event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function (ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function (x2, y2) {
  return x2[0] === y2[0] && x2[1] === y2[1];
};
var generateStyle = function (id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React.useRef([]);
  var touchStartRef = React.useRef([0, 0]);
  var activeAxis = React.useRef();
  var id = React.useState(idCounter++)[0];
  var Style2 = React.useState(function () {
    return styleSingleton();
  })[0];
  var lastProps = React.useRef(props);
  React.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  React.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React.useCallback(function (event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React.useCallback(function (_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e2) {
      return e2.name === event.type && e2.target === event.target && deltaCompare(e2.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function (node2) {
        return node2.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React.useCallback(function (name, delta, target, should) {
    var event = {
      name,
      delta,
      target,
      should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e2) {
        return e2 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React.useCallback(function (event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React.useEffect(function () {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function () {
      lockStack = lockStack.filter(function (inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return React.createElement(React.Fragment, null, inert ? React.createElement(Style2, {
    styles: generateStyle(id)
  }) : null, removeScrollBar ? React.createElement(RemoveScrollBar, {
    gapMode: "margin"
  }) : null);
}
var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React.forwardRef(function (props, ref) {
  return React.createElement(RemoveScroll, __assign({}, props, {
    ref,
    sideCar: SideCar
  }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var $01b9c$RemoveScroll = ReactRemoveScroll;
const $cc7e05a45900e73f$var$OPEN_KEYS = [" ", "Enter", "ArrowUp", "ArrowDown"];
const $cc7e05a45900e73f$var$SELECTION_KEYS = [" ", "Enter"];
const $cc7e05a45900e73f$var$SELECT_NAME = "Select";
const [$cc7e05a45900e73f$var$Collection, $cc7e05a45900e73f$var$useCollection, $cc7e05a45900e73f$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($cc7e05a45900e73f$var$SELECT_NAME);
const [$cc7e05a45900e73f$var$createSelectContext, $cc7e05a45900e73f$export$286727a75dc039bd] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($cc7e05a45900e73f$var$SELECT_NAME, [$cc7e05a45900e73f$var$createCollectionScope]);
const [$cc7e05a45900e73f$var$SelectProvider, $cc7e05a45900e73f$var$useSelectContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
const [$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
const $cc7e05a45900e73f$export$ef9b1a59e592288f = props => {
  const {
    __scopeSelect,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    value: valueProp,
    defaultValue,
    onValueChange,
    dir,
    name,
    autoComplete,
    disabled: disabled2,
    required
  } = props;
  const [trigger, setTrigger] = useState(null);
  const [valueNode, setValueNode] = useState(null);
  const [valueNodeHasChildren, setValueNodeHasChildren] = useState(false);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const triggerPointerDownPosRef = useRef(null);
  const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
  const [nativeOptionsSet, setNativeOptionsSet] = useState( /* @__PURE__ */new Set());
  const nativeSelectKey = Array.from(nativeOptionsSet).map(option => option.props.value).join(";");
  return /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectProvider, {
    required,
    scope: __scopeSelect,
    trigger,
    onTriggerChange: setTrigger,
    valueNode,
    onValueNodeChange: setValueNode,
    valueNodeHasChildren,
    onValueNodeHasChildrenChange: setValueNodeHasChildren,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    value,
    onValueChange: setValue,
    open: open2,
    onOpenChange: setOpen,
    dir: direction,
    triggerPointerDownPosRef,
    disabled: disabled2
  }, /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$Collection.Provider, {
    scope: __scopeSelect
  }, /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
    scope: props.__scopeSelect,
    onNativeOptionAdd: useCallback(option => {
      setNativeOptionsSet(prev2 => new Set(prev2).add(option));
    }, []),
    onNativeOptionRemove: useCallback(option => {
      setNativeOptionsSet(prev2 => {
        const optionsSet = new Set(prev2);
        optionsSet.delete(option);
        return optionsSet;
      });
    }, [])
  }, children)), isFormControl ? /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$BubbleSelect, {
    key: nativeSelectKey,
    "aria-hidden": true,
    required,
    tabIndex: -1,
    name,
    autoComplete,
    value,
    onChange: event => setValue(event.target.value),
    disabled: disabled2
  }, value === void 0 ? /* @__PURE__ */createElement$1("option", {
    value: ""
  }) : null, Array.from(nativeOptionsSet)) : null);
};
const $cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
const $cc7e05a45900e73f$export$3ac1e88a1c0b9f1 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    disabled: disabled2 = false,
    ...triggerProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
  const isDisabled = context.disabled || disabled2;
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.onTriggerChange);
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const [searchRef, handleTypeaheadSearch, resetTypeahead] = $cc7e05a45900e73f$var$useTypeaheadSearch(search => {
    const enabledItems = getItems().filter(item => !item.disabled);
    const currentItem = enabledItems.find(item => item.value === context.value);
    const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
    if (nextItem !== void 0) context.onValueChange(nextItem.value);
  });
  const handleOpen = () => {
    if (!isDisabled) {
      context.onOpenChange(true);
      resetTypeahead();
    }
  };
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.button, _extends$1({
    type: "button",
    role: "combobox",
    "aria-controls": context.contentId,
    "aria-expanded": context.open,
    "aria-required": context.required,
    "aria-autocomplete": "none",
    dir: context.dir,
    "data-state": context.open ? "open" : "closed",
    disabled: isDisabled,
    "data-disabled": isDisabled ? "" : void 0,
    "data-placeholder": context.value === void 0 ? "" : void 0
  }, triggerProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff10(triggerProps.onClick, event => {
      event.currentTarget.focus();
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(triggerProps.onPointerDown, event => {
      const target = event.target;
      if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
      if (event.button === 0 && event.ctrlKey === false) {
        handleOpen();
        context.triggerPointerDownPosRef.current = {
          x: Math.round(event.pageX),
          y: Math.round(event.pageY)
        };
        event.preventDefault();
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(triggerProps.onKeyDown, event => {
      const isTypingAhead = searchRef.current !== "";
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
      if (isTypingAhead && event.key === " ") return;
      if ($cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
        handleOpen();
        event.preventDefault();
      }
    })
  }));
});
const $cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
const $cc7e05a45900e73f$export$e288731fd71264f0 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    className,
    style,
    children,
    placeholder,
    ...valueProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
  const {
    onValueNodeHasChildrenChange
  } = context;
  const hasChildren = children !== void 0;
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.onValueNodeChange);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    onValueNodeHasChildrenChange(hasChildren);
  }, [onValueNodeHasChildrenChange, hasChildren]);
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$1({}, valueProps, {
    ref: composedRefs,
    style: {
      pointerEvents: "none"
    }
  }), context.value === void 0 && placeholder !== void 0 ? placeholder : children);
});
const $cc7e05a45900e73f$export$99b400cabb58c515 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    children,
    ...iconProps
  } = props;
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$1({
    "aria-hidden": true
  }, iconProps, {
    ref: forwardedRef
  }), children || "\u25BC");
});
const $cc7e05a45900e73f$export$b2af6c9944296213 = props => {
  return /* @__PURE__ */createElement$1($f1701beae083dbae$export$602eac185826482c, _extends$1({
    asChild: true
  }, props));
};
const $cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
const $cc7e05a45900e73f$export$c973a4b3cb86a03d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
  const [fragment, setFragment] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    setFragment(new DocumentFragment());
  }, []);
  return /* @__PURE__ */createElement$1(Fragment$1, null, context.open ? /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectContentImpl, _extends$1({}, props, {
    ref: forwardedRef
  })) : fragment ? /* @__PURE__ */createPortal( /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectContentProvider, {
    scope: props.__scopeSelect
  }, /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$Collection.Slot, {
    scope: props.__scopeSelect
  }, /* @__PURE__ */createElement$1("div", null, props.children))), fragment) : null);
});
const $cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
const [$cc7e05a45900e73f$var$SelectContentProvider, $cc7e05a45900e73f$var$useSelectContentContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME);
const $cc7e05a45900e73f$var$SelectContentImpl = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    onCloseAutoFocus,
    ...contentProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
  const [contentWrapper, setContentWrapper] = useState(null);
  const [content, setContent] = useState(null);
  const [viewport, setViewport] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setContent(node2));
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemText, setSelectedItemText] = useState(null);
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const [isPositioned, setIsPositioned] = useState(false);
  const shouldRepositionRef = useRef(true);
  const shouldExpandOnScrollRef = useRef(false);
  const firstValidItemFoundRef = useRef(false);
  useEffect(() => {
    if (content) return hideOthers(content);
  }, [content]);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const [contentZIndex, setContentZIndex] = useState();
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  const focusFirst = useCallback(candidates => {
    const [firstItem, ...restItems] = getItems().map(item => item.ref.current);
    const [lastItem] = restItems.slice(-1);
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates) {
      if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
      candidate === null || candidate === void 0 || candidate.scrollIntoView({
        block: "nearest"
      });
      if (candidate === firstItem && viewport) viewport.scrollTop = 0;
      if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
      candidate === null || candidate === void 0 || candidate.focus();
      if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
  }, [getItems, viewport]);
  const position2 = useCallback(() => {
    if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
      const triggerRect = context.trigger.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const valueNodeRect = context.valueNode.getBoundingClientRect();
      const itemTextRect = selectedItemText.getBoundingClientRect();
      if (context.dir !== "rtl") {
        const itemTextOffset = itemTextRect.left - contentRect.left;
        const left = valueNodeRect.left - itemTextOffset;
        const leftDelta = triggerRect.left - left;
        const minContentWidth = triggerRect.width + leftDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const rightEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
        const clampedLeft = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(left, [$cc7e05a45900e73f$var$CONTENT_MARGIN, rightEdge - contentWidth]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.left = clampedLeft + "px";
      } else {
        const itemTextOffset = contentRect.right - itemTextRect.right;
        const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
        const rightDelta = window.innerWidth - triggerRect.right - right;
        const minContentWidth = triggerRect.width + rightDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const leftEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
        const clampedRight = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(right, [$cc7e05a45900e73f$var$CONTENT_MARGIN, leftEdge - contentWidth]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.right = clampedRight + "px";
      }
      const items = getItems();
      const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
      const itemsHeight = viewport.scrollHeight;
      const contentStyles = window.getComputedStyle(content);
      const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
      const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
      const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
      const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
      const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
      const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
      const viewportStyles = window.getComputedStyle(viewport);
      const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
      const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
      const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $cc7e05a45900e73f$var$CONTENT_MARGIN;
      const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
      const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
      const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
      const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
      const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
      const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
      if (willAlignWithoutTopOverflow) {
        const isLastItem = selectedItem === items[items.length - 1].ref.current;
        contentWrapper.style.bottom = "0px";
        const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
        const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
        const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
        contentWrapper.style.height = height + "px";
      } else {
        const isFirstItem = selectedItem === items[0].ref.current;
        contentWrapper.style.top = "0px";
        const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
        const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
        contentWrapper.style.height = height + "px";
        viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
      }
      contentWrapper.style.margin = `${$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
      contentWrapper.style.minHeight = minContentHeight + "px";
      contentWrapper.style.maxHeight = availableHeight + "px";
      setIsPositioned(true);
      requestAnimationFrame(() => shouldExpandOnScrollRef.current = true);
    }
  }, [getItems, context.trigger, context.valueNode, contentWrapper, content, viewport, selectedItem, selectedItemText, context.dir]);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => position2(), [position2]);
  const focusSelectedItem = useCallback(() => focusFirst([selectedItem, content]), [focusFirst, selectedItem, content]);
  useEffect(() => {
    if (isPositioned) focusSelectedItem();
  }, [isPositioned, focusSelectedItem]);
  const handleScrollButtonChange = useCallback(node2 => {
    if (node2 && shouldRepositionRef.current === true) {
      position2();
      focusSelectedItem();
      shouldRepositionRef.current = false;
    }
  }, [position2, focusSelectedItem]);
  const {
    onOpenChange,
    triggerPointerDownPosRef
  } = context;
  useEffect(() => {
    if (content) {
      let pointerMoveDelta = {
        x: 0,
        y: 0
      };
      const handlePointerMove = event => {
        var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
        pointerMoveDelta = {
          x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
          y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
        };
      };
      const handlePointerUp = event => {
        if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();else if (!content.contains(event.target)) onOpenChange(false);
        document.removeEventListener("pointermove", handlePointerMove);
        triggerPointerDownPosRef.current = null;
      };
      if (triggerPointerDownPosRef.current !== null) {
        document.addEventListener("pointermove", handlePointerMove);
        document.addEventListener("pointerup", handlePointerUp, {
          capture: true,
          once: true
        });
      }
      return () => {
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp, {
          capture: true
        });
      };
    }
  }, [content, onOpenChange, triggerPointerDownPosRef]);
  useEffect(() => {
    const close2 = () => onOpenChange(false);
    window.addEventListener("blur", close2);
    window.addEventListener("resize", close2);
    return () => {
      window.removeEventListener("blur", close2);
      window.removeEventListener("resize", close2);
    };
  }, [onOpenChange]);
  const [searchRef, handleTypeaheadSearch] = $cc7e05a45900e73f$var$useTypeaheadSearch(search => {
    const enabledItems = getItems().filter(item => !item.disabled);
    const currentItem = enabledItems.find(item => item.ref.current === document.activeElement);
    const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
    if (nextItem) setTimeout(() => nextItem.ref.current.focus());
  });
  const itemRefCallback = useCallback((node2, value, disabled2) => {
    const isFirstValidItem = !firstValidItemFoundRef.current && !disabled2;
    const isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) {
      setSelectedItem(node2);
      if (isFirstValidItem) firstValidItemFoundRef.current = true;
    }
  }, [context.value]);
  const handleItemLeave = useCallback(() => content === null || content === void 0 ? void 0 : content.focus(), [content]);
  const itemTextRefCallback = useCallback((node2, value, disabled2) => {
    const isFirstValidItem = !firstValidItemFoundRef.current && !disabled2;
    const isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) setSelectedItemText(node2);
  }, [context.value]);
  return /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectContentProvider, {
    scope: __scopeSelect,
    contentWrapper,
    content,
    viewport,
    onViewportChange: setViewport,
    itemRefCallback,
    selectedItem,
    onItemLeave: handleItemLeave,
    itemTextRefCallback,
    selectedItemText,
    onScrollButtonChange: handleScrollButtonChange,
    isPositioned,
    shouldExpandOnScrollRef,
    searchRef
  }, /* @__PURE__ */createElement$1($01b9c$RemoveScroll, {
    as: $5e63c961fc1ce211$export$8c6ed5c666ac1360$6,
    allowPinchZoom: true
  }, /* @__PURE__ */createElement$1("div", {
    ref: setContentWrapper,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: contentZIndex
    }
  }, /* @__PURE__ */createElement$1($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    trapped: context.open,
    onMountAutoFocus: event => {
      event.preventDefault();
    },
    onUnmountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(onCloseAutoFocus, event => {
      var _context$trigger;
      (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
        preventScroll: true
      });
      event.preventDefault();
    })
  }, /* @__PURE__ */createElement$1($5cb92bef7577960e$export$177fb62ff3ec1f22, _extends$1({
    role: "listbox",
    id: context.contentId,
    "data-state": context.open ? "open" : "closed",
    dir: context.dir,
    onContextMenu: event => event.preventDefault()
  }, contentProps, {
    ref: composedRefs,
    style: {
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      maxHeight: "100%",
      outline: "none",
      ...contentProps.style
    },
    disableOutsidePointerEvents: true,
    onFocusOutside: event => event.preventDefault(),
    onDismiss: () => context.onOpenChange(false),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(contentProps.onKeyDown, event => {
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      if (event.key === "Tab") event.preventDefault();
      if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
      if (["ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
        const items = getItems().filter(item => !item.disabled);
        let candidateNodes = items.map(item => item.ref.current);
        if (["ArrowUp", "End"].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
        if (["ArrowUp", "ArrowDown"].includes(event.key)) {
          const currentElement = event.target;
          const currentIndex = candidateNodes.indexOf(currentElement);
          candidateNodes = candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(() => focusFirst(candidateNodes));
        event.preventDefault();
      }
    })
  }))))));
});
const $cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
const $cc7e05a45900e73f$export$9ed6e7b40248d36d = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    ...viewportProps
  } = props;
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, contentContext.onViewportChange);
  const prevScrollTopRef = useRef(0);
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1("style", {
    dangerouslySetInnerHTML: {
      __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
    }
  }), /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$Collection.Slot, {
    scope: __scopeSelect
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$1({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, viewportProps, {
    ref: composedRefs,
    style: {
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...viewportProps.style
    },
    onScroll: $e42e1063c40fb3ef$export$b9ecd428b558ff10(viewportProps.onScroll, event => {
      const viewport = event.currentTarget;
      const {
        contentWrapper,
        shouldExpandOnScrollRef
      } = contentContext;
      if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
        const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
        if (scrolledBy > 0) {
          const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
          const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
          const cssHeight = parseFloat(contentWrapper.style.height);
          const prevHeight = Math.max(cssMinHeight, cssHeight);
          if (prevHeight < availableHeight) {
            const nextHeight = prevHeight + scrolledBy;
            const clampedNextHeight = Math.min(availableHeight, nextHeight);
            const heightDiff = nextHeight - clampedNextHeight;
            contentWrapper.style.height = clampedNextHeight + "px";
            if (contentWrapper.style.bottom === "0px") {
              viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
              contentWrapper.style.justifyContent = "flex-end";
            }
          }
        }
      }
      prevScrollTopRef.current = viewport.scrollTop;
    })
  }))));
});
const $cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
$cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$GROUP_NAME);
const $cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
const [$cc7e05a45900e73f$var$SelectItemContextProvider, $cc7e05a45900e73f$var$useSelectItemContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$ITEM_NAME);
const $cc7e05a45900e73f$export$13ef48a934230896 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    value,
    disabled: disabled2 = false,
    textValue: textValueProp,
    ...itemProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
  const isSelected = context.value === value;
  const [textValue, setTextValue] = useState(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
  const [isFocused, setIsFocused] = useState(false);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => {
    var _contentContext$itemR;
    return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node2, value, disabled2);
  });
  const textId = $1746a345f3d73bb7$export$f680877a34711e37();
  const handleSelect = () => {
    if (!disabled2) {
      context.onValueChange(value);
      context.onOpenChange(false);
    }
  };
  return /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$SelectItemContextProvider, {
    scope: __scopeSelect,
    value,
    disabled: disabled2,
    textId,
    isSelected,
    onItemTextChange: useCallback(node2 => {
      setTextValue(prevTextValue => {
        var _node$textContent;
        return prevTextValue || ((_node$textContent = node2 === null || node2 === void 0 ? void 0 : node2.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
      });
    }, [])
  }, /* @__PURE__ */createElement$1($cc7e05a45900e73f$var$Collection.ItemSlot, {
    scope: __scopeSelect,
    value,
    disabled: disabled2,
    textValue
  }, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.div, _extends$1({
    role: "option",
    "aria-labelledby": textId,
    "data-highlighted": isFocused ? "" : void 0,
    "aria-selected": isSelected && isFocused,
    "data-state": isSelected ? "checked" : "unchecked",
    "aria-disabled": disabled2 || void 0,
    "data-disabled": disabled2 ? "" : void 0,
    tabIndex: disabled2 ? void 0 : -1
  }, itemProps, {
    ref: composedRefs,
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onFocus, () => setIsFocused(true)),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onBlur, () => setIsFocused(false)),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onPointerUp, handleSelect),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onPointerMove, event => {
      if (disabled2) {
        var _contentContext$onIte;
        (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
      } else event.currentTarget.focus({
        preventScroll: true
      });
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onPointerLeave, event => {
      if (event.currentTarget === document.activeElement) {
        var _contentContext$onIte2;
        (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(itemProps.onKeyDown, event => {
      var _contentContext$searc;
      const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
      if (isTypingAhead && event.key === " ") return;
      if ($cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect();
      if (event.key === " ") event.preventDefault();
    })
  }))));
});
const $cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
const $cc7e05a45900e73f$export$3572fb0fb821ff49 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    className,
    style,
    ...itemTextProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const itemContext = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const nativeOptionsContext = $cc7e05a45900e73f$var$useSelectNativeOptionsContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const [itemTextNode, setItemTextNode] = useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, node2 => setItemTextNode(node2), itemContext.onItemTextChange, node2 => {
    var _contentContext$itemT;
    return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node2, itemContext.value, itemContext.disabled);
  });
  const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
  const nativeOption = useMemo(() => /* @__PURE__ */createElement$1("option", {
    key: itemContext.value,
    value: itemContext.value,
    disabled: itemContext.disabled
  }, textContent), [itemContext.disabled, itemContext.value, textContent]);
  const {
    onNativeOptionAdd,
    onNativeOptionRemove
  } = nativeOptionsContext;
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    onNativeOptionAdd(nativeOption);
    return () => onNativeOptionRemove(nativeOption);
  }, [onNativeOptionAdd, onNativeOptionRemove, nativeOption]);
  return /* @__PURE__ */createElement$1(Fragment$1, null, /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034$1.span, _extends$1({
    id: itemContext.textId
  }, itemTextProps, {
    ref: composedRefs
  })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /* @__PURE__ */createPortal(itemTextProps.children, context.valueNode) : null);
});
const $cc7e05a45900e73f$var$BubbleSelect = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    value,
    ...selectProps
  } = props;
  const ref = useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
  const prevValue = $010c2913dbd2fe3d$export$5cae361ad82dce8b(value);
  useEffect(() => {
    const select = ref.current;
    const selectProto = window.HTMLSelectElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
    const setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      const event = new Event("change", {
        bubbles: true
      });
      setValue.call(select, value);
      select.dispatchEvent(event);
    }
  }, [prevValue, value]);
  return /* @__PURE__ */createElement$1($ea1ef594cf570d83$export$439d29a4e110a164$1, {
    asChild: true
  }, /* @__PURE__ */createElement$1("select", _extends$1({}, selectProps, {
    ref: composedRefs,
    defaultValue: value
  })));
});
$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
  const handleSearchChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onSearchChange);
  const searchRef = useRef("");
  const timerRef = useRef(0);
  const handleTypeaheadSearch = useCallback(key => {
    const search = searchRef.current + key;
    handleSearchChange(search);
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(() => updateSearch(""), 1e3);
    })(search);
  }, [handleSearchChange]);
  const resetTypeahead = useCallback(() => {
    searchRef.current = "";
    window.clearTimeout(timerRef.current);
  }, []);
  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  return [searchRef, handleTypeaheadSearch, resetTypeahead];
}
function $cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
  const isRepeated = search.length > 1 && Array.from(search).every(char2 => char2 === search[0]);
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
  let wrappedItems = $cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
  const excludeCurrentItem = normalizedSearch.length === 1;
  if (excludeCurrentItem) wrappedItems = wrappedItems.filter(v2 => v2 !== currentItem);
  const nextItem = wrappedItems.find(item => item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
  return nextItem !== currentItem ? nextItem : void 0;
}
function $cc7e05a45900e73f$var$wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
const $cc7e05a45900e73f$export$be92b6f5f03c0fe9 = $cc7e05a45900e73f$export$ef9b1a59e592288f;
const $cc7e05a45900e73f$export$41fb9f06171c75f4 = $cc7e05a45900e73f$export$3ac1e88a1c0b9f1;
const $cc7e05a45900e73f$export$4c8d1a57a761ef94 = $cc7e05a45900e73f$export$e288731fd71264f0;
const $cc7e05a45900e73f$export$f04a61298a47a40f = $cc7e05a45900e73f$export$99b400cabb58c515;
const $cc7e05a45900e73f$export$602eac185826482c = $cc7e05a45900e73f$export$b2af6c9944296213;
const $cc7e05a45900e73f$export$7c6e2c02157bb7d2 = $cc7e05a45900e73f$export$c973a4b3cb86a03d;
const $cc7e05a45900e73f$export$d5c6c08dc2d3ca7 = $cc7e05a45900e73f$export$9ed6e7b40248d36d;
const $cc7e05a45900e73f$export$6d08773d2e66f8f2 = $cc7e05a45900e73f$export$13ef48a934230896;
const $cc7e05a45900e73f$export$d6e5bf9c43ea9319 = $cc7e05a45900e73f$export$3572fb0fb821ff49;
const StyledInlineSelectTrigger = styled($cc7e05a45900e73f$export$41fb9f06171c75f4, {
  textColor: "inherit",
  textStyles: "inherit",
  border: "1px solid transparent",
  paddingX: "2px",
  backgroundColor: "$white",
  textOverflow: "ellipsis",
  display: "inline-flex",
  gap: "$1",
  "&::placeholder": {
    color: "$gray8"
  },
  borderBottom: "1px dashed $blue8",
  "&:hover": {
    border: "1px solid $blue4",
    borderRadius: "$1"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 1,
    borderRadius: "$1"
  },
  "&:active": {
    borderRadius: "$1",
    outline: "none",
    border: "1px solid $blue5",
    backgroundColor: "$blue1"
  },
  "&:disabled": {
    color: "$gray5",
    backgroundColor: "transparent",
    borderBottom: "1px dashed $gray5",
    "&::placeholder": {
      color: "$gray5"
    },
    "&:hover, &:active": {
      border: "1px solid transparent",
      borderBottom: "1px dashed $gray5",
      borderRadius: 0
    }
  }
});
const StyledInlineSelectContent = styled($cc7e05a45900e73f$export$7c6e2c02157bb7d2, {
  background: "$white",
  display: "flex",
  flexDirection: "column",
  gap: "$1",
  boxShadow: "$raised08",
  zIndex: "$menu"
});
const StyledInlineSelectItem = styled($cc7e05a45900e73f$export$6d08773d2e66f8f2, {
  padding: "$1",
  textStyles: "body",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "$blue1",
    outline: "none"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$blue2",
    outline: "none"
  },
  "&[data-disabled]": {
    color: "$gray5",
    cursor: "not-allowed"
  }
});
const SelectItem = React__default.forwardRef((_ref149, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref149;
  return /* @__PURE__ */jsx$1(StyledInlineSelectItem, {
    ...props,
    ref: forwardedRef,
    children: /* @__PURE__ */jsx$1($cc7e05a45900e73f$export$d6e5bf9c43ea9319, {
      children
    })
  });
});
SelectItem.displayName = "SelectItem";
const InlineSelect = _ref150 => {
  let {
    label,
    placeholder,
    options,
    onValueChange,
    value,
    ...rootProps
  } = _ref150;
  return /* @__PURE__ */jsxs($cc7e05a45900e73f$export$be92b6f5f03c0fe9, {
    value,
    onValueChange,
    ...rootProps,
    children: [/* @__PURE__ */jsxs(StyledInlineSelectTrigger, {
      "aria-label": label,
      children: [/* @__PURE__ */jsx$1($cc7e05a45900e73f$export$4c8d1a57a761ef94, {
        placeholder
      }), /* @__PURE__ */jsx$1($cc7e05a45900e73f$export$f04a61298a47a40f, {
        children: /* @__PURE__ */jsx$1(Icon, {
          icon: faChevronDown_2
        })
      })]
    }), /* @__PURE__ */jsx$1($cc7e05a45900e73f$export$602eac185826482c, {
      children: /* @__PURE__ */jsx$1(StyledInlineSelectContent, {
        children: /* @__PURE__ */jsx$1($cc7e05a45900e73f$export$d5c6c08dc2d3ca7, {
          children: options.map(option => /* @__PURE__ */jsx$1(SelectItem, {
            value: option.value,
            children: option.label
          }, option.value))
        })
      })
    })]
  });
};
InlineSelect.displayName = "InlineSelect";
var faChevronLeft$1 = {};
Object.defineProperty(faChevronLeft$1, "__esModule", {
  value: true
});
var faChevronLeft_2 = faChevronLeft$1.faChevronLeft = void 0;
const faChevronLeft = {
  prefix: "fal",
  iconName: "faChevronLeft",
  icon: [320, 512, [], "", "M234.8 36.25c3.438 3.141 5.156 7.438 5.156 11.75c0 3.891-1.406 7.781-4.25 10.86L53.77 256l181.1 197.1c6 6.5 5.625 16.64-.9062 22.61c-6.5 6-16.59 5.594-22.59-.8906l-192-208c-5.688-6.156-5.688-15.56 0-21.72l192-208C218.2 30.66 228.3 30.25 234.8 36.25z"]
};
faChevronLeft_2 = faChevronLeft$1.faChevronLeft = faChevronLeft;
var faChevronsLeft$1 = {};
Object.defineProperty(faChevronsLeft$1, "__esModule", {
  value: true
});
var faChevronsLeft_2 = faChevronsLeft$1.faChevronsLeft = void 0;
const faChevronsLeft = {
  prefix: "fal",
  iconName: "faChevronsLeft",
  icon: [448, 512, [], "", "M235.8 453.1L53.8 256l181.1-197.1c2.844-3.078 4.25-6.969 4.25-10.86c0-4.312-1.719-8.609-5.156-11.75c-6.5-6-16.59-5.594-22.59 .8906l-192 208c-5.688 6.156-5.688 15.56 0 21.72l192 208c6 6.484 16.09 6.891 22.59 .8906C241.4 469.8 241.8 459.6 235.8 453.1zM212.2 245.1c-5.688 6.156-5.688 15.56 0 21.72l192 208c6 6.484 16.09 6.891 22.59 .8906c6.531-5.969 6.906-16.11 .9062-22.61l-181.1-197.1l181.1-197.1c2.844-3.078 4.25-6.969 4.25-10.86c0-4.312-1.719-8.609-5.156-11.75c-6.5-6-16.59-5.594-22.59 .8906L212.2 245.1z"]
};
faChevronsLeft_2 = faChevronsLeft$1.faChevronsLeft = faChevronsLeft;
var faChevronsRight$1 = {};
Object.defineProperty(faChevronsRight$1, "__esModule", {
  value: true
});
var faChevronsRight_2 = faChevronsRight$1.faChevronsRight = void 0;
const faChevronsRight = {
  prefix: "fal",
  iconName: "faChevronsRight",
  icon: [448, 512, [], "", "M212.2 58.86l181.1 197.1L212.2 453.1c-2.844 3.078-4.25 6.969-4.25 10.86c0 4.312 1.719 8.609 5.156 11.75c6.5 6 16.59 5.594 22.59-.8906l192-208c5.688-6.156 5.688-15.56 0-21.72l-192-208c-6-6.484-16.09-6.891-22.59-.8906C206.6 42.22 206.2 52.36 212.2 58.86zM235.8 266.9c5.688-6.156 5.688-15.56 0-21.72l-192-208c-6-6.484-16.09-6.891-22.59-.8906c-6.531 5.969-6.906 16.11-.9062 22.61l181.1 197.1L20.26 453.1c-2.844 3.078-4.25 6.969-4.25 10.86c0 4.312 1.719 8.609 5.156 11.75c6.5 6 16.59 5.594 22.59-.8906L235.8 266.9z"]
};
faChevronsRight_2 = faChevronsRight$1.faChevronsRight = faChevronsRight;
const TableEmptyStateSVG = () => /* @__PURE__ */jsxs("svg", {
  width: "184",
  height: "92",
  viewBox: "0 0 184 92",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/* @__PURE__ */jsx$1("path", {
    d: "M0.5 1.75238C0.5 0.784568 1.28457 0 2.25238 0H181.748C182.715 0 183.5 0.784568 183.5 1.75238V10H0.5V1.75238Z",
    fill: "#BBDBFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "0.5",
    y: "16",
    width: "46.4381",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "62.938",
    y: "16",
    width: "31.5429",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "110.481",
    y: "16",
    width: "32.419",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "158.9",
    y: "16",
    width: "24.5333",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("path", {
    d: "M0.5 32H183.5",
    stroke: "#BBDBFE",
    strokeWidth: "1.31429"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "0.5",
    y: "38",
    width: "46.4381",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "62.938",
    y: "38",
    width: "31.5429",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "110.481",
    y: "38",
    width: "32.419",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "158.9",
    y: "38",
    width: "24.5333",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("path", {
    d: "M0.5 54H183.5",
    stroke: "#BBDBFE",
    strokeWidth: "1.31429"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "0.5",
    y: "60",
    width: "46.4381",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "62.938",
    y: "60",
    width: "31.5429",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "110.481",
    y: "60",
    width: "32.419",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "158.9",
    y: "60",
    width: "24.5333",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("path", {
    d: "M0.5 76H183.5",
    stroke: "#BBDBFE",
    strokeWidth: "1.31429"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "0.5",
    y: "82",
    width: "46.4381",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "62.938",
    y: "82",
    width: "31.5429",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "110.481",
    y: "82",
    width: "32.419",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  }), /* @__PURE__ */jsx$1("rect", {
    x: "158.9",
    y: "82",
    width: "24.5333",
    height: "10",
    rx: "1.75238",
    fill: "#DCECFE"
  })]
});
const StyledTableCont = styled(Paper, {
  display: "grid",
  gridTemplateRows: "auto 44px",
  gridTemplateColumns: "auto",
  gridTemplateAreas: `
    'table'
    'pagination'
  `,
  width: "100%",
  maxWidth: "100%"
});
const StyledTable = styled("table", {
  borderSpacing: 0,
  emptyCells: "show",
  textColor: "body",
  width: "100%"
});
const StyledTableHeader = styled("thead", {
  position: "sticky",
  top: 0,
  textAlign: "left",
  verticalAlign: "middle",
  zIndex: "$default",
  variants: {
    hidden: {
      true: {
        display: "none"
      }
    }
  }
});
const StyledTableBody = styled("tbody", {
  overflowY: "auto",
  overflowX: "hidden",
  maxHeight: "100%"
});
const StyledTableRow = styled("tr", {
  backgroundColor: "$white",
  variants: {
    highlighted: {
      true: {
        backgroundColor: "$blue2"
      }
    }
  }
});
const StyledTableSubRow = styled("tr", {
  backgroundColor: "$gray2"
});
const StyledTableHeaderCell = styled("th", {
  minHeight: 32,
  textColor: "thead",
  textStyles: "thead",
  padding: "$1 $2",
  backgroundColor: "$blue1",
  borderBottom: "1px solid $gray3",
  verticalAlign: "top",
  variants: {
    clickable: {
      true: {
        cursor: "pointer",
        userSelect: "none"
      }
    },
    sticky: {
      true: {
        position: "sticky",
        left: 0
      }
    }
  }
});
const StyledTableCell = styled("td", {
  height: 56,
  textStyles: "body",
  textColor: "body",
  borderBottom: "1px solid $gray3",
  padding: "$2",
  variants: {
    sticky: {
      true: {
        position: "sticky",
        left: 0,
        background: "$white"
      }
    },
    disableBorderBottom: {
      true: {
        borderBottom: "none"
      }
    },
    textAlign: {
      left: {
        textAlign: "left"
      },
      right: {
        textAlign: "right"
      }
    }
  }
});
const StyledPaginationSimpleGrid = styled(SimpleGrid, {
  paddingX: "$2",
  paddingY: "10px",
  backgroundColor: "$white"
});
const TableBasePaginationPageSizes = [5, 10, 25, 50];
const TableBasePagination = _ref151 => {
  let {
    totalRows,
    pageSize,
    onPageSizeChange,
    pageIndex,
    onPageIndexChange,
    canGetPreviousPage,
    canGetNextPage
  } = _ref151;
  const pageCount = useMemo(() => Math.ceil(totalRows / pageSize) || 1, [pageSize, totalRows]);
  const pageOptions = useMemo(() => Array.from({
    length: pageCount
  }, (_, i) => i).map(page => ({
    label: (page + 1).toString(),
    value: page
  })), [pageCount]);
  const defaultPageSizeOptions = useMemo(() => TableBasePaginationPageSizes.filter(size => size < totalRows).map(size => ({
    label: size.toString(),
    value: size
  })), [totalRows]);
  const largestPageSize = Math.max(...TableBasePaginationPageSizes);
  const customPageSizeOption = useMemo(() => totalRows <= largestPageSize ? [{
    label: totalRows.toString(),
    value: totalRows
  }] : [], [largestPageSize, totalRows]);
  const totalRowOptions = useMemo(() => [...defaultPageSizeOptions, ...customPageSizeOption].sort((a2, b2) => a2.value - b2.value), [customPageSizeOption, defaultPageSizeOptions]);
  return /* @__PURE__ */jsxs(StyledPaginationSimpleGrid, {
    columns: 3,
    fullWidth: true,
    children: [/* @__PURE__ */jsx$1(Flex, {
      alignItems: "center",
      children: /* @__PURE__ */jsxs(Text, {
        variant: "metadata",
        children: [`Showing `, /* @__PURE__ */jsx$1(InlineSelect, {
          label: "Table Page Size",
          options: totalRowOptions,
          value: Math.min(totalRows, pageSize),
          onValueChange: onPageSizeChange
        }), ` of ${totalRows}`]
      })
    }), /* @__PURE__ */jsxs(Flex, {
      alignItems: "center",
      justifyContent: "center",
      children: [/* @__PURE__ */jsx$1(IconButton, {
        size: "small",
        title: "First Page",
        icon: faChevronsLeft_2,
        onClick: () => onPageIndexChange(0),
        disabled: !canGetPreviousPage
      }), /* @__PURE__ */jsx$1(IconButton, {
        size: "small",
        title: "Previous Page",
        icon: faChevronLeft_2,
        onClick: () => onPageIndexChange(pageIndex - 1),
        disabled: !canGetPreviousPage
      }), /* @__PURE__ */jsxs(Text, {
        variant: "metadata",
        children: [/* @__PURE__ */jsx$1(InlineSelect, {
          label: "Current Table Page",
          options: pageOptions,
          value: pageCount > 1 ? pageIndex : 0,
          onValueChange: onPageIndexChange
        }), " ", "of ", pageCount]
      }), /* @__PURE__ */jsx$1(IconButton, {
        size: "small",
        title: "Next Page",
        icon: faChevronRight_2$1,
        onClick: () => onPageIndexChange(pageIndex + 1),
        disabled: !canGetNextPage
      }), /* @__PURE__ */jsx$1(IconButton, {
        size: "small",
        title: "Last Page",
        icon: faChevronsRight_2,
        onClick: () => onPageIndexChange(pageCount - 1),
        disabled: !canGetNextPage
      })]
    })]
  });
};
const TableEmptyState = _ref152 => {
  let {
    title,
    subtitle,
    minHeight,
    action,
    image
  } = _ref152;
  return /* @__PURE__ */jsxs(Flex, {
    direction: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    fullWidth: true,
    css: {
      minHeight
    },
    children: [image || /* @__PURE__ */jsx$1(TableEmptyStateSVG, {}), /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      alignItems: "center",
      gap: 2,
      children: [/* @__PURE__ */jsxs(Flex, {
        direction: "column",
        alignItems: "center",
        gap: 0,
        children: [title && /* @__PURE__ */jsx$1(Text, {
          variant: "bodyBold",
          children: title
        }), subtitle && /* @__PURE__ */jsx$1(Text, {
          variant: "metadata",
          children: subtitle
        })]
      }), action && action]
    })]
  });
};
const TableRowExpansionIcon = _ref153 => {
  let {
    isExpanded,
    handleToggle
  } = _ref153;
  const buttonText = isExpanded ? "Collapse Rows" : "Expand Rows";
  return /* @__PURE__ */jsx$1(IconButton, {
    title: buttonText,
    icon: isExpanded ? faChevronDown_2 : faChevronRight_2$1,
    onClick: handleToggle,
    "aria-label": buttonText,
    hideTooltip: true
  });
};
const TableRowSelectionCheckbox = _ref154 => {
  let {
    isChecked,
    handleCheckbox
  } = _ref154;
  return /* @__PURE__ */jsx$1(Checkbox, {
    checked: isChecked,
    onChange: handleCheckbox,
    ariaLabel: "select row"
  });
};
const TableRowSelectionAllCheckbox = _ref155 => {
  let {
    isChecked,
    handleCheckbox
  } = _ref155;
  return /* @__PURE__ */jsx$1(Checkbox, {
    checked: isChecked,
    onChange: handleCheckbox,
    ariaLabel: "select row"
  });
};
const TableBase = {
  Root: StyledTableCont,
  Table: StyledTable,
  Head: StyledTableHeader,
  Body: StyledTableBody,
  Row: StyledTableRow,
  SubRow: StyledTableSubRow,
  HCell: StyledTableHeaderCell,
  Cell: StyledTableCell,
  Pagination: TableBasePagination,
  EmptyState: TableEmptyState,
  RowExpansionIcon: TableRowExpansionIcon,
  TableRowSelectionCheckbox,
  TableRowSelectionAllCheckbox
};
const useSafeLayoutEffect = (globalThis == null ? void 0 : globalThis.document) ? useLayoutEffect$1 : useEffect;
function useCallbackRef(fn) {
  let deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const ref = useRef(fn);
  useSafeLayoutEffect(() => {
    ref.current = fn;
  });
  return useCallback(function () {
    var _a;
    for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      args[_key16] = arguments[_key16];
    }
    return (_a = ref.current) == null ? void 0 : _a.call(ref, ...args);
  }, deps);
}
function runIfFn(valueOrFn) {
  for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
    args[_key17 - 1] = arguments[_key17];
  }
  return isFunction$1(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange: onChange3,
    shouldUpdate = (prev2, next2) => prev2 !== next2
  } = props;
  const onChangeProp = useCallbackRef(onChange3);
  const shouldUpdateProp = useCallbackRef(shouldUpdate);
  const [valueState, setValue] = useState(defaultValue);
  const isControlled = valueProp !== void 0;
  const value = isControlled ? valueProp : valueState;
  const updateValue = useCallback(next2 => {
    const nextValue = runIfFn(next2, value);
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp(nextValue);
  }, [isControlled, onChangeProp, value, shouldUpdateProp]);
  return [value, updateValue];
}
function isFunction(func) {
  return typeof func === "function";
}
var faChevronUp$1 = {};
Object.defineProperty(faChevronUp$1, "__esModule", {
  value: true
});
var faChevronUp_2 = faChevronUp$1.faChevronUp = void 0;
const faChevronUp = {
  prefix: "fal",
  iconName: "faChevronUp",
  icon: [448, 512, [], "", "M443.8 330.8C440.6 334.3 436.3 336 432 336c-3.891 0-7.781-1.406-10.86-4.25L224 149.8l-197.1 181.1c-6.5 6-16.64 5.625-22.61-.9062c-6-6.5-5.594-16.59 .8906-22.59l208-192c6.156-5.688 15.56-5.688 21.72 0l208 192C449.3 314.3 449.8 324.3 443.8 330.8z"]
};
faChevronUp_2 = faChevronUp$1.faChevronUp = faChevronUp;
const StyledTableBannerContainer = styled(Box, {
  display: "grid",
  paddingX: "$2",
  rowGap: "$1",
  columnGap: "$1",
  minHeight: "40px",
  width: "100%",
  alignItems: "center",
  backgroundColor: "$blue10"
});
const StyledTableBannerContent = styled(Flex, {
  paddingY: "10px"
});
const TableBannerContent = _ref156 => {
  let {
    children
  } = _ref156;
  return /* @__PURE__ */jsx$1(StyledTableBannerContent, {
    children
  });
};
const TableBannerActions = _ref157 => {
  let {
    children
  } = _ref157;
  return /* @__PURE__ */jsx$1(ButtonGroup, {
    children
  });
};
const TableBannerRoot = forwardRef((_ref158, forwardedRef) => {
  let {
    rootProps,
    children,
    ...props
  } = _ref158;
  return /* @__PURE__ */jsx$1(StyledTableBannerContainer, {
    ref: forwardedRef,
    ...props,
    ...rootProps,
    children: /* @__PURE__ */jsx$1(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      children
    })
  });
});
const TableBanner = {
  Root: TableBannerRoot,
  Actions: TableBannerActions,
  Content: TableBannerContent
};
TableBannerRoot.displayName = "TableBanner";
const getTableColumns = _ref159 => {
  let {
    columns,
    sortingEnabled
  } = _ref159;
  const displayAccessorColumns = columns.map(col => {
    var _a;
    const displayColData = col;
    if (displayColData == null ? void 0 : displayColData.render) {
      return {
        id: displayColData.id,
        cell: _ref160 => {
          let {
            row
          } = _ref160;
          return displayColData.render(row.original);
        },
        size: displayColData.size
      };
    }
    const accessorColData = col;
    const accessorCol = {
      id: (_a = accessorColData.id) != null ? _a : accessorColData.value,
      accessorFn: typeof accessorColData.value === "string" ? data => data[accessorColData.value] : accessorColData.value,
      cell: props => {
        return accessorColData.cell ? accessorColData.cell(props.row.original) : /* @__PURE__ */jsx$1("span", {
          children: props.getValue()
        });
      },
      ...(accessorColData.header != null && {
        header: accessorColData.header
      }),
      size: accessorColData.size,
      enableSorting: sortingEnabled ? !accessorColData.disableSort : false
    };
    return accessorCol;
  });
  return displayAccessorColumns;
};
const THeadText = styled("span", {
  clampLines: 2,
  textStyles: "thead",
  textColor: "thead"
});
const DefaultPaginationState = {
  pageIndex: 0,
  pageSize: 25
};
const TableStateChangeTypes = ["sorting", "pagination", "columnVisibility", "rowSelection"];
const Table = _ref161 => {
  let {
    columns = [],
    rows,
    onStateChange = () => {},
    isLoading = false,
    loadingRows = rows.length,
    pagination,
    sorting,
    search,
    height,
    disableBoxShadow,
    emptyState: {
      title: emptyTitle = "No data to display",
      subtitle: emptySubtitle = "Try adjusting your filters or search",
      minHeight: emptyMinHeight = 400,
      action: emptyAction = void 0,
      image: emptyImage = void 0
    } = {},
    tableRef,
    isExpandable,
    columnStickyIndex,
    renderToolbar,
    hideHeader = false,
    highlightedRow = void 0,
    enableRowSelection,
    enableMultiRowSelection,
    childrenBannerActions
  } = _ref161;
  const defaultPagination = useMemo(() => {
    var _a;
    return (_a = pagination == null ? void 0 : pagination.defaultPagination) != null ? _a : DefaultPaginationState;
  }, [pagination == null ? void 0 : pagination.defaultPagination]);
  const [currSorting, setCurrSorting] = useControllableState({
    defaultValue: sorting == null ? void 0 : sorting.defaultSort,
    value: sorting == null ? void 0 : sorting.value,
    onChange: sorting == null ? void 0 : sorting.onChange
  });
  const [currPagination, setCurrPagination] = useState(defaultPagination);
  const [rowSelection, setRowSelection] = useState({});
  const initialColumnVisibility = columns.reduce((result, obj) => {
    var _a;
    const columnId = (_a = obj.id) != null ? _a : obj.value;
    if (!isNilOrEmpty(columnId)) {
      result[columnId] = obj.visibilityHidden ? false : true;
    }
    return result;
  }, {});
  const [columnVisibility, setColumnVisibility] = useState(initialColumnVisibility);
  const resetSorting = useCallback(() => {
    setCurrSorting(currSorting);
  }, [currSorting, setCurrSorting]);
  const resetPagination = useCallback(() => {
    setCurrPagination(currPagination2 => ({
      ...currPagination2,
      pageIndex: 0
    }));
  }, []);
  const resetColumnVisibility = useCallback(() => {
    setColumnVisibility({});
  }, []);
  const paginationEnabled = pagination != null;
  const sortingEnabled = (sorting == null ? void 0 : sorting.disableSort) !== true;
  const searchEnabled = search != null;
  const onChangeState = useMemo(() => ({
    setPagination: setCurrPagination,
    setSorting: setCurrSorting,
    setColumnVisibility,
    setRowSelection,
    resetPagination,
    resetSorting,
    resetColumnVisibility,
    sorting: currSorting,
    pagination: currPagination,
    columnVisibility,
    rowSelection
  }), [setCurrSorting, resetPagination, resetSorting, resetColumnVisibility, currSorting, currPagination, columnVisibility, rowSelection, setRowSelection]);
  const handleOnSortingChange = useCallback(newSorting => {
    const event = "sorting";
    setCurrSorting(newSorting);
    onStateChange(mergeRight$1(onChangeState, {
      event,
      sorting: is$1(Function, newSorting) ? newSorting(currSorting) : newSorting
    }));
  }, [currSorting, onChangeState, onStateChange, setCurrSorting]);
  const handlePaginationChange = useCallback(newPagination => {
    const event = "pagination";
    setCurrPagination(newPagination);
    onStateChange(mergeRight$1(onChangeState, {
      event,
      pagination: is$1(Function, newPagination) ? newPagination(currPagination) : newPagination
    }));
  }, [currPagination, onChangeState, onStateChange]);
  const handleColumnVisibilityChange = useCallback(newColumnVisibility => {
    const event = "columnVisibility";
    setColumnVisibility(newColumnVisibility);
    onStateChange(mergeRight$1(onChangeState, {
      event,
      columnVisibility: is$1(Function, newColumnVisibility) ? newColumnVisibility(columnVisibility) : newColumnVisibility
    }));
  }, [columnVisibility, onChangeState, onStateChange]);
  const handleRowSelectionChange = useCallback(newRowSelection => {
    const event = "rowSelection";
    setRowSelection(newRowSelection);
    onStateChange(mergeRight$1(onChangeState, {
      event,
      rowSelection: is$1(Function, newRowSelection) ? newRowSelection(rowSelection) : newRowSelection
    }));
  }, [rowSelection, onChangeState, onStateChange]);
  const tableColumns = useMemo(() => {
    return getTableColumns({
      columns,
      sortingEnabled
    });
  }, [columns, sortingEnabled]);
  const columnOptions = useMemo(() => tableColumns.reduce((acc, col, i) => {
    const {
      align
    } = columns[i];
    acc.set(col.id, {
      align
    });
    return acc;
  }, /* @__PURE__ */new Map()), [tableColumns, columns]);
  const adjustedTableColumns = useMemo(() => {
    if (isExpandable) {
      const ExpanderColumnDef = {
        id: "expander",
        cell: _ref162 => {
          let {
            row
          } = _ref162;
          return row.getCanExpand() && row.originalSubRows && row.originalSubRows.length > 0 && /* @__PURE__ */jsx$1(TableBase.RowExpansionIcon, {
            isExpanded: row.getIsExpanded(),
            handleToggle: row.getToggleExpandedHandler()
          });
        },
        size: 60
      };
      return [ExpanderColumnDef, ...tableColumns];
    }
    if (enableMultiRowSelection) {
      const MultiRowSelectionColumnDef = {
        id: "rowSelection",
        header: _ref163 => {
          let {
            table: table2
          } = _ref163;
          return /* @__PURE__ */jsx$1(TableBase.TableRowSelectionCheckbox, {
            isChecked: table2.getIsAllRowsSelected() ? true : table2.getIsSomeRowsSelected() ? "indeterminate" : false,
            handleCheckbox: () => table2.toggleAllRowsSelected()
          });
        },
        cell: _ref164 => {
          let {
            row
          } = _ref164;
          return /* @__PURE__ */jsx$1(TableBase.TableRowSelectionCheckbox, {
            isChecked: row.getIsSelected(),
            handleCheckbox: row.getToggleSelectedHandler()
          });
        },
        size: 60
      };
      return [MultiRowSelectionColumnDef, ...tableColumns];
    }
    return tableColumns;
  }, [tableColumns, isExpandable, enableMultiRowSelection]);
  const loadingData = useMemo(() => {
    return Array.from({
      length: paginationEnabled ? currPagination.pageSize : loadingRows
    }).map(() => ({}));
  }, [currPagination.pageSize, loadingRows, paginationEnabled]);
  const table = useReactTable({
    data: isLoading ? loadingData : rows,
    columns: adjustedTableColumns,
    enableRowSelection,
    enableMultiRowSelection,
    childrenBannerActions,
    enableSubRowSelection: false,
    onRowSelectionChange: handleRowSelectionChange,
    state: {
      sorting: currSorting,
      pagination: currPagination,
      columnVisibility,
      rowSelection
    },
    getSortedRowModel: getSortedRowModel(),
    onSortingChange: handleOnSortingChange,
    getRowCanExpand: () => true,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getSubRows: originalRow => {
      return (originalRow == null ? void 0 : originalRow.subRows) || "";
    },
    getRowId: (originalRow, index2) => {
      var _a;
      return ((_a = originalRow.id) == null ? void 0 : _a.toString()) || index2.toString();
    },
    ...(paginationEnabled && {
      pageCount: Math.ceil(pagination.rowTotal / currPagination.pageSize),
      onPaginationChange: handlePaginationChange,
      getPaginationRowModel: getPaginationRowModel(),
      manualPagination: !pagination.enableClientSidePagination
    }),
    onColumnVisibilityChange: handleColumnVisibilityChange
  });
  useImperativeHandle(tableRef, () => ({
    reset: _ref165 => {
      let {
        pagination: pagination2 = defaultPagination,
        sorting: sorting2 = currSorting
      } = _ref165;
      table.setPageIndex(pagination2.pageIndex);
      setCurrSorting(sorting2);
      setCurrPagination(pagination2);
    },
    resetRowSelection: () => {
      setRowSelection({});
    }
  }), [setCurrPagination, setCurrSorting, currSorting, defaultPagination, table]);
  const tableProps = tableRef ? {
    ref: tableRef
  } : {};
  return /* @__PURE__ */jsxs(TableBase.Root, {
    ref: tableProps.ref,
    elevation: disableBoxShadow ? 1 : 2,
    css: {
      height,
      gridTemplateRows: `auto auto ${paginationEnabled ? "44px" : ""}`,
      gridTemplateAreas: `${renderToolbar ? '"header"' : ""} "table" ${paginationEnabled ? '"pagination"' : ""} `
    },
    children: [/* @__PURE__ */jsxs(Flex, {
      alignItems: "center",
      justifyContent: searchEnabled ? "space-between" : "flex-end",
      direction: "row",
      children: [searchEnabled && /* @__PURE__ */jsxs(Flex, {
        alignItems: "center",
        css: {
          padding: "1rem"
        },
        direction: "row",
        children: [/* @__PURE__ */jsx$1(InputText, {
          placeholder: search.placeholder || "Search",
          hideLabel: true,
          label: "",
          onChange: search.onChange
        }), search.renderFilters && search.renderFilters()]
      }), renderToolbar && renderToolbar({
        table
      })]
    }), /* @__PURE__ */jsxs(Box, {
      css: {
        position: "relative",
        maxWidth: "100%",
        overflowX: "auto",
        overflowY: "auto",
        maxHeight: "100%"
      },
      children: [enableMultiRowSelection && Object.keys(rowSelection).length > 0 && /* @__PURE__ */jsxs(TableBanner.Root, {
        children: [/* @__PURE__ */jsx$1(TableBannerContent, {
          children: /* @__PURE__ */jsxs(Text, {
            as: "span",
            css: {
              color: "$white"
            },
            children: [Object.keys(rowSelection).length, " items selected"]
          })
        }), /* @__PURE__ */jsx$1(TableBannerActions, {
          children: childrenBannerActions
        })]
      }), /* @__PURE__ */jsxs(TableBase.Table, {
        children: [/* @__PURE__ */jsx$1(TableBase.Head, {
          hidden: hideHeader,
          children: table.getHeaderGroups().map(headerGroup => /* @__PURE__ */jsx$1(TableBase.Row, {
            children: headerGroup.headers.map((header, headerCellIndex) => {
              var _a;
              return /* @__PURE__ */jsx$1(TableBase.HCell, {
                clickable: header.column.getCanSort(),
                onClick: header.column.getToggleSortingHandler(),
                css: {
                  minWidth: header.getSize()
                },
                sticky: !isNil$1(columnStickyIndex) && headerCellIndex === columnStickyIndex,
                children: /* @__PURE__ */jsxs(Flex, {
                  gap: "half",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  children: [/* @__PURE__ */jsx$1(THeadText, {
                    children: header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())
                  }), (_a = {
                    asc: /* @__PURE__ */jsx$1(Icon, {
                      size: "small",
                      icon: faChevronUp_2
                    }),
                    desc: /* @__PURE__ */jsx$1(Icon, {
                      size: "small",
                      icon: faChevronDown_2
                    })
                  }[header.column.getIsSorted()]) != null ? _a : null]
                })
              }, header.id);
            })
          }, headerGroup.id))
        }), /* @__PURE__ */jsx$1(TableBase.Body, {
          children: table.getRowModel().rows.map((row, rowIndex, rows2) => {
            var _a;
            const Row = row.depth === 0 ? TableBase.Row : TableBase.SubRow;
            return /* @__PURE__ */jsx$1(Row, {
              ...(!isNilOrEmpty(highlightedRow) && {
                highlighted: isFunction(highlightedRow) ? highlightedRow(row.original) : ((_a = row == null ? void 0 : row.original) == null ? void 0 : _a.id) === highlightedRow
              }),
              children: row.getVisibleCells().map((cell, cellindex) => {
                var _a2;
                const colOptions = columnOptions.get(cell.column.id);
                return /* @__PURE__ */jsx$1(TableBase.Cell, {
                  css: {
                    minWidth: cell.column.getSize()
                  },
                  sticky: !isNil$1(columnStickyIndex) && cellindex === columnStickyIndex,
                  disableBorderBottom: paginationEnabled ? rows2.length - 1 === rowIndex : false,
                  textAlign: (_a2 = colOptions == null ? void 0 : colOptions.align) != null ? _a2 : "left",
                  children: /* @__PURE__ */jsx$1(Skeleton, {
                    height: 16,
                    isLoading,
                    round: cell.column.id === "actions" || cell.column.id === "expander",
                    size: cell.column.id === "actions" || cell.column.id === "expander" ? 16 : void 0,
                    children: flexRender(cell.column.columnDef.cell, cell.getContext())
                  })
                }, cell.id);
              })
            }, row.id);
          })
        })]
      }), table.getRowModel().rows.length === 0 && /* @__PURE__ */jsx$1(TableBase.EmptyState, {
        title: emptyTitle,
        subtitle: emptySubtitle,
        minHeight: emptyMinHeight,
        action: emptyAction,
        image: emptyImage
      })]
    }), paginationEnabled && /* @__PURE__ */jsx$1(TableBase.Pagination, {
      totalRows: pagination.rowTotal,
      pageSize: currPagination.pageSize,
      onPageSizeChange: newPageSize => {
        table.setPageSize(newPageSize);
      },
      pageIndex: currPagination.pageIndex,
      onPageIndexChange: newPageIndex => {
        table.setPageIndex(newPageIndex);
      },
      canGetPreviousPage: table.getCanPreviousPage(),
      canGetNextPage: table.getCanNextPage()
    })]
  });
};
const useTableState = args => {
  const {
    defaultSort = [],
    defaultPagination = DefaultPaginationState,
    defaultColumnVisibility = {},
    defaulRowSelection = {}
  } = args || {};
  const [tableState, setTableState] = useState({
    sorting: defaultSort,
    pagination: defaultPagination,
    columnVisibility: defaultColumnVisibility,
    rowSelection: defaulRowSelection
  });
  const handleTableStateChange = useCallback(_ref166 => {
    let {
      pagination,
      sorting,
      columnVisibility,
      resetPagination,
      event,
      rowSelection
    } = _ref166;
    if (event === "sorting") {
      resetPagination();
    }
    setTableState({
      pagination,
      sorting,
      columnVisibility,
      rowSelection
    });
  }, []);
  return {
    tableState,
    handleTableStateChange
  };
};
const useTableRef = () => {
  const tableRef = useRef(null);
  return tableRef;
};
const StyledPopoverContent = styled(Popover.Content, {
  maxHeight: "500px",
  gridArea: "dialog-content",
  overflow: "auto",
  WebkitOverflowScrolling: "touch",
  overflowScrolling: "touch",
  background: `
    linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    linear-gradient(180deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center top,
    linear-gradient(0deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center bottom
  `,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 40px, 100% 4px, 100% 4px",
  backgroundAttachment: "local, local, scroll, scroll",
  padding: "0px $2 0px $2"
});
const TableVisibilityMenu = _ref167 => {
  let {
    table
  } = _ref167;
  return /* @__PURE__ */jsx$1(Flex, {
    justifyContent: "flex-end",
    alignItems: "center",
    children: /* @__PURE__ */jsxs(Popover.Root, {
      children: [/* @__PURE__ */jsx$1(Popover.Trigger, {
        children: /* @__PURE__ */jsx$1(IconButton, {
          title: "Column visibility",
          icon: faGear_2
        })
      }), /* @__PURE__ */jsx$1(StyledPopoverContent, {
        hideWhenDetached: true,
        side: "bottom",
        align: "end",
        hideCloseButton: true,
        hideArrow: true,
        minWidth: 150,
        maxWidth: 300,
        css: {
          borderTop: "none !important",
          padding: 0,
          borderRadius: "4px",
          backgroundColor: "$white",
          display: "grid"
        },
        width: "min-content",
        children: /* @__PURE__ */jsxs(List, {
          children: [/* @__PURE__ */jsx$1(ListItem, {
            prefix: /* @__PURE__ */jsx$1(Checkbox, {
              label: table.getIsAllColumnsVisible() ? "Hide all columns" : "Show all columns",
              checked: table.getIsAllColumnsVisible() || "indeterminate",
              onChange: table.getToggleAllColumnsVisibilityHandler()
            }),
            clickable: false,
            label: ""
          }), /* @__PURE__ */jsx$1(StyledDropdownGroupSeparator, {}), table.getAllLeafColumns().map((column2, index2) => {
            if (typeof column2.columnDef.header !== "string" || column2.columnDef.header === "") {
              return;
            }
            const isColumnVisible = column2 == null ? void 0 : column2.getIsVisible();
            const handleChangeColumnChecked = () => {
              const toggleVisibilityHandler = column2 == null ? void 0 : column2.getToggleVisibilityHandler();
              toggleVisibilityHandler({
                target: isColumnVisible
              });
            };
            return /* @__PURE__ */jsx$1(ListItem, {
              prefix: /* @__PURE__ */jsx$1(Checkbox, {
                label: column2.columnDef.header,
                checked: isColumnVisible,
                onChange: handleChangeColumnChecked
              }),
              clickable: false,
              label: ""
            }, `toggle-column-visibility-item-${index2}`);
          })]
        })
      })]
    })
  });
};
const TableToolbar = {
  VisibilityMenu: TableVisibilityMenu
};
const ariaButtonEvents = function () {
  let fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  const onClick = e2 => {
    e2.preventDefault();
    fn(e2);
  };
  const onKeyDown = e2 => {
    if (e2.key === " ") {
      e2.preventDefault();
    }
    if (e2.key === "Enter") {
      e2.preventDefault();
      fn(e2);
    }
  };
  const onKeyUp = e2 => {
    if (e2.key === " ") {
      e2.preventDefault();
      fn(e2);
    }
  };
  return {
    onClick,
    onKeyDown,
    onKeyUp
  };
};
var faCheck$1 = {};
Object.defineProperty(faCheck$1, "__esModule", {
  value: true
});
var faCheck_2 = faCheck$1.faCheck = void 0;
const faCheck = {
  prefix: "far",
  iconName: "faCheck",
  icon: [512, 512, [], "", "M480.1 128.1l-272 272C204.3 405.7 198.2 408 192 408s-12.28-2.344-16.97-7.031l-144-144c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L192 350.1l255-255c9.375-9.375 24.56-9.375 33.94 0S490.3 119.6 480.1 128.1z"]
};
faCheck_2 = faCheck$1.faCheck = faCheck;
var faLock$1 = {};
Object.defineProperty(faLock$1, "__esModule", {
  value: true
});
var faLock_2 = faLock$1.faLock = void 0;
const faLock = {
  prefix: "fas",
  iconName: "faLock",
  icon: [448, 512, [], "", "M384 223.1L368 224V144c0-79.41-64.59-144-144-144S80 64.59 80 144V224L64 223.1c-35.35 0-64 28.65-64 64v160c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64v-160C448 252.7 419.3 223.1 384 223.1zM144 144C144 99.88 179.9 64 224 64s80 35.88 80 80V224h-160V144z"]
};
faLock_2 = faLock$1.faLock = faLock;
const StepStatusEnum = {
  COMPLETE: "COMPLETE",
  INVALID: "INVALID",
  LOCKED: "LOCKED",
  INCOMPLETE: "INCOMPLETE"
};
const StepContainer = styled(Box, {
  textAlign: "center",
  flexGrow: 1
});
const ProgressContainer = styled(Box, {
  height: "$3",
  marginBottom: "$half",
  position: "relative",
  zIndex: 0
});
const ProgressBar = styled(Box, {
  height: "$half",
  position: "absolute",
  top: `calc(50% - $half / 2)`,
  zIndex: -1,
  variants: {
    position: {
      prev: {
        left: 0,
        right: "50%"
      },
      next: {
        right: 0,
        left: "50%"
      }
    },
    active: {
      true: {
        background: "$cyan6"
      },
      false: {
        background: "$gray4"
      }
    }
  }
});
const ProgressIconContainer = styled(Box, {
  $$currentColor: "$colors$cyan6",
  $$incompleteColor: "$colors$gray5",
  $$invalidColor: "$colors$yellow4",
  $$activeColor: "$colors$cyan4",
  backgroundColor: "$white",
  borderRadius: "50%",
  cursor: "pointer",
  display: "inline-block",
  height: "$3",
  width: "$3",
  '&[data-disabled="true"]': {
    cursor: "not-allowed"
  },
  variants: {
    active: {
      true: {}
    },
    status: {
      [StepStatusEnum.COMPLETE]: {
        backgroundColor: "$$currentColor",
        boxShadow: "0 0 0 1px $$currentColor"
      },
      [StepStatusEnum.INCOMPLETE]: {
        boxShadow: "0 0 0 1px $$incompleteColor"
      },
      [StepStatusEnum.LOCKED]: {
        boxShadow: "0 0 0 1px $$incompleteColor"
      },
      [StepStatusEnum.INVALID]: {
        boxShadow: "0 0 0 1px $$invalidColor"
      }
    }
  },
  compoundVariants: [{
    active: true,
    status: StepStatusEnum.COMPLETE,
    css: {
      boxShadow: "0 0 0 2px $$activeColor"
    }
  }, {
    active: true,
    status: StepStatusEnum.INCOMPLETE,
    css: {
      boxShadow: "0 0 0 2px $$activeColor"
    }
  }, {
    active: true,
    status: StepStatusEnum.LOCKED,
    css: {
      boxShadow: "0 0 0 2px $$activeColor"
    }
  }, {
    active: true,
    status: StepStatusEnum.INVALID,
    css: {
      boxShadow: "0 0 0 2px $$activeColor"
    }
  }]
});
const ProgressIcon = styled(Icon, {
  transform: "translateY(2px)"
});
const StepDescriptionContainer = styled(Box, {
  padding: "0 calc($base * 1.5)",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  width: "100%"
});
const StepDescription = styled(Box, {
  padding: "0 $half",
  display: "inline-block",
  cursor: "pointer",
  border: "1px solid transparent",
  '&[data-disabled="true"]': {
    cursor: "not-allowed"
  },
  "&:focus-visible": {
    outlineColor: "$blue6"
  },
  "&::after": {
    display: "block",
    content: "attr(data-content)",
    fontWeight: "$bold",
    height: 1,
    color: "transparent",
    overflow: "hidden",
    visibility: "hidden"
  },
  variants: {
    current: {
      true: {
        fontWeight: "$bold",
        color: "$gray12"
      }
    },
    status: {
      [StepStatusEnum.COMPLETE]: {},
      [StepStatusEnum.INCOMPLETE]: {
        color: "$gray8"
      },
      [StepStatusEnum.LOCKED]: {
        color: "$gray8"
      },
      [StepStatusEnum.INVALID]: {}
    }
  },
  compoundVariants: [{
    current: true,
    status: StepStatusEnum.INCOMPLETE,
    css: {
      color: "$gray12"
    }
  }, {
    current: true,
    status: StepStatusEnum.LOCKED,
    css: {
      color: "$gray12"
    }
  }]
});
const StepStatusIcon = {
  [StepStatusEnum.LOCKED]: /* @__PURE__ */jsx$1(ProgressIcon, {
    color: "gray8",
    icon: faLock_2
  }),
  [StepStatusEnum.COMPLETE]: /* @__PURE__ */jsx$1(ProgressIcon, {
    color: "white",
    icon: faCheck_2,
    css: {
      transform: "translateY(3px)"
    }
  }),
  [StepStatusEnum.INVALID]: /* @__PURE__ */jsx$1(ProgressIcon, {
    color: "gray12",
    icon: faTriangleExclamation_2
  }),
  [StepStatusEnum.INCOMPLETE]: null
};
const Step = _ref168 => {
  let {
    label,
    status,
    onSelect,
    index: index2,
    activeStep
  } = _ref168;
  const isLocked = StepStatusEnum.LOCKED === status;
  const canChangeStep = !isLocked && onSelect;
  const handleClick = e2 => {
    if (canChangeStep) {
      e2.preventDefault();
      onSelect(e2);
    }
  };
  return /* @__PURE__ */jsxs(StepContainer, {
    children: [/* @__PURE__ */jsxs(ProgressContainer, {
      children: [/* @__PURE__ */jsx$1(ProgressBar, {
        position: "prev",
        active: index2 <= activeStep
      }), /* @__PURE__ */jsx$1(ProgressBar, {
        position: "next",
        active: index2 < activeStep
      }), /* @__PURE__ */jsx$1(ProgressIconContainer, {
        onClick: handleClick,
        status,
        active: index2 === activeStep,
        "data-disabled": !canChangeStep,
        children: StepStatusIcon[status]
      })]
    }), /* @__PURE__ */jsx$1(StepDescriptionContainer, {
      children: /* @__PURE__ */jsx$1(StepDescription, {
        current: index2 === activeStep,
        status,
        "data-content": label,
        "data-disabled": !canChangeStep,
        "aria-disabled": !canChangeStep,
        "aria-label": isLocked ? "Step is locked" : void 0,
        role: onSelect ? "button" : void 0,
        tabIndex: onSelect ? 0 : void 0,
        ...ariaButtonEvents(canChangeStep ? onSelect : void 0),
        children: label
      })
    })]
  });
};
const Stepper = forwardRef(function Stepper2(_ref169, forwardedRef) {
  let {
    activeStep,
    steps,
    onStepClick,
    ...props
  } = _ref169;
  return /* @__PURE__ */jsx$1(Flex, {
    gap: 0,
    fullWidth: true,
    ...props,
    ref: forwardedRef,
    children: steps.map((step, index2) => /* @__PURE__ */jsx$1(Step, {
      index: index2,
      activeStep,
      onSelect: onStepClick ? event => onStepClick(index2, event) : void 0,
      ...step
    }, index2))
  });
});
const StyledWizardTitle = styled(ModalBase.Title, {
  paddingY: "$2",
  paddingX: "$4",
  backgroundColor: "$gray2",
  width: "100%"
});
const StyledWizardStepper = styled(Stepper, {
  marginTop: "-12px"
});
const StyledWizardContentContainer = styled(ModalBase.ContentContainer, {
  padding: 0
});
const StyledWizardContent = styled(ModalBase.Content, {
  height: "100vh",
  width: "100vw",
  display: "grid",
  gridTemplateRows: "112px auto",
  gap: "$2"
});
const StyledWizardStep = styled(Box, {
  display: "grid",
  overflowY: "auto",
  variants: {
    split: {
      left: {
        gridTemplateColumns: "auto max(25%, 340px)"
      },
      right: {
        gridTemplateColumns: "max(25%, 340px) auto"
      },
      center: {
        gridTemplateColumns: "1fr 1fr"
      }
    }
  }
});
const defaultProps = {
  open: false,
  activeStep: 0,
  steps: [],
  onStepChange: () => {},
  onSubmit: () => {},
  canSubmit: false,
  submitButtonText: "Finish"
};
const [WizardProvider, useWizardContext] = createComponentContext("Wizard", defaultProps);
const WizardRoot = _ref170 => {
  let {
    children,
    ...props
  } = _ref170;
  const defaultContext = {
    ...defaultProps,
    ...props
  };
  return /* @__PURE__ */jsx$1(ModalBase.Root, {
    open: props.open,
    children: /* @__PURE__ */jsx$1(WizardProvider, {
      ...defaultContext,
      children
    })
  });
};
const WizardTitle = _ref171 => {
  let {
    children
  } = _ref171;
  const {
    activeStep,
    steps,
    onClose,
    onSave,
    onStepChange,
    canSave
  } = useWizardContext();
  return /* @__PURE__ */jsxs(Box, {
    children: [/* @__PURE__ */jsxs(StyledWizardTitle, {
      as: Flex,
      justifyContent: "space-between",
      children: [/* @__PURE__ */jsx$1(Header, {
        children
      }), /* @__PURE__ */jsxs(ButtonGroup, {
        children: [!!onClose && /* @__PURE__ */jsx$1(Button, {
          variant: "secondary",
          onClick: onClose,
          children: "Cancel"
        }), !!onSave && /* @__PURE__ */jsx$1(Button, {
          onClick: onSave,
          disabled: !canSave,
          children: "Save & Close"
        })]
      })]
    }), /* @__PURE__ */jsx$1(StyledWizardStepper, {
      activeStep,
      steps,
      onStepClick: onStepChange
    })]
  });
};
const WizardDialog = _ref172 => {
  let {
    children,
    title
  } = _ref172;
  const {
    activeStep
  } = useWizardContext();
  const childrenArray = React__default.Children.toArray(children);
  const activeComponent = childrenArray[activeStep];
  return /* @__PURE__ */jsx$1(ModalBase.Portal, {
    children: /* @__PURE__ */jsx$1(StyledWizardContentContainer, {
      children: /* @__PURE__ */jsxs(StyledWizardContent, {
        children: [/* @__PURE__ */jsx$1(WizardTitle, {
          children: title
        }), activeComponent]
      })
    })
  });
};
const WizardStep = _ref173 => {
  let {
    children,
    split,
    ...props
  } = _ref173;
  return /* @__PURE__ */jsx$1(StyledWizardStep, {
    split,
    ...props,
    children
  });
};
const WizardStepColumn = _ref174 => {
  let {
    children,
    direction = "column",
    gap = 3,
    fullWidth = true,
    alignItems = "center",
    ...props
  } = _ref174;
  return /* @__PURE__ */jsx$1(Flex, {
    direction,
    gap,
    fullWidth,
    alignItems,
    ...props,
    children
  });
};
const WizardStepActionButton = _ref175 => {
  let {
    onClick,
    disabled: disabled2,
    children,
    ...props
  } = _ref175;
  const {
    activeStep,
    canSubmit,
    onStepChange,
    onSubmit,
    steps,
    submitButtonText
  } = useWizardContext();
  const isLastStep = activeStep === steps.length - 1;
  const isContinueDisabled = isLastStep ? !canSubmit : steps[activeStep + 1].status === StepStatusEnum.LOCKED;
  const handleContinue = e2 => {
    if (onClick) {
      onClick(e2);
    }
    if (isLastStep && onSubmit) {
      onSubmit(e2);
    } else {
      onStepChange(activeStep + 1, e2);
    }
  };
  return /* @__PURE__ */jsx$1(Flex, {
    justifyContent: "center",
    alignItems: "center",
    fullWidth: true,
    children: /* @__PURE__ */jsx$1(Button, {
      ...props,
      onClick: handleContinue,
      disabled: disabled2 || isContinueDisabled,
      children: children ? children : isLastStep ? submitButtonText : "Continue"
    })
  });
};
const Wizard = {
  Root: WizardRoot,
  Trigger: ModalBase.Trigger,
  Dialog: WizardDialog,
  Step: WizardStep,
  StepColumn: WizardStepColumn,
  StepActionButton: WizardStepActionButton
};
var faXmark$1 = {};
Object.defineProperty(faXmark$1, "__esModule", {
  value: true
});
var faXmark_2 = faXmark$1.faXmark = void 0;
const faXmark = {
  prefix: "far",
  iconName: "faXmark",
  icon: [320, 512, [], "", "M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"]
};
faXmark_2 = faXmark$1.faXmark = faXmark;
const StyledDrawerHeader = styled($5d3850c4d0b4e6c7$export$f99233281efd08a0, {
  textStyles: "h3",
  textColor: "h3",
  wordBreak: "break-word"
});
const slideIn = keyframes$1({
  from: {
    transform: "translateX(100%)"
  },
  to: {
    transform: "translateX(0%)"
  }
});
const slideOut = keyframes$1({
  from: {
    transform: "translateX(0%)"
  },
  to: {
    transform: "translateX(100%)",
    display: "none"
  }
});
const StyledDrawerContent = styled(Box, {
  height: "100vh",
  position: "fixed",
  display: "flex",
  gap: "$2",
  right: 0,
  top: 0,
  flexDirection: "column",
  background: "$white",
  zIndex: "$drawer",
  '&[data-state="open"]': {
    transform: "translateX(100%)",
    animation: `${slideIn} 300ms 300ms ease-out forwards`,
    boxShadow: "$3"
  },
  '&[data-state="closed"]': {
    transform: "translateX(0%)",
    animation: `${slideOut} 300ms ease-out forwards`
  },
  variants: {
    size: {
      small: {
        width: "363px"
      },
      large: {
        width: "717px"
      }
    }
  }
});
const DrawerHeaderContainer = styled(Box, {
  alignItems: "center",
  display: "flex",
  width: "90%",
  gap: "$1"
});
const fadeIn = keyframes$1({
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 0.8
  }
});
const fadeout = keyframes$1({
  "0%": {
    opacity: 0.8
  },
  "99%": {
    opacity: 0,
    width: "100vw",
    height: "100vh",
    display: "none"
  },
  "100%": {
    opacity: 0,
    display: "none",
    width: 0,
    height: 0
  }
});
const DrawerOverlay = styled($5d3850c4d0b4e6c7$export$c6fdb837b070b4ff, {
  backgroundColor: "$gray10",
  opacity: 0.8,
  position: "fixed",
  top: 0,
  right: 0,
  width: "100vw",
  height: "100vh",
  inset: 0,
  zIndex: "$drawer",
  '&[data-state="open"]': {
    animation: `${fadeIn} 300ms ease-out forwards`
  },
  '&[data-state="closed"]': {
    animation: `${fadeout} 300ms 300ms ease-out forwards`
  }
});
const StyledDrawerTitle = styled(Flex, {
  gridArea: "dialog-title",
  padding: "$2 $2 $0 $2"
});
const StyledDrawerActions = styled(Flex, {
  gridArea: "dialog-actions",
  padding: "$0 $2 $2 $2"
});
const StyledDrawerDialogContent = styled(Box, {
  height: "100vh",
  gridArea: "dialog-content",
  overflow: "auto",
  WebkitOverflowScrolling: "touch",
  overflowScrolling: "touch",
  background: `
    linear-gradient(white 30%, rgba(255, 255, 255, 0)) center top,
    linear-gradient(rgba(255, 255, 255, 0), white 70%) center bottom,
    linear-gradient(180deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center top,
    linear-gradient(0deg, rgba(96, 110, 120, 0.24), rgba(96, 110, 120, 0)) center bottom
  `,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% 40px, 100% 40px, 100% 4px, 100% 4px",
  backgroundAttachment: "local, local, scroll, scroll",
  padding: "0px $2 0px $2"
});
const StyledRadixClose = styled($5d3850c4d0b4e6c7$export$f39c2d165cd861fe, {
  position: "absolute",
  top: "$1",
  right: "$1"
});
var DrawerSizeEnum = /* @__PURE__ */(DrawerSizeEnum2 => {
  DrawerSizeEnum2["small"] = "small";
  DrawerSizeEnum2["large"] = "large";
  return DrawerSizeEnum2;
})(DrawerSizeEnum || {});
const DrawerTrigger = forwardRef((_ref176, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref176;
  return /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$41fb9f06171c75f4, {
    ref: forwardedRef,
    asChild: true,
    ...props,
    children
  });
});
DrawerTrigger.displayName = "DrawerTrigger";
const DrawerContext = createContext$1({
  open: false,
  onClose: () => {}
});
const DrawerRoot = _ref177 => {
  let {
    children,
    open: open2,
    onClose
  } = _ref177;
  return /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$be92b6f5f03c0fe9, {
    open: open2,
    children: /* @__PURE__ */jsx$1(DrawerContext.Provider, {
      value: {
        open: open2,
        onClose
      },
      children
    })
  });
};
DrawerRoot.displayName = "Drawer.Root";
const DrawerDialog = forwardRef((_ref178, forwardedRef) => {
  let {
    children,
    size = DrawerSizeEnum.small,
    hasOverlay = false,
    preventContentAutoFocusOnOpen = false,
    ...props
  } = _ref178;
  const {
    onClose
  } = useContext(DrawerContext);
  return /* @__PURE__ */jsxs($5d3850c4d0b4e6c7$export$602eac185826482c, {
    ...props,
    children: [hasOverlay && /* @__PURE__ */jsx$1(DrawerOverlay, {}), /* @__PURE__ */jsx$1($5d3850c4d0b4e6c7$export$7c6e2c02157bb7d2, {
      asChild: true,
      onEscapeKeyDown: onClose,
      onPointerDownOutside: onClose,
      onInteractOutside: onClose,
      onOpenAutoFocus: evt => preventContentAutoFocusOnOpen ? evt.preventDefault() : null,
      children: /* @__PURE__ */jsxs(StyledDrawerContent, {
        size,
        ref: forwardedRef,
        children: [children, /* @__PURE__ */jsx$1(StyledRadixClose, {
          asChild: true,
          children: /* @__PURE__ */jsx$1(IconButton, {
            title: "Close",
            icon: faXmark_2,
            onClick: onClose
          })
        })]
      })
    })]
  });
});
DrawerDialog.displayName = "Drawer.DrawerDialog";
const DrawerDialogTitle = _ref179 => {
  let {
    title,
    prefix: prefix2,
    children
  } = _ref179;
  return /* @__PURE__ */jsxs(StyledDrawerTitle, {
    direction: "column",
    gap: 0,
    children: [/* @__PURE__ */jsxs(DrawerHeaderContainer, {
      children: [prefix2 && prefix2, /* @__PURE__ */jsx$1(StyledDrawerHeader, {
        children: title
      })]
    }), children]
  });
};
DrawerDialogTitle.displayName = "Drawer.Title";
const DrawerDialogContent = forwardRef((_ref180, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref180;
  return /* @__PURE__ */jsx$1(StyledDrawerDialogContent, {
    ref: forwardedRef,
    ...props,
    children
  });
});
DrawerDialogContent.displayName = "DrawerDialogContent";
const DrawerDialogActions = forwardRef((_ref181, forwardedRef) => {
  let {
    children,
    justifyContent = "flex-end",
    ...props
  } = _ref181;
  return /* @__PURE__ */jsx$1(StyledDrawerActions, {
    ref: forwardedRef,
    justifyContent,
    ...props,
    children
  });
});
DrawerDialogActions.displayName = "Drawer.Actions";
const Drawer = {
  Root: DrawerRoot,
  Trigger: DrawerTrigger,
  Dialog: DrawerDialog,
  Title: DrawerDialogTitle,
  Content: DrawerDialogContent,
  Actions: DrawerDialogActions
};
const StyledButtonBase = styled("button", {
  ...ButtonBaseStyles,
  backgroundColor: "transparent",
  borderColor: "transparent",
  boxShadow: "none",
  color: "$blue10",
  padding: 0,
  "&:hover": {
    color: "$blue8"
  },
  "&:active": {
    color: "$blue10"
  },
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$1",
    color: "$blue12"
  },
  "&:disabled": {
    backgroundColor: "transparent",
    color: "$gray5",
    cursor: "not-allowed"
  },
  variants: {
    size: ButtonSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const StyledButtonContentBase = styled(Box, {
  display: "flex",
  alignItems: "center",
  gap: "$1"
});
const ButtonLoaderSizeVariant = {
  small: {
    width: "0.5rem",
    height: "0.5rem"
  },
  medium: {
    width: "0.65rem",
    height: "0.65rem"
  }
};
const StyledButtonLoader = styled(CircleLoader, {
  variants: {
    size: ButtonLoaderSizeVariant
  },
  defaultVariants: {
    size: "medium"
  }
});
const InlineButton = forwardRef((_ref182, forwardedRef) => {
  let {
    size,
    children,
    loading,
    ...props
  } = _ref182;
  return /* @__PURE__ */jsx$1(StyledButtonBase, {
    ref: forwardedRef,
    size,
    "aria-busy": loading,
    ...props,
    children: /* @__PURE__ */jsxs(StyledButtonContentBase, {
      children: [children, loading && /* @__PURE__ */jsx$1(StyledButtonLoader, {
        "aria-label": "loading",
        variant: "inherit"
      })]
    })
  });
});
InlineButton.displayName = "InlineButton";
const ChipContainerBaseStyles = {
  display: "flex",
  gap: "$half",
  alignItems: "center",
  borderRadius: "$4",
  paddingX: "$1",
  width: "max-content",
  position: "relative",
  maxHeight: "$3"
};
const ChipText = styled("span", {
  textStyles: "body",
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflowWrap: "break-word",
  wordBreak: "break-all",
  maxWidth: "24ch"
});
const ChipContainer = styled("div", {
  ...ChipContainerBaseStyles,
  alignItems: "center",
  paddingX: "$1",
  backgroundColor: "$blue2",
  border: "1px solid $blue5"
});
const ChipGroupContainer = styled("ul", {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  columnGap: "$half",
  rowGap: "$1",
  flexWrap: "wrap",
  alignItems: "center"
});
const ChipGroupListItem = styled("li", {
  listStyle: "none",
  margin: 0,
  padding: 0
});
const Chip = forwardRef((_ref183, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref183;
  return /* @__PURE__ */jsx$1(ChipContainer, {
    ref: forwardedRef,
    ...props,
    children: /* @__PURE__ */jsx$1(ChipText, {
      children
    })
  });
});
Chip.displayName = "Chip";
const ChipGroup = forwardRef((_ref184, forwardedRef) => {
  let {
    children,
    ...props
  } = _ref184;
  return /* @__PURE__ */jsx$1(ChipGroupContainer, {
    ref: forwardedRef,
    ...props,
    children: React__default.Children.map(children, (child, index2) => {
      const item = child;
      return /* @__PURE__ */jsx$1(ChipGroupListItem, {
        children: React__default.cloneElement(item)
      }, `chip-${index2}`);
    })
  });
});
ChipGroup.displayName = "ChipGroup";
const DismissableChipContainer = styled("div", {
  ...ChipContainerBaseStyles,
  alignItems: "center",
  paddingX: "$1",
  backgroundColor: "$blue2",
  border: "1px solid $blue5",
  "&:hover": {
    backgroundColor: "$gray2",
    border: "1px solid $blue3"
  },
  variants: {
    isDismissable: {
      true: {
        paddingRight: 0,
        "&:hover": {
          backgroundColor: "$blue2",
          border: "1px solid $blue5"
        }
      }
    }
  }
});
const DismissableChipDismissButton = styled("button", {
  border: "none",
  height: "22px",
  width: "20px",
  minWidth: "$2",
  padding: 0,
  cursor: "pointer",
  margin: 0,
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  borderTopRightRadius: "$round",
  borderBottomRightRadius: "$round",
  "&:hover": {
    backgroundColor: "$blue3"
  }
});
const DismissableChipGroupWrapper = styled("div", {
  display: "flex",
  minHeight: "$4",
  justifyContent: "center",
  gap: "$1"
});
const DismissableChipGroupContainer = styled("ul", {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  columnGap: "$half",
  rowGap: "$1",
  flexWrap: "wrap",
  alignItems: "center"
});
const DismissableChipGroupListItem = styled("li", {
  listStyle: "none",
  margin: 0,
  padding: 0
});
const DismissableChipClearButton = styled(InlineButton, {
  height: "max-content",
  whiteSpace: "nowrap",
  padding: 0
});
const DismissableChip = forwardRef((_ref185, forwardedRef) => {
  let {
    children,
    onDismiss,
    value
  } = _ref185;
  return /* @__PURE__ */jsxs(DismissableChipContainer, {
    isDismissable: true,
    ref: forwardedRef,
    children: [/* @__PURE__ */jsx$1(ChipText, {
      children
    }), /* @__PURE__ */jsx$1(DismissableChipDismissButton, {
      onClick: () => onDismiss && onDismiss(value),
      "aria-label": `remove chip - ${children == null ? void 0 : children.toString()}`,
      children: /* @__PURE__ */jsx$1(Icon, {
        icon: faXmark_2$1,
        size: "extra-small",
        variant: "dark"
      })
    })]
  });
});
DismissableChip.displayName = "DismissableChip";
const DismissableChipGroup = forwardRef((_ref186, forwardedRef) => {
  let {
    children,
    onChange: onChange3 = () => null,
    ...props
  } = _ref186;
  const childrenChipValues = useMemo(() => {
    var _a;
    return (_a = React__default.Children.map(children, child => {
      var _a2;
      return (_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.value;
    })) != null ? _a : [];
  }, [children]);
  const [visibleChipValues, setVisibleChipValues] = useState(childrenChipValues);
  const onChipButtonClick = useCallback(value => {
    const dismissedSelectionValues = without$1([value], visibleChipValues);
    setVisibleChipValues(dismissedSelectionValues);
    onChange3(dismissedSelectionValues);
  }, [visibleChipValues, onChange3]);
  const clearAllValues = useCallback(() => {
    setVisibleChipValues([]);
    onChange3([]);
  }, [onChange3]);
  useEffect(() => {
    setVisibleChipValues(childrenChipValues);
  }, [childrenChipValues]);
  return /* @__PURE__ */jsxs(DismissableChipGroupWrapper, {
    ref: forwardedRef,
    ...props,
    children: [/* @__PURE__ */jsx$1(DismissableChipGroupContainer, {
      children: React__default.Children.map(children, child => {
        const item = child;
        if (!visibleChipValues.includes(item.props.value)) {
          return null;
        }
        return /* @__PURE__ */jsx$1(DismissableChipGroupListItem, {
          children: React__default.cloneElement(item, {
            onDismiss: onChipButtonClick
          })
        }, `${item.props.value}`);
      })
    }), !!visibleChipValues.length && /* @__PURE__ */jsx$1(DismissableChipClearButton, {
      onClick: clearAllValues,
      children: "Clear all"
    })]
  });
});
DismissableChipGroup.displayName = "DismissableChipGroup";
const SelectableChipContainer = styled("button", {
  ...ChipContainerBaseStyles,
  cursor: "pointer",
  backgroundColor: "$gray1",
  border: "1px solid $blue3",
  "&:focus-visible": {
    outline: "solid 1px $blue6",
    outlineOffset: 2,
    borderRadius: "$4"
  },
  "&:hover": {
    backgroundColor: "$gray2",
    border: "1px solid $blue3"
  },
  '&[aria-checked="true"]': {
    backgroundColor: "$blue2",
    border: "1px solid $blue5"
  }
});
const SelectableChipGroupContainer = styled("ul", {
  listStyle: "none",
  padding: 0,
  margin: 0,
  display: "flex",
  columnGap: "$half",
  rowGap: "$1",
  flexWrap: "wrap"
});
const SelectableChipGroupListItem = styled("li", {
  listStyle: "none",
  margin: 0,
  padding: 0
});
const SelectableChip = forwardRef((_ref187, forwardedRef) => {
  let {
    children,
    selected,
    onClick = () => null,
    value
  } = _ref187;
  const onToggleButtonClick = useCallback(() => {
    onClick(value);
  }, [value, onClick]);
  return /* @__PURE__ */jsx$1(SelectableChipContainer, {
    onClick: onToggleButtonClick,
    "aria-checked": selected,
    role: "switch",
    ref: forwardedRef,
    children: /* @__PURE__ */jsx$1(ChipText, {
      children
    })
  });
});
SelectableChip.displayName = "SelectableChip";
const SelectableChipGroup = forwardRef((_ref188, forwardedRef) => {
  let {
    children,
    onChange: onChange3 = () => null,
    initialSelectedValues = []
  } = _ref188;
  const [selectedValues, setSelectedValues] = useState(initialSelectedValues);
  const onChipButtonClick = useCallback(value => {
    const chipSelectionValues = selectedValues.includes(value) ? without$1([value], selectedValues) : [...selectedValues, value];
    setSelectedValues(chipSelectionValues);
    onChange3(chipSelectionValues);
  }, [selectedValues, onChange3]);
  return /* @__PURE__ */jsx$1(SelectableChipGroupContainer, {
    ref: forwardedRef,
    children: React__default.Children.map(children, (child, index2) => {
      const item = child;
      return /* @__PURE__ */jsx$1(SelectableChipGroupListItem, {
        children: React__default.cloneElement(item, {
          onClick: onChipButtonClick,
          selected: selectedValues.includes(item.props.value),
          key: `${item.props.value}-${index2}`
        })
      }, `${item.props.value}-${index2}`);
    })
  });
});
SelectableChipGroup.displayName = "SelectableChipGroup";
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af() {
  for (var _len18 = arguments.length, refs = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    refs[_key18] = arguments[_key18];
  }
  return node2 => refs.forEach(ref => $6ed0406888f73fc4$var$setRef(ref, node2));
}
const $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  const childrenArray = Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map(child => {
      if (child === slottable) {
        if (Children.count(newElement) > 1) return Children.only(null);
        return /* @__PURE__ */isValidElement(newElement) ? newElement.props.children : null;
      } else return child;
    });
    return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */isValidElement(newElement) ? /* @__PURE__ */cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */createElement$1($5e63c961fc1ce211$var$SlotClone, _extends$1({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
const $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    children,
    ...slotProps
  } = props;
  if ( /* @__PURE__ */isValidElement(children)) return /* @__PURE__ */cloneElement(children, {
    ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
    ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
  });
  return Children.count(children) > 1 ? Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
const $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = _ref189 => {
  let {
    children
  } = _ref189;
  return /* @__PURE__ */createElement$1(Fragment$1, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = {
    ...childProps
  };
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) overrideProps[propName] = function () {
        childPropValue(...arguments);
        slotPropValue(...arguments);
      };else if (slotPropValue) overrideProps[propName] = slotPropValue;
    } else if (propName === "style") overrideProps[propName] = {
      ...slotPropValue,
      ...childPropValue
    };else if (propName === "className") overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
  }
  return {
    ...slotProps,
    ...overrideProps
  };
}
const $8927f6f2acc4f386$var$NODES = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"];
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node2) => {
  const Node = /* @__PURE__ */forwardRef((props, forwardedRef) => {
    const {
      asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node2;
    useEffect(() => {
      window[Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */createElement$1(Comp, _extends$1({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node2}`;
  return {
    ...primitive,
    [node2]: Node
  };
}, {});
const $89eedd556c436f6a$var$DEFAULT_ORIENTATION = "horizontal";
const $89eedd556c436f6a$var$ORIENTATIONS = ["horizontal", "vertical"];
const $89eedd556c436f6a$export$1ff3c3f08ae963c0 = /* @__PURE__ */forwardRef((props, forwardedRef) => {
  const {
    decorative,
    orientation: orientationProp = $89eedd556c436f6a$var$DEFAULT_ORIENTATION,
    ...domProps
  } = props;
  const orientation = $89eedd556c436f6a$var$isValidOrientation(orientationProp) ? orientationProp : $89eedd556c436f6a$var$DEFAULT_ORIENTATION;
  const ariaOrientation = orientation === "vertical" ? orientation : void 0;
  const semanticProps = decorative ? {
    role: "none"
  } : {
    "aria-orientation": ariaOrientation,
    role: "separator"
  };
  return /* @__PURE__ */createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$1({
    "data-orientation": orientation
  }, semanticProps, domProps, {
    ref: forwardedRef
  }));
});
$89eedd556c436f6a$export$1ff3c3f08ae963c0.propTypes = {
  orientation(props, propName, componentName) {
    const propValue = props[propName];
    const strVal = String(propValue);
    if (propValue && !$89eedd556c436f6a$var$isValidOrientation(propValue)) return new Error($89eedd556c436f6a$var$getInvalidOrientationError(strVal, componentName));
    return null;
  }
};
function $89eedd556c436f6a$var$getInvalidOrientationError(value, componentName) {
  return `Invalid prop \`orientation\` of value \`${value}\` supplied to \`${componentName}\`, expected one of:
  - horizontal
  - vertical

Defaulting to \`${$89eedd556c436f6a$var$DEFAULT_ORIENTATION}\`.`;
}
function $89eedd556c436f6a$var$isValidOrientation(orientation) {
  return $89eedd556c436f6a$var$ORIENTATIONS.includes(orientation);
}
const $89eedd556c436f6a$export$be92b6f5f03c0fe9 = $89eedd556c436f6a$export$1ff3c3f08ae963c0;
var SeparatorOrientationEnum = /* @__PURE__ */(SeparatorOrientationEnum2 => {
  SeparatorOrientationEnum2["HORIZONTAL"] = "horizontal";
  SeparatorOrientationEnum2["VERTICAL"] = "vertical";
  return SeparatorOrientationEnum2;
})(SeparatorOrientationEnum || {});
const SeparatorOrientationVariant = {
  horizontal: {
    height: 1,
    width: "100%"
  },
  vertical: {
    height: "100%",
    width: 1
  }
};
const SeparatorStyledBase = styled($89eedd556c436f6a$export$be92b6f5f03c0fe9, {
  variants: {
    orientation: SeparatorOrientationVariant
  },
  defaultVariants: {
    orientation: "horizontal"
  }
});
const Separator = forwardRef((_ref190, forwardedRef) => {
  let {
    color = "$gray3",
    rootProps,
    margin,
    decorative = true,
    orientation = "horizontal",
    ...props
  } = _ref190;
  return /* @__PURE__ */jsx$1(SeparatorStyledBase, {
    css: {
      backgroundColor: `${resolveColorFromTheme(color)}`,
      margin: `${margin}`
    },
    orientation,
    decorative,
    ref: forwardedRef,
    ...rootProps,
    ...props
  });
});
Separator.displayName = "Separator";
var _excluded = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading,
    allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile,
    _ref$createOptionPosi = _ref3.createOptionPosition,
    createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi,
    _ref$formatCreateLabe = _ref3.formatCreateLabel,
    formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe,
    _ref$isValidNewOption = _ref3.isValidNewOption,
    isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption,
    _ref$getNewOptionData = _ref3.getNewOptionData,
    getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData,
    onCreateOption = _ref3.onCreateOption,
    _ref$options = _ref3.options,
    propsOptions = _ref$options === void 0 ? [] : _ref$options,
    propsOnChange = _ref3.onChange,
    restSelectProps = _objectWithoutProperties(_ref3, _excluded);
  var _restSelectProps$getO = restSelectProps.getOptionValue,
    getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO,
    _restSelectProps$getO2 = restSelectProps.getOptionLabel,
    getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2,
    inputValue = restSelectProps.inputValue,
    isLoading = restSelectProps.isLoading,
    isMulti = restSelectProps.isMulti,
    value = restSelectProps.value,
    name = restSelectProps.name;
  var newOption = useMemo(function () {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options = useMemo(function () {
    return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading, newOption, propsOptions]);
  var onChange3 = useCallback(function (newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption) onCreateOption(inputValue);else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options,
    onChange: onChange3
  });
}
var CreatableSelect = /* @__PURE__ */forwardRef(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */React.createElement(Select$1, _extends({
    ref
  }, selectProps));
});
var MultiSelectTextSizeVariantEnum = /* @__PURE__ */(MultiSelectTextSizeVariantEnum2 => {
  MultiSelectTextSizeVariantEnum2["SMALL"] = "small";
  MultiSelectTextSizeVariantEnum2["MEDIUM"] = "medium";
  MultiSelectTextSizeVariantEnum2["LARGE"] = "large";
  MultiSelectTextSizeVariantEnum2["X_LARGE"] = "x-large";
  MultiSelectTextSizeVariantEnum2["FULL_WIDTH"] = "fullWidth";
  return MultiSelectTextSizeVariantEnum2;
})(MultiSelectTextSizeVariantEnum || {});
const MultiSelectTextSizeVariant = {
  small: {
    width: 120
  },
  medium: {
    width: 280
  },
  large: {
    width: 372
  },
  "x-large": {
    width: 550
  },
  fullWidth: {
    width: "100%"
  }
};
const MultiSelectTextSizeVariantStitches = MultiSelectTextSizeVariant;
const MultiSelectTextInputRoot = styled(Flex, {
  variants: {
    size: MultiSelectTextSizeVariantStitches
  },
  defaultVariants: {
    size: MultiSelectTextSizeVariantEnum.MEDIUM
  }
});
const components = {
  DropdownIndicator: null,
  ClearIndicator: props => /* @__PURE__ */jsx$1(CustomClearIndicator, {
    ...props
  })
};
const createOption = label => ({
  label,
  value: label
});
const MultiSelectTextInput = _ref191 => {
  let {
    placeholder = "Type and press enter...",
    initialValue = [],
    isDisabled = false,
    onChange: onChange3,
    success = "",
    error: error2 = "",
    label,
    hideLabel,
    description,
    size = "medium"
  } = _ref191;
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(initialValue);
  const [isCurrentInputValid, setIsCurrentInputValid] = useState(true);
  const handleKeyDown = event => {
    if (!inputValue) {
      return;
    }
    if (event.key === "Enter") {
      if (isCurrentInputValid) {
        setValue(prev2 => [...prev2, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
      }
    }
  };
  const onDelete = (newValue, _action) => {
    setValue(newValue);
  };
  useEffect(() => {
    onChange3 && onChange3(value);
  }, [value]);
  const selectStyles = useReactSelectStyles({
    size: "medium",
    error: !!error2,
    success: !!success
  });
  const {
    elementId: selectId,
    descriptionElementId,
    successMessageElementId,
    errorMessageElementId
  } = useInputLabels(label || "multi-select", "select");
  const describedById = error2 && errorMessageElementId || success && successMessageElementId || description && descriptionElementId;
  return /* @__PURE__ */jsx$1(MultiSelectTextInputRoot, {
    size,
    children: /* @__PURE__ */jsxs(Flex, {
      direction: "column",
      gap: "half",
      fullWidth: true,
      children: [label && !hideLabel && /* @__PURE__ */jsx$1(InputBase.Label, {
        htmlFor: selectId,
        label
      }), /* @__PURE__ */jsx$1(CreatableSelect, {
        components,
        inputValue,
        isClearable: true,
        isMulti: true,
        isValidNewOption: (currentValue, values) => {
          const isCurrentValueRepeated = values.some(each => {
            const value2 = each;
            return value2.value === currentValue;
          });
          setIsCurrentInputValid(!isCurrentValueRepeated);
          return isCurrentValueRepeated;
        },
        menuIsOpen: false,
        onChange: onDelete,
        isDisabled,
        onInputChange: newValue => setInputValue(newValue),
        onKeyDown: handleKeyDown,
        placeholder,
        value,
        styles: selectStyles,
        "aria-describedby": describedById
      }), /* @__PURE__ */jsx$1(InputBase.Description, {
        id: descriptionElementId,
        children: description
      }), /* @__PURE__ */jsx$1(InputBase.ErrorState, {
        id: errorMessageElementId,
        errorMessage: error2
      }), /* @__PURE__ */jsx$1(InputBase.SuccessState, {
        id: successMessageElementId,
        successMessage: error2 ? "" : success
      })]
    })
  });
};
const PageHeaderVariant = {
  withTabs: {
    borderBottom: "none"
  }
};
const StyledNavContainer = styled("header", {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  position: "relative",
  background: "$white",
  borderBottom: "1px solid var(--color-p1-4)",
  marginBottom: 0,
  variants: {
    variant: PageHeaderVariant
  }
});
const StyledSecondary = styled(Box, {
  position: "absolute",
  top: "16px",
  left: "32px"
});
const StyledTitleBlock = styled(Header, {
  padding: 0
});
const StyledMainContentWrapper = styled(Flex, {
  padding: "$4",
  position: "relative"
});
const PageHeaderTitle = _ref192 => {
  let {
    children: title,
    ...rest
  } = _ref192;
  return /* @__PURE__ */jsx$1(StyledTitleBlock, {
    ...rest,
    variant: "h3",
    children: title
  });
};
const PageHeaderSecondary = _ref193 => {
  let {
    children,
    ...rest
  } = _ref193;
  return /* @__PURE__ */jsx$1(StyledSecondary, {
    ...rest,
    children
  });
};
const PageHeaderTabs = _ref194 => {
  let {
    tabs,
    ...rest
  } = _ref194;
  return !!tabs && (tabs == null ? void 0 : tabs.length) > 0 ? /* @__PURE__ */jsx$1(Tabs, {
    ...rest,
    tabListProps: {
      css: {
        paddingLeft: "$4",
        paddingRight: "$4",
        marginBottom: "0"
      }
    },
    options: tabs
  }) : null;
};
const RightElements = _ref195 => {
  let {
    children,
    ...rest
  } = _ref195;
  return children ? /* @__PURE__ */jsx$1(Box, {
    ...rest,
    children
  }) : null;
};
const MainContentWrapper = _ref196 => {
  let {
    children,
    ...rest
  } = _ref196;
  return /* @__PURE__ */jsx$1(StyledMainContentWrapper, {
    alignItems: "center",
    justifyContent: "space-between",
    ...rest,
    children
  });
};
const PageHeader = {
  Root: StyledNavContainer,
  Main: MainContentWrapper,
  Title: PageHeaderTitle,
  RightElements,
  Secondary: PageHeaderSecondary,
  Tabs: PageHeaderTabs
};
var NodeContainerTypeVariantEnum = /* @__PURE__ */(NodeContainerTypeVariantEnum2 => {
  NodeContainerTypeVariantEnum2["HEADER"] = "header";
  NodeContainerTypeVariantEnum2["CONTENT"] = "content";
  NodeContainerTypeVariantEnum2["SEARCH"] = "search";
  return NodeContainerTypeVariantEnum2;
})(NodeContainerTypeVariantEnum || {});
const NodeContainerTypeVariant = {
  header: {
    margin: "27px 0 8px",
    paddingLeft: "8px"
  },
  content: {
    boxSizing: "border-box",
    flexDirection: "column",
    flexGrow: 1,
    margin: 0,
    overflow: "scroll",
    padding: "0 0 96px",
    width: "100%",
    "&::-webkit-scrollbar": {
      width: "0px",
      background: "transparent"
    }
  },
  search: {
    margin: "0 0 8px 8px",
    padding: 0
  }
};
const defaultSubnav = {
  transition: "0.3s ease-out",
  width: "216px",
  collapsedWidth: "24px"
};
const StyledPanel = styled(Box, {
  background: "#fff",
  boxSizing: "border-box",
  display: "inline-flex",
  flexDirection: "column",
  height: "100%",
  minWidth: defaultSubnav == null ? void 0 : defaultSubnav.width,
  padding: "0 8px 0 12px",
  position: "relative",
  transition: `all ${defaultSubnav.transition}`,
  transitionProperty: "min-width, width, transform",
  willChange: "min-width, width, transform",
  userSelect: "none",
  verticalAlign: "top",
  whiteSpace: "nowrap",
  width: "100%"
});
const StyledNodeContainer = styled(Box, {
  color: "var(--color-p1-10)",
  display: "flex",
  transition: `transform all ${defaultSubnav.transition}`,
  "&:hover": {
    transform: "translateX(0)",
    transitionDelay: "0.5s"
  },
  variants: {
    type: NodeContainerTypeVariant
  }
});
var faChevronRight$1 = {};
Object.defineProperty(faChevronRight$1, "__esModule", {
  value: true
});
var faChevronRight_2 = faChevronRight$1.faChevronRight = void 0;
const faChevronRight = {
  prefix: "fas",
  iconName: "faChevronRight",
  icon: [320, 512, [], "", "M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"]
};
faChevronRight_2 = faChevronRight$1.faChevronRight = faChevronRight;
const ParentNodeWrapper = styled(Box, {
  marginTop: "24px"
});
const NodeGroupHeader = styled(Box, {
  cursor: "pointer",
  fontFamily: "var(--main-font-family--bold)",
  fontSize: "var(--font-size-subtle)",
  letterSpacing: "0.8px",
  paddingLeft: "8px"
});
const NodeGroupToggle = styled(Box, {
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
  textTransform: "uppercase",
  svg: {
    display: "inline-block",
    marginTop: "-2px",
    transition: `transform ${defaultSubnav.transition}`,
    transitionDuration: "0.2s",
    transform: "rotate(90deg)",
    path: {
      fill: "#9eabb3",
      stroke: "#9eabb3"
    }
  },
  variants: {
    state: {
      collapsed: {
        svg: {
          transform: "rotate(0)"
        }
      },
      expanded: {
        svg: {
          transform: "rotate(90deg)"
        }
      }
    }
  }
});
const NodeGroupDrawerWrapper = styled(Box, {
  overflow: "hidden"
});
const slideUpAndFadeOut = keyframes$1({
  "0%": {
    transform: "translateY(0)",
    opacity: 1,
    height: "max-content"
  },
  "100%": {
    transform: "translateY(-100%)",
    opacity: 0,
    display: "none"
  }
});
const slideDownAndFadeIn = keyframes$1({
  "0%": {
    transform: "translateY(-100%)",
    opacity: 0
  },
  "100%": {
    transform: "translateY(0)",
    opacity: 1
  }
});
const NodeGroupDrawer = styled(Box, {
  marginTop: "0",
  paddingTop: "2px",
  overflow: "hidden",
  transition: `all ${defaultSubnav.transition}`,
  variants: {
    state: {
      expanded: {
        animation: `${slideDownAndFadeIn} 0.3s forwards`
      },
      collapsed: {
        animation: `${slideUpAndFadeOut} 0.3s forwards`
      }
    }
  }
});
const ParentNode = _ref197 => {
  let {
    label,
    onClick,
    query,
    ...rest
  } = _ref197;
  const [expanded, toggleExpanded] = useState(rest.expanded);
  const nodes = getChildNodes({
    nodes: rest.nodes,
    onItemSelectedCallback: rest.onItemSelectedCallback,
    query
  });
  const toggleClick = () => {
    onClick && onClick();
    toggleExpanded(!expanded);
  };
  if (!nodes.length) {
    return null;
  }
  return /* @__PURE__ */jsxs(ParentNodeWrapper, {
    children: [/* @__PURE__ */jsx$1(NodeGroupHeader, {
      onClick: toggleClick,
      children: /* @__PURE__ */jsxs(NodeGroupToggle, {
        state: expanded ? "expanded" : "collapsed",
        children: [/* @__PURE__ */jsx$1(Header, {
          variant: "h4",
          children: label
        }), /* @__PURE__ */jsx$1(Icon, {
          icon: faChevronRight_2,
          size: "small"
        })]
      })
    }), /* @__PURE__ */jsx$1(NodeGroupDrawerWrapper, {
      children: /* @__PURE__ */jsx$1(NodeGroupDrawer, {
        state: expanded ? "expanded" : "collapsed",
        children: nodes
      })
    })]
  });
};
const StyledText = styled(Text, {
  alignItems: "center",
  borderRadius: "2px",
  color: "$gray-10",
  cursor: "pointer",
  display: "flex",
  padding: "6px 8px",
  textDecoration: "none",
  transition: `all ${defaultSubnav.transition}`,
  "&:hover": {
    background: "#f5f8fa"
  },
  svg: {
    marginRight: "4px",
    path: {
      fill: "#1d2225"
    }
  },
  variants: {
    state: {
      disabled: {
        color: "var(--color-p1-6)",
        cursor: "default",
        pointerEvents: "none",
        "&:hover": {
          background: "inherit"
        },
        svg: {
          path: {
            fill: "#4e5c65"
          }
        }
      }
    }
  }
});
const EndNode = props => {
  const {
    label,
    value,
    icon: icon3,
    disabled: disabled2,
    onItemSelectedCallback,
    ...rest
  } = props;
  return /* @__PURE__ */jsxs(StyledText, {
    state: disabled2 ? "disabled" : void 0,
    onClick: () => onItemSelectedCallback && onItemSelectedCallback({
      ...props,
      label,
      value
    }),
    ...rest,
    children: [icon3 && /* @__PURE__ */jsx$1(Icon, {
      icon: icon3,
      size: "small"
    }), label]
  });
};
const getChildNodes = _ref198 => {
  let {
    nodes,
    onItemSelectedCallback,
    query
  } = _ref198;
  return nodes.map(_ref199 => {
    let {
      hide: hide2,
      ...node2
    } = _ref199;
    if (query && !node2.nodes && !node2.label.toLowerCase().includes(query.toLowerCase())) {
      return;
    }
    const CollapsibleListNode = node2.nodes ? ParentNode : EndNode;
    return hide2 ? null : /* @__PURE__ */jsx$1(CollapsibleListNode, {
      onItemSelectedCallback,
      query,
      ...node2
    }, node2.label);
  }).filter(Boolean);
};
const CollapsibleList = _ref200 => {
  let {
    hasSearch,
    title,
    nodes,
    onItemSelectedCallback
  } = _ref200;
  const [query, setQuery] = useState("");
  const childNodes = getChildNodes({
    nodes,
    onItemSelectedCallback,
    query
  });
  const handleSearch = _ref201 => {
    let {
      target: {
        value
      }
    } = _ref201;
    setQuery(value);
  };
  return /* @__PURE__ */jsxs(StyledPanel, {
    children: [/* @__PURE__ */jsx$1(StyledNodeContainer, {
      type: "header",
      children: /* @__PURE__ */jsx$1(Header, {
        variant: "h3",
        children: title
      })
    }), hasSearch && /* @__PURE__ */jsx$1(StyledNodeContainer, {
      type: "search",
      children: /* @__PURE__ */jsx$1(InputText, {
        label: "",
        hideLabel: true,
        placeholder: "Search",
        size: "full-width",
        onChange: handleSearch
      })
    }), /* @__PURE__ */jsx$1(StyledNodeContainer, {
      type: "content",
      children: childNodes
    })]
  });
};
var DisplayStateVariantEnum = /* @__PURE__ */(DisplayStateVariantEnum2 => {
  DisplayStateVariantEnum2["EXPANDED"] = "expanded";
  return DisplayStateVariantEnum2;
})(DisplayStateVariantEnum || {});
const createStore = (defaultContext, options) => {
  const Context = React__default.createContext({
    store: defaultContext,
    setStore: () => {}
  });
  const Provider = _ref202 => {
    let {
      children
    } = _ref202;
    const [store, setStore] = React__default.useState(defaultContext);
    React__default.useEffect(() => {
      if (options == null ? void 0 : options.onMount) {
        options.onMount({
          store,
          setStore
        });
      }
    }, []);
    return /* @__PURE__ */jsx$1(Context.Provider, {
      value: {
        store,
        setStore
      },
      children
    });
  };
  const useStore = () => {
    const {
      store,
      setStore
    } = React__default.useContext(Context);
    const updateStore = React__default.useCallback(newValue => {
      setStore(prevValue => mergeDeepRight$1(prevValue, isFunction(newValue) ? newValue(store) : newValue));
    }, [setStore, store]);
    return {
      store,
      setStore,
      updateStore
    };
  };
  return {
    Provider,
    useStore
  };
};
export { Accordion, AccordionThemeVariantEnum, AccountAvatar, Banner, BannerRoot, BannerThemeVariant, BannerThemeVariantEnum, Box, Breadcrumb, Button, ButtonBaseColorVariantEnum as ButtonColorVariantEnum, ButtonGroup, ButtonSizeVariant, ButtonSizeVariantEnum, Card, ChatLimitBorderCompoundVariant, Checkbox, CheckboxClassNames, CheckboxGroup, CheckboxSelectionBlock, Chip, ChipGroup, CircleLoader, CollapsibleList, CustomClearIndicator, DefaultPaginationState, DismissableChip, DismissableChipGroup, DisplayStateVariantEnum, Drawer, DrawerSizeEnum, EndNode, FeatureBadge, FeatureBadgeSizeVariantEnum, FeatureBadgeVariantEnum, FeatureTooltip, FeatureTooltipContentOrientationVariantEnum, Flex, FlexAlignItemsVariantEnum, FlexDirectionVariantEnum, FlexItemAlignSelfVariantEnum, FlexJustifyContentVariantEnum, FlexWrapVariantEnum, Header, HeaderVariant, HeaderVariantEnum, HighlightText, HighlightTextColorVariantEnum, Icon, IconButton, ButtonBaseColorVariantEnum as IconButtonColorVariantEnum, IconButtonSizeVariant, IconButtonSizeVariantEnum, IconColorVariant, IconColorVariantEnum, IconMenuButton, IconMenuButtonIconVariantEnum, IconSizeVariant, IconSizeVariantEnum, InfoBadge, InfoBadgeSizeVariantEnum, InfoBadgeVariantEnum, InlineAlert, InlineAlertDescription, InlineAlertThemeVariant, InlineAlertThemeVariantEnum, InlineButton, InlineInput, InlineInputVariantEnum, InlineSelect, InputNumber, InputPartial, InputText, Link, LinkSizeVariantEnum, LinkTile, LinkTypeVariantEnum, LoaderStyleVariant, LoaderStyleVariantEnum, MenuButton, Modal, ModalBase, ModalDialogAlertVariantEnum, ModalSizeVariantEnum, MultiSelectTextInput, MultiSelectTextSizeVariantEnum, NodeContainerTypeVariant, NodeContainerTypeVariantEnum, NotificationBadge, PageHeader, Paper, PaperElevationVariant, ParentNode, Popover, PopoverArrowSizeVariantEnum, RadioGroup, RadioItem, RadioSelectionBlock, Select, SelectSizeVariantEnum, SelectableChip, SelectableChipGroup, SelectionTile, SelectionTileItem, SelectionTileList, Separator, SeparatorOrientationEnum, SeparatorOrientationVariant, ServerThemeProvider, SimpleGrid, SimpleGridAlignItemsVariant, SimpleGridAlignItemsVariantEnum, SimpleGridColumnsVariant, SimpleGridGapVariant, SimpleGridJustifyItemsVariant, SimpleGridJustifyItemsVariantEnum, Skeleton, SplitMenuButton, StatusBadge, StatusBadgeSizeVariantEnum, StatusBadgeVariantEnum, StatusIcon, StatusIconFillColorMap, StatusIconVariantTypeEnum, StatusIndicator, StatusIndicatorColorVariant, StatusIndicatorColorVariantEnum, StatusIndicatorSizeVariant, StatusIndicatorSizeVariantEnum, StatusMessage, StatusMessageLabelColorVariant, StatusMessageVariantTypeEnum, StatusTagVariantEnum, StepStatusEnum, Stepper, StyledMainContentWrapper, StyledNavContainer, StyledPaperBase, StyledSecondary, StyledTitleBlock, Table, TableBase, TableBasePaginationPageSizes, TableEmptyState, TableStateChangeTypes, TableToolbar, Tabs, Tag, Text, TextGutterBottomVariant, TextTruncateVariant, TextVariant, TextVariantEnum, Textarea, ThemeProvider, ToastProvider, ToastVariantEnum, Toggle, ToggleButton, ToggleButtonGroup, Tooltip, TooltipBorderRadiusVariantEnum, TooltipSideVariantEnum, UserAvatar, UserAvatarFallback, UserAvatarStatusEnum, Wizard, applyGlobalStyles, config$1 as config, createComponentContext, createStore, css$4 as css, getChildNodes, getCssText, isFunction, keyframes$1 as keyframes, styled, theme, useCloseModal, useTableRef, useTableState, useToast };